(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 94371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ unitlessKeys; }
/* harmony export */ });
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};




/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(88593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clsx": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 8115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ UserAgentApplication; }
});

;// CONCATENATED MODULE: ./node_modules/msal/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/CryptoUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var CryptoUtils = /** @class */ (function () {
    function CryptoUtils() {
    }
    /**
     * Creates a new random GUID
     * @returns string (GUID)
     */
    CryptoUtils.createNewGuid = function () {
        /*
         * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
         * pseudo-random numbers.
         * The algorithm is as follows:
         *     Set the two most significant bits (bits 6 and 7) of the
         *        clock_seq_hi_and_reserved to zero and one, respectively.
         *     Set the four most significant bits (bits 12 through 15) of the
         *        time_hi_and_version field to the 4-bit version number from
         *        Section 4.1.3. Version4
         *     Set all the other bits to randomly (or pseudo-randomly) chosen
         *     values.
         * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
         * time-low               = 4hexOctet
         * time-mid               = 2hexOctet
         * time-high-and-version  = 2hexOctet
         * clock-seq-and-reserved = hexOctet:
         * clock-seq-low          = hexOctet
         * node                   = 6hexOctet
         * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
         * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
         * y values are 8, 9, A, B
         */
        var cryptoObj = window.crypto; // for IE 11
        if (cryptoObj && cryptoObj.getRandomValues) {
            var buffer = new Uint8Array(16);
            cryptoObj.getRandomValues(buffer);
            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
            return CryptoUtils.decimalToHex(buffer[0]) + CryptoUtils.decimalToHex(buffer[1])
                + CryptoUtils.decimalToHex(buffer[2]) + CryptoUtils.decimalToHex(buffer[3])
                + "-" + CryptoUtils.decimalToHex(buffer[4]) + CryptoUtils.decimalToHex(buffer[5])
                + "-" + CryptoUtils.decimalToHex(buffer[6]) + CryptoUtils.decimalToHex(buffer[7])
                + "-" + CryptoUtils.decimalToHex(buffer[8]) + CryptoUtils.decimalToHex(buffer[9])
                + "-" + CryptoUtils.decimalToHex(buffer[10]) + CryptoUtils.decimalToHex(buffer[11])
                + CryptoUtils.decimalToHex(buffer[12]) + CryptoUtils.decimalToHex(buffer[13])
                + CryptoUtils.decimalToHex(buffer[14]) + CryptoUtils.decimalToHex(buffer[15]);
        }
        else {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = "";
            for (var i = 0; i < 36; i++) {
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
                    // each x and y needs to be random
                    r = Math.random() * 16 | 0;
                }
                if (guidHolder[i] === "x") {
                    guidResponse += hex[r];
                }
                else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???
                    guidResponse += hex[r];
                }
                else {
                    guidResponse += guidHolder[i];
                }
            }
            return guidResponse;
        }
    };
    /**
     * verifies if a string is  GUID
     * @param guid
     */
    CryptoUtils.isGuid = function (guid) {
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(guid);
    };
    /**
     * Decimal to Hex
     *
     * @param num
     */
    CryptoUtils.decimalToHex = function (num) {
        var hex = num.toString(16);
        while (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };
    // See: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_4_%E2%80%93_escaping_the_string_before_encoding_it
    /**
     * encoding string to base64 - platform specific check
     *
     * @param input
     */
    CryptoUtils.base64Encode = function (input) {
        return btoa(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
            return String.fromCharCode(Number("0x" + p1));
        }));
    };
    /**
     * Decodes a base64 encoded string.
     *
     * @param input
     */
    CryptoUtils.base64Decode = function (input) {
        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
        switch (encodedString.length % 4) {
            case 0:
                break;
            case 2:
                encodedString += "==";
                break;
            case 3:
                encodedString += "=";
                break;
            default:
                throw new Error("Invalid base64 string");
        }
        return decodeURIComponent(atob(encodedString).split("").map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
    };
    /**
     * deserialize a string
     *
     * @param query
     */
    CryptoUtils.deserialize = function (query) {
        var match; // Regex for replacing addition symbol with a space
        var pl = /\+/g;
        var search = /([^&=]+)=([^&]*)/g;
        var decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); };
        var obj = {};
        match = search.exec(query);
        while (match) {
            obj[decode(match[1])] = decode(match[2]);
            match = search.exec(query);
        }
        return obj;
    };
    return CryptoUtils;
}());

//# sourceMappingURL=CryptoUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/Constants.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 * Constants
 */
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Object.defineProperty(Constants, "libraryName", {
        get: function () { return "Msal.js"; } // used in telemetry sdkName
        ,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "claims", {
        get: function () { return "claims"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "clientId", {
        get: function () { return "clientId"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "adalIdToken", {
        get: function () { return "adal.idtoken"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "cachePrefix", {
        get: function () { return "msal"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "scopes", {
        get: function () { return "scopes"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "no_account", {
        get: function () { return "NO_ACCOUNT"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "upn", {
        get: function () { return "upn"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "domain_hint", {
        get: function () { return "domain_hint"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "prompt_select_account", {
        get: function () { return "&prompt=select_account"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "prompt_none", {
        get: function () { return "&prompt=none"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "prompt", {
        get: function () { return "prompt"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "response_mode_fragment", {
        get: function () { return "&response_mode=fragment"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "resourceDelimiter", {
        get: function () { return "|"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "cacheDelimiter", {
        get: function () { return "."; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "popUpWidth", {
        get: function () { return this._popUpWidth; },
        set: function (width) {
            this._popUpWidth = width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "popUpHeight", {
        get: function () { return this._popUpHeight; },
        set: function (height) {
            this._popUpHeight = height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "login", {
        get: function () { return "LOGIN"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "renewToken", {
        get: function () { return "RENEW_TOKEN"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "unknown", {
        get: function () { return "UNKNOWN"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "ADFS", {
        get: function () { return "adfs"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "homeAccountIdentifier", {
        get: function () { return "homeAccountIdentifier"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "common", {
        get: function () { return "common"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "openidScope", {
        get: function () { return "openid"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "profileScope", {
        get: function () { return "profile"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "oidcScopes", {
        get: function () { return [this.openidScope, this.profileScope]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "interactionTypeRedirect", {
        get: function () { return "redirectInteraction"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "interactionTypePopup", {
        get: function () { return "popupInteraction"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "interactionTypeSilent", {
        get: function () { return "silentInteraction"; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constants, "inProgress", {
        get: function () { return "inProgress"; },
        enumerable: false,
        configurable: true
    });
    Constants._popUpWidth = 483;
    Constants._popUpHeight = 600;
    return Constants;
}());

var SESSION_STORAGE = "sessionStorage";
/**
 * Keys in the hashParams
 */
var ServerHashParamKeys;
(function (ServerHashParamKeys) {
    ServerHashParamKeys["SCOPE"] = "scope";
    ServerHashParamKeys["STATE"] = "state";
    ServerHashParamKeys["ERROR"] = "error";
    ServerHashParamKeys["ERROR_DESCRIPTION"] = "error_description";
    ServerHashParamKeys["ACCESS_TOKEN"] = "access_token";
    ServerHashParamKeys["ID_TOKEN"] = "id_token";
    ServerHashParamKeys["EXPIRES_IN"] = "expires_in";
    ServerHashParamKeys["SESSION_STATE"] = "session_state";
    ServerHashParamKeys["CLIENT_INFO"] = "client_info";
})(ServerHashParamKeys || (ServerHashParamKeys = {}));
/**
 * @hidden
 * @ignore
 * response_type from OpenIDConnect
 * References: https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html & https://tools.ietf.org/html/rfc6749#section-4.2.1
 *
 */
var ResponseTypes = {
    id_token: "id_token",
    token: "token",
    id_token_token: "id_token token"
};
/**
 * @hidden
 * CacheKeys for MSAL
 */
var TemporaryCacheKeys;
(function (TemporaryCacheKeys) {
    TemporaryCacheKeys["AUTHORITY"] = "authority";
    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireTokenAccount";
    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
    TemporaryCacheKeys["STATE_LOGIN"] = "state.login";
    TemporaryCacheKeys["STATE_ACQ_TOKEN"] = "state.acquireToken";
    TemporaryCacheKeys["STATE_RENEW"] = "state.renew";
    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.idtoken";
    TemporaryCacheKeys["LOGIN_REQUEST"] = "login.request";
    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
    TemporaryCacheKeys["URL_HASH"] = "urlHash";
    TemporaryCacheKeys["INTERACTION_STATUS"] = "interaction.status";
    TemporaryCacheKeys["REDIRECT_REQUEST"] = "redirect_request";
})(TemporaryCacheKeys || (TemporaryCacheKeys = {}));
var PersistentCacheKeys;
(function (PersistentCacheKeys) {
    PersistentCacheKeys["IDTOKEN"] = "idtoken";
    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
})(PersistentCacheKeys || (PersistentCacheKeys = {}));
var ErrorCacheKeys;
(function (ErrorCacheKeys) {
    ErrorCacheKeys["LOGIN_ERROR"] = "login.error";
    ErrorCacheKeys["ERROR"] = "error";
    ErrorCacheKeys["ERROR_DESC"] = "error.description";
})(ErrorCacheKeys || (ErrorCacheKeys = {}));
var DEFAULT_AUTHORITY = "https://login.microsoftonline.com/common/";
var AAD_INSTANCE_DISCOVERY_ENDPOINT = DEFAULT_AUTHORITY + "/discovery/instance?api-version=1.1&authorization_endpoint=";
var WELL_KNOWN_SUFFIX = ".well-known/openid-configuration";
/**
 * @hidden
 * SSO Types - generated to populate hints
 */
var SSOTypes;
(function (SSOTypes) {
    SSOTypes["ACCOUNT"] = "account";
    SSOTypes["SID"] = "sid";
    SSOTypes["LOGIN_HINT"] = "login_hint";
    SSOTypes["ORGANIZATIONS"] = "organizations";
    SSOTypes["CONSUMERS"] = "consumers";
    SSOTypes["ID_TOKEN"] = "id_token";
    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})(SSOTypes || (SSOTypes = {}));
/**
 * @hidden
 */
var DisallowedEQParams = [
    SSOTypes.SID,
    SSOTypes.LOGIN_HINT
];
var NetworkRequestType = {
    GET: "GET",
    POST: "POST"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 * @hidden
 */
var PromptState = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none"
};
/**
 * Frame name prefixes for the hidden iframe created in silent frames
 */
var FramePrefix = {
    ID_TOKEN_FRAME: "msalIdTokenFrame",
    TOKEN_FRAME: "msalRenewFrame"
};
//# sourceMappingURL=Constants.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/error/AuthError.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

var AuthErrorMessage = {
    unexpectedError: {
        code: "unexpected_error",
        desc: "Unexpected error in authentication."
    },
    noWindowObjectError: {
        code: "no_window_object",
        desc: "No window object available. Details:"
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorMessage) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.errorCode = errorCode;
        _this.errorMessage = errorMessage;
        _this.name = "AuthError";
        return _this;
    }
    AuthError.createUnexpectedError = function (errDesc) {
        return new AuthError(AuthErrorMessage.unexpectedError.code, AuthErrorMessage.unexpectedError.desc + ": " + errDesc);
    };
    AuthError.createNoWindowObjectError = function (errDesc) {
        return new AuthError(AuthErrorMessage.noWindowObjectError.code, AuthErrorMessage.noWindowObjectError.desc + " " + errDesc);
    };
    return AuthError;
}(Error));

//# sourceMappingURL=AuthError.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/StringUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    /**
     * Check if a string is empty
     *
     * @param str
     */
    StringUtils.isEmpty = function (str) {
        return (typeof str === "undefined" || !str || 0 === str.length);
    };
    /**
     * Check if a string's value is a valid JSON object
     *
     * @param str
     */
    StringUtils.validateAndParseJsonCacheKey = function (str) {
        try {
            var parsedKey = JSON.parse(str);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */
            return (parsedKey && typeof parsedKey === "object") ? parsedKey : null;
        }
        catch (error) {
            return null;
        }
    };
    return StringUtils;
}());

//# sourceMappingURL=StringUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/error/ClientAuthError.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



var ClientAuthErrorMessage = {
    endpointResolutionError: {
        code: "endpoints_resolution_error",
        desc: "Error: could not resolve endpoints. Please check network and try again."
    },
    popUpWindowError: {
        code: "popup_window_error",
        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
    },
    tokenRenewalError: {
        code: "token_renewal_error",
        desc: "Token renewal operation failed due to timeout."
    },
    invalidIdToken: {
        code: "invalid_id_token",
        desc: "Invalid ID token format."
    },
    invalidStateError: {
        code: "invalid_state_error",
        desc: "Invalid state."
    },
    nonceMismatchError: {
        code: "nonce_mismatch_error",
        desc: "Nonce is not matching, Nonce received: "
    },
    loginProgressError: {
        code: "login_progress_error",
        desc: "Login_In_Progress: Error during login call - login is already in progress."
    },
    acquireTokenProgressError: {
        code: "acquiretoken_progress_error",
        desc: "AcquireToken_In_Progress: Error during login call - login is already in progress."
    },
    userCancelledError: {
        code: "user_cancelled",
        desc: "User cancelled the flow."
    },
    callbackError: {
        code: "callback_error",
        desc: "Error occurred in token received callback function."
    },
    userLoginRequiredError: {
        code: "user_login_error",
        desc: "User login is required. For silent calls, request must contain either sid or login_hint"
    },
    userDoesNotExistError: {
        code: "user_non_existent",
        desc: "User object does not exist. Please call a login API."
    },
    clientInfoDecodingError: {
        code: "client_info_decoding_error",
        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
    },
    clientInfoNotPopulatedError: {
        code: "client_info_not_populated_error",
        desc: "The service did not populate client_info in the response, Please verify with the service team"
    },
    nullOrEmptyIdToken: {
        code: "null_or_empty_id_token",
        desc: "The idToken is null or empty. Please review the trace to determine the root cause."
    },
    idTokenNotParsed: {
        code: "id_token_parsing_error",
        desc: "ID token cannot be parsed. Please review stack trace to determine root cause."
    },
    tokenEncodingError: {
        code: "token_encoding_error",
        desc: "The token to be decoded is not encoded correctly."
    },
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The interaction type passed to the handler was incorrect or unknown"
    },
    cacheParseError: {
        code: "cannot_parse_cache",
        desc: "The cached token key is not a valid JSON and cannot be parsed"
    },
    blockTokenRequestsInHiddenIframe: {
        code: "block_token_requests",
        desc: "Token calls are blocked in hidden iframes"
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */
var ClientAuthError = /** @class */ (function (_super) {
    __extends(ClientAuthError, _super);
    function ClientAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientAuthError";
        Object.setPrototypeOf(_this, ClientAuthError.prototype);
        return _this;
    }
    ClientAuthError.createEndpointResolutionError = function (errDetail) {
        var errorMessage = ClientAuthErrorMessage.endpointResolutionError.desc;
        if (errDetail && !StringUtils.isEmpty(errDetail)) {
            errorMessage += " Details: " + errDetail;
        }
        return new ClientAuthError(ClientAuthErrorMessage.endpointResolutionError.code, errorMessage);
    };
    ClientAuthError.createPopupWindowError = function (errDetail) {
        var errorMessage = ClientAuthErrorMessage.popUpWindowError.desc;
        if (errDetail && !StringUtils.isEmpty(errDetail)) {
            errorMessage += " Details: " + errDetail;
        }
        return new ClientAuthError(ClientAuthErrorMessage.popUpWindowError.code, errorMessage);
    };
    ClientAuthError.createTokenRenewalTimeoutError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenRenewalError.code, ClientAuthErrorMessage.tokenRenewalError.desc);
    };
    ClientAuthError.createInvalidIdTokenError = function (idToken) {
        return new ClientAuthError(ClientAuthErrorMessage.invalidIdToken.code, ClientAuthErrorMessage.invalidIdToken.desc + " Given token: " + idToken);
    };
    // TODO: Is this not a security flaw to send the user the state expected??
    ClientAuthError.createInvalidStateError = function (invalidState, actualState) {
        return new ClientAuthError(ClientAuthErrorMessage.invalidStateError.code, ClientAuthErrorMessage.invalidStateError.desc + " " + invalidState + ", state expected : " + actualState + ".");
    };
    // TODO: Is this not a security flaw to send the user the Nonce expected??
    ClientAuthError.createNonceMismatchError = function (invalidNonce, actualNonce) {
        return new ClientAuthError(ClientAuthErrorMessage.nonceMismatchError.code, ClientAuthErrorMessage.nonceMismatchError.desc + " " + invalidNonce + ", nonce expected : " + actualNonce + ".");
    };
    ClientAuthError.createLoginInProgressError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.loginProgressError.code, ClientAuthErrorMessage.loginProgressError.desc);
    };
    ClientAuthError.createAcquireTokenInProgressError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.acquireTokenProgressError.code, ClientAuthErrorMessage.acquireTokenProgressError.desc);
    };
    ClientAuthError.createUserCancelledError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userCancelledError.code, ClientAuthErrorMessage.userCancelledError.desc);
    };
    ClientAuthError.createErrorInCallbackFunction = function (errorDesc) {
        return new ClientAuthError(ClientAuthErrorMessage.callbackError.code, ClientAuthErrorMessage.callbackError.desc + " " + errorDesc + ".");
    };
    ClientAuthError.createUserLoginRequiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userLoginRequiredError.code, ClientAuthErrorMessage.userLoginRequiredError.desc);
    };
    ClientAuthError.createUserDoesNotExistError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userDoesNotExistError.code, ClientAuthErrorMessage.userDoesNotExistError.desc);
    };
    ClientAuthError.createClientInfoDecodingError = function (caughtError) {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoDecodingError.code, ClientAuthErrorMessage.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
    };
    ClientAuthError.createClientInfoNotPopulatedError = function (caughtError) {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoNotPopulatedError.code, ClientAuthErrorMessage.clientInfoNotPopulatedError.desc + " Failed with error: " + caughtError);
    };
    ClientAuthError.createIdTokenNullOrEmptyError = function (invalidRawTokenString) {
        return new ClientAuthError(ClientAuthErrorMessage.nullOrEmptyIdToken.code, ClientAuthErrorMessage.nullOrEmptyIdToken.desc + " Raw ID Token Value: " + invalidRawTokenString);
    };
    ClientAuthError.createIdTokenParsingError = function (caughtParsingError) {
        return new ClientAuthError(ClientAuthErrorMessage.idTokenNotParsed.code, ClientAuthErrorMessage.idTokenNotParsed.desc + " Failed with error: " + caughtParsingError);
    };
    ClientAuthError.createTokenEncodingError = function (incorrectlyEncodedToken) {
        return new ClientAuthError(ClientAuthErrorMessage.tokenEncodingError.code, ClientAuthErrorMessage.tokenEncodingError.desc + " Attempted to decode: " + incorrectlyEncodedToken);
    };
    ClientAuthError.createInvalidInteractionTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidInteractionType.code, ClientAuthErrorMessage.invalidInteractionType.desc);
    };
    ClientAuthError.createCacheParseError = function (key) {
        var errorMessage = "invalid key: " + key + ", " + ClientAuthErrorMessage.cacheParseError.desc;
        return new ClientAuthError(ClientAuthErrorMessage.cacheParseError.code, errorMessage);
    };
    ClientAuthError.createBlockTokenRequestsInHiddenIframeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.blockTokenRequestsInHiddenIframe.code, ClientAuthErrorMessage.blockTokenRequestsInHiddenIframe.desc);
    };
    return ClientAuthError;
}(AuthError));

//# sourceMappingURL=ClientAuthError.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/error/ClientConfigurationError.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


var ClientConfigurationErrorMessage = {
    configurationNotSet: {
        code: "no_config_set",
        desc: "Configuration has not been set. Please call the UserAgentApplication constructor with a valid Configuration object."
    },
    storageNotSupported: {
        code: "storage_not_supported",
        desc: "The value for the cacheLocation is not supported."
    },
    noRedirectCallbacksSet: {
        code: "no_redirect_callbacks",
        desc: "No redirect callbacks have been set. Please call handleRedirectCallback() with the appropriate function arguments before continuing. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
        code: "invalid_callback_object",
        desc: "The object passed for the callback was invalid. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    scopesRequired: {
        code: "scopes_required",
        desc: "Scopes are required to obtain an access token."
    },
    emptyScopes: {
        code: "empty_input_scopes_error",
        desc: "Scopes cannot be passed as empty array."
    },
    nonArrayScopes: {
        code: "nonarray_input_scopes_error",
        desc: "Scopes cannot be passed as non-array."
    },
    invalidPrompt: {
        code: "invalid_prompt_value",
        desc: "Supported prompt values are 'login', 'select_account', 'consent' and 'none'",
    },
    invalidAuthorityType: {
        code: "invalid_authority_type",
        desc: "The given authority is not a valid type of authority supported by MSAL. Please see here for valid authorities: <insert URL here>."
    },
    authorityUriInsecure: {
        code: "authority_uri_insecure",
        desc: "Authority URIs must use https."
    },
    authorityUriInvalidPath: {
        code: "authority_uri_invalid_path",
        desc: "Given authority URI is invalid."
    },
    unsupportedAuthorityValidation: {
        code: "unsupported_authority_validation",
        desc: "The authority validation is not supported for this authority type."
    },
    untrustedAuthority: {
        code: "untrusted_authority",
        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter or set validateAuthority=false."
    },
    b2cAuthorityUriInvalidPath: {
        code: "b2c_authority_uri_invalid_path",
        desc: "The given URI for the B2C authority is invalid."
    },
    b2cKnownAuthoritiesNotSet: {
        code: "b2c_known_authorities_not_set",
        desc: "Must set known authorities when validateAuthority is set to True and using B2C"
    },
    claimsRequestParsingError: {
        code: "claims_request_parsing_error",
        desc: "Could not parse the given claims request object."
    },
    emptyRequestError: {
        code: "empty_request_error",
        desc: "Request object is required."
    },
    invalidCorrelationIdError: {
        code: "invalid_guid_sent_as_correlationId",
        desc: "Please set the correlationId as a valid guid"
    },
    telemetryConfigError: {
        code: "telemetry_config_error",
        desc: "Telemetry config is not configured with required values"
    },
    ssoSilentError: {
        code: "sso_silent_error",
        desc: "request must contain either sid or login_hint"
    },
    invalidAuthorityMetadataError: {
        code: "authority_metadata_error",
        desc: "Invalid authorityMetadata. Must be a JSON object containing authorization_endpoint, end_session_endpoint, and issuer fields."
    }
};
/**
 * Error thrown when there is an error in configuration of the .js library.
 */
var ClientConfigurationError = /** @class */ (function (_super) {
    __extends(ClientConfigurationError, _super);
    function ClientConfigurationError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientConfigurationError";
        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
        return _this;
    }
    ClientConfigurationError.createNoSetConfigurationError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.configurationNotSet.code, "" + ClientConfigurationErrorMessage.configurationNotSet.desc);
    };
    ClientConfigurationError.createStorageNotSupportedError = function (givenCacheLocation) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.storageNotSupported.code, ClientConfigurationErrorMessage.storageNotSupported.desc + " Given location: " + givenCacheLocation);
    };
    ClientConfigurationError.createRedirectCallbacksNotSetError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.noRedirectCallbacksSet.code, ClientConfigurationErrorMessage.noRedirectCallbacksSet.desc);
    };
    ClientConfigurationError.createInvalidCallbackObjectError = function (callbackObject) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCallbackObject.code, ClientConfigurationErrorMessage.invalidCallbackObject.desc + " Given value for callback function: " + callbackObject);
    };
    ClientConfigurationError.createEmptyScopesArrayError = function (scopesValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.emptyScopes.code, ClientConfigurationErrorMessage.emptyScopes.desc + " Given value: " + scopesValue + ".");
    };
    ClientConfigurationError.createScopesNonArrayError = function (scopesValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.nonArrayScopes.code, ClientConfigurationErrorMessage.nonArrayScopes.desc + " Given value: " + scopesValue + ".");
    };
    ClientConfigurationError.createScopesRequiredError = function (scopesValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.scopesRequired.code, ClientConfigurationErrorMessage.scopesRequired.desc + " Given value: " + scopesValue);
    };
    ClientConfigurationError.createInvalidPromptError = function (promptValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidPrompt.code, ClientConfigurationErrorMessage.invalidPrompt.desc + " Given value: " + promptValue);
    };
    ClientConfigurationError.createClaimsRequestParsingError = function (claimsRequestParseError) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.claimsRequestParsingError.code, ClientConfigurationErrorMessage.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
    };
    ClientConfigurationError.createEmptyRequestError = function () {
        var _a = ClientConfigurationErrorMessage.emptyRequestError, code = _a.code, desc = _a.desc;
        return new ClientConfigurationError(code, desc);
    };
    ClientConfigurationError.createInvalidCorrelationIdError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCorrelationIdError.code, ClientConfigurationErrorMessage.invalidCorrelationIdError.desc);
    };
    ClientConfigurationError.createKnownAuthoritiesNotSetError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.b2cKnownAuthoritiesNotSet.code, ClientConfigurationErrorMessage.b2cKnownAuthoritiesNotSet.desc);
    };
    ClientConfigurationError.createInvalidAuthorityTypeError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthorityType.code, ClientConfigurationErrorMessage.invalidAuthorityType.desc);
    };
    ClientConfigurationError.createUntrustedAuthorityError = function (host) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.untrustedAuthority.code, ClientConfigurationErrorMessage.untrustedAuthority.desc + " Provided Authority: " + host);
    };
    ClientConfigurationError.createTelemetryConfigError = function (config) {
        var _a = ClientConfigurationErrorMessage.telemetryConfigError, code = _a.code, desc = _a.desc;
        var requiredKeys = {
            applicationName: "string",
            applicationVersion: "string",
            telemetryEmitter: "function"
        };
        var missingKeys = Object.keys(requiredKeys)
            .reduce(function (keys, key) {
            return config[key] ? keys : keys.concat([key + " (" + requiredKeys[key] + ")"]);
        }, []);
        return new ClientConfigurationError(code, desc + " mising values: " + missingKeys.join(","));
    };
    ClientConfigurationError.createSsoSilentError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.ssoSilentError.code, ClientConfigurationErrorMessage.ssoSilentError.desc);
    };
    ClientConfigurationError.createInvalidAuthorityMetadataError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthorityMetadataError.code, ClientConfigurationErrorMessage.invalidAuthorityMetadataError.desc);
    };
    return ClientConfigurationError;
}(ClientAuthError));

//# sourceMappingURL=ClientConfigurationError.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/ScopeSet.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



var ScopeSet = /** @class */ (function () {
    function ScopeSet() {
    }
    /**
     * Check if there are dup scopes in a given request
     *
     * @param cachedScopes
     * @param scopes
     */
    // TODO: Rename this, intersecting scopes isn't a great name for duplicate checker
    ScopeSet.isIntersectingScopes = function (cachedScopes, scopes) {
        var convertedCachedScopes = this.trimAndConvertArrayToLowerCase(__spreadArrays(cachedScopes));
        var requestScopes = this.trimAndConvertArrayToLowerCase(__spreadArrays(scopes));
        for (var i = 0; i < requestScopes.length; i++) {
            if (convertedCachedScopes.indexOf(requestScopes[i].toLowerCase()) > -1) {
                return true;
            }
        }
        return false;
    };
    /**
     * Check if a given scope is present in the request
     *
     * @param cachedScopes
     * @param scopes
     */
    ScopeSet.containsScope = function (cachedScopes, scopes) {
        var convertedCachedScopes = this.trimAndConvertArrayToLowerCase(__spreadArrays(cachedScopes));
        var requestScopes = this.trimAndConvertArrayToLowerCase(__spreadArrays(scopes));
        return requestScopes.every(function (value) { return convertedCachedScopes.indexOf(value.toString().toLowerCase()) >= 0; });
    };
    /**
     *  Trims and converts string to lower case
     *
     * @param scopes
     */
    // TODO: Rename this, too generic name for a function that only deals with scopes
    ScopeSet.trimAndConvertToLowerCase = function (scope) {
        return scope.trim().toLowerCase();
    };
    /**
     * Performs trimAndConvertToLowerCase on string array
     * @param scopes
     */
    ScopeSet.trimAndConvertArrayToLowerCase = function (scopes) {
        var _this = this;
        return scopes.map(function (scope) { return _this.trimAndConvertToLowerCase(scope); });
    };
    /**
     * Trims each scope in scopes array
     * @param scopes
     */
    ScopeSet.trimScopes = function (scopes) {
        return scopes.map(function (scope) { return scope.trim(); });
    };
    /**
     * Remove one element from a scope array
     *
     * @param scopes
     * @param scope
     */
    // TODO: Rename this, too generic name for a function that only deals with scopes
    ScopeSet.removeElement = function (scopes, scope) {
        var scopeVal = this.trimAndConvertToLowerCase(scope);
        return scopes.filter(function (value) { return value !== scopeVal; });
    };
    /**
     * Parse the scopes into a formatted scopeList
     * @param scopes
     */
    ScopeSet.parseScope = function (scopes) {
        var scopeList = "";
        if (scopes) {
            for (var i = 0; i < scopes.length; ++i) {
                scopeList += (i !== scopes.length - 1) ? scopes[i] + " " : scopes[i];
            }
        }
        return scopeList;
    };
    /**
     * @hidden
     *
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} scopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     * @ignore
     */
    ScopeSet.validateInputScope = function (scopes, scopesRequired) {
        if (!scopes) {
            if (scopesRequired) {
                throw ClientConfigurationError.createScopesRequiredError(scopes);
            }
            else {
                return;
            }
        }
        // Check that scopes is an array object (also throws error if scopes == null)
        if (!Array.isArray(scopes)) {
            throw ClientConfigurationError.createScopesNonArrayError(scopes);
        }
        // Check that scopes is not an empty array
        if (scopes.length < 1 && scopesRequired) {
            throw ClientConfigurationError.createEmptyScopesArrayError(scopes.toString());
        }
    };
    /**
     * @hidden
     *
     * Extracts scope value from the state sent with the authentication request.
     * @param {string} state
     * @returns {string} scope.
     * @ignore
     */
    ScopeSet.getScopeFromState = function (state) {
        if (state) {
            var splitIndex = state.indexOf(Constants.resourceDelimiter);
            if (splitIndex > -1 && splitIndex + 1 < state.length) {
                return state.substring(splitIndex + 1);
            }
        }
        return "";
    };
    /**
     * @ignore
     * Appends extraScopesToConsent if passed
     * @param {@link AuthenticationParameters}
     */
    ScopeSet.appendScopes = function (reqScopes, reqExtraScopesToConsent) {
        if (reqScopes) {
            var convertedExtraScopes = reqExtraScopesToConsent ? this.trimAndConvertArrayToLowerCase(__spreadArrays(reqExtraScopesToConsent)) : null;
            var convertedReqScopes = this.trimAndConvertArrayToLowerCase(__spreadArrays(reqScopes));
            return convertedExtraScopes ? __spreadArrays(convertedReqScopes, convertedExtraScopes) : convertedReqScopes;
        }
        return null;
    };
    // #endregion
    /**
     * @ignore
     * Returns true if the scopes array only contains openid and/or profile
     */
    ScopeSet.onlyContainsOidcScopes = function (scopes) {
        var scopesCount = scopes.length;
        var oidcScopesFound = 0;
        if (scopes.indexOf(Constants.openidScope) > -1) {
            oidcScopesFound += 1;
        }
        if (scopes.indexOf(Constants.profileScope) > -1) {
            oidcScopesFound += 1;
        }
        return (scopesCount > 0 && scopesCount === oidcScopesFound);
    };
    /**
     * @ignore
     * Returns true if the scopes array only contains openid and/or profile
     */
    ScopeSet.containsAnyOidcScopes = function (scopes) {
        var containsOpenIdScope = scopes.indexOf(Constants.openidScope) > -1;
        var containsProfileScope = scopes.indexOf(Constants.profileScope) > -1;
        return (containsOpenIdScope || containsProfileScope);
    };
    /**
     * @ignore
     * Returns true if the clientId is the only scope in the array
     */
    ScopeSet.onlyContainsClientId = function (scopes, clientId) {
        // Double negation to force false value returned in case scopes is null
        return !!scopes && (scopes.indexOf(clientId) > -1 && scopes.length === 1);
    };
    /**
     * @ignore
     * Adds missing OIDC scopes to scopes array without duplication. Since STS requires OIDC scopes for
     * all implicit flow requests, 'openid' and 'profile' should always be included in the final request
     */
    ScopeSet.appendDefaultScopes = function (scopes) {
        var extendedScopes = scopes;
        if (extendedScopes.indexOf(Constants.openidScope) === -1) {
            extendedScopes.push(Constants.openidScope);
        }
        if (extendedScopes.indexOf(Constants.profileScope) === -1) {
            extendedScopes.push(Constants.profileScope);
        }
        return extendedScopes;
    };
    /**
     * @ignore
     * Removes present OIDC scopes from scopes array.
     */
    ScopeSet.removeDefaultScopes = function (scopes) {
        return scopes.filter(function (scope) {
            return (scope !== Constants.openidScope && scope !== Constants.profileScope);
        });
    };
    /**
     * @ignore
     * Removes clientId from scopes array if included as only scope. If it's not the only scope, it is treated as a resource scope.
     * @param scopes Array<string>: Pre-normalized scopes array
     * @param clientId string: The application's clientId that is searched for in the scopes array
     */
    ScopeSet.translateClientIdIfSingleScope = function (scopes, clientId) {
        return this.onlyContainsClientId(scopes, clientId) ? Constants.oidcScopes : scopes;
    };
    return ScopeSet;
}());

//# sourceMappingURL=ScopeSet.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/UrlUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




/**
 * @hidden
 */
var UrlUtils = /** @class */ (function () {
    function UrlUtils() {
    }
    /**
     * generates the URL with QueryString Parameters
     * @param scopes
     */
    UrlUtils.createNavigateUrl = function (serverRequestParams) {
        var str = this.createNavigationUrlString(serverRequestParams);
        var authEndpoint = serverRequestParams.authorityInstance.AuthorizationEndpoint;
        // if the endpoint already has queryparams, lets add to it, otherwise add the first one
        if (authEndpoint.indexOf("?") < 0) {
            authEndpoint += "?";
        }
        else {
            authEndpoint += "&";
        }
        var requestUrl = "" + authEndpoint + str.join("&");
        return requestUrl;
    };
    /**
     * Generate the array of all QueryStringParams to be sent to the server
     * @param scopes
     */
    UrlUtils.createNavigationUrlString = function (serverRequestParams) {
        var scopes = ScopeSet.appendDefaultScopes(serverRequestParams.scopes);
        var str = [];
        str.push("response_type=" + serverRequestParams.responseType);
        str.push("scope=" + encodeURIComponent(ScopeSet.parseScope(scopes)));
        str.push("client_id=" + encodeURIComponent(serverRequestParams.clientId));
        str.push("redirect_uri=" + encodeURIComponent(serverRequestParams.redirectUri));
        str.push("state=" + encodeURIComponent(serverRequestParams.state));
        str.push("nonce=" + encodeURIComponent(serverRequestParams.nonce));
        str.push("client_info=1");
        str.push("x-client-SKU=" + serverRequestParams.xClientSku);
        str.push("x-client-Ver=" + serverRequestParams.xClientVer);
        if (serverRequestParams.promptValue) {
            str.push("prompt=" + encodeURIComponent(serverRequestParams.promptValue));
        }
        if (serverRequestParams.claimsValue) {
            str.push("claims=" + encodeURIComponent(serverRequestParams.claimsValue));
        }
        if (serverRequestParams.queryParameters) {
            str.push(serverRequestParams.queryParameters);
        }
        if (serverRequestParams.extraQueryParameters) {
            str.push(serverRequestParams.extraQueryParameters);
        }
        str.push("client-request-id=" + encodeURIComponent(serverRequestParams.correlationId));
        return str;
    };
    /**
     * Returns current window URL as redirect uri
     */
    UrlUtils.getCurrentUrl = function () {
        return window.location.href.split("?")[0].split("#")[0];
    };
    /**
     * Returns given URL with query string removed
     */
    UrlUtils.removeHashFromUrl = function (url) {
        return url.split("#")[0];
    };
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */
    UrlUtils.replaceTenantPath = function (url, tenantId) {
        var lowerCaseUrl = url.toLowerCase();
        var urlObject = this.GetUrlComponents(lowerCaseUrl);
        var pathArray = urlObject.PathSegments;
        if (tenantId && (pathArray.length !== 0 && (pathArray[0] === Constants.common || pathArray[0] === SSOTypes.ORGANIZATIONS || pathArray[0] === SSOTypes.CONSUMERS))) {
            pathArray[0] = tenantId;
        }
        return this.constructAuthorityUriFromObject(urlObject, pathArray);
    };
    UrlUtils.constructAuthorityUriFromObject = function (urlObject, pathArray) {
        return this.CanonicalizeUri(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + pathArray.join("/"));
    };
    /**
     * Checks if an authority is common (ex. https://a:b/common/)
     * @param url The url
     * @returns true if authority is common and false otherwise
     */
    UrlUtils.isCommonAuthority = function (url) {
        var authority = this.CanonicalizeUri(url);
        var pathArray = this.GetUrlComponents(authority).PathSegments;
        return (pathArray.length !== 0 && pathArray[0] === Constants.common);
    };
    /**
     * Checks if an authority is for organizations (ex. https://a:b/organizations/)
     * @param url The url
     * @returns true if authority is for  and false otherwise
     */
    UrlUtils.isOrganizationsAuthority = function (url) {
        var authority = this.CanonicalizeUri(url);
        var pathArray = this.GetUrlComponents(authority).PathSegments;
        return (pathArray.length !== 0 && pathArray[0] === SSOTypes.ORGANIZATIONS);
    };
    /**
     * Checks if an authority is for consumers (ex. https://a:b/consumers/)
     * @param url The url
     * @returns true if authority is for  and false otherwise
     */
    UrlUtils.isConsumersAuthority = function (url) {
        var authority = this.CanonicalizeUri(url);
        var pathArray = this.GetUrlComponents(authority).PathSegments;
        return (pathArray.length !== 0 && pathArray[0] === SSOTypes.CONSUMERS);
    };
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */
    UrlUtils.GetUrlComponents = function (url) {
        if (!url) {
            throw "Url required";
        }
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        var match = url.match(regEx);
        if (!match || match.length < 6) {
            throw "Valid url required";
        }
        var urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5]
        };
        var pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter(function (val) { return val && val.length > 0; }); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (match[6]) {
            urlComponents.Search = match[6];
        }
        if (match[8]) {
            urlComponents.Hash = match[8];
        }
        return urlComponents;
    };
    /**
     * Given a url or path, append a trailing slash if one doesnt exist
     *
     * @param url
     */
    UrlUtils.CanonicalizeUri = function (url) {
        if (url) {
            var lowerCaseUrl = url.toLowerCase();
            if (!UrlUtils.endsWith(lowerCaseUrl, "/")) {
                lowerCaseUrl += "/";
            }
            return lowerCaseUrl;
        }
        return url;
    };
    /**
     * Checks to see if the url ends with the suffix
     * Required because we are compiling for es5 instead of es6
     * @param url
     * @param str
     */
    // TODO: Rename this, not clear what it is supposed to do
    UrlUtils.endsWith = function (url, suffix) {
        if (!url || !suffix) {
            return false;
        }
        return url.indexOf(suffix, url.length - suffix.length) !== -1;
    };
    /**
     * Utils function to remove the login_hint and domain_hint from the i/p extraQueryParameters
     * @param url
     * @param name
     */
    UrlUtils.urlRemoveQueryStringParameter = function (url, name) {
        if (StringUtils.isEmpty(url)) {
            return url;
        }
        var updatedUrl = url;
        var regex = new RegExp("(\\&" + name + "=)[^\&]+");
        updatedUrl = url.replace(regex, "");
        // name=value&
        regex = new RegExp("(" + name + "=)[^\&]+&");
        updatedUrl = url.replace(regex, "");
        // name=value
        regex = new RegExp("(" + name + "=)[^\&]+");
        updatedUrl = url.replace(regex, "");
        return updatedUrl;
    };
    /**
     * @hidden
     * @ignore
     *
     * Returns the anchor part(#) of the URL
     */
    UrlUtils.getHashFromUrl = function (urlStringOrFragment) {
        var hashIndex1 = urlStringOrFragment.indexOf("#");
        var hashIndex2 = urlStringOrFragment.indexOf("#/");
        if (hashIndex2 > -1) {
            return urlStringOrFragment.substring(hashIndex2 + 2);
        }
        else if (hashIndex1 > -1) {
            return urlStringOrFragment.substring(hashIndex1 + 1);
        }
        return urlStringOrFragment;
    };
    /**
     * @hidden
     * Check if the url contains a hash with known properties
     * @ignore
     */
    UrlUtils.urlContainsHash = function (urlString) {
        var parameters = UrlUtils.deserializeHash(urlString);
        return (parameters.hasOwnProperty(ServerHashParamKeys.ERROR_DESCRIPTION) ||
            parameters.hasOwnProperty(ServerHashParamKeys.ERROR) ||
            parameters.hasOwnProperty(ServerHashParamKeys.ACCESS_TOKEN) ||
            parameters.hasOwnProperty(ServerHashParamKeys.ID_TOKEN));
    };
    /**
     * @hidden
     * Returns deserialized portion of URL hash
     * @ignore
     */
    UrlUtils.deserializeHash = function (urlFragment) {
        var hash = UrlUtils.getHashFromUrl(urlFragment);
        return CryptoUtils.deserialize(hash);
    };
    /**
     * @ignore
     * @param {string} URI
     * @returns {string} host from the URI
     *
     * extract URI from the host
     */
    UrlUtils.getHostFromUri = function (uri) {
        // remove http:// or https:// from uri
        var extractedUri = String(uri).replace(/^(https?:)\/\//, "");
        extractedUri = extractedUri.split("/")[0];
        return extractedUri;
    };
    return UrlUtils;
}());

//# sourceMappingURL=UrlUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/cache/AccessTokenKey.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/**
 * @hidden
 */
var AccessTokenKey = /** @class */ (function () {
    function AccessTokenKey(authority, clientId, scopes, uid, utid) {
        this.authority = UrlUtils.CanonicalizeUri(authority);
        this.clientId = clientId;
        this.scopes = scopes;
        this.homeAccountIdentifier = CryptoUtils.base64Encode(uid) + "." + CryptoUtils.base64Encode(utid);
    }
    return AccessTokenKey;
}());

//# sourceMappingURL=AccessTokenKey.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/cache/AccessTokenValue.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var AccessTokenValue = /** @class */ (function () {
    function AccessTokenValue(accessToken, idToken, expiresIn, homeAccountIdentifier) {
        this.accessToken = accessToken;
        this.idToken = idToken;
        this.expiresIn = expiresIn;
        this.homeAccountIdentifier = homeAccountIdentifier;
    }
    return AccessTokenValue;
}());

//# sourceMappingURL=AccessTokenValue.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/packageMetadata.js
/* eslint-disable header/header */
var packageMetadata_name = "msal";
var version = "1.4.18";
//# sourceMappingURL=packageMetadata.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/ServerRequestParameters.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */





/**
 * Nonce: OIDC Nonce definition: https://openid.net/specs/openid-connect-core-1_0.html#IDToken
 * State: OAuth Spec: https://tools.ietf.org/html/rfc6749#section-10.12
 * @hidden
 */
var ServerRequestParameters = /** @class */ (function () {
    /**
     * Constructor
     * @param authority
     * @param clientId
     * @param scope
     * @param responseType
     * @param redirectUri
     * @param state
     */
    function ServerRequestParameters(authority, clientId, responseType, redirectUri, scopes, state, correlationId) {
        this.authorityInstance = authority;
        this.clientId = clientId;
        this.nonce = CryptoUtils.createNewGuid();
        // set scope to clientId if null
        this.scopes = scopes ? __spreadArrays(scopes) : Constants.oidcScopes;
        this.scopes = ScopeSet.trimScopes(this.scopes);
        // set state (already set at top level)
        this.state = state;
        // set correlationId
        this.correlationId = correlationId;
        // telemetry information
        this.xClientSku = "MSAL.JS";
        this.xClientVer = version;
        this.responseType = responseType;
        this.redirectUri = redirectUri;
    }
    Object.defineProperty(ServerRequestParameters.prototype, "authority", {
        get: function () {
            return this.authorityInstance ? this.authorityInstance.CanonicalAuthority : null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     * @ignore
     *
     * Utility to populate QueryParameters and ExtraQueryParameters to ServerRequestParamerers
     * @param request
     * @param serverAuthenticationRequest
     */
    ServerRequestParameters.prototype.populateQueryParams = function (account, request, adalIdTokenObject, silentCall) {
        var queryParameters = {};
        if (request) {
            // add the prompt parameter to serverRequestParameters if passed
            if (request.prompt) {
                this.promptValue = request.prompt;
            }
            // Add claims challenge to serverRequestParameters if passed
            if (request.claimsRequest) {
                this.claimsValue = request.claimsRequest;
            }
            // if the developer provides one of these, give preference to developer choice
            if (ServerRequestParameters.isSSOParam(request)) {
                queryParameters = this.constructUnifiedCacheQueryParameter(request, null);
            }
        }
        if (adalIdTokenObject) {
            queryParameters = this.constructUnifiedCacheQueryParameter(null, adalIdTokenObject);
        }
        /*
         * adds sid/login_hint if not populated
         * this.logger.verbose("Calling addHint parameters");
         */
        queryParameters = this.addHintParameters(account, queryParameters);
        // sanity check for developer passed extraQueryParameters
        var eQParams = request ? request.extraQueryParameters : null;
        // Populate the extraQueryParameters to be sent to the server
        this.queryParameters = ServerRequestParameters.generateQueryParametersString(queryParameters);
        this.extraQueryParameters = ServerRequestParameters.generateQueryParametersString(eQParams, silentCall);
    };
    // #region QueryParam helpers
    /**
     * Constructs extraQueryParameters to be sent to the server for the AuthenticationParameters set by the developer
     * in any login() or acquireToken() calls
     * @param idTokenObject
     * @param extraQueryParameters
     * @param sid
     * @param loginHint
     */
    // TODO: check how this behaves when domain_hint only is sent in extraparameters and idToken has no upn.
    ServerRequestParameters.prototype.constructUnifiedCacheQueryParameter = function (request, idTokenObject) {
        var _a;
        // preference order: account > sid > login_hint
        var ssoType;
        var ssoData;
        var serverReqParam = {};
        // if account info is passed, account.login_hint claim > account.sid > account.username
        if (request) {
            if (request.account) {
                var account = request.account;
                if ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.login_hint) {
                    ssoType = SSOTypes.LOGIN_HINT;
                    ssoData = account.idTokenClaims.login_hint;
                }
                else if (account.sid) {
                    ssoType = SSOTypes.SID;
                    ssoData = account.sid;
                }
                else if (account.userName) {
                    ssoType = SSOTypes.LOGIN_HINT;
                    ssoData = account.userName;
                }
            }
            // sid from request
            else if (request.sid) {
                ssoType = SSOTypes.SID;
                ssoData = request.sid;
            }
            // loginHint from request
            else if (request.loginHint) {
                ssoType = SSOTypes.LOGIN_HINT;
                ssoData = request.loginHint;
            }
        }
        // adalIdToken retrieved from cache
        else if (idTokenObject) {
            if (idTokenObject.hasOwnProperty(Constants.upn)) {
                ssoType = SSOTypes.ID_TOKEN;
                ssoData = idTokenObject["upn"];
            }
        }
        serverReqParam = this.addSSOParameter(ssoType, ssoData);
        return serverReqParam;
    };
    /**
     * @hidden
     *
     * Adds login_hint to authorization URL which is used to pre-fill the username field of sign in page for the user if known ahead of time
     * domain_hint if added skips the email based discovery process of the user - only supported for interactive calls in implicit_flow
     * domain_req utid received as part of the clientInfo
     * login_req uid received as part of clientInfo
     * Also does a sanity check for extraQueryParameters passed by the user to ensure no repeat queryParameters
     *
     * @param {@link Account} account - Account for which the token is requested
     * @param queryparams
     * @param {@link ServerRequestParameters}
     * @ignore
     */
    ServerRequestParameters.prototype.addHintParameters = function (account, params) {
        var _a, _b;
        /*
         * This is a final check for all queryParams added so far; preference order: sid > login_hint
         * sid cannot be passed along with login_hint or domain_hint, hence we check both are not populated yet in queryParameters
         */
        var qParams = params;
        if (account) {
            if (!qParams[SSOTypes.SID] && !qParams[SSOTypes.LOGIN_HINT]) {
                if ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.login_hint) {
                    // Use login_hint claim if available over sid or email/upn
                    qParams = this.addSSOParameter(SSOTypes.LOGIN_HINT, (_b = account.idTokenClaims) === null || _b === void 0 ? void 0 : _b.login_hint, qParams);
                }
                else if (account.sid && this.promptValue === PromptState.NONE) {
                    // sid - populate only if login_hint is not already populated and the account has sid
                    qParams = this.addSSOParameter(SSOTypes.SID, account.sid, qParams);
                }
                else if (account.userName) {
                    // Add username/upn as loginHint if nothing else available
                    qParams = this.addSSOParameter(SSOTypes.LOGIN_HINT, account.userName, qParams);
                }
            }
        }
        return qParams;
    };
    /**
     * Add SID to extraQueryParameters
     * @param sid
     */
    ServerRequestParameters.prototype.addSSOParameter = function (ssoType, ssoData, params) {
        var ssoParam = params || {};
        if (!ssoData) {
            return ssoParam;
        }
        switch (ssoType) {
            case SSOTypes.SID: {
                ssoParam[SSOTypes.SID] = ssoData;
                break;
            }
            case SSOTypes.ID_TOKEN: {
                ssoParam[SSOTypes.LOGIN_HINT] = ssoData;
                break;
            }
            case SSOTypes.LOGIN_HINT: {
                ssoParam[SSOTypes.LOGIN_HINT] = ssoData;
                break;
            }
        }
        return ssoParam;
    };
    /**
     * Utility to generate a QueryParameterString from a Key-Value mapping of extraQueryParameters passed
     * @param extraQueryParameters
     */
    ServerRequestParameters.generateQueryParametersString = function (queryParameters, silentCall) {
        var paramsString = null;
        if (queryParameters) {
            Object.keys(queryParameters).forEach(function (key) {
                // sid cannot be passed along with login_hint or domain_hint
                if (key === Constants.domain_hint && (silentCall || queryParameters[SSOTypes.SID])) {
                    return;
                }
                if (!paramsString) {
                    paramsString = key + "=" + encodeURIComponent(queryParameters[key]);
                }
                else {
                    paramsString += "&" + key + "=" + encodeURIComponent(queryParameters[key]);
                }
            });
        }
        return paramsString;
    };
    // #endregion
    /**
     * Check to see if there are SSO params set in the Request
     * @param request
     */
    ServerRequestParameters.isSSOParam = function (request) {
        return !!(request && (request.account || request.sid || request.loginHint));
    };
    /**
     * Returns the correct response_type string attribute for an acquireToken request configuration
     * @param accountsMatch boolean: Determines whether the account in the request matches the cached account
     * @param scopes Array<string>: AuthenticationRequest scopes configuration
     * @param loginScopesOnly boolean: True if the scopes array ONLY contains the clientId or any combination of OIDC scopes, without resource scopes
     */
    ServerRequestParameters.determineResponseType = function (accountsMatch, scopes) {
        // Supports getting an id_token by sending in clientId as only scope or OIDC scopes as only scopes
        if (ScopeSet.onlyContainsOidcScopes(scopes)) {
            return ResponseTypes.id_token;
        }
        // If accounts match, check if OIDC scopes are included, otherwise return id_token_token
        return (accountsMatch) ? this.responseTypeForMatchingAccounts(scopes) : ResponseTypes.id_token_token;
    };
    /**
     * Returns the correct response_type string attribute for an acquireToken request configuration that contains an
     * account that matches the account in the MSAL cache.
     * @param scopes Array<string>: AuthenticationRequest scopes configuration
     */
    ServerRequestParameters.responseTypeForMatchingAccounts = function (scopes) {
        // Opt-into also requesting an ID token by sending in 'openid', 'profile' or both along with resource scopes when login is not necessary.
        return (ScopeSet.containsAnyOidcScopes(scopes)) ? ResponseTypes.id_token_token : ResponseTypes.token;
    };
    return ServerRequestParameters;
}());

//# sourceMappingURL=ServerRequestParameters.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/XHRClient.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * XHR client for JSON endpoints
 * https://www.npmjs.com/package/async-promise
 * @hidden
 */
var XhrClient = /** @class */ (function () {
    function XhrClient() {
    }
    XhrClient.prototype.sendRequestAsync = function (url, method, enableCaching) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, /* async: */ true);
            if (enableCaching) {
                /*
                 * TODO: (shivb) ensure that this can be cached
                 * xhr.setRequestHeader("Cache-Control", "Public");
                 */
            }
            xhr.onload = function () {
                if (xhr.status < 200 || xhr.status >= 300) {
                    reject(_this.handleError(xhr.responseText));
                }
                var jsonResponse;
                try {
                    jsonResponse = JSON.parse(xhr.responseText);
                }
                catch (e) {
                    reject(_this.handleError(xhr.responseText));
                }
                var response = {
                    statusCode: xhr.status,
                    body: jsonResponse
                };
                resolve(response);
            };
            xhr.onerror = function () {
                reject(xhr.status);
            };
            if (method === NetworkRequestType.GET) {
                xhr.send();
            }
            else {
                throw "not implemented";
            }
        });
    };
    XhrClient.prototype.handleError = function (responseText) {
        var jsonResponse;
        try {
            jsonResponse = JSON.parse(responseText);
            if (jsonResponse["error"]) {
                return jsonResponse["error"];
            }
            else {
                throw responseText;
            }
        }
        catch (e) {
            return responseText;
        }
    };
    return XhrClient;
}());

//# sourceMappingURL=XHRClient.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/authority/TrustedAuthority.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var TrustedAuthority = /** @class */ (function () {
    function TrustedAuthority() {
    }
    /**
     *
     * @param validateAuthority
     * @param knownAuthorities
     */
    TrustedAuthority.setTrustedAuthoritiesFromConfig = function (validateAuthority, knownAuthorities) {
        if (validateAuthority && !this.getTrustedHostList().length) {
            knownAuthorities.forEach(function (authority) {
                TrustedAuthority.TrustedHostList.push(authority.toLowerCase());
            });
        }
    };
    /**
     *
     * @param telemetryManager
     * @param correlationId
     */
    TrustedAuthority.getAliases = function (authorityToVerify, telemetryManager, correlationId) {
        return __awaiter(this, void 0, void 0, function () {
            var client, httpMethod, instanceDiscoveryEndpoint, httpEvent;
            return __generator(this, function (_a) {
                client = new XhrClient();
                httpMethod = NetworkRequestType.GET;
                instanceDiscoveryEndpoint = "" + AAD_INSTANCE_DISCOVERY_ENDPOINT + authorityToVerify + "oauth2/v2.0/authorize";
                httpEvent = telemetryManager.createAndStartHttpEvent(correlationId, httpMethod, instanceDiscoveryEndpoint, "getAliases");
                return [2 /*return*/, client.sendRequestAsync(instanceDiscoveryEndpoint, httpMethod, true)
                        .then(function (response) {
                        httpEvent.httpResponseStatus = response.statusCode;
                        telemetryManager.stopEvent(httpEvent);
                        return response.body["metadata"];
                    })
                        .catch(function (err) {
                        httpEvent.serverErrorCode = err;
                        telemetryManager.stopEvent(httpEvent);
                        throw err;
                    })];
            });
        });
    };
    /**
     *
     * @param telemetryManager
     * @param correlationId
     */
    TrustedAuthority.setTrustedAuthoritiesFromNetwork = function (authorityToVerify, telemetryManager, correlationId) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, host;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAliases(authorityToVerify, telemetryManager, correlationId)];
                    case 1:
                        metadata = _a.sent();
                        metadata.forEach(function (entry) {
                            var authorities = entry["aliases"];
                            authorities.forEach(function (authority) {
                                TrustedAuthority.TrustedHostList.push(authority.toLowerCase());
                            });
                        });
                        host = UrlUtils.GetUrlComponents(authorityToVerify).HostNameAndPort;
                        if (TrustedAuthority.getTrustedHostList().length && !TrustedAuthority.IsInTrustedHostList(host)) {
                            // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
                            TrustedAuthority.TrustedHostList.push(host.toLowerCase());
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TrustedAuthority.getTrustedHostList = function () {
        return this.TrustedHostList;
    };
    /**
     * Checks to see if the host is in a list of trusted hosts
     * @param host
     */
    TrustedAuthority.IsInTrustedHostList = function (host) {
        return this.TrustedHostList.indexOf(host.toLowerCase()) > -1;
    };
    TrustedAuthority.TrustedHostList = [];
    return TrustedAuthority;
}());

//# sourceMappingURL=TrustedAuthority.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/authority/Authority.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */






/**
 * @hidden
 */
var AuthorityType;
(function (AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
})(AuthorityType || (AuthorityType = {}));
/**
 * @hidden
 */
var Authority = /** @class */ (function () {
    function Authority(authority, validateAuthority, authorityMetadata) {
        this.IsValidationEnabled = validateAuthority;
        this.CanonicalAuthority = authority;
        this.validateAsUri();
        this.tenantDiscoveryResponse = authorityMetadata;
    }
    Authority.isAdfs = function (authorityUrl) {
        var components = UrlUtils.GetUrlComponents(authorityUrl);
        var pathSegments = components.PathSegments;
        return (pathSegments.length && pathSegments[0].toLowerCase() === Constants.ADFS);
    };
    Object.defineProperty(Authority.prototype, "AuthorityType", {
        get: function () {
            return Authority.isAdfs(this.canonicalAuthority) ? AuthorityType.Adfs : AuthorityType.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "Tenant", {
        get: function () {
            return this.CanonicalAuthorityUrlComponents.PathSegments[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "AuthorizationEndpoint", {
        get: function () {
            this.validateResolved();
            return this.tenantDiscoveryResponse.AuthorizationEndpoint.replace(/{tenant}|{tenantid}/g, this.Tenant);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "EndSessionEndpoint", {
        get: function () {
            this.validateResolved();
            return this.tenantDiscoveryResponse.EndSessionEndpoint.replace(/{tenant}|{tenantid}/g, this.Tenant);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "SelfSignedJwtAudience", {
        get: function () {
            this.validateResolved();
            return this.tenantDiscoveryResponse.Issuer.replace(/{tenant}|{tenantid}/g, this.Tenant);
        },
        enumerable: false,
        configurable: true
    });
    Authority.prototype.validateResolved = function () {
        if (!this.hasCachedMetadata()) {
            throw "Please call ResolveEndpointsAsync first";
        }
    };
    Object.defineProperty(Authority.prototype, "CanonicalAuthority", {
        /**
         * A URL that is the authority set by the developer
         */
        get: function () {
            return this.canonicalAuthority;
        },
        set: function (url) {
            this.canonicalAuthority = UrlUtils.CanonicalizeUri(url);
            this.canonicalAuthorityUrlComponents = null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "CanonicalAuthorityUrlComponents", {
        get: function () {
            if (!this.canonicalAuthorityUrlComponents) {
                this.canonicalAuthorityUrlComponents = UrlUtils.GetUrlComponents(this.CanonicalAuthority);
            }
            return this.canonicalAuthorityUrlComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "DefaultOpenIdConfigurationEndpoint", {
        // http://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
        get: function () {
            return (this.AuthorityType === AuthorityType.Adfs) ? "" + this.CanonicalAuthority + WELL_KNOWN_SUFFIX : this.CanonicalAuthority + "v2.0/" + WELL_KNOWN_SUFFIX;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Given a string, validate that it is of the form https://domain/path
     */
    Authority.prototype.validateAsUri = function () {
        var components;
        try {
            components = this.CanonicalAuthorityUrlComponents;
        }
        catch (e) {
            throw ClientConfigurationErrorMessage.invalidAuthorityType;
        }
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") {
            throw ClientConfigurationErrorMessage.authorityUriInsecure;
        }
        if (!components.PathSegments || components.PathSegments.length < 1) {
            throw ClientConfigurationErrorMessage.authorityUriInvalidPath;
        }
    };
    /**
     * Calls the OIDC endpoint and returns the response
     */
    Authority.prototype.DiscoverEndpoints = function (openIdConfigurationEndpoint, telemetryManager, correlationId) {
        var client = new XhrClient();
        var httpMethod = NetworkRequestType.GET;
        var httpEvent = telemetryManager.createAndStartHttpEvent(correlationId, httpMethod, openIdConfigurationEndpoint, "openIdConfigurationEndpoint");
        return client.sendRequestAsync(openIdConfigurationEndpoint, httpMethod, /* enableCaching: */ true)
            .then(function (response) {
            httpEvent.httpResponseStatus = response.statusCode;
            telemetryManager.stopEvent(httpEvent);
            return {
                AuthorizationEndpoint: response.body["authorization_endpoint"],
                EndSessionEndpoint: response.body["end_session_endpoint"],
                Issuer: response.body["issuer"]
            };
        })
            .catch(function (err) {
            httpEvent.serverErrorCode = err;
            telemetryManager.stopEvent(httpEvent);
            throw err;
        });
    };
    /**
     * Returns a promise.
     * Checks to see if the authority is in the cache
     * Discover endpoints via openid-configuration
     * If successful, caches the endpoint for later use in OIDC
     */
    Authority.prototype.resolveEndpointsAsync = function (telemetryManager, correlationId) {
        return __awaiter(this, void 0, void 0, function () {
            var host, openIdConfigurationEndpointResponse, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.IsValidationEnabled) return [3 /*break*/, 3];
                        host = this.canonicalAuthorityUrlComponents.HostNameAndPort;
                        if (!(TrustedAuthority.getTrustedHostList().length === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, TrustedAuthority.setTrustedAuthoritiesFromNetwork(this.canonicalAuthority, telemetryManager, correlationId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!TrustedAuthority.IsInTrustedHostList(host)) {
                            throw ClientConfigurationError.createUntrustedAuthorityError(host);
                        }
                        _b.label = 3;
                    case 3:
                        openIdConfigurationEndpointResponse = this.GetOpenIdConfigurationEndpoint();
                        _a = this;
                        return [4 /*yield*/, this.DiscoverEndpoints(openIdConfigurationEndpointResponse, telemetryManager, correlationId)];
                    case 4:
                        _a.tenantDiscoveryResponse = _b.sent();
                        return [2 /*return*/, this.tenantDiscoveryResponse];
                }
            });
        });
    };
    /**
     * Checks if there is a cached tenant discovery response with required fields.
     */
    Authority.prototype.hasCachedMetadata = function () {
        return !!(this.tenantDiscoveryResponse &&
            this.tenantDiscoveryResponse.AuthorizationEndpoint &&
            this.tenantDiscoveryResponse.EndSessionEndpoint &&
            this.tenantDiscoveryResponse.Issuer);
    };
    /**
     * Returns a promise which resolves to the OIDC endpoint
     * Only responds with the endpoint
     */
    Authority.prototype.GetOpenIdConfigurationEndpoint = function () {
        return this.DefaultOpenIdConfigurationEndpoint;
    };
    return Authority;
}());

//# sourceMappingURL=Authority.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/ClientInfo.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



/**
 * @hidden
 */
var ClientInfo = /** @class */ (function () {
    function ClientInfo(rawClientInfo, authority) {
        if (!rawClientInfo || StringUtils.isEmpty(rawClientInfo)) {
            this.uid = "";
            this.utid = "";
            return;
        }
        try {
            var decodedClientInfo = CryptoUtils.base64Decode(rawClientInfo);
            var clientInfo = JSON.parse(decodedClientInfo);
            if (clientInfo) {
                if (clientInfo.hasOwnProperty("uid")) {
                    this.uid = authority ? ClientInfo.stripPolicyFromUid(clientInfo.uid, authority) : clientInfo.uid;
                }
                if (clientInfo.hasOwnProperty("utid")) {
                    this.utid = clientInfo.utid;
                }
            }
        }
        catch (e) {
            throw ClientAuthError.createClientInfoDecodingError(e);
        }
    }
    Object.defineProperty(ClientInfo.prototype, "uid", {
        get: function () {
            return this._uid ? this._uid : "";
        },
        set: function (uid) {
            this._uid = uid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientInfo.prototype, "utid", {
        get: function () {
            return this._utid ? this._utid : "";
        },
        set: function (utid) {
            this._utid = utid;
        },
        enumerable: false,
        configurable: true
    });
    ClientInfo.createClientInfoFromIdToken = function (idToken, authority) {
        var clientInfo = {
            uid: idToken.subject,
            utid: ""
        };
        return new ClientInfo(CryptoUtils.base64Encode(JSON.stringify(clientInfo)), authority);
    };
    ClientInfo.stripPolicyFromUid = function (uid, authority) {
        var uidSegments = uid.split("-");
        // Reverse the url segments so the last one is more easily accessible
        var urlSegments = authority.split("/").reverse();
        var policy = "";
        if (!StringUtils.isEmpty(urlSegments[0])) {
            policy = urlSegments[0];
        }
        else if (urlSegments.length > 1) {
            // If the original url had a trailing slash, urlSegments[0] would be "" so take the next element
            policy = urlSegments[1];
        }
        if (uidSegments[uidSegments.length - 1] === policy) {
            // If the last segment of uid matches the last segment of authority url, remove the last segment of uid
            return uidSegments.slice(0, uidSegments.length - 1).join("-");
        }
        return uid;
    };
    ClientInfo.prototype.encodeClientInfo = function () {
        var clientInfo = JSON.stringify({ uid: this.uid, utid: this.utid });
        return CryptoUtils.base64Encode(clientInfo);
    };
    return ClientInfo;
}());

//# sourceMappingURL=ClientInfo.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/TimeUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var TimeUtils = /** @class */ (function () {
    function TimeUtils() {
    }
    /**
     * Returns time in seconds for expiration based on string value passed in.
     *
     * @param expiresIn
     */
    TimeUtils.parseExpiresIn = function (expiresIn) {
        // if AAD did not send "expires_in" property, use default expiration of 3599 seconds, for some reason AAD sends 3599 as "expires_in" value instead of 3600
        var expires = expiresIn || "3599";
        return parseInt(expires, 10);
    };
    /**
     * Return the current time in Unix time (seconds). Date.getTime() returns in milliseconds.
     */
    TimeUtils.now = function () {
        return Math.round(new Date().getTime() / 1000.0);
    };
    /**
     * Returns the amount of time in milliseconds since the page loaded.
     */
    TimeUtils.relativeNowMs = function () {
        return window.performance.now();
    };
    return TimeUtils;
}());

//# sourceMappingURL=TimeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/TokenUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



/**
 * @hidden
 */
var TokenUtils = /** @class */ (function () {
    function TokenUtils() {
    }
    /**
     * decode a JWT
     *
     * @param jwtToken
     */
    TokenUtils.decodeJwt = function (jwtToken) {
        if (StringUtils.isEmpty(jwtToken)) {
            return null;
        }
        var idTokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = idTokenPartsRegex.exec(jwtToken);
        if (!matches || matches.length < 4) {
            // this._requestContext.logger.warn("The returned id_token is not parseable.");
            return null;
        }
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    /**
     * Evaluates whether token cache item expiration is within expiration offset range
     * @param tokenCacheItem
     */
    TokenUtils.validateExpirationIsWithinOffset = function (expiration, tokenRenewalOffsetSeconds) {
        var offset = tokenRenewalOffsetSeconds || 300;
        return expiration && (expiration > TimeUtils.now() + offset);
    };
    /**
     * Extract IdToken by decoding the RAWIdToken
     *
     * @param encodedIdToken
     */
    TokenUtils.extractIdToken = function (encodedIdToken) {
        // id token will be decoded to get the username
        var decodedToken = this.decodeJwt(encodedIdToken);
        if (!decodedToken) {
            return null;
        }
        try {
            var base64IdToken = decodedToken["JWSPayload"];
            var base64Decoded = CryptoUtils.base64Decode(base64IdToken);
            if (!base64Decoded) {
                // this._requestContext.logger.info("The returned id_token could not be base64 url safe decoded.");
                return null;
            }
            // ECMA script has JSON built-in support
            return JSON.parse(base64Decoded);
        }
        catch (err) {
            // this._requestContext.logger.error("The returned id_token could not be decoded" + err);
        }
        return null;
    };
    return TokenUtils;
}());

//# sourceMappingURL=TokenUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/IdToken.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



/**
 * @hidden
 */
var IdToken = /** @class */ (function () {
    /* tslint:disable:no-string-literal */
    function IdToken(rawIdToken) {
        if (StringUtils.isEmpty(rawIdToken)) {
            throw ClientAuthError.createIdTokenNullOrEmptyError(rawIdToken);
        }
        try {
            this.rawIdToken = rawIdToken;
            this.claims = TokenUtils.extractIdToken(rawIdToken);
            if (this.claims) {
                if (this.claims.hasOwnProperty("iss")) {
                    this.issuer = this.claims["iss"];
                }
                if (this.claims.hasOwnProperty("oid")) {
                    this.objectId = this.claims["oid"];
                }
                if (this.claims.hasOwnProperty("sub")) {
                    this.subject = this.claims["sub"];
                }
                if (this.claims.hasOwnProperty("tid")) {
                    this.tenantId = this.claims["tid"];
                }
                if (this.claims.hasOwnProperty("ver")) {
                    this.version = this.claims["ver"];
                }
                if (this.claims.hasOwnProperty("preferred_username")) {
                    this.preferredName = this.claims["preferred_username"];
                }
                else if (this.claims.hasOwnProperty("upn")) {
                    this.preferredName = this.claims["upn"];
                }
                if (this.claims.hasOwnProperty("name")) {
                    this.name = this.claims["name"];
                }
                if (this.claims.hasOwnProperty("nonce")) {
                    this.nonce = this.claims["nonce"];
                }
                if (this.claims.hasOwnProperty("exp")) {
                    this.expiration = this.claims["exp"];
                }
                if (this.claims.hasOwnProperty("home_oid")) {
                    this.homeObjectId = this.claims["home_oid"];
                }
                if (this.claims.hasOwnProperty("sid")) {
                    this.sid = this.claims["sid"];
                }
                if (this.claims.hasOwnProperty("cloud_instance_host_name")) {
                    this.cloudInstance = this.claims["cloud_instance_host_name"];
                }
                /* tslint:enable:no-string-literal */
            }
        }
        catch (e) {
            /*
             * TODO: This error here won't really every be thrown, since extractIdToken() returns null if the decodeJwt() fails.
             * Need to add better error handling here to account for being unable to decode jwts.
             */
            throw ClientAuthError.createIdTokenParsingError(e);
        }
    }
    return IdToken;
}());

//# sourceMappingURL=IdToken.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/cache/AccessTokenCacheItem.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var AccessTokenCacheItem = /** @class */ (function () {
    function AccessTokenCacheItem(key, value) {
        this.key = key;
        this.value = value;
    }
    return AccessTokenCacheItem;
}());

//# sourceMappingURL=AccessTokenCacheItem.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/cache/BrowserStorage.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/**
 * @hidden
 */
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(cacheLocation) {
        if (!window) {
            throw AuthError.createNoWindowObjectError("Browser storage class could not find window object");
        }
        var storageSupported = typeof window[cacheLocation] !== "undefined" && window[cacheLocation] !== null;
        if (!storageSupported) {
            throw ClientConfigurationError.createStorageNotSupportedError(cacheLocation);
        }
        this.cacheLocation = cacheLocation;
    }
    /**
     * add value to storage
     * @param key
     * @param value
     * @param enableCookieStorage
     */
    BrowserStorage.prototype.setItem = function (key, value, enableCookieStorage) {
        window[this.cacheLocation].setItem(key, value);
        if (enableCookieStorage) {
            this.setItemCookie(key, value);
        }
    };
    /**
     * get one item by key from storage
     * @param key
     * @param enableCookieStorage
     */
    BrowserStorage.prototype.getItem = function (key, enableCookieStorage) {
        if (enableCookieStorage && this.getItemCookie(key)) {
            return this.getItemCookie(key);
        }
        return window[this.cacheLocation].getItem(key);
    };
    /**
     * remove value from storage
     * @param key
     */
    BrowserStorage.prototype.removeItem = function (key) {
        return window[this.cacheLocation].removeItem(key);
    };
    /**
     * clear storage (remove all items from it)
     */
    BrowserStorage.prototype.clear = function () {
        return window[this.cacheLocation].clear();
    };
    /**
     * add value to cookies
     * @param cName
     * @param cValue
     * @param expires
     */
    BrowserStorage.prototype.setItemCookie = function (cName, cValue, expires) {
        var cookieStr = encodeURIComponent(cName) + "=" + encodeURIComponent(cValue) + ";path=/;";
        if (expires) {
            var expireTime = this.getCookieExpirationTime(expires);
            cookieStr += "expires=" + expireTime + ";";
        }
        document.cookie = cookieStr;
    };
    /**
     * get one item by key from cookies
     * @param cName
     */
    BrowserStorage.prototype.getItemCookie = function (cName) {
        var name = encodeURIComponent(cName) + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return decodeURIComponent(c.substring(name.length, c.length));
            }
        }
        return "";
    };
    /**
     * Clear an item in the cookies by key
     * @param cName
     */
    BrowserStorage.prototype.clearItemCookie = function (cName) {
        this.setItemCookie(cName, "", -1);
    };
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     */
    BrowserStorage.prototype.getCookieExpirationTime = function (cookieLifeDays) {
        var today = new Date();
        var expr = new Date(today.getTime() + cookieLifeDays * 24 * 60 * 60 * 1000);
        return expr.toUTCString();
    };
    return BrowserStorage;
}());

//# sourceMappingURL=BrowserStorage.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/RequestUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */








/**
 * @hidden
 */
var RequestUtils = /** @class */ (function () {
    function RequestUtils() {
    }
    /**
     * @ignore
     *
     * @param request
     * @param isLoginCall
     * @param cacheStorage
     * @param clientId
     *
     * validates all request parameters and generates a consumable request object
     */
    RequestUtils.validateRequest = function (request, isLoginCall, clientId, interactionType) {
        // Throw error if request is empty for acquire * calls
        if (!isLoginCall && !request) {
            throw ClientConfigurationError.createEmptyRequestError();
        }
        var scopes;
        var extraQueryParameters;
        if (request) {
            // if extraScopesToConsent is passed in loginCall, append them to the login request; Validate and filter scopes (the validate function will throw if validation fails)
            scopes = isLoginCall ? ScopeSet.appendScopes(request.scopes, request.extraScopesToConsent) : request.scopes;
            ScopeSet.validateInputScope(scopes, !isLoginCall);
            scopes = ScopeSet.translateClientIdIfSingleScope(scopes, clientId);
            // validate prompt parameter
            this.validatePromptParameter(request.prompt);
            // validate extraQueryParameters
            extraQueryParameters = this.validateEQParameters(request.extraQueryParameters, request.claimsRequest);
            // validate claimsRequest
            this.validateClaimsRequest(request.claimsRequest);
        }
        // validate and generate state and correlationId
        var state = this.validateAndGenerateState(request && request.state, interactionType);
        var correlationId = this.validateAndGenerateCorrelationId(request && request.correlationId);
        var validatedRequest = __assign(__assign({}, request), { extraQueryParameters: extraQueryParameters,
            scopes: scopes,
            state: state,
            correlationId: correlationId });
        return validatedRequest;
    };
    /**
     * @ignore
     *
     * Utility to test if valid prompt value is passed in the request
     * @param request
     */
    RequestUtils.validatePromptParameter = function (prompt) {
        if (prompt) {
            if ([PromptState.LOGIN, PromptState.SELECT_ACCOUNT, PromptState.CONSENT, PromptState.NONE].indexOf(prompt) < 0) {
                throw ClientConfigurationError.createInvalidPromptError(prompt);
            }
        }
    };
    /**
     * @ignore
     *
     * Removes unnecessary or duplicate query parameters from extraQueryParameters
     * @param request
     */
    RequestUtils.validateEQParameters = function (extraQueryParameters, claimsRequest) {
        var eQParams = __assign({}, extraQueryParameters);
        if (!eQParams) {
            return null;
        }
        if (claimsRequest) {
            // this.logger.warning("Removed duplicate claims from extraQueryParameters. Please use either the claimsRequest field OR pass as extraQueryParameter - not both.");
            delete eQParams[Constants.claims];
        }
        DisallowedEQParams.forEach(function (param) {
            if (eQParams[param]) {
                // this.logger.warning("Removed duplicate " + param + " from extraQueryParameters. Please use the " + param + " field in request object.");
                delete eQParams[param];
            }
        });
        return eQParams;
    };
    /**
     * @ignore
     *
     * Validates the claims passed in request is a JSON
     * TODO: More validation will be added when the server team tells us how they have actually implemented claims
     * @param claimsRequest
     */
    RequestUtils.validateClaimsRequest = function (claimsRequest) {
        if (!claimsRequest) {
            return;
        }
        try {
            JSON.parse(claimsRequest);
        }
        catch (e) {
            throw ClientConfigurationError.createClaimsRequestParsingError(e);
        }
    };
    /**
     * @ignore
     *
     * generate unique state per request
     * @param userState User-provided state value
     * @returns State string include library state and user state
     */
    RequestUtils.validateAndGenerateState = function (userState, interactionType) {
        return !StringUtils.isEmpty(userState) ? "" + RequestUtils.generateLibraryState(interactionType) + Constants.resourceDelimiter + userState : RequestUtils.generateLibraryState(interactionType);
    };
    /**
     * Generates the state value used by the library.
     *
     * @returns Base64 encoded string representing the state
     */
    RequestUtils.generateLibraryState = function (interactionType) {
        var stateObject = {
            id: CryptoUtils.createNewGuid(),
            ts: TimeUtils.now(),
            method: interactionType
        };
        var stateString = JSON.stringify(stateObject);
        return CryptoUtils.base64Encode(stateString);
    };
    /**
     * Decodes the state value into a StateObject
     *
     * @param state State value returned in the request
     * @returns Parsed values from the encoded state value
     */
    RequestUtils.parseLibraryState = function (state) {
        var libraryState = decodeURIComponent(state).split(Constants.resourceDelimiter)[0];
        if (CryptoUtils.isGuid(libraryState)) {
            // If state is guid, assume timestamp is now and is redirect, as redirect should be only method where this can happen.
            return {
                id: libraryState,
                ts: TimeUtils.now(),
                method: Constants.interactionTypeRedirect
            };
        }
        try {
            var stateString = CryptoUtils.base64Decode(libraryState);
            var stateObject = JSON.parse(stateString);
            return stateObject;
        }
        catch (e) {
            throw ClientAuthError.createInvalidStateError(state, null);
        }
    };
    /**
     * @ignore
     *
     * validate correlationId and generate if not valid or not set by the user
     * @param correlationId
     */
    RequestUtils.validateAndGenerateCorrelationId = function (correlationId) {
        // validate user set correlationId or set one for the user if null
        if (correlationId && !CryptoUtils.isGuid(correlationId)) {
            throw ClientConfigurationError.createInvalidCorrelationIdError();
        }
        return CryptoUtils.isGuid(correlationId) ? correlationId : CryptoUtils.createNewGuid();
    };
    /**
     * Create a request signature
     * @param request
     */
    RequestUtils.createRequestSignature = function (request) {
        return "" + request.scopes.join(" ").toLowerCase() + Constants.resourceDelimiter + request.authority;
    };
    return RequestUtils;
}());

//# sourceMappingURL=RequestUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/cache/AuthCache.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */








/**
 * @hidden
 */
var AuthCache = /** @class */ (function (_super) {
    __extends(AuthCache, _super);
    function AuthCache(clientId, cacheLocation, storeAuthStateInCookie) {
        var _this = _super.call(this, cacheLocation) || this;
        _this.temporaryCache = new BrowserStorage(SESSION_STORAGE);
        _this.clientId = clientId;
        // This is hardcoded to true for now. We may make this configurable in the future
        _this.rollbackEnabled = true;
        _this.migrateCacheEntries(storeAuthStateInCookie);
        return _this;
    }
    /**
     * Support roll back to old cache schema until the next major release: true by default now
     * @param storeAuthStateInCookie
     */
    AuthCache.prototype.migrateCacheEntries = function (storeAuthStateInCookie) {
        var _this = this;
        var idTokenKey = Constants.cachePrefix + "." + PersistentCacheKeys.IDTOKEN;
        var clientInfoKey = Constants.cachePrefix + "." + PersistentCacheKeys.CLIENT_INFO;
        var errorKey = Constants.cachePrefix + "." + ErrorCacheKeys.ERROR;
        var errorDescKey = Constants.cachePrefix + "." + ErrorCacheKeys.ERROR_DESC;
        var idTokenValue = _super.prototype.getItem.call(this, idTokenKey);
        var idToken;
        if (idTokenValue) {
            try {
                idToken = new IdToken(idTokenValue);
            }
            catch (e) {
                return;
            }
        }
        if (idToken && idToken.claims && idToken.claims.aud === this.clientId) {
            var clientInfoValue = _super.prototype.getItem.call(this, clientInfoKey);
            var errorValue = _super.prototype.getItem.call(this, errorKey);
            var errorDescValue = _super.prototype.getItem.call(this, errorDescKey);
            var values_1 = [idTokenValue, clientInfoValue, errorValue, errorDescValue];
            var keysToMigrate = [PersistentCacheKeys.IDTOKEN, PersistentCacheKeys.CLIENT_INFO, ErrorCacheKeys.ERROR, ErrorCacheKeys.ERROR_DESC];
            keysToMigrate.forEach(function (cacheKey, index) { return _this.duplicateCacheEntry(cacheKey, values_1[index], storeAuthStateInCookie); });
        }
    };
    /**
     * Utility function to help with roll back keys
     * @param newKey
     * @param value
     * @param storeAuthStateInCookie
     */
    AuthCache.prototype.duplicateCacheEntry = function (newKey, value, storeAuthStateInCookie) {
        if (value) {
            this.setItem(newKey, value, storeAuthStateInCookie);
        }
    };
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */
    AuthCache.prototype.generateCacheKey = function (key, addInstanceId) {
        try {
            // Defined schemas do not need the key appended
            JSON.parse(key);
            return key;
        }
        catch (e) {
            if (key.indexOf("" + Constants.cachePrefix) === 0 || key.indexOf(Constants.adalIdToken) === 0) {
                return key;
            }
            return addInstanceId ? Constants.cachePrefix + "." + this.clientId + "." + key : Constants.cachePrefix + "." + key;
        }
    };
    /**
     * Validates that the input cache key contains the account search terms (clientId and homeAccountIdentifier) and
     * then whether or not it contains the "scopes", depending on the token type being searched for. With matching account
     * search terms, Access Token search tries to match the "scopes" keyword, while Id Token search expects "scopes" to not be included.
     * @param key
     * @param clientId
     * @param homeAccountIdentifier
     * @param tokenType
     */
    AuthCache.prototype.matchKeyForType = function (key, clientId, homeAccountIdentifier, tokenType) {
        // All valid token cache item keys are valid JSON objects, ignore keys that aren't
        var parsedKey = StringUtils.validateAndParseJsonCacheKey(key);
        if (!parsedKey) {
            return null;
        }
        // Does the cache item match the request account
        var accountMatches = key.match(clientId) && key.match(homeAccountIdentifier);
        // Does the cache item match the requested token type
        var tokenTypeMatches = false;
        switch (tokenType) {
            case ServerHashParamKeys.ACCESS_TOKEN:
                // Cache item is an access token if scopes are included in the cache item key
                tokenTypeMatches = !!key.match(Constants.scopes);
                break;
            case ServerHashParamKeys.ID_TOKEN:
                // Cache may be an ID token if scopes are NOT included in the cache item key
                tokenTypeMatches = !key.match(Constants.scopes);
                break;
        }
        return (accountMatches && tokenTypeMatches) ? parsedKey : null;
    };
    /**
     * add value to storage
     * @param key
     * @param value
     * @param enableCookieStorage
     */
    AuthCache.prototype.setItem = function (key, value, enableCookieStorage) {
        _super.prototype.setItem.call(this, this.generateCacheKey(key, true), value, enableCookieStorage);
        // Values stored in cookies will have rollback disabled to minimize cookie length
        if (this.rollbackEnabled && !enableCookieStorage) {
            _super.prototype.setItem.call(this, this.generateCacheKey(key, false), value, enableCookieStorage);
        }
    };
    /**
     * get one item by key from storage
     * @param key
     * @param enableCookieStorage
     */
    AuthCache.prototype.getItem = function (key, enableCookieStorage) {
        return _super.prototype.getItem.call(this, this.generateCacheKey(key, true), enableCookieStorage);
    };
    /**
     * remove value from storage
     * @param key
     */
    AuthCache.prototype.removeItem = function (key) {
        this.temporaryCache.removeItem(this.generateCacheKey(key, true));
        _super.prototype.removeItem.call(this, this.generateCacheKey(key, true));
        if (this.rollbackEnabled) {
            _super.prototype.removeItem.call(this, this.generateCacheKey(key, false));
        }
    };
    /**
     * Sets temporary cache value
     * @param key
     * @param value
     * @param enableCookieStorage
     */
    AuthCache.prototype.setTemporaryItem = function (key, value, enableCookieStorage) {
        this.temporaryCache.setItem(this.generateCacheKey(key, true), value, enableCookieStorage);
    };
    /**
     * Gets temporary cache value
     * @param key
     * @param enableCookieStorage
     */
    AuthCache.prototype.getTemporaryItem = function (key, enableCookieStorage) {
        return this.temporaryCache.getItem(this.generateCacheKey(key, true), enableCookieStorage);
    };
    /**
     * Reset the cache items
     */
    AuthCache.prototype.resetCacheItems = function () {
        var storage = window[this.cacheLocation];
        var key;
        for (key in storage) {
            // Check if key contains msal prefix; For now, we are clearing all cache items created by MSAL.js
            if (storage.hasOwnProperty(key) && (key.indexOf(Constants.cachePrefix) !== -1)) {
                _super.prototype.removeItem.call(this, key);
                // TODO: Clear cache based on client id (clarify use cases where this is needed)
            }
        }
    };
    /**
     * Reset all temporary cache items
     */
    AuthCache.prototype.resetTempCacheItems = function (state) {
        var _this = this;
        var stateId = state && RequestUtils.parseLibraryState(state).id;
        var isTokenRenewalInProgress = this.tokenRenewalInProgress(state);
        var storage = window[this.cacheLocation];
        // check state and remove associated cache
        if (stateId && !isTokenRenewalInProgress) {
            Object.keys(storage).forEach(function (key) {
                if (key.indexOf(stateId) !== -1) {
                    _this.removeItem(key);
                    _super.prototype.clearItemCookie.call(_this, key);
                }
            });
        }
        // delete the interaction status cache
        this.setInteractionInProgress(false);
        this.removeItem(TemporaryCacheKeys.REDIRECT_REQUEST);
    };
    /**
     * Set cookies for IE
     * @param cName
     * @param cValue
     * @param expires
     */
    AuthCache.prototype.setItemCookie = function (cName, cValue, expires) {
        _super.prototype.setItemCookie.call(this, this.generateCacheKey(cName, true), cValue, expires);
        if (this.rollbackEnabled) {
            _super.prototype.setItemCookie.call(this, this.generateCacheKey(cName, false), cValue, expires);
        }
    };
    AuthCache.prototype.clearItemCookie = function (cName) {
        _super.prototype.clearItemCookie.call(this, this.generateCacheKey(cName, true));
        if (this.rollbackEnabled) {
            _super.prototype.clearItemCookie.call(this, this.generateCacheKey(cName, false));
        }
    };
    /**
     * get one item by key from cookies
     * @param cName
     */
    AuthCache.prototype.getItemCookie = function (cName) {
        return _super.prototype.getItemCookie.call(this, this.generateCacheKey(cName, true));
    };
    /**
     * Get all tokens of a certain type from the cache
     * @param clientId
     * @param homeAccountIdentifier
     * @param tokenType
     */
    AuthCache.prototype.getAllTokensByType = function (clientId, homeAccountIdentifier, tokenType) {
        var _this = this;
        var results = Object.keys(window[this.cacheLocation]).reduce(function (tokens, key) {
            var matchedTokenKey = _this.matchKeyForType(key, clientId, homeAccountIdentifier, tokenType);
            if (matchedTokenKey) {
                var value = _this.getItem(key);
                if (value) {
                    try {
                        var newAccessTokenCacheItem = new AccessTokenCacheItem(matchedTokenKey, JSON.parse(value));
                        return tokens.concat([newAccessTokenCacheItem]);
                    }
                    catch (err) {
                        // Skip cache items with non-valid JSON values
                        return tokens;
                    }
                }
            }
            return tokens;
        }, []);
        return results;
    };
    /**
     * Get all access tokens in the cache
     * @param clientId
     * @param homeAccountIdentifier
     */
    AuthCache.prototype.getAllAccessTokens = function (clientId, homeAccountIdentifier) {
        return this.getAllTokensByType(clientId, homeAccountIdentifier, ServerHashParamKeys.ACCESS_TOKEN);
    };
    /**
     * Get all id tokens in the cache in the form of AccessTokenCacheItem objects so they are
     * in a normalized format and can make use of the existing cached access token validation logic
     */
    AuthCache.prototype.getAllIdTokens = function (clientId, homeAccountIdentifier) {
        return this.getAllTokensByType(clientId, homeAccountIdentifier, ServerHashParamKeys.ID_TOKEN);
    };
    /**
     * Get all access and ID tokens in the cache
     * @param clientId
     * @param homeAccountIdentifier
     */
    AuthCache.prototype.getAllTokens = function (clientId, homeAccountIdentifier) {
        var accessTokens = this.getAllAccessTokens(clientId, homeAccountIdentifier);
        var idTokens = this.getAllIdTokens(clientId, homeAccountIdentifier);
        return __spreadArrays(accessTokens, idTokens);
    };
    /**
     * Returns whether or not interaction is currently in progress. Optionally scope it to just this clientId
     * @param forThisClient
     */
    AuthCache.prototype.isInteractionInProgress = function (matchClientId) {
        var clientId = this.getInteractionInProgress();
        if (matchClientId) {
            return clientId === this.clientId;
        }
        else {
            return !!clientId;
        }
    };
    /**
     * Returns the clientId of the interaction currently in progress
     */
    AuthCache.prototype.getInteractionInProgress = function () {
        return this.getTemporaryItem(this.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS, false));
    };
    /**
     * Sets interaction in progress state
     * @param isInProgress
     */
    AuthCache.prototype.setInteractionInProgress = function (newInProgressValue) {
        if (newInProgressValue) {
            if (this.isInteractionInProgress(false)) {
                throw ClientAuthError.createAcquireTokenInProgressError();
            }
            else {
                // Ensure we don't overwrite interaction in progress for a different clientId
                this.setTemporaryItem(this.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS, false), this.clientId);
            }
        }
        else if (!newInProgressValue && this.isInteractionInProgress(true)) {
            // Only remove if the current in progress interaction is for this clientId
            this.removeItem(this.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS, false));
        }
    };
    /**
     * Return if the token renewal is still in progress
     *
     * @param stateValue
     */
    AuthCache.prototype.tokenRenewalInProgress = function (stateValue) {
        var renewStatus = this.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.RENEW_STATUS, stateValue));
        return !!(renewStatus && renewStatus === Constants.inProgress);
    };
    /**
     * Clear all cookies
     */
    AuthCache.prototype.clearMsalCookie = function (state) {
        var _this = this;
        /*
         * If state is truthy, remove values associated with that request.
         * Otherwise, remove all MSAL cookies.
         */
        if (state) {
            this.clearItemCookie(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.NONCE_IDTOKEN, state));
            this.clearItemCookie(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_LOGIN, state));
            this.clearItemCookie(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.LOGIN_REQUEST, state));
            this.clearItemCookie(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_ACQ_TOKEN, state));
        }
        else {
            var cookies = document.cookie.split(";");
            cookies.forEach(function (cookieString) {
                var cookieName = cookieString.trim().split("=")[0];
                if (cookieName.indexOf(Constants.cachePrefix) > -1) {
                    _super.prototype.clearItemCookie.call(_this, cookieName);
                }
            });
        }
    };
    /**
     * Create acquireTokenAccountKey to cache account object
     * @param accountId
     * @param state
     */
    AuthCache.generateAcquireTokenAccountKey = function (accountId, state) {
        var stateId = RequestUtils.parseLibraryState(state).id;
        return "" + TemporaryCacheKeys.ACQUIRE_TOKEN_ACCOUNT + Constants.resourceDelimiter + accountId + Constants.resourceDelimiter + stateId;
    };
    /**
     * Create authorityKey to cache authority
     * @param state
     */
    AuthCache.generateAuthorityKey = function (state) {
        return AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.AUTHORITY, state);
    };
    /**
     * Generates the cache key for temporary cache items, using request state
     * @param tempCacheKey Cache key prefix
     * @param state Request state value
     */
    AuthCache.generateTemporaryCacheKey = function (tempCacheKey, state) {
        // Use the state id (a guid), in the interest of shorter key names, which is important for cookies.
        var stateId = RequestUtils.parseLibraryState(state).id;
        return "" + tempCacheKey + Constants.resourceDelimiter + stateId;
    };
    return AuthCache;
}(BrowserStorage));

//# sourceMappingURL=AuthCache.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/Account.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/**
 * accountIdentifier       combination of idToken.uid and idToken.utid
 * homeAccountIdentifier   combination of clientInfo.uid and clientInfo.utid
 * userName                idToken.preferred_username
 * name                    idToken.name
 * idToken                 idToken
 * sid                     idToken.sid - session identifier
 * environment             idtoken.issuer (the authority that issues the token)
 */
var Account = /** @class */ (function () {
    /**
     * Creates an Account Object
     * @praram accountIdentifier
     * @param homeAccountIdentifier
     * @param userName
     * @param name
     * @param idToken
     * @param sid
     * @param environment
     */
    function Account(accountIdentifier, homeAccountIdentifier, userName, name, idTokenClaims, sid, environment) {
        this.accountIdentifier = accountIdentifier;
        this.homeAccountIdentifier = homeAccountIdentifier;
        this.userName = userName;
        this.name = name;
        // will be deprecated soon
        this.idToken = idTokenClaims;
        this.idTokenClaims = idTokenClaims;
        this.sid = sid;
        this.environment = environment;
    }
    /**
     * @hidden
     * @param idToken
     * @param clientInfo
     */
    Account.createAccount = function (idToken, clientInfo) {
        // create accountIdentifier
        var accountIdentifier = idToken.objectId || idToken.subject;
        // create homeAccountIdentifier
        var uid = clientInfo ? clientInfo.uid : "";
        var utid = clientInfo ? clientInfo.utid : "";
        var homeAccountIdentifier;
        if (!StringUtils.isEmpty(uid)) {
            homeAccountIdentifier = StringUtils.isEmpty(utid) ? CryptoUtils.base64Encode(uid) : CryptoUtils.base64Encode(uid) + "." + CryptoUtils.base64Encode(utid);
        }
        return new Account(accountIdentifier, homeAccountIdentifier, idToken.preferredName, idToken.name, idToken.claims, idToken.sid, idToken.issuer);
    };
    /**
     * Utils function to compare two Account objects - used to check if the same user account is logged in
     *
     * @param a1: Account object
     * @param a2: Account object
     */
    Account.compareAccounts = function (a1, a2) {
        if (!a1 || !a2) {
            return false;
        }
        if (a1.homeAccountIdentifier && a2.homeAccountIdentifier) {
            if (a1.homeAccountIdentifier === a2.homeAccountIdentifier) {
                return true;
            }
        }
        return false;
    };
    return Account;
}());

//# sourceMappingURL=Account.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/WindowUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var WindowUtils = /** @class */ (function () {
    function WindowUtils() {
    }
    /**
     * @hidden
     * Checks if the current page is running in an iframe.
     * @ignore
     */
    WindowUtils.isInIframe = function () {
        return window.parent !== window;
    };
    /**
     * @hidden
     * Check if the current page is running in a popup.
     * @ignore
     */
    WindowUtils.isInPopup = function () {
        return !!(window.opener && window.opener !== window);
    };
    /**
     * @hidden
     * @param prefix
     * @param scopes
     * @param authority
     */
    WindowUtils.generateFrameName = function (prefix, requestSignature) {
        return "" + prefix + Constants.resourceDelimiter + requestSignature;
    };
    /**
     * @hidden
     * Polls an iframe until it loads a url with a hash
     * @ignore
     */
    WindowUtils.monitorIframeForHash = function (contentWindow, timeout, urlNavigate, logger) {
        return new Promise(function (resolve, reject) {
            /*
             * Polling for iframes can be purely timing based,
             * since we don't need to account for interaction.
             */
            var nowMark = TimeUtils.relativeNowMs();
            var timeoutMark = nowMark + timeout;
            logger.verbose("monitorWindowForIframe polling started");
            var intervalId = setInterval(function () {
                if (TimeUtils.relativeNowMs() > timeoutMark) {
                    logger.error("monitorIframeForHash unable to find hash in url, timing out");
                    logger.errorPii("monitorIframeForHash polling timed out for url: " + urlNavigate);
                    clearInterval(intervalId);
                    reject(ClientAuthError.createTokenRenewalTimeoutError());
                    return;
                }
                var href;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = contentWindow.location.href;
                }
                catch (e) { }
                if (href && UrlUtils.urlContainsHash(href)) {
                    logger.verbose("monitorIframeForHash found url in hash");
                    clearInterval(intervalId);
                    resolve(contentWindow.location.hash);
                }
            }, WindowUtils.POLLING_INTERVAL_MS);
        });
    };
    /**
     * @hidden
     * Polls a popup until it loads a url with a hash
     * @ignore
     */
    WindowUtils.monitorPopupForHash = function (contentWindow, timeout, urlNavigate, logger) {
        return new Promise(function (resolve, reject) {
            /*
             * Polling for popups needs to be tick-based,
             * since a non-trivial amount of time can be spent on interaction (which should not count against the timeout).
             */
            var maxTicks = timeout / WindowUtils.POLLING_INTERVAL_MS;
            var ticks = 0;
            logger.verbose("monitorWindowForHash polling started");
            var intervalId = setInterval(function () {
                if (contentWindow.closed) {
                    logger.error("monitorWindowForHash window closed");
                    clearInterval(intervalId);
                    reject(ClientAuthError.createUserCancelledError());
                    return;
                }
                var href;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = contentWindow.location.href;
                }
                catch (e) { }
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") {
                    return;
                }
                /*
                 * Only run clock when we are on same domain for popups
                 * as popup operations can take a long time.
                 */
                ticks++;
                if (href && UrlUtils.urlContainsHash(href)) {
                    logger.verbose("monitorPopupForHash found url in hash");
                    clearInterval(intervalId);
                    var hash = contentWindow.location.hash;
                    WindowUtils.clearUrlFragment(contentWindow);
                    resolve(hash);
                }
                else if (ticks > maxTicks) {
                    logger.error("monitorPopupForHash unable to find hash in url, timing out");
                    logger.errorPii("monitorPopupForHash polling timed out for url: " + urlNavigate);
                    clearInterval(intervalId);
                    reject(ClientAuthError.createTokenRenewalTimeoutError());
                }
            }, WindowUtils.POLLING_INTERVAL_MS);
        });
    };
    /**
     * @hidden
     * Loads iframe with authorization endpoint URL
     * @ignore
     */
    WindowUtils.loadFrame = function (urlNavigate, frameName, timeoutMs, logger) {
        var _this = this;
        /*
         * This trick overcomes iframe navigation in IE
         * IE does not load the page consistently in iframe
         */
        logger.infoPii("LoadFrame: " + frameName);
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                var frameHandle = _this.loadFrameSync(urlNavigate, frameName, logger);
                if (!frameHandle) {
                    reject("Unable to load iframe with name: " + frameName);
                    return;
                }
                resolve(frameHandle);
            }, timeoutMs);
        });
    };
    /**
     * @hidden
     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
     * @param urlNavigate
     * @param frameName
     * @param logger
     */
    WindowUtils.loadFrameSync = function (urlNavigate, frameName, logger) {
        var frameHandle = WindowUtils.addHiddenIFrame(frameName, logger);
        // returning to handle null in loadFrame, also to avoid null object access errors
        if (!frameHandle) {
            return null;
        }
        else if (frameHandle.src === "" || frameHandle.src === "about:blank") {
            frameHandle.src = urlNavigate;
            logger.infoPii("Frame Name : " + frameName + " Navigated to: " + urlNavigate);
        }
        return frameHandle;
    };
    /**
     * @hidden
     * Adds the hidden iframe for silent token renewal.
     * @ignore
     */
    WindowUtils.addHiddenIFrame = function (iframeId, logger) {
        if (typeof iframeId === "undefined") {
            return null;
        }
        logger.info("Add msal iframe to document");
        logger.infoPii("Add msal frame to document:" + iframeId);
        var adalFrame = document.getElementById(iframeId);
        if (!adalFrame) {
            logger.verbose("Add msal iframe does not exist");
            var ifr = document.createElement("iframe");
            ifr.setAttribute("id", iframeId);
            ifr.setAttribute("aria-hidden", "true");
            ifr.style.visibility = "hidden";
            ifr.style.position = "absolute";
            ifr.style.width = ifr.style.height = "0";
            ifr.style.border = "0";
            ifr.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
            adalFrame = document.getElementsByTagName("body")[0].appendChild(ifr);
        }
        else {
            logger.verbose("Add msal iframe already exists");
        }
        return adalFrame;
    };
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */
    WindowUtils.removeHiddenIframe = function (iframe) {
        if (document.body === iframe.parentNode) {
            document.body.removeChild(iframe);
        }
    };
    /**
     * @hidden
     * Find and return the iframe element with the given hash
     * @ignore
     */
    WindowUtils.getIframeWithHash = function (hash) {
        var iframes = document.getElementsByTagName("iframe");
        var iframeArray = Array.apply(null, Array(iframes.length)).map(function (iframe, index) { return iframes.item(index); }); // eslint-disable-line prefer-spread
        return iframeArray.filter(function (iframe) {
            try {
                return iframe.contentWindow.location.hash === hash;
            }
            catch (e) {
                return false;
            }
        })[0];
    };
    /**
     * @hidden
     * Returns an array of all the popups opened by MSAL
     * @ignore
     */
    WindowUtils.getPopups = function () {
        if (!window.openedWindows) {
            window.openedWindows = [];
        }
        return window.openedWindows;
    };
    /**
     * @hidden
     * Find and return the popup with the given hash
     * @ignore
     */
    WindowUtils.getPopUpWithHash = function (hash) {
        return WindowUtils.getPopups().filter(function (popup) {
            try {
                return popup.location.hash === hash;
            }
            catch (e) {
                return false;
            }
        })[0];
    };
    /**
     * @hidden
     * Add the popup to the known list of popups
     * @ignore
     */
    WindowUtils.trackPopup = function (popup) {
        WindowUtils.getPopups().push(popup);
    };
    /**
     * @hidden
     * Close all popups
     * @ignore
     */
    WindowUtils.closePopups = function () {
        WindowUtils.getPopups().forEach(function (popup) { return popup.close(); });
    };
    /**
     * @ignore
     *
     * blocks any login/acquireToken calls to reload from within a hidden iframe (generated for silent calls)
     */
    WindowUtils.blockReloadInHiddenIframes = function () {
        // return an error if called from the hidden iframe created by the msal js silent calls
        if (UrlUtils.urlContainsHash(window.location.hash) && WindowUtils.isInIframe()) {
            throw ClientAuthError.createBlockTokenRequestsInHiddenIframeError();
        }
    };
    /**
     *
     * @param cacheStorage
     */
    WindowUtils.checkIfBackButtonIsPressed = function (cacheStorage) {
        var redirectCache = cacheStorage.getItem(TemporaryCacheKeys.REDIRECT_REQUEST);
        // if redirect request is set and there is no hash
        if (redirectCache && !UrlUtils.urlContainsHash(window.location.hash)) {
            var splitCache = redirectCache.split(Constants.resourceDelimiter);
            splitCache.shift();
            var state = splitCache.length > 0 ? splitCache.join(Constants.resourceDelimiter) : null;
            cacheStorage.resetTempCacheItems(state);
        }
    };
    /**
     * Removes url fragment from browser url
     */
    WindowUtils.clearUrlFragment = function (contentWindow) {
        contentWindow.location.hash = "";
        // Office.js sets history.replaceState to null
        if (typeof contentWindow.history.replaceState === "function") {
            // Full removes "#" from url
            contentWindow.history.replaceState(null, null, "" + contentWindow.location.pathname + contentWindow.location.search);
        }
    };
    /**
     * @hidden
     * Interval in milliseconds that we poll a window
     * @ignore
     */
    WindowUtils.POLLING_INTERVAL_MS = 50;
    return WindowUtils;
}());

//# sourceMappingURL=WindowUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/ResponseUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var ResponseUtils = /** @class */ (function () {
    function ResponseUtils() {
    }
    ResponseUtils.setResponseIdToken = function (originalResponse, idTokenObj) {
        if (!originalResponse) {
            return null;
        }
        else if (!idTokenObj) {
            return originalResponse;
        }
        var exp = Number(idTokenObj.expiration);
        if (exp && !originalResponse.expiresOn) {
            originalResponse.expiresOn = new Date(exp * 1000);
        }
        return __assign(__assign({}, originalResponse), { idToken: idTokenObj, idTokenClaims: idTokenObj.claims, uniqueId: idTokenObj.objectId || idTokenObj.subject, tenantId: idTokenObj.tenantId });
    };
    ResponseUtils.buildAuthResponse = function (idToken, authResponse, serverAuthenticationRequest, account, scopes, accountState) {
        switch (serverAuthenticationRequest.responseType) {
            case ResponseTypes.id_token:
                var idTokenResponse = __assign(__assign({}, authResponse), { tokenType: ServerHashParamKeys.ID_TOKEN, account: account, scopes: scopes, accountState: accountState });
                idTokenResponse = ResponseUtils.setResponseIdToken(idTokenResponse, idToken);
                return (idTokenResponse.idToken) ? idTokenResponse : null;
            case ResponseTypes.id_token_token:
                var idTokeTokenResponse = ResponseUtils.setResponseIdToken(authResponse, idToken);
                return (idTokeTokenResponse && idTokeTokenResponse.accessToken && idTokeTokenResponse.idToken) ? idTokeTokenResponse : null;
            case ResponseTypes.token:
                var tokenResponse = ResponseUtils.setResponseIdToken(authResponse, idToken);
                return tokenResponse;
            default:
                return null;
        }
    };
    return ResponseUtils;
}());

//# sourceMappingURL=ResponseUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/authority/AuthorityFactory.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * @hidden
 */



var AuthorityFactory = /** @class */ (function () {
    function AuthorityFactory() {
    }
    AuthorityFactory.saveMetadataFromNetwork = function (authorityInstance, telemetryManager, correlationId) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, authorityInstance.resolveEndpointsAsync(telemetryManager, correlationId)];
                    case 1:
                        metadata = _a.sent();
                        this.metadataMap.set(authorityInstance.CanonicalAuthority, metadata);
                        return [2 /*return*/, metadata];
                }
            });
        });
    };
    AuthorityFactory.getMetadata = function (authorityUrl) {
        return this.metadataMap.get(authorityUrl);
    };
    AuthorityFactory.saveMetadataFromConfig = function (authorityUrl, authorityMetadataJson) {
        try {
            if (authorityMetadataJson) {
                var parsedMetadata = JSON.parse(authorityMetadataJson);
                if (!parsedMetadata.authorization_endpoint || !parsedMetadata.end_session_endpoint || !parsedMetadata.issuer) {
                    throw ClientConfigurationError.createInvalidAuthorityMetadataError();
                }
                this.metadataMap.set(authorityUrl, {
                    AuthorizationEndpoint: parsedMetadata.authorization_endpoint,
                    EndSessionEndpoint: parsedMetadata.end_session_endpoint,
                    Issuer: parsedMetadata.issuer
                });
            }
        }
        catch (e) {
            throw ClientConfigurationError.createInvalidAuthorityMetadataError();
        }
    };
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (eg aad, b2c)
     */
    AuthorityFactory.CreateInstance = function (authorityUrl, validateAuthority, authorityMetadata) {
        if (StringUtils.isEmpty(authorityUrl)) {
            return null;
        }
        if (authorityMetadata) {
            // todo: log statements
            this.saveMetadataFromConfig(authorityUrl, authorityMetadata);
        }
        return new Authority(authorityUrl, validateAuthority, this.metadataMap.get(authorityUrl));
    };
    AuthorityFactory.metadataMap = new Map();
    return AuthorityFactory;
}());

//# sourceMappingURL=AuthorityFactory.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/Logger.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger(localCallback, options) {
        if (options === void 0) { options = {}; }
        /**
         * @hidden
         */
        this.level = LogLevel.Info;
        var _a = options.correlationId, correlationId = _a === void 0 ? "" : _a, _b = options.level, level = _b === void 0 ? LogLevel.Info : _b, _c = options.piiLoggingEnabled, piiLoggingEnabled = _c === void 0 ? false : _c;
        this.localCallback = localCallback;
        this.correlationId = correlationId;
        this.level = level;
        this.piiLoggingEnabled = piiLoggingEnabled;
    }
    /**
     * @hidden
     */
    Logger.prototype.logMessage = function (logLevel, logMessage, containsPii) {
        if ((logLevel > this.level) || (!this.piiLoggingEnabled && containsPii)) {
            return;
        }
        var timestamp = new Date().toUTCString();
        var log;
        if (!StringUtils.isEmpty(this.correlationId)) {
            log = timestamp + ":" + this.correlationId + "-" + version + "-" + LogLevel[logLevel] + (containsPii ? "-pii" : "") + " " + logMessage;
        }
        else {
            log = timestamp + ":" + version + "-" + LogLevel[logLevel] + (containsPii ? "-pii" : "") + " " + logMessage;
        }
        this.executeCallback(logLevel, log, containsPii);
    };
    /**
     * @hidden
     */
    Logger.prototype.executeCallback = function (level, message, containsPii) {
        if (this.localCallback) {
            this.localCallback(level, message, containsPii);
        }
    };
    /**
     * @hidden
     */
    Logger.prototype.error = function (message) {
        this.logMessage(LogLevel.Error, message, false);
    };
    /**
     * @hidden
     */
    Logger.prototype.errorPii = function (message) {
        this.logMessage(LogLevel.Error, message, true);
    };
    /**
     * @hidden
     */
    Logger.prototype.warning = function (message) {
        this.logMessage(LogLevel.Warning, message, false);
    };
    /**
     * @hidden
     */
    Logger.prototype.warningPii = function (message) {
        this.logMessage(LogLevel.Warning, message, true);
    };
    /**
     * @hidden
     */
    Logger.prototype.info = function (message) {
        this.logMessage(LogLevel.Info, message, false);
    };
    /**
     * @hidden
     */
    Logger.prototype.infoPii = function (message) {
        this.logMessage(LogLevel.Info, message, true);
    };
    /**
     * @hidden
     */
    Logger.prototype.verbose = function (message) {
        this.logMessage(LogLevel.Verbose, message, false);
    };
    /**
     * @hidden
     */
    Logger.prototype.verbosePii = function (message) {
        this.logMessage(LogLevel.Verbose, message, true);
    };
    Logger.prototype.isPiiLoggingEnabled = function () {
        return this.piiLoggingEnabled;
    };
    return Logger;
}());

//# sourceMappingURL=Logger.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/Configuration.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */



/**
 * Defaults for the Configuration Options
 */
var FRAME_TIMEOUT = 6000;
var OFFSET = 300;
var NAVIGATE_FRAME_WAIT = 500;
var DEFAULT_AUTH_OPTIONS = {
    clientId: "",
    authority: null,
    validateAuthority: true,
    authorityMetadata: "",
    knownAuthorities: [],
    redirectUri: function () { return UrlUtils.getCurrentUrl(); },
    postLogoutRedirectUri: function () { return UrlUtils.getCurrentUrl(); },
    navigateToLoginRequestUrl: true
};
var DEFAULT_CACHE_OPTIONS = {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
};
var DEFAULT_SYSTEM_OPTIONS = {
    logger: new Logger(null),
    loadFrameTimeout: FRAME_TIMEOUT,
    tokenRenewalOffsetSeconds: OFFSET,
    navigateFrameWait: NAVIGATE_FRAME_WAIT
};
var DEFAULT_FRAMEWORK_OPTIONS = {
    isAngular: false,
    unprotectedResources: new Array(),
    protectedResourceMap: new Map()
};
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param TAuthOptions
 * @param TCacheOptions
 * @param TSystemOptions
 * @param TFrameworkOptions
 * @param TAuthorityDataOptions
 *
 * @returns TConfiguration object
 */
function buildConfiguration(_a) {
    var auth = _a.auth, _b = _a.cache, cache = _b === void 0 ? {} : _b, _c = _a.system, system = _c === void 0 ? {} : _c, _d = _a.framework, framework = _d === void 0 ? {} : _d;
    var overlayedConfig = {
        auth: __assign(__assign({}, DEFAULT_AUTH_OPTIONS), auth),
        cache: __assign(__assign({}, DEFAULT_CACHE_OPTIONS), cache),
        system: __assign(__assign({}, DEFAULT_SYSTEM_OPTIONS), system),
        framework: __assign(__assign({}, DEFAULT_FRAMEWORK_OPTIONS), framework)
    };
    return overlayedConfig;
}
//# sourceMappingURL=Configuration.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/error/ServerError.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


var ServerErrorMessage = {
    serverUnavailable: {
        code: "server_unavailable",
        desc: "Server is temporarily unavailable."
    },
    unknownServerError: {
        code: "unknown_server_error"
    },
};
/**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */
var ServerError = /** @class */ (function (_super) {
    __extends(ServerError, _super);
    function ServerError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ServerError";
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    ServerError.createServerUnavailableError = function () {
        return new ServerError(ServerErrorMessage.serverUnavailable.code, ServerErrorMessage.serverUnavailable.desc);
    };
    ServerError.createUnknownServerError = function (errorDesc) {
        return new ServerError(ServerErrorMessage.unknownServerError.code, errorDesc);
    };
    return ServerError;
}(AuthError));

//# sourceMappingURL=ServerError.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/error/InteractionRequiredAuthError.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


var InteractionRequiredAuthErrorMessage = {
    interactionRequired: {
        code: "interaction_required"
    },
    consentRequired: {
        code: "consent_required"
    },
    loginRequired: {
        code: "login_required"
    },
};
/**
 * Error thrown when the user is required to perform an interactive token request.
 */
var InteractionRequiredAuthError = /** @class */ (function (_super) {
    __extends(InteractionRequiredAuthError, _super);
    function InteractionRequiredAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "InteractionRequiredAuthError";
        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
        return _this;
    }
    InteractionRequiredAuthError.isInteractionRequiredError = function (errorString) {
        var interactionRequiredCodes = [
            InteractionRequiredAuthErrorMessage.interactionRequired.code,
            InteractionRequiredAuthErrorMessage.consentRequired.code,
            InteractionRequiredAuthErrorMessage.loginRequired.code
        ];
        return errorString && interactionRequiredCodes.indexOf(errorString) > -1;
    };
    InteractionRequiredAuthError.createLoginRequiredAuthError = function (errorDesc) {
        return new InteractionRequiredAuthError(InteractionRequiredAuthErrorMessage.loginRequired.code, errorDesc);
    };
    InteractionRequiredAuthError.createInteractionRequiredAuthError = function (errorDesc) {
        return new InteractionRequiredAuthError(InteractionRequiredAuthErrorMessage.interactionRequired.code, errorDesc);
    };
    InteractionRequiredAuthError.createConsentRequiredAuthError = function (errorDesc) {
        return new InteractionRequiredAuthError(InteractionRequiredAuthErrorMessage.consentRequired.code, errorDesc);
    };
    return InteractionRequiredAuthError;
}(ServerError));

//# sourceMappingURL=InteractionRequiredAuthError.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/AuthResponse.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function buildResponseStateOnly(state) {
    return {
        uniqueId: "",
        tenantId: "",
        tokenType: "",
        idToken: null,
        idTokenClaims: null,
        accessToken: "",
        scopes: null,
        expiresOn: null,
        account: null,
        accountState: state,
        fromCache: false
    };
}
//# sourceMappingURL=AuthResponse.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/TelemetryConstants.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EVENT_NAME_PREFIX = "msal.";
var EVENT_NAME_KEY = "event_name";
var START_TIME_KEY = "start_time";
var ELAPSED_TIME_KEY = "elapsed_time";
var TELEMETRY_BLOB_EVENT_NAMES = {
    MsalCorrelationIdConstStrKey: "Microsoft.MSAL.correlation_id",
    ApiTelemIdConstStrKey: "msal.api_telem_id",
    ApiIdConstStrKey: "msal.api_id",
    BrokerAppConstStrKey: "Microsoft_MSAL_broker_app",
    CacheEventCountConstStrKey: "Microsoft_MSAL_cache_event_count",
    HttpEventCountTelemetryBatchKey: "Microsoft_MSAL_http_event_count",
    IdpConstStrKey: "Microsoft_MSAL_idp",
    IsSilentTelemetryBatchKey: "",
    IsSuccessfulConstStrKey: "Microsoft_MSAL_is_successful",
    ResponseTimeConstStrKey: "Microsoft_MSAL_response_time",
    TenantIdConstStrKey: "Microsoft_MSAL_tenant_id",
    UiEventCountTelemetryBatchKey: "Microsoft_MSAL_ui_event_count"
};
// This is used to replace the real tenant in telemetry info
var TENANT_PLACEHOLDER = "<tenant>";
//# sourceMappingURL=TelemetryConstants.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/TelemetryUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var scrubTenantFromUri = function (uri) {
    var url = UrlUtils.GetUrlComponents(uri);
    // validate trusted host
    if (Authority.isAdfs(uri)) {
        /**
         * returning what was passed because the library needs to work with uris that are non
         * AAD trusted but passed by users such as B2C or others.
         * HTTP Events for instance can take a url to the open id config endpoint
         */
        return uri;
    }
    var pathParams = url.PathSegments;
    if (pathParams && pathParams.length >= 2) {
        var tenantPosition = pathParams[1] === "tfp" ? 2 : 1;
        if (tenantPosition < pathParams.length) {
            pathParams[tenantPosition] = TENANT_PLACEHOLDER;
        }
    }
    return url.Protocol + "//" + url.HostNameAndPort + "/" + pathParams.join("/");
};
var hashPersonalIdentifier = function (valueToHash) {
    /*
     * TODO sha256 this
     * Current test runner is being funny with node libs that are webpacked anyway
     * need a different solution
     */
    return CryptoUtils.base64Encode(valueToHash);
};
var prependEventNamePrefix = function (suffix) { return "" + EVENT_NAME_PREFIX + (suffix || ""); };
var supportsBrowserPerformance = function () { return !!(typeof window !== "undefined" &&
    "performance" in window &&
    window.performance.mark &&
    window.performance.measure); };
var endBrowserPerformanceMeasurement = function (measureName, startMark, endMark) {
    if (supportsBrowserPerformance()) {
        window.performance.mark(endMark);
        window.performance.measure(measureName, startMark, endMark);
        window.performance.clearMeasures(measureName);
        window.performance.clearMarks(startMark);
        window.performance.clearMarks(endMark);
    }
};
var startBrowserPerformanceMeasurement = function (startMark) {
    if (supportsBrowserPerformance()) {
        window.performance.mark(startMark);
    }
};
//# sourceMappingURL=TelemetryUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/TelemetryEvent.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var TelemetryEvent = /** @class */ (function () {
    function TelemetryEvent(eventName, correlationId, eventLabel) {
        var _a;
        this.eventId = CryptoUtils.createNewGuid();
        this.label = eventLabel;
        this.event = (_a = {},
            _a[prependEventNamePrefix(EVENT_NAME_KEY)] = eventName,
            _a[prependEventNamePrefix(ELAPSED_TIME_KEY)] = -1,
            _a["" + TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey] = correlationId,
            _a);
    }
    TelemetryEvent.prototype.setElapsedTime = function (time) {
        this.event[prependEventNamePrefix(ELAPSED_TIME_KEY)] = time;
    };
    TelemetryEvent.prototype.stop = function () {
        // Set duration of event
        this.setElapsedTime(+Date.now() - +this.startTimestamp);
        endBrowserPerformanceMeasurement(this.displayName, this.perfStartMark, this.perfEndMark);
    };
    TelemetryEvent.prototype.start = function () {
        this.startTimestamp = Date.now();
        this.event[prependEventNamePrefix(START_TIME_KEY)] = this.startTimestamp;
        startBrowserPerformanceMeasurement(this.perfStartMark);
    };
    Object.defineProperty(TelemetryEvent.prototype, "telemetryCorrelationId", {
        get: function () {
            return this.event["" + TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey];
        },
        set: function (value) {
            this.event["" + TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TelemetryEvent.prototype, "eventName", {
        get: function () {
            return this.event[prependEventNamePrefix(EVENT_NAME_KEY)];
        },
        enumerable: false,
        configurable: true
    });
    TelemetryEvent.prototype.get = function () {
        return __assign(__assign({}, this.event), { eventId: this.eventId });
    };
    Object.defineProperty(TelemetryEvent.prototype, "key", {
        get: function () {
            return this.telemetryCorrelationId + "_" + this.eventId + "-" + this.eventName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TelemetryEvent.prototype, "displayName", {
        get: function () {
            return "Msal-" + this.label + "-" + this.telemetryCorrelationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TelemetryEvent.prototype, "perfStartMark", {
        get: function () {
            return "start-" + this.key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TelemetryEvent.prototype, "perfEndMark", {
        get: function () {
            return "end-" + this.key;
        },
        enumerable: false,
        configurable: true
    });
    return TelemetryEvent;
}());
/* harmony default export */ var telemetry_TelemetryEvent = (TelemetryEvent);
//# sourceMappingURL=TelemetryEvent.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/DefaultEvent.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var DefaultEvent = /** @class */ (function (_super) {
    __extends(DefaultEvent, _super);
    // TODO Platform Type
    function DefaultEvent(platform, correlationId, clientId, eventCount) {
        var _this = _super.call(this, prependEventNamePrefix("default_event"), correlationId, "DefaultEvent") || this;
        _this.event[prependEventNamePrefix("client_id")] = clientId;
        _this.event[prependEventNamePrefix("sdk_plaform")] = platform.sdk;
        _this.event[prependEventNamePrefix("sdk_version")] = platform.sdkVersion;
        _this.event[prependEventNamePrefix("application_name")] = platform.applicationName;
        _this.event[prependEventNamePrefix("application_version")] = platform.applicationVersion;
        _this.event[prependEventNamePrefix("effective_connection_speed")] = platform.networkInformation && platform.networkInformation.connectionSpeed;
        _this.event["" + TELEMETRY_BLOB_EVENT_NAMES.UiEventCountTelemetryBatchKey] = _this.getEventCount(prependEventNamePrefix("ui_event"), eventCount);
        _this.event["" + TELEMETRY_BLOB_EVENT_NAMES.HttpEventCountTelemetryBatchKey] = _this.getEventCount(prependEventNamePrefix("http_event"), eventCount);
        _this.event["" + TELEMETRY_BLOB_EVENT_NAMES.CacheEventCountConstStrKey] = _this.getEventCount(prependEventNamePrefix("cache_event"), eventCount);
        return _this;
        // / Device id?
    }
    DefaultEvent.prototype.getEventCount = function (eventName, eventCount) {
        if (!eventCount[eventName]) {
            return 0;
        }
        return eventCount[eventName];
    };
    return DefaultEvent;
}(telemetry_TelemetryEvent));
/* harmony default export */ var telemetry_DefaultEvent = (DefaultEvent);
//# sourceMappingURL=DefaultEvent.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/ApiEvent.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var _a;




var EVENT_KEYS = {
    AUTHORITY: prependEventNamePrefix("authority"),
    AUTHORITY_TYPE: prependEventNamePrefix("authority_type"),
    PROMPT: prependEventNamePrefix("ui_behavior"),
    TENANT_ID: prependEventNamePrefix("tenant_id"),
    USER_ID: prependEventNamePrefix("user_id"),
    WAS_SUCESSFUL: prependEventNamePrefix("was_successful"),
    API_ERROR_CODE: prependEventNamePrefix("api_error_code"),
    LOGIN_HINT: prependEventNamePrefix("login_hint")
};
var API_CODE;
(function (API_CODE) {
    API_CODE[API_CODE["AcquireTokenRedirect"] = 2001] = "AcquireTokenRedirect";
    API_CODE[API_CODE["AcquireTokenSilent"] = 2002] = "AcquireTokenSilent";
    API_CODE[API_CODE["AcquireTokenPopup"] = 2003] = "AcquireTokenPopup";
    API_CODE[API_CODE["LoginRedirect"] = 2004] = "LoginRedirect";
    API_CODE[API_CODE["LoginPopup"] = 2005] = "LoginPopup";
    API_CODE[API_CODE["Logout"] = 2006] = "Logout";
})(API_CODE || (API_CODE = {}));
var API_EVENT_IDENTIFIER;
(function (API_EVENT_IDENTIFIER) {
    API_EVENT_IDENTIFIER["AcquireTokenRedirect"] = "AcquireTokenRedirect";
    API_EVENT_IDENTIFIER["AcquireTokenSilent"] = "AcquireTokenSilent";
    API_EVENT_IDENTIFIER["AcquireTokenPopup"] = "AcquireTokenPopup";
    API_EVENT_IDENTIFIER["LoginRedirect"] = "LoginRedirect";
    API_EVENT_IDENTIFIER["LoginPopup"] = "LoginPopup";
    API_EVENT_IDENTIFIER["Logout"] = "Logout";
})(API_EVENT_IDENTIFIER || (API_EVENT_IDENTIFIER = {}));
var mapEventIdentiferToCode = (_a = {},
    _a[API_EVENT_IDENTIFIER.AcquireTokenSilent] = API_CODE.AcquireTokenSilent,
    _a[API_EVENT_IDENTIFIER.AcquireTokenPopup] = API_CODE.AcquireTokenPopup,
    _a[API_EVENT_IDENTIFIER.AcquireTokenRedirect] = API_CODE.AcquireTokenRedirect,
    _a[API_EVENT_IDENTIFIER.LoginPopup] = API_CODE.LoginPopup,
    _a[API_EVENT_IDENTIFIER.LoginRedirect] = API_CODE.LoginRedirect,
    _a[API_EVENT_IDENTIFIER.Logout] = API_CODE.Logout,
    _a);
var ApiEvent = /** @class */ (function (_super) {
    __extends(ApiEvent, _super);
    function ApiEvent(correlationId, piiEnabled, apiEventIdentifier) {
        var _this = _super.call(this, prependEventNamePrefix("api_event"), correlationId, apiEventIdentifier) || this;
        if (apiEventIdentifier) {
            _this.apiCode = mapEventIdentiferToCode[apiEventIdentifier];
            _this.apiEventIdentifier = apiEventIdentifier;
        }
        _this.piiEnabled = piiEnabled;
        return _this;
    }
    Object.defineProperty(ApiEvent.prototype, "apiEventIdentifier", {
        set: function (apiEventIdentifier) {
            this.event[TELEMETRY_BLOB_EVENT_NAMES.ApiTelemIdConstStrKey] = apiEventIdentifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "apiCode", {
        set: function (apiCode) {
            this.event[TELEMETRY_BLOB_EVENT_NAMES.ApiIdConstStrKey] = apiCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "authority", {
        set: function (uri) {
            this.event[EVENT_KEYS.AUTHORITY] = scrubTenantFromUri(uri).toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "apiErrorCode", {
        set: function (errorCode) {
            this.event[EVENT_KEYS.API_ERROR_CODE] = errorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "tenantId", {
        set: function (tenantId) {
            this.event[EVENT_KEYS.TENANT_ID] = this.piiEnabled && tenantId ?
                hashPersonalIdentifier(tenantId)
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "accountId", {
        set: function (accountId) {
            this.event[EVENT_KEYS.USER_ID] = this.piiEnabled && accountId ?
                hashPersonalIdentifier(accountId)
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "wasSuccessful", {
        get: function () {
            return this.event[EVENT_KEYS.WAS_SUCESSFUL] === true;
        },
        set: function (wasSuccessful) {
            this.event[EVENT_KEYS.WAS_SUCESSFUL] = wasSuccessful;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "loginHint", {
        set: function (loginHint) {
            this.event[EVENT_KEYS.LOGIN_HINT] = this.piiEnabled && loginHint ?
                hashPersonalIdentifier(loginHint)
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "authorityType", {
        set: function (authorityType) {
            this.event[EVENT_KEYS.AUTHORITY_TYPE] = authorityType.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiEvent.prototype, "promptType", {
        set: function (promptType) {
            this.event[EVENT_KEYS.PROMPT] = promptType.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    return ApiEvent;
}(telemetry_TelemetryEvent));
/* harmony default export */ var telemetry_ApiEvent = (ApiEvent);
//# sourceMappingURL=ApiEvent.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/HttpEvent.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */




var HttpEvent_EVENT_KEYS = {
    HTTP_PATH: prependEventNamePrefix("http_path"),
    USER_AGENT: prependEventNamePrefix("user_agent"),
    QUERY_PARAMETERS: prependEventNamePrefix("query_parameters"),
    API_VERSION: prependEventNamePrefix("api_version"),
    RESPONSE_CODE: prependEventNamePrefix("response_code"),
    O_AUTH_ERROR_CODE: prependEventNamePrefix("oauth_error_code"),
    HTTP_METHOD: prependEventNamePrefix("http_method"),
    REQUEST_ID_HEADER: prependEventNamePrefix("request_id_header"),
    SPE_INFO: prependEventNamePrefix("spe_info"),
    SERVER_ERROR_CODE: prependEventNamePrefix("server_error_code"),
    SERVER_SUB_ERROR_CODE: prependEventNamePrefix("server_sub_error_code"),
    URL: prependEventNamePrefix("url")
};
var HttpEvent = /** @class */ (function (_super) {
    __extends(HttpEvent, _super);
    function HttpEvent(correlationId, eventLabel) {
        return _super.call(this, prependEventNamePrefix("http_event"), correlationId, eventLabel) || this;
    }
    Object.defineProperty(HttpEvent.prototype, "url", {
        set: function (url) {
            var scrubbedUri = scrubTenantFromUri(url);
            this.event[HttpEvent_EVENT_KEYS.URL] = scrubbedUri && scrubbedUri.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "httpPath", {
        set: function (httpPath) {
            this.event[HttpEvent_EVENT_KEYS.HTTP_PATH] = scrubTenantFromUri(httpPath).toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "userAgent", {
        set: function (userAgent) {
            this.event[HttpEvent_EVENT_KEYS.USER_AGENT] = userAgent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "queryParams", {
        set: function (queryParams) {
            this.event[HttpEvent_EVENT_KEYS.QUERY_PARAMETERS] = ServerRequestParameters.generateQueryParametersString(queryParams);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "apiVersion", {
        set: function (apiVersion) {
            this.event[HttpEvent_EVENT_KEYS.API_VERSION] = apiVersion.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "httpResponseStatus", {
        set: function (statusCode) {
            this.event[HttpEvent_EVENT_KEYS.RESPONSE_CODE] = statusCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "oAuthErrorCode", {
        set: function (errorCode) {
            this.event[HttpEvent_EVENT_KEYS.O_AUTH_ERROR_CODE] = errorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "httpMethod", {
        set: function (httpMethod) {
            this.event[HttpEvent_EVENT_KEYS.HTTP_METHOD] = httpMethod;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "requestIdHeader", {
        set: function (requestIdHeader) {
            this.event[HttpEvent_EVENT_KEYS.REQUEST_ID_HEADER] = requestIdHeader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "speInfo", {
        /**
         * Indicates whether the request was executed on a ring serving SPE traffic.
         * An empty string indicates this occurred on an outer ring, and the string "I"
         * indicates the request occurred on the inner ring
         */
        set: function (speInfo) {
            this.event[HttpEvent_EVENT_KEYS.SPE_INFO] = speInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "serverErrorCode", {
        set: function (errorCode) {
            this.event[HttpEvent_EVENT_KEYS.SERVER_ERROR_CODE] = errorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpEvent.prototype, "serverSubErrorCode", {
        set: function (subErrorCode) {
            this.event[HttpEvent_EVENT_KEYS.SERVER_SUB_ERROR_CODE] = subErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    return HttpEvent;
}(telemetry_TelemetryEvent));
/* harmony default export */ var telemetry_HttpEvent = (HttpEvent);
//# sourceMappingURL=HttpEvent.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/telemetry/TelemetryManager.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */






var TelemetryManager = /** @class */ (function () {
    function TelemetryManager(config, telemetryEmitter, logger) {
        // correlation Id to list of events
        this.completedEvents = {};
        // event key to event
        this.inProgressEvents = {};
        // correlation id to map of eventname to count
        this.eventCountByCorrelationId = {};
        // Implement after API EVENT
        this.onlySendFailureTelemetry = false;
        // TODO THROW if bad options
        this.telemetryPlatform = __assign({ sdk: Constants.libraryName, sdkVersion: version, networkInformation: {
                // @ts-ignore
                connectionSpeed: typeof navigator !== "undefined" && navigator.connection && navigator.connection.effectiveType
            } }, config.platform);
        this.clientId = config.clientId;
        this.onlySendFailureTelemetry = config.onlySendFailureTelemetry;
        /*
         * TODO, when i get to wiring this through, think about what it means if
         * a developer does not implement telem at all, we still instrument, but telemetryEmitter can be
         * optional?
         */
        this.telemetryEmitter = telemetryEmitter;
        this.logger = logger;
    }
    TelemetryManager.getTelemetrymanagerStub = function (clientId, logger) {
        var applicationName = "UnSetStub";
        var applicationVersion = "0.0";
        var telemetryEmitter = function () { };
        var telemetryPlatform = {
            applicationName: applicationName,
            applicationVersion: applicationVersion
        };
        var telemetryManagerConfig = {
            platform: telemetryPlatform,
            clientId: clientId
        };
        return new this(telemetryManagerConfig, telemetryEmitter, logger);
    };
    TelemetryManager.prototype.startEvent = function (event) {
        this.logger.verbose("Telemetry Event started: " + event.key);
        if (!this.telemetryEmitter) {
            return;
        }
        event.start();
        this.inProgressEvents[event.key] = event;
    };
    TelemetryManager.prototype.stopEvent = function (event) {
        this.logger.verbose("Telemetry Event stopped: " + event.key);
        if (!this.telemetryEmitter || !this.inProgressEvents[event.key]) {
            return;
        }
        event.stop();
        this.incrementEventCount(event);
        var completedEvents = this.completedEvents[event.telemetryCorrelationId];
        this.completedEvents[event.telemetryCorrelationId] = __spreadArrays((completedEvents || []), [event]);
        delete this.inProgressEvents[event.key];
    };
    TelemetryManager.prototype.flush = function (correlationId) {
        var _this = this;
        this.logger.verbose("Flushing telemetry events: " + correlationId);
        // If there is only unfinished events should this still return them?
        if (!this.telemetryEmitter || !this.completedEvents[correlationId]) {
            return;
        }
        var orphanedEvents = this.getOrphanedEvents(correlationId);
        orphanedEvents.forEach(function (event) { return _this.incrementEventCount(event); });
        var eventsToFlush = __spreadArrays(this.completedEvents[correlationId], orphanedEvents);
        delete this.completedEvents[correlationId];
        var eventCountsToFlush = this.eventCountByCorrelationId[correlationId];
        delete this.eventCountByCorrelationId[correlationId];
        // TODO add funcitonality for onlyFlushFailures after implementing api event? ??
        if (!eventsToFlush || !eventsToFlush.length) {
            return;
        }
        var defaultEvent = new telemetry_DefaultEvent(this.telemetryPlatform, correlationId, this.clientId, eventCountsToFlush);
        var eventsWithDefaultEvent = __spreadArrays(eventsToFlush, [defaultEvent]);
        this.telemetryEmitter(eventsWithDefaultEvent.map(function (e) { return e.get(); }));
    };
    TelemetryManager.prototype.createAndStartApiEvent = function (correlationId, apiEventIdentifier) {
        var apiEvent = new telemetry_ApiEvent(correlationId, this.logger.isPiiLoggingEnabled(), apiEventIdentifier);
        this.startEvent(apiEvent);
        return apiEvent;
    };
    TelemetryManager.prototype.stopAndFlushApiEvent = function (correlationId, apiEvent, wasSuccessful, errorCode) {
        apiEvent.wasSuccessful = wasSuccessful;
        if (errorCode) {
            apiEvent.apiErrorCode = errorCode;
        }
        this.stopEvent(apiEvent);
        this.flush(correlationId);
    };
    TelemetryManager.prototype.createAndStartHttpEvent = function (correlation, httpMethod, url, eventLabel) {
        var httpEvent = new telemetry_HttpEvent(correlation, eventLabel);
        httpEvent.url = url;
        httpEvent.httpMethod = httpMethod;
        this.startEvent(httpEvent);
        return httpEvent;
    };
    TelemetryManager.prototype.incrementEventCount = function (event) {
        var _a;
        /*
         * TODO, name cache event different?
         * if type is cache event, change name
         */
        var eventName = event.eventName;
        var eventCount = this.eventCountByCorrelationId[event.telemetryCorrelationId];
        if (!eventCount) {
            this.eventCountByCorrelationId[event.telemetryCorrelationId] = (_a = {},
                _a[eventName] = 1,
                _a);
        }
        else {
            eventCount[eventName] = eventCount[eventName] ? eventCount[eventName] + 1 : 1;
        }
    };
    TelemetryManager.prototype.getOrphanedEvents = function (correlationId) {
        var _this = this;
        return Object.keys(this.inProgressEvents)
            .reduce(function (memo, eventKey) {
            if (eventKey.indexOf(correlationId) !== -1) {
                var event_1 = _this.inProgressEvents[eventKey];
                delete _this.inProgressEvents[eventKey];
                return __spreadArrays(memo, [event_1]);
            }
            return memo;
        }, []);
    };
    return TelemetryManager;
}());
/* harmony default export */ var telemetry_TelemetryManager = (TelemetryManager);
//# sourceMappingURL=TelemetryManager.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/utils/AuthCacheUtils.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/**
 * @hidden
 */
var AuthCacheUtils = /** @class */ (function () {
    function AuthCacheUtils() {
    }
    AuthCacheUtils.filterTokenCacheItemsByScope = function (tokenCacheItems, requestScopes) {
        return tokenCacheItems.filter(function (cacheItem) {
            var cachedScopes = cacheItem.key.scopes.split(" ");
            var searchScopes = ScopeSet.removeDefaultScopes(requestScopes);
            // If requestScopes contain only default scopes search for default scopes otherwise search for everything but default scopes
            return searchScopes.length === 0 ? ScopeSet.containsScope(cachedScopes, requestScopes) : ScopeSet.containsScope(cachedScopes, searchScopes);
        });
    };
    AuthCacheUtils.filterTokenCacheItemsByAuthority = function (tokenCacheItems, authority) {
        return tokenCacheItems.filter(function (cacheItem) { return UrlUtils.CanonicalizeUri(cacheItem.key.authority) === authority; });
    };
    AuthCacheUtils.filterTokenCacheItemsByDomain = function (tokenCacheItems, requestDomain) {
        return tokenCacheItems.filter(function (cacheItem) {
            var cacheItemDomain = UrlUtils.GetUrlComponents(cacheItem.key.authority).HostNameAndPort;
            return cacheItemDomain === requestDomain;
        });
    };
    return AuthCacheUtils;
}());

//# sourceMappingURL=AuthCacheUtils.js.map
;// CONCATENATED MODULE: ./node_modules/msal/lib-es6/UserAgentApplication.js
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */































// default authority
var UserAgentApplication_DEFAULT_AUTHORITY = "https://login.microsoftonline.com/common";
/**
 * UserAgentApplication class
 *
 * Object Instance that the developer can use to make loginXX OR acquireTokenXX functions
 */
var UserAgentApplication = /** @class */ (function () {
    /**
     * @constructor
     * Constructor for the UserAgentApplication used to instantiate the UserAgentApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application.
     * You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/&lt;Enter_the_Tenant_Info_Here&gt;.
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     *
     * In Azure B2C, authority is of the form https://&lt;instance&gt;/tfp/&lt;tenant&gt;/&lt;policyName&gt;/
     *
     * @param {@link (Configuration:type)} configuration object for the MSAL UserAgentApplication instance
     */
    function UserAgentApplication(configuration) {
        // callbacks for token/error
        this.authResponseCallback = null;
        this.tokenReceivedCallback = null;
        this.errorReceivedCallback = null;
        // Set the Configuration
        this.config = buildConfiguration(configuration);
        this.logger = this.config.system.logger;
        this.clientId = this.config.auth.clientId;
        this.inCookie = this.config.cache.storeAuthStateInCookie;
        this.telemetryManager = this.getTelemetryManagerFromConfig(this.config.system.telemetry, this.clientId);
        TrustedAuthority.setTrustedAuthoritiesFromConfig(this.config.auth.validateAuthority, this.config.auth.knownAuthorities);
        AuthorityFactory.saveMetadataFromConfig(this.config.auth.authority, this.config.auth.authorityMetadata);
        // if no authority is passed, set the default: "https://login.microsoftonline.com/common"
        this.authority = this.config.auth.authority || UserAgentApplication_DEFAULT_AUTHORITY;
        // cache keys msal - typescript throws an error if any value other than "localStorage" or "sessionStorage" is passed
        this.cacheStorage = new AuthCache(this.clientId, this.config.cache.cacheLocation, this.inCookie);
        // Initialize window handling code
        if (!window.activeRenewals) {
            window.activeRenewals = {};
        }
        if (!window.renewStates) {
            window.renewStates = [];
        }
        if (!window.callbackMappedToRenewStates) {
            window.callbackMappedToRenewStates = {};
        }
        if (!window.promiseMappedToRenewStates) {
            window.promiseMappedToRenewStates = {};
        }
        window.msal = this;
        var urlHash = window.location.hash;
        var urlContainsHash = UrlUtils.urlContainsHash(urlHash);
        // check if back button is pressed
        WindowUtils.checkIfBackButtonIsPressed(this.cacheStorage);
        // On the server 302 - Redirect, handle this
        if (urlContainsHash && this.cacheStorage.isInteractionInProgress(true)) {
            var stateInfo = this.getResponseState(urlHash);
            if (stateInfo.method === Constants.interactionTypeRedirect) {
                this.handleRedirectAuthenticationResponse(urlHash);
            }
        }
    }
    Object.defineProperty(UserAgentApplication.prototype, "authority", {
        /**
         * Method to manage the authority URL.
         *
         * @returns {string} authority
         */
        get: function () {
            return this.authorityInstance.CanonicalAuthority;
        },
        /**
         * setter for the authority URL
         * @param {string} authority
         */
        // If the developer passes an authority, create an instance
        set: function (val) {
            this.authorityInstance = AuthorityFactory.CreateInstance(val, this.config.auth.validateAuthority);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get the current authority instance from the MSAL configuration object
     *
     * @returns {@link Authority} authority instance
     */
    UserAgentApplication.prototype.getAuthorityInstance = function () {
        return this.authorityInstance;
    };
    UserAgentApplication.prototype.handleRedirectCallback = function (authOrTokenCallback, errorReceivedCallback) {
        if (!authOrTokenCallback) {
            throw ClientConfigurationError.createInvalidCallbackObjectError(authOrTokenCallback);
        }
        // Set callbacks
        if (errorReceivedCallback) {
            this.tokenReceivedCallback = authOrTokenCallback;
            this.errorReceivedCallback = errorReceivedCallback;
            this.logger.warning("This overload for callback is deprecated - please change the format of the callbacks to a single callback as shown: (err: AuthError, response: AuthResponse).");
        }
        else {
            this.authResponseCallback = authOrTokenCallback;
        }
        if (this.redirectError) {
            this.authErrorHandler(Constants.interactionTypeRedirect, this.redirectError, this.redirectResponse);
        }
        else if (this.redirectResponse) {
            this.authResponseHandler(Constants.interactionTypeRedirect, this.redirectResponse);
        }
    };
    /**
     * Public API to verify if the URL contains the hash with known properties
     * @param hash
     */
    UserAgentApplication.prototype.urlContainsHash = function (hash) {
        this.logger.verbose("UrlContainsHash has been called");
        return UrlUtils.urlContainsHash(hash);
    };
    UserAgentApplication.prototype.authResponseHandler = function (interactionType, response, resolve) {
        this.logger.verbose("AuthResponseHandler has been called");
        this.cacheStorage.setInteractionInProgress(false);
        if (interactionType === Constants.interactionTypeRedirect) {
            this.logger.verbose("Interaction type is redirect");
            if (this.errorReceivedCallback) {
                this.logger.verbose("Two callbacks were provided to handleRedirectCallback, calling success callback with response");
                this.tokenReceivedCallback(response);
            }
            else if (this.authResponseCallback) {
                this.logger.verbose("One callback was provided to handleRedirectCallback, calling authResponseCallback with response");
                this.authResponseCallback(null, response);
            }
        }
        else if (interactionType === Constants.interactionTypePopup) {
            this.logger.verbose("Interaction type is popup, resolving");
            resolve(response);
        }
        else {
            throw ClientAuthError.createInvalidInteractionTypeError();
        }
    };
    UserAgentApplication.prototype.authErrorHandler = function (interactionType, authErr, response, reject) {
        this.logger.verbose("AuthErrorHandler has been called");
        // set interaction_status to complete
        this.cacheStorage.setInteractionInProgress(false);
        if (interactionType === Constants.interactionTypeRedirect) {
            this.logger.verbose("Interaction type is redirect");
            if (this.errorReceivedCallback) {
                this.logger.verbose("Two callbacks were provided to handleRedirectCallback, calling error callback");
                this.errorReceivedCallback(authErr, response.accountState);
            }
            else if (this.authResponseCallback) {
                this.logger.verbose("One callback was provided to handleRedirectCallback, calling authResponseCallback with error");
                this.authResponseCallback(authErr, response);
            }
            else {
                this.logger.verbose("handleRedirectCallback has not been called and no callbacks are registered, throwing error");
                throw authErr;
            }
        }
        else if (interactionType === Constants.interactionTypePopup) {
            this.logger.verbose("Interaction type is popup, rejecting");
            reject(authErr);
        }
        else {
            throw ClientAuthError.createInvalidInteractionTypeError();
        }
    };
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint.
     * @param {@link (AuthenticationParameters:type)}
     */
    UserAgentApplication.prototype.loginRedirect = function (userRequest) {
        this.logger.verbose("LoginRedirect has been called");
        // validate request
        var request = RequestUtils.validateRequest(userRequest, true, this.clientId, Constants.interactionTypeRedirect);
        this.acquireTokenInteractive(Constants.interactionTypeRedirect, true, request, null, null);
    };
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint.
     * @param {@link (AuthenticationParameters:type)}
     *
     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
     */
    UserAgentApplication.prototype.acquireTokenRedirect = function (userRequest) {
        this.logger.verbose("AcquireTokenRedirect has been called");
        // validate request
        var request = RequestUtils.validateRequest(userRequest, false, this.clientId, Constants.interactionTypeRedirect);
        this.acquireTokenInteractive(Constants.interactionTypeRedirect, false, request, null, null);
    };
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param {@link (AuthenticationParameters:type)}
     *
     * @returns {Promise.<AuthResponse>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */
    UserAgentApplication.prototype.loginPopup = function (userRequest) {
        var _this = this;
        this.logger.verbose("LoginPopup has been called");
        // validate request
        var request = RequestUtils.validateRequest(userRequest, true, this.clientId, Constants.interactionTypePopup);
        var apiEvent = this.telemetryManager.createAndStartApiEvent(request.correlationId, API_EVENT_IDENTIFIER.LoginPopup);
        return new Promise(function (resolve, reject) {
            _this.acquireTokenInteractive(Constants.interactionTypePopup, true, request, resolve, reject);
        })
            .then(function (resp) {
            _this.logger.verbose("Successfully logged in");
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, true);
            return resp;
        })
            .catch(function (error) {
            _this.cacheStorage.resetTempCacheItems(request.state);
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, false, error.errorCode);
            throw error;
        });
    };
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     * @param {@link AuthenticationParameters}
     *
     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
     * @returns {Promise.<AuthResponse>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */
    UserAgentApplication.prototype.acquireTokenPopup = function (userRequest) {
        var _this = this;
        this.logger.verbose("AcquireTokenPopup has been called");
        // validate request
        var request = RequestUtils.validateRequest(userRequest, false, this.clientId, Constants.interactionTypePopup);
        var apiEvent = this.telemetryManager.createAndStartApiEvent(request.correlationId, API_EVENT_IDENTIFIER.AcquireTokenPopup);
        return new Promise(function (resolve, reject) {
            _this.acquireTokenInteractive(Constants.interactionTypePopup, false, request, resolve, reject);
        })
            .then(function (resp) {
            _this.logger.verbose("Successfully acquired token");
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, true);
            return resp;
        })
            .catch(function (error) {
            _this.cacheStorage.resetTempCacheItems(request.state);
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, false, error.errorCode);
            throw error;
        });
    };
    // #region Acquire Token
    /**
     * Use when initiating the login process or when you want to obtain an access_token for your API,
     * either by redirecting the user's browser window to the authorization endpoint or via opening a popup window in the user's browser.
     * @param {@link (AuthenticationParameters:type)}
     *
     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
     */
    UserAgentApplication.prototype.acquireTokenInteractive = function (interactionType, isLoginCall, request, resolve, reject) {
        var _this = this;
        this.logger.verbose("AcquireTokenInteractive has been called");
        // block the request if made from the hidden iframe
        WindowUtils.blockReloadInHiddenIframes();
        try {
            this.cacheStorage.setInteractionInProgress(true);
        }
        catch (e) {
            // If already in progress, do not proceed
            var thrownError = isLoginCall ? ClientAuthError.createLoginInProgressError() : ClientAuthError.createAcquireTokenInProgressError();
            var stateOnlyResponse = buildResponseStateOnly(this.getAccountState(request.state));
            this.cacheStorage.resetTempCacheItems(request.state);
            this.authErrorHandler(interactionType, thrownError, stateOnlyResponse, reject);
            return;
        }
        if (interactionType === Constants.interactionTypeRedirect) {
            this.cacheStorage.setItem(TemporaryCacheKeys.REDIRECT_REQUEST, "" + Constants.inProgress + Constants.resourceDelimiter + request.state);
        }
        // Get the account object if a session exists
        var account;
        if (request && request.account && !isLoginCall) {
            account = request.account;
            this.logger.verbose("Account set from request");
        }
        else {
            account = this.getAccount();
            this.logger.verbose("Account set from MSAL Cache");
        }
        // If no session exists, prompt the user to login.
        if (!account && !ServerRequestParameters.isSSOParam(request)) {
            if (isLoginCall) {
                // extract ADAL id_token if exists
                var adalIdToken = this.extractADALIdToken();
                // silent login if ADAL id_token is retrieved successfully - SSO
                if (adalIdToken && !request.scopes) {
                    this.logger.info("ADAL's idToken exists. Extracting login information from ADAL's idToken");
                    var tokenRequest = this.buildIDTokenRequest(request);
                    this.silentLogin = true;
                    this.acquireTokenSilent(tokenRequest).then(function (response) {
                        _this.silentLogin = false;
                        _this.logger.info("Unified cache call is successful");
                        _this.authResponseHandler(interactionType, response, resolve);
                        return;
                    }, function (error) {
                        _this.silentLogin = false;
                        _this.logger.error("Error occurred during unified cache ATS: " + error);
                        // proceed to login since ATS failed
                        _this.acquireTokenHelper(null, interactionType, isLoginCall, request, resolve, reject);
                    });
                }
                // No ADAL token found, proceed to login
                else {
                    this.logger.verbose("Login call but no token found, proceed to login");
                    this.acquireTokenHelper(null, interactionType, isLoginCall, request, resolve, reject);
                }
            }
            // AcquireToken call, but no account or context given, so throw error
            else {
                this.logger.verbose("AcquireToken call, no context or account given");
                this.logger.info("User login is required");
                var stateOnlyResponse = buildResponseStateOnly(this.getAccountState(request.state));
                this.cacheStorage.resetTempCacheItems(request.state);
                this.authErrorHandler(interactionType, ClientAuthError.createUserLoginRequiredError(), stateOnlyResponse, reject);
                return;
            }
        }
        // User session exists
        else {
            this.logger.verbose("User session exists, login not required");
            this.acquireTokenHelper(account, interactionType, isLoginCall, request, resolve, reject);
        }
    };
    /**
     * @hidden
     * @ignore
     * Helper function to acquireToken
     *
     */
    UserAgentApplication.prototype.acquireTokenHelper = function (account, interactionType, isLoginCall, request, resolve, reject) {
        return __awaiter(this, void 0, void 0, function () {
            var requestSignature, serverAuthenticationRequest, acquireTokenAuthority, popUpWindow, responseType, loginStartPage, urlNavigate, hash, error_1, navigate, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("AcquireTokenHelper has been called");
                        this.logger.verbose("Interaction type: " + interactionType + ". isLoginCall: " + isLoginCall);
                        requestSignature = request.scopes ? request.scopes.join(" ").toLowerCase() : Constants.oidcScopes.join(" ");
                        this.logger.verbosePii("Request signature: " + requestSignature);
                        acquireTokenAuthority = (request && request.authority) ? AuthorityFactory.CreateInstance(request.authority, this.config.auth.validateAuthority, request.authorityMetadata) : this.authorityInstance;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 11, , 12]);
                        if (!!acquireTokenAuthority.hasCachedMetadata()) return [3 /*break*/, 3];
                        this.logger.verbose("No cached metadata for authority");
                        return [4 /*yield*/, AuthorityFactory.saveMetadataFromNetwork(acquireTokenAuthority, this.telemetryManager, request.correlationId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.logger.verbose("Cached metadata found for authority");
                        _a.label = 4;
                    case 4:
                        responseType = isLoginCall ? ResponseTypes.id_token : this.getTokenType(account, request.scopes);
                        loginStartPage = request.redirectStartPage || window.location.href;
                        serverAuthenticationRequest = new ServerRequestParameters(acquireTokenAuthority, this.clientId, responseType, this.getRedirectUri(request && request.redirectUri), request.scopes, request.state, request.correlationId);
                        this.logger.verbose("Finished building server authentication request");
                        this.updateCacheEntries(serverAuthenticationRequest, account, isLoginCall, loginStartPage);
                        this.logger.verbose("Updating cache entries");
                        // populate QueryParameters (sid/login_hint) and any other extraQueryParameters set by the developer
                        serverAuthenticationRequest.populateQueryParams(account, request);
                        this.logger.verbose("Query parameters populated from account");
                        urlNavigate = UrlUtils.createNavigateUrl(serverAuthenticationRequest) + Constants.response_mode_fragment;
                        // set state in cache
                        if (interactionType === Constants.interactionTypeRedirect) {
                            if (!isLoginCall) {
                                this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_ACQ_TOKEN, request.state), serverAuthenticationRequest.state, this.inCookie);
                                this.logger.verbose("State cached for redirect");
                                this.logger.verbosePii("State cached: " + serverAuthenticationRequest.state);
                            }
                            else {
                                this.logger.verbose("Interaction type redirect but login call is true. State not cached");
                            }
                        }
                        else if (interactionType === Constants.interactionTypePopup) {
                            window.renewStates.push(serverAuthenticationRequest.state);
                            window.requestType = isLoginCall ? Constants.login : Constants.renewToken;
                            this.logger.verbose("State saved to window");
                            this.logger.verbosePii("State saved: " + serverAuthenticationRequest.state);
                            // Register callback to capture results from server
                            this.registerCallback(serverAuthenticationRequest.state, requestSignature, resolve, reject);
                        }
                        else {
                            this.logger.verbose("Invalid interaction error. State not cached");
                            throw ClientAuthError.createInvalidInteractionTypeError();
                        }
                        if (!(interactionType === Constants.interactionTypePopup)) return [3 /*break*/, 9];
                        this.logger.verbose("Interaction type is popup. Generating popup window");
                        // Generate a popup window
                        try {
                            popUpWindow = this.openPopup(urlNavigate, "msal", Constants.popUpWidth, Constants.popUpHeight);
                            // Push popup window handle onto stack for tracking
                            WindowUtils.trackPopup(popUpWindow);
                        }
                        catch (e) {
                            this.logger.info(ClientAuthErrorMessage.popUpWindowError.code + ":" + ClientAuthErrorMessage.popUpWindowError.desc);
                            this.cacheStorage.setItem(ErrorCacheKeys.ERROR, ClientAuthErrorMessage.popUpWindowError.code);
                            this.cacheStorage.setItem(ErrorCacheKeys.ERROR_DESC, ClientAuthErrorMessage.popUpWindowError.desc);
                            if (reject) {
                                reject(ClientAuthError.createPopupWindowError());
                                return [2 /*return*/];
                            }
                        }
                        if (!popUpWindow) return [3 /*break*/, 8];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, WindowUtils.monitorPopupForHash(popUpWindow, this.config.system.loadFrameTimeout, urlNavigate, this.logger)];
                    case 6:
                        hash = _a.sent();
                        this.handleAuthenticationResponse(hash);
                        // Request completed successfully, set to completed
                        this.cacheStorage.setInteractionInProgress(false);
                        this.logger.info("Closing popup window");
                        // TODO: Check how this can be extracted for any framework specific code?
                        if (this.config.framework.isAngular) {
                            this.broadcast("msal:popUpHashChanged", hash);
                        }
                        WindowUtils.closePopups();
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        if (reject) {
                            reject(error_1);
                        }
                        if (this.config.framework.isAngular) {
                            this.broadcast("msal:popUpClosed", error_1.errorCode + Constants.resourceDelimiter + error_1.errorMessage);
                        }
                        else {
                            // Request failed, set to canceled
                            this.cacheStorage.setInteractionInProgress(false);
                            popUpWindow.close();
                        }
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        // If onRedirectNavigate is implemented, invoke it and provide urlNavigate
                        if (request.onRedirectNavigate) {
                            this.logger.verbose("Invoking onRedirectNavigate callback");
                            navigate = request.onRedirectNavigate(urlNavigate);
                            // Returning false from onRedirectNavigate will stop navigation
                            if (navigate !== false) {
                                this.logger.verbose("onRedirectNavigate did not return false, navigating");
                                this.navigateWindow(urlNavigate);
                            }
                            else {
                                this.logger.verbose("onRedirectNavigate returned false, stopping navigation");
                            }
                        }
                        else {
                            // Otherwise, perform navigation
                            this.logger.verbose("Navigating window to urlNavigate");
                            this.navigateWindow(urlNavigate);
                        }
                        _a.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        err_1 = _a.sent();
                        this.logger.error(err_1);
                        this.cacheStorage.resetTempCacheItems(request.state);
                        this.authErrorHandler(interactionType, ClientAuthError.createEndpointResolutionError(err_1.toString), buildResponseStateOnly(request.state), reject);
                        if (popUpWindow) {
                            popUpWindow.close();
                        }
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * API interfacing idToken request when applications already have a session/hint acquired by authorization client applications
     * @param request
     */
    UserAgentApplication.prototype.ssoSilent = function (request) {
        this.logger.verbose("ssoSilent has been called");
        // throw an error on an empty request
        if (!request) {
            throw ClientConfigurationError.createEmptyRequestError();
        }
        // throw an error on no hints passed
        if (!request.sid && !request.loginHint) {
            throw ClientConfigurationError.createSsoSilentError();
        }
        return this.acquireTokenSilent(__assign(__assign({}, request), { scopes: Constants.oidcScopes }));
    };
    /**
     * Use this function to obtain a token before every call to the API / resource provider
     *
     * MSAL return's a cached token when available
     * Or it send's a request to the STS to obtain a new token using a hidden iframe.
     *
     * @param {@link AuthenticationParameters}
     *
     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
     * @returns {Promise.<AuthResponse>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     *
     */
    UserAgentApplication.prototype.acquireTokenSilent = function (userRequest) {
        var _this = this;
        this.logger.verbose("AcquireTokenSilent has been called");
        // validate the request
        var request = RequestUtils.validateRequest(userRequest, false, this.clientId, Constants.interactionTypeSilent);
        var apiEvent = this.telemetryManager.createAndStartApiEvent(request.correlationId, API_EVENT_IDENTIFIER.AcquireTokenSilent);
        var requestSignature = RequestUtils.createRequestSignature(request);
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var scope, account, adalIdToken, responseType, serverAuthenticationRequest, adalIdTokenObject, userContainedClaims, authErr, cacheResultResponse, logMessage, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // block the request if made from the hidden iframe
                        WindowUtils.blockReloadInHiddenIframes();
                        scope = request.scopes.join(" ").toLowerCase();
                        this.logger.verbosePii("Serialized scopes: " + scope);
                        if (request.account) {
                            account = request.account;
                            this.logger.verbose("Account set from request");
                        }
                        else {
                            account = this.getAccount();
                            this.logger.verbose("Account set from MSAL Cache");
                        }
                        adalIdToken = this.cacheStorage.getItem(Constants.adalIdToken);
                        // In the event of no account being passed in the config, no session id, and no pre-existing adalIdToken, user will need to log in
                        if (!account && !(request.sid || request.loginHint) && StringUtils.isEmpty(adalIdToken)) {
                            this.logger.info("User login is required");
                            // The promise rejects with a UserLoginRequiredError, which should be caught and user should be prompted to log in interactively
                            return [2 /*return*/, reject(ClientAuthError.createUserLoginRequiredError())];
                        }
                        responseType = this.getTokenType(account, request.scopes);
                        this.logger.verbose("Response type: " + responseType);
                        serverAuthenticationRequest = new ServerRequestParameters(AuthorityFactory.CreateInstance(request.authority, this.config.auth.validateAuthority, request.authorityMetadata), this.clientId, responseType, this.getRedirectUri(request.redirectUri), request.scopes, request.state, request.correlationId);
                        this.logger.verbose("Finished building server authentication request");
                        // populate QueryParameters (sid/login_hint) and any other extraQueryParameters set by the developer
                        if (ServerRequestParameters.isSSOParam(request) || account) {
                            serverAuthenticationRequest.populateQueryParams(account, request, null, true);
                            this.logger.verbose("Query parameters populated from existing SSO or account");
                        }
                        // if user didn't pass login_hint/sid and adal's idtoken is present, extract the login_hint from the adalIdToken
                        else if (!account && !StringUtils.isEmpty(adalIdToken)) {
                            adalIdTokenObject = TokenUtils.extractIdToken(adalIdToken);
                            this.logger.verbose("ADAL's idToken exists. Extracting login information from ADAL's idToken to populate query parameters");
                            serverAuthenticationRequest.populateQueryParams(account, null, adalIdTokenObject, true);
                        }
                        else {
                            this.logger.verbose("No additional query parameters added");
                        }
                        userContainedClaims = request.claimsRequest || serverAuthenticationRequest.claimsValue;
                        // If request.forceRefresh is set to true, force a request for a new token instead of getting it from the cache
                        if (!userContainedClaims && !request.forceRefresh) {
                            try {
                                cacheResultResponse = this.getCachedToken(serverAuthenticationRequest, account);
                            }
                            catch (e) {
                                authErr = e;
                            }
                        }
                        if (!cacheResultResponse) return [3 /*break*/, 1];
                        this.logger.verbose("Token found in cache lookup");
                        this.logger.verbosePii("Scopes found: " + JSON.stringify(cacheResultResponse.scopes));
                        resolve(cacheResultResponse);
                        return [2 /*return*/, null];
                    case 1:
                        if (!authErr) return [3 /*break*/, 2];
                        this.logger.infoPii(authErr.errorCode + ":" + authErr.errorMessage);
                        reject(authErr);
                        return [2 /*return*/, null];
                    case 2:
                        logMessage = void 0;
                        if (userContainedClaims) {
                            logMessage = "Skipped cache lookup since claims were given";
                        }
                        else if (request.forceRefresh) {
                            logMessage = "Skipped cache lookup since request.forceRefresh option was set to true";
                        }
                        else {
                            logMessage = "No valid token found in cache lookup";
                        }
                        this.logger.verbose(logMessage);
                        // Cache result can return null if cache is empty. In that case, set authority to default value if no authority is passed to the API.
                        if (!serverAuthenticationRequest.authorityInstance) {
                            serverAuthenticationRequest.authorityInstance = request.authority ?
                                AuthorityFactory.CreateInstance(request.authority, this.config.auth.validateAuthority, request.authorityMetadata)
                                : this.authorityInstance;
                        }
                        this.logger.verbosePii("Authority instance: " + serverAuthenticationRequest.authority);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 7, , 8]);
                        if (!!serverAuthenticationRequest.authorityInstance.hasCachedMetadata()) return [3 /*break*/, 5];
                        this.logger.verbose("No cached metadata for authority");
                        return [4 /*yield*/, AuthorityFactory.saveMetadataFromNetwork(serverAuthenticationRequest.authorityInstance, this.telemetryManager, request.correlationId)];
                    case 4:
                        _a.sent();
                        this.logger.verbose("Authority has been updated with endpoint discovery response");
                        return [3 /*break*/, 6];
                    case 5:
                        this.logger.verbose("Cached metadata found for authority");
                        _a.label = 6;
                    case 6:
                        /*
                         * refresh attempt with iframe
                         * Already renewing for this scope, callback when we get the token.
                         */
                        if (window.activeRenewals[requestSignature]) {
                            this.logger.verbose("Renewing token in progress. Registering callback");
                            // Active renewals contains the state for each renewal.
                            this.registerCallback(window.activeRenewals[requestSignature], requestSignature, resolve, reject);
                        }
                        else {
                            if (request.scopes && ScopeSet.onlyContainsOidcScopes(request.scopes)) {
                                /*
                                 * App uses idToken to send to api endpoints
                                 * Default scope is tracked as OIDC scopes to store this token
                                 */
                                this.logger.verbose("OpenID Connect scopes only, renewing idToken");
                                this.silentLogin = true;
                                this.renewIdToken(requestSignature, resolve, reject, account, serverAuthenticationRequest);
                            }
                            else {
                                // renew access token
                                this.logger.verbose("Renewing access token");
                                this.renewToken(requestSignature, resolve, reject, account, serverAuthenticationRequest);
                            }
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        this.logger.error(err_2);
                        reject(ClientAuthError.createEndpointResolutionError(err_2.toString()));
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        }); })
            .then(function (res) {
            _this.logger.verbose("Successfully acquired token");
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, true);
            return res;
        })
            .catch(function (error) {
            _this.cacheStorage.resetTempCacheItems(request.state);
            _this.telemetryManager.stopAndFlushApiEvent(request.correlationId, apiEvent, false, error.errorCode);
            throw error;
        });
    };
    // #endregion
    // #region Popup Window Creation
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @ignore
     * @hidden
     */
    UserAgentApplication.prototype.openPopup = function (urlNavigate, title, popUpWidth, popUpHeight) {
        this.logger.verbose("OpenPopup has been called");
        try {
            /**
             * adding winLeft and winTop to account for dual monitor
             * using screenLeft and screenTop for IE8 and earlier
             */
            var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
            var winTop = window.screenTop ? window.screenTop : window.screenY;
            /**
             * window.innerWidth displays browser window"s height and width excluding toolbars
             * using document.documentElement.clientWidth for IE8 and earlier
             */
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var left = ((width / 2) - (popUpWidth / 2)) + winLeft;
            var top_1 = ((height / 2) - (popUpHeight / 2)) + winTop;
            // open the window
            var popupWindow = window.open(urlNavigate, title, "width=" + popUpWidth + ", height=" + popUpHeight + ", top=" + top_1 + ", left=" + left + ", scrollbars=yes");
            if (!popupWindow) {
                throw ClientAuthError.createPopupWindowError();
            }
            if (popupWindow.focus) {
                popupWindow.focus();
            }
            return popupWindow;
        }
        catch (e) {
            this.cacheStorage.setInteractionInProgress(false);
            throw ClientAuthError.createPopupWindowError(e.toString());
        }
    };
    // #endregion
    // #region Iframe Management
    /**
     * @hidden
     * Calling _loadFrame but with a timeout to signal failure in loadframeStatus. Callbacks are left.
     * registered when network errors occur and subsequent token requests for same resource are registered to the pending request.
     * @ignore
     */
    UserAgentApplication.prototype.loadIframeTimeout = function (urlNavigate, frameName, requestSignature) {
        return __awaiter(this, void 0, void 0, function () {
            var expectedState, iframe, _a, hash, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        expectedState = window.activeRenewals[requestSignature];
                        this.logger.verbosePii("Set loading state to pending for: " + requestSignature + ":" + expectedState);
                        this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.RENEW_STATUS, expectedState), Constants.inProgress);
                        if (!this.config.system.navigateFrameWait) return [3 /*break*/, 2];
                        return [4 /*yield*/, WindowUtils.loadFrame(urlNavigate, frameName, this.config.system.navigateFrameWait, this.logger)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = WindowUtils.loadFrameSync(urlNavigate, frameName, this.logger);
                        _b.label = 3;
                    case 3:
                        iframe = _a;
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, WindowUtils.monitorIframeForHash(iframe.contentWindow, this.config.system.loadFrameTimeout, urlNavigate, this.logger)];
                    case 5:
                        hash = _b.sent();
                        if (hash) {
                            this.handleAuthenticationResponse(hash);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        if (this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.RENEW_STATUS, expectedState)) === Constants.inProgress) {
                            // fail the iframe session if it's in pending state
                            this.logger.verbose("Loading frame has timed out after: " + (this.config.system.loadFrameTimeout / 1000) + " seconds for scope/authority " + requestSignature + ":" + expectedState);
                            // Error after timeout
                            if (expectedState && window.callbackMappedToRenewStates[expectedState]) {
                                window.callbackMappedToRenewStates[expectedState](null, error_2);
                            }
                            this.cacheStorage.removeItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.RENEW_STATUS, expectedState));
                        }
                        WindowUtils.removeHiddenIframe(iframe);
                        throw error_2;
                    case 7:
                        WindowUtils.removeHiddenIframe(iframe);
                        return [2 /*return*/];
                }
            });
        });
    };
    // #endregion
    // #region General Helpers
    /**
     * @hidden
     * Used to redirect the browser to the STS authorization endpoint
     * @param {string} urlNavigate - URL of the authorization endpoint
     */
    UserAgentApplication.prototype.navigateWindow = function (urlNavigate, popupWindow) {
        // Navigate if valid URL
        if (urlNavigate && !StringUtils.isEmpty(urlNavigate)) {
            var navigateWindow = popupWindow ? popupWindow : window;
            var logMessage = popupWindow ? "Navigated Popup window to:" + urlNavigate : "Navigate to:" + urlNavigate;
            this.logger.infoPii(logMessage);
            navigateWindow.location.assign(urlNavigate);
        }
        else {
            this.logger.info("Navigate url is empty");
            throw AuthError.createUnexpectedError("Navigate url is empty");
        }
    };
    /**
     * @hidden
     * Used to add the developer requested callback to the array of callbacks for the specified scopes. The updated array is stored on the window object
     * @param {string} expectedState - Unique state identifier (guid).
     * @param {string} scope - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {Function} resolve - The resolve function of the promise object.
     * @param {Function} reject - The reject function of the promise object.
     * @ignore
     */
    UserAgentApplication.prototype.registerCallback = function (expectedState, requestSignature, resolve, reject) {
        var _this = this;
        // track active renewals
        window.activeRenewals[requestSignature] = expectedState;
        // initialize callbacks mapped array
        if (!window.promiseMappedToRenewStates[expectedState]) {
            window.promiseMappedToRenewStates[expectedState] = [];
        }
        // indexing on the current state, push the callback params to callbacks mapped
        window.promiseMappedToRenewStates[expectedState].push({ resolve: resolve, reject: reject });
        // Store the server response in the current window??
        if (!window.callbackMappedToRenewStates[expectedState]) {
            window.callbackMappedToRenewStates[expectedState] = function (response, error) {
                // reset active renewals
                delete window.activeRenewals[requestSignature];
                // for all promiseMappedtoRenewStates for a given 'state' - call the reject/resolve with error/token respectively
                for (var i = 0; i < window.promiseMappedToRenewStates[expectedState].length; ++i) {
                    try {
                        if (error) {
                            window.promiseMappedToRenewStates[expectedState][i].reject(error);
                        }
                        else if (response) {
                            window.promiseMappedToRenewStates[expectedState][i].resolve(response);
                        }
                        else {
                            _this.cacheStorage.resetTempCacheItems(expectedState);
                            throw AuthError.createUnexpectedError("Error and response are both null");
                        }
                    }
                    catch (e) {
                        _this.logger.warning(e);
                    }
                }
                // reset
                delete window.promiseMappedToRenewStates[expectedState];
                delete window.callbackMappedToRenewStates[expectedState];
            };
        }
    };
    // #endregion
    // #region Logout
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     */
    UserAgentApplication.prototype.logout = function (correlationId) {
        this.logger.verbose("Logout has been called");
        this.logoutAsync(correlationId);
    };
    /**
     * Async version of logout(). Use to log out the current user.
     * @param correlationId Request correlationId
     */
    UserAgentApplication.prototype.logoutAsync = function (correlationId) {
        return __awaiter(this, void 0, void 0, function () {
            var requestCorrelationId, apiEvent, correlationIdParam, postLogoutQueryParam, urlNavigate, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestCorrelationId = correlationId || CryptoUtils.createNewGuid();
                        apiEvent = this.telemetryManager.createAndStartApiEvent(requestCorrelationId, API_EVENT_IDENTIFIER.Logout);
                        this.clearCache();
                        this.account = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!!this.authorityInstance.hasCachedMetadata()) return [3 /*break*/, 3];
                        this.logger.verbose("No cached metadata for authority");
                        return [4 /*yield*/, AuthorityFactory.saveMetadataFromNetwork(this.authorityInstance, this.telemetryManager, correlationId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.logger.verbose("Cached metadata found for authority");
                        _a.label = 4;
                    case 4:
                        correlationIdParam = "client-request-id=" + requestCorrelationId;
                        postLogoutQueryParam = void 0;
                        if (this.getPostLogoutRedirectUri()) {
                            postLogoutQueryParam = "&post_logout_redirect_uri=" + encodeURIComponent(this.getPostLogoutRedirectUri());
                            this.logger.verbose("redirectUri found and set");
                        }
                        else {
                            postLogoutQueryParam = "";
                            this.logger.verbose("No redirectUri set for app. postLogoutQueryParam is empty");
                        }
                        urlNavigate = void 0;
                        if (this.authorityInstance.EndSessionEndpoint) {
                            urlNavigate = this.authorityInstance.EndSessionEndpoint + "?" + correlationIdParam + postLogoutQueryParam;
                            this.logger.verbose("EndSessionEndpoint found and urlNavigate set");
                            this.logger.verbosePii("urlNavigate set to: " + this.authorityInstance.EndSessionEndpoint);
                        }
                        else {
                            urlNavigate = this.authority + "oauth2/v2.0/logout?" + correlationIdParam + postLogoutQueryParam;
                            this.logger.verbose("No endpoint, urlNavigate set to default");
                        }
                        this.telemetryManager.stopAndFlushApiEvent(requestCorrelationId, apiEvent, true);
                        this.logger.verbose("Navigating window to urlNavigate");
                        this.navigateWindow(urlNavigate);
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _a.sent();
                        this.telemetryManager.stopAndFlushApiEvent(requestCorrelationId, apiEvent, false, error_3.errorCode);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     * Clear all access tokens and ID tokens in the cache.
     * @ignore
     */
    UserAgentApplication.prototype.clearCache = function () {
        this.logger.verbose("Clearing cache");
        window.renewStates = [];
        var tokenCacheItems = this.cacheStorage.getAllTokens(Constants.clientId, Constants.homeAccountIdentifier);
        for (var i = 0; i < tokenCacheItems.length; i++) {
            this.cacheStorage.removeItem(JSON.stringify(tokenCacheItems[i].key));
        }
        this.cacheStorage.resetCacheItems();
        this.cacheStorage.clearMsalCookie();
        this.logger.verbose("Cache cleared");
    };
    /**
     * @hidden
     * Clear a given access token from the cache.
     *
     * @param accessToken
     */
    UserAgentApplication.prototype.clearCacheForScope = function (accessToken) {
        this.logger.verbose("Clearing access token from cache");
        var accessTokenItems = this.cacheStorage.getAllAccessTokens(Constants.clientId, Constants.homeAccountIdentifier);
        for (var i = 0; i < accessTokenItems.length; i++) {
            var token = accessTokenItems[i];
            if (token.value.accessToken === accessToken) {
                this.cacheStorage.removeItem(JSON.stringify(token.key));
                this.logger.verbosePii("Access token removed: " + token.key);
            }
        }
    };
    // #endregion
    // #region Response
    /**
     * @hidden
     * @ignore
     * Checks if the redirect response is received from the STS. In case of redirect, the url fragment has either id_token, access_token or error.
     * @param {string} hash - Hash passed from redirect page.
     * @returns {Boolean} - true if response contains id_token, access_token or error, false otherwise.
     */
    UserAgentApplication.prototype.isCallback = function (hash) {
        this.logger.info("isCallback will be deprecated in favor of urlContainsHash in MSAL.js v2.0.");
        this.logger.verbose("isCallback has been called");
        return UrlUtils.urlContainsHash(hash);
    };
    /**
     * @hidden
     * Used to call the constructor callback with the token/error
     * @param {string} [hash=window.location.hash] - Hash fragment of Url.
     */
    UserAgentApplication.prototype.processCallBack = function (hash, respStateInfo, parentCallback) {
        this.logger.info("ProcessCallBack has been called. Processing callback from redirect response");
        // get the state info from the hash
        var stateInfo = respStateInfo;
        if (!stateInfo) {
            this.logger.verbose("StateInfo is null, getting stateInfo from hash");
            stateInfo = this.getResponseState(hash);
        }
        var response;
        var authErr;
        // Save the token info from the hash
        try {
            response = this.saveTokenFromHash(hash, stateInfo);
        }
        catch (err) {
            authErr = err;
        }
        try {
            // Clear the cookie in the hash
            this.cacheStorage.clearMsalCookie(stateInfo.state);
            var accountState = this.getAccountState(stateInfo.state);
            if (response) {
                if ((stateInfo.requestType === Constants.renewToken) || response.accessToken) {
                    if (window.parent !== window) {
                        this.logger.verbose("Window is in iframe, acquiring token silently");
                    }
                    else {
                        this.logger.verbose("Acquiring token interactive in progress");
                    }
                    this.logger.verbose("Response tokenType set to " + ServerHashParamKeys.ACCESS_TOKEN);
                    response.tokenType = ServerHashParamKeys.ACCESS_TOKEN;
                }
                else if (stateInfo.requestType === Constants.login) {
                    this.logger.verbose("Response tokenType set to " + ServerHashParamKeys.ID_TOKEN);
                    response.tokenType = ServerHashParamKeys.ID_TOKEN;
                }
                if (!parentCallback) {
                    this.logger.verbose("Setting redirectResponse");
                    this.redirectResponse = response;
                    return;
                }
            }
            else if (!parentCallback) {
                this.logger.verbose("Response is null, setting redirectResponse with state");
                this.redirectResponse = buildResponseStateOnly(accountState);
                this.redirectError = authErr;
                this.cacheStorage.resetTempCacheItems(stateInfo.state);
                return;
            }
            this.logger.verbose("Calling callback provided to processCallback");
            parentCallback(response, authErr);
        }
        catch (err) {
            this.logger.error("Error occurred in token received callback function: " + err);
            throw ClientAuthError.createErrorInCallbackFunction(err.toString());
        }
    };
    /**
     * @hidden
     * This method must be called for processing the response received from the STS if using popups or iframes. It extracts the hash, processes the token or error
     * information and saves it in the cache. It then resolves the promises with the result.
     * @param {string} [hash=window.location.hash] - Hash fragment of Url.
     */
    UserAgentApplication.prototype.handleAuthenticationResponse = function (hash) {
        this.logger.verbose("HandleAuthenticationResponse has been called");
        // retrieve the hash
        var locationHash = hash || window.location.hash;
        // if (window.parent !== window), by using self, window.parent becomes equal to window in getResponseState method specifically
        var stateInfo = this.getResponseState(locationHash);
        this.logger.verbose("Obtained state from response");
        var tokenResponseCallback = window.callbackMappedToRenewStates[stateInfo.state];
        this.processCallBack(locationHash, stateInfo, tokenResponseCallback);
    };
    /**
     * @hidden
     * This method must be called for processing the response received from the STS when using redirect flows. It extracts the hash, processes the token or error
     * information and saves it in the cache. The result can then be accessed by user registered callbacks.
     * @param {string} [hash=window.location.hash] - Hash fragment of Url.
     */
    UserAgentApplication.prototype.handleRedirectAuthenticationResponse = function (hash) {
        this.logger.info("Returned from redirect url");
        this.logger.verbose("HandleRedirectAuthenticationResponse has been called");
        // clear hash from window
        WindowUtils.clearUrlFragment(window);
        this.logger.verbose("Window.location.hash cleared");
        // if (window.parent !== window), by using self, window.parent becomes equal to window in getResponseState method specifically
        var stateInfo = this.getResponseState(hash);
        // if set to navigate to loginRequest page post login
        if (this.config.auth.navigateToLoginRequestUrl && window.parent === window) {
            this.logger.verbose("Window.parent is equal to window, not in popup or iframe. Navigation to login request url after login turned on");
            var loginRequestUrl = this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.LOGIN_REQUEST, stateInfo.state), this.inCookie);
            // Redirect to home page if login request url is null (real null or the string null)
            if (!loginRequestUrl || loginRequestUrl === "null") {
                this.logger.error("Unable to get valid login request url from cache, redirecting to home page");
                window.location.assign("/");
                return;
            }
            else {
                this.logger.verbose("Valid login request url obtained from cache");
                var currentUrl = UrlUtils.removeHashFromUrl(window.location.href);
                var finalRedirectUrl = UrlUtils.removeHashFromUrl(loginRequestUrl);
                if (currentUrl !== finalRedirectUrl) {
                    this.logger.verbose("Current url is not login request url, navigating");
                    this.logger.verbosePii("CurrentUrl: " + currentUrl + ", finalRedirectUrl: " + finalRedirectUrl);
                    window.location.assign("" + finalRedirectUrl + hash);
                    return;
                }
                else {
                    this.logger.verbose("Current url matches login request url");
                    var loginRequestUrlComponents = UrlUtils.GetUrlComponents(loginRequestUrl);
                    if (loginRequestUrlComponents.Hash) {
                        this.logger.verbose("Login request url contains hash, resetting non-msal hash");
                        window.location.hash = loginRequestUrlComponents.Hash;
                    }
                }
            }
        }
        else if (!this.config.auth.navigateToLoginRequestUrl) {
            this.logger.verbose("Default navigation to start page after login turned off");
        }
        this.processCallBack(hash, stateInfo, null);
    };
    /**
     * @hidden
     * Creates a stateInfo object from the URL fragment and returns it.
     * @param {string} hash  -  Hash passed from redirect page
     * @returns {TokenResponse} an object created from the redirect response from AAD comprising of the keys - parameters, requestType, stateMatch, stateResponse and valid.
     * @ignore
     */
    UserAgentApplication.prototype.getResponseState = function (hash) {
        this.logger.verbose("GetResponseState has been called");
        var parameters = UrlUtils.deserializeHash(hash);
        var stateResponse;
        if (!parameters) {
            throw AuthError.createUnexpectedError("Hash was not parsed correctly.");
        }
        if (parameters.hasOwnProperty(ServerHashParamKeys.STATE)) {
            this.logger.verbose("Hash contains state. Creating stateInfo object");
            var parsedState = RequestUtils.parseLibraryState(parameters["state"]);
            stateResponse = {
                requestType: Constants.unknown,
                state: parameters["state"],
                timestamp: parsedState.ts,
                method: parsedState.method,
                stateMatch: false
            };
        }
        else {
            throw AuthError.createUnexpectedError("Hash does not contain state.");
        }
        /*
         * async calls can fire iframe and login request at the same time if developer does not use the API as expected
         * incoming callback needs to be looked up to find the request type
         */
        // loginRedirect
        if (stateResponse.state === this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_LOGIN, stateResponse.state), this.inCookie) || stateResponse.state === this.silentAuthenticationState) {
            this.logger.verbose("State matches cached state, setting requestType to login");
            stateResponse.requestType = Constants.login;
            stateResponse.stateMatch = true;
            return stateResponse;
        }
        // acquireTokenRedirect
        else if (stateResponse.state === this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_ACQ_TOKEN, stateResponse.state), this.inCookie)) {
            this.logger.verbose("State matches cached state, setting requestType to renewToken");
            stateResponse.requestType = Constants.renewToken;
            stateResponse.stateMatch = true;
            return stateResponse;
        }
        // external api requests may have many renewtoken requests for different resource
        if (!stateResponse.stateMatch) {
            this.logger.verbose("State does not match cached state, setting requestType to type from window");
            stateResponse.requestType = window.requestType;
            var statesInParentContext = window.renewStates;
            for (var i = 0; i < statesInParentContext.length; i++) {
                if (statesInParentContext[i] === stateResponse.state) {
                    this.logger.verbose("Matching state found for request");
                    stateResponse.stateMatch = true;
                    break;
                }
            }
            if (!stateResponse.stateMatch) {
                this.logger.verbose("Matching state not found for request");
            }
        }
        return stateResponse;
    };
    // #endregion
    // #region Token Processing (Extract to TokenProcessing.ts)
    /**
     * @hidden
     * Used to get token for the specified set of scopes from the cache
     * @param {@link ServerRequestParameters} - Request sent to the STS to obtain an id_token/access_token
     * @param {Account} account - Account for which the scopes were requested
     */
    UserAgentApplication.prototype.getCachedToken = function (serverAuthenticationRequest, account) {
        this.logger.verbose("GetCachedToken has been called");
        var scopes = serverAuthenticationRequest.scopes;
        /**
         * Id Token should be returned in every acquireTokenSilent call. The only exception is a response_type = token
         * request when a valid ID Token is not present in the cache.
         */
        var idToken = this.getCachedIdToken(serverAuthenticationRequest, account);
        var authResponse = this.getCachedAccessToken(serverAuthenticationRequest, account, scopes);
        var accountState = this.getAccountState(serverAuthenticationRequest.state);
        return ResponseUtils.buildAuthResponse(idToken, authResponse, serverAuthenticationRequest, account, scopes, accountState);
    };
    /**
     * @hidden
     *
     * Uses passed in authority to further filter an array of tokenCacheItems until only the token being searched for remains, then returns that tokenCacheItem.
     * This method will throw if authority filtering still yields multiple matching tokens and will return null if not tokens match the authority passed in.
     *
     * @param authority
     * @param tokenCacheItems
     * @param request
     * @param requestScopes
     * @param tokenType
     */
    UserAgentApplication.prototype.getTokenCacheItemByAuthority = function (authority, tokenCacheItems, requestScopes, tokenType) {
        var _this = this;
        var filteredAuthorityItems;
        if (UrlUtils.isCommonAuthority(authority) || UrlUtils.isOrganizationsAuthority(authority) || UrlUtils.isConsumersAuthority(authority)) {
            filteredAuthorityItems = AuthCacheUtils.filterTokenCacheItemsByDomain(tokenCacheItems, UrlUtils.GetUrlComponents(authority).HostNameAndPort);
        }
        else {
            filteredAuthorityItems = AuthCacheUtils.filterTokenCacheItemsByAuthority(tokenCacheItems, authority);
        }
        if (filteredAuthorityItems.length === 1) {
            return filteredAuthorityItems[0];
        }
        else if (filteredAuthorityItems.length > 1) {
            this.logger.warning("Multiple matching tokens found. Cleaning cache and requesting a new token.");
            filteredAuthorityItems.forEach(function (accessTokenCacheItem) {
                _this.cacheStorage.removeItem(JSON.stringify(accessTokenCacheItem.key));
            });
            return null;
        }
        else {
            this.logger.verbose("No matching tokens of type " + tokenType + " found");
            return null;
        }
    };
    /**
     *
     * @hidden
     *
     * Searches the token cache for an ID Token that matches the request parameter and returns it as an IdToken object.
     *
     * @param serverAuthenticationRequest
     * @param account
     */
    UserAgentApplication.prototype.getCachedIdToken = function (serverAuthenticationRequest, account) {
        this.logger.verbose("Getting all cached tokens of type ID Token");
        var idTokenCacheItems = this.cacheStorage.getAllIdTokens(this.clientId, account ? account.homeAccountIdentifier : null);
        var matchAuthority = serverAuthenticationRequest.authority || this.authority;
        var idTokenCacheItem = this.getTokenCacheItemByAuthority(matchAuthority, idTokenCacheItems, null, ServerHashParamKeys.ID_TOKEN);
        if (idTokenCacheItem) {
            this.logger.verbose("Evaluating ID token found");
            var idTokenIsStillValid = this.evaluateTokenExpiration(idTokenCacheItem);
            if (idTokenIsStillValid) {
                this.logger.verbose("ID token expiration is within offset, using ID token found in cache");
                var idTokenValue = idTokenCacheItem.value;
                if (idTokenValue) {
                    this.logger.verbose("ID Token found in cache is valid and unexpired");
                }
                else {
                    this.logger.verbose("ID Token found in cache is invalid");
                }
                return (idTokenValue) ? new IdToken(idTokenValue.idToken) : null;
            }
            else {
                this.logger.verbose("Cached ID token is expired, removing from cache");
                this.cacheStorage.removeItem(JSON.stringify(idTokenCacheItem.key));
                return null;
            }
        }
        else {
            this.logger.verbose("No tokens found");
            return null;
        }
    };
    /**
     *
     * @hidden
     *
     * Searches the token cache for an access token that matches the request parameters and returns it as an AuthResponse.
     *
     * @param serverAuthenticationRequest
     * @param account
     * @param scopes
     */
    UserAgentApplication.prototype.getCachedAccessToken = function (serverAuthenticationRequest, account, scopes) {
        this.logger.verbose("Getting all cached tokens of type Access Token");
        var tokenCacheItems = this.cacheStorage.getAllAccessTokens(this.clientId, account ? account.homeAccountIdentifier : null);
        var scopeFilteredTokenCacheItems = AuthCacheUtils.filterTokenCacheItemsByScope(tokenCacheItems, scopes);
        var matchAuthority = serverAuthenticationRequest.authority || this.authority;
        // serverAuthenticationRequest.authority can only be common or organizations if not null
        var accessTokenCacheItem = this.getTokenCacheItemByAuthority(matchAuthority, scopeFilteredTokenCacheItems, scopes, ServerHashParamKeys.ACCESS_TOKEN);
        if (!accessTokenCacheItem) {
            this.logger.verbose("No matching token found when filtering by scope and authority");
            return null;
        }
        else {
            serverAuthenticationRequest.authorityInstance = AuthorityFactory.CreateInstance(accessTokenCacheItem.key.authority, this.config.auth.validateAuthority);
            this.logger.verbose("Evaluating access token found");
            var tokenIsStillValid = this.evaluateTokenExpiration(accessTokenCacheItem);
            // The response value will stay null if token retrieved from the cache is expired, otherwise it will be populated with said token's data
            if (tokenIsStillValid) {
                this.logger.verbose("Access token expiration is within offset, using access token found in cache");
                var responseAccount = account || this.getAccount();
                if (!responseAccount) {
                    throw AuthError.createUnexpectedError("Account should not be null here.");
                }
                var aState = this.getAccountState(serverAuthenticationRequest.state);
                var response = {
                    uniqueId: "",
                    tenantId: "",
                    tokenType: ServerHashParamKeys.ACCESS_TOKEN,
                    idToken: null,
                    idTokenClaims: null,
                    accessToken: accessTokenCacheItem.value.accessToken,
                    scopes: accessTokenCacheItem.key.scopes.split(" "),
                    expiresOn: new Date(Number(accessTokenCacheItem.value.expiresIn) * 1000),
                    account: responseAccount,
                    accountState: aState,
                    fromCache: true
                };
                return response;
            }
            else {
                this.logger.verbose("Access token expired, removing from cache");
                this.cacheStorage.removeItem(JSON.stringify(accessTokenCacheItem.key));
                return null;
            }
        }
    };
    /**
     * Returns true if the token passed in is within the acceptable expiration time offset, false if it is expired.
     * @param tokenCacheItem
     * @param serverAuthenticationRequest
     */
    UserAgentApplication.prototype.evaluateTokenExpiration = function (tokenCacheItem) {
        var expiration = Number(tokenCacheItem.value.expiresIn);
        return TokenUtils.validateExpirationIsWithinOffset(expiration, this.config.system.tokenRenewalOffsetSeconds);
    };
    /**
     * @hidden
     * Check if ADAL id_token exists and return if exists.
     *
     */
    UserAgentApplication.prototype.extractADALIdToken = function () {
        this.logger.verbose("ExtractADALIdToken has been called");
        var adalIdToken = this.cacheStorage.getItem(Constants.adalIdToken);
        return (!StringUtils.isEmpty(adalIdToken)) ? TokenUtils.extractIdToken(adalIdToken) : null;
    };
    /**
     * @hidden
     * Acquires access token using a hidden iframe.
     * @ignore
     */
    UserAgentApplication.prototype.renewToken = function (requestSignature, resolve, reject, account, serverAuthenticationRequest) {
        this.logger.verbose("RenewToken has been called");
        this.logger.verbosePii("RenewToken scope and authority: " + requestSignature);
        var frameName = WindowUtils.generateFrameName(FramePrefix.TOKEN_FRAME, requestSignature);
        WindowUtils.addHiddenIFrame(frameName, this.logger);
        this.updateCacheEntries(serverAuthenticationRequest, account, false);
        this.logger.verbosePii("RenewToken expected state: " + serverAuthenticationRequest.state);
        // Build urlNavigate with "prompt=none" and navigate to URL in hidden iFrame
        var urlNavigate = UrlUtils.urlRemoveQueryStringParameter(UrlUtils.createNavigateUrl(serverAuthenticationRequest), Constants.prompt) + Constants.prompt_none + Constants.response_mode_fragment;
        window.renewStates.push(serverAuthenticationRequest.state);
        window.requestType = Constants.renewToken;
        this.logger.verbose("Set window.renewState and requestType");
        this.registerCallback(serverAuthenticationRequest.state, requestSignature, resolve, reject);
        this.logger.infoPii("Navigate to: " + urlNavigate);
        this.loadIframeTimeout(urlNavigate, frameName, requestSignature).catch(function (error) { return reject(error); });
    };
    /**
     * @hidden
     * Renews idtoken for app's own backend when clientId is passed as a single scope in the scopes array.
     * @ignore
     */
    UserAgentApplication.prototype.renewIdToken = function (requestSignature, resolve, reject, account, serverAuthenticationRequest) {
        this.logger.info("RenewIdToken has been called");
        var frameName = WindowUtils.generateFrameName(FramePrefix.ID_TOKEN_FRAME, requestSignature);
        WindowUtils.addHiddenIFrame(frameName, this.logger);
        this.updateCacheEntries(serverAuthenticationRequest, account, false);
        this.logger.verbose("RenewIdToken expected state: " + serverAuthenticationRequest.state);
        // Build urlNavigate with "prompt=none" and navigate to URL in hidden iFrame
        var urlNavigate = UrlUtils.urlRemoveQueryStringParameter(UrlUtils.createNavigateUrl(serverAuthenticationRequest), Constants.prompt) + Constants.prompt_none + Constants.response_mode_fragment;
        if (this.silentLogin) {
            this.logger.verbose("Silent login is true, set silentAuthenticationState");
            window.requestType = Constants.login;
            this.silentAuthenticationState = serverAuthenticationRequest.state;
        }
        else {
            this.logger.verbose("Not silent login, set window.renewState and requestType");
            window.requestType = Constants.renewToken;
            window.renewStates.push(serverAuthenticationRequest.state);
        }
        // note: scope here is clientId
        this.registerCallback(serverAuthenticationRequest.state, requestSignature, resolve, reject);
        this.logger.infoPii("Navigate to:\" " + urlNavigate);
        this.loadIframeTimeout(urlNavigate, frameName, requestSignature).catch(function (error) { return reject(error); });
    };
    /**
     * @hidden
     *
     * This method builds an Access Token Cache item and saves it to the cache, returning the original
     * AuthResponse augmented with a parsed expiresOn attribute.
     *
     * @param response The AuthResponse object that contains the token to be saved
     * @param authority The authority under which the ID token will be cached
     * @param scopes The scopes to be added to the cache item key (undefined for ID token cache items)
     * @param clientInfo Client Info object that is used to generate the homeAccountIdentifier
     * @param expiration Token expiration timestamp
     */
    UserAgentApplication.prototype.saveToken = function (response, authority, scopes, clientInfo, expiration) {
        var accessTokenKey = new AccessTokenKey(authority, this.clientId, scopes, clientInfo.uid, clientInfo.utid);
        var accessTokenValue = new AccessTokenValue(response.accessToken, response.idToken.rawIdToken, expiration.toString(), clientInfo.encodeClientInfo());
        this.cacheStorage.setItem(JSON.stringify(accessTokenKey), JSON.stringify(accessTokenValue));
        if (expiration) {
            this.logger.verbose("New expiration set for token");
            response.expiresOn = new Date(expiration * 1000);
        }
        else {
            this.logger.error("Could not parse expiresIn parameter for access token");
        }
        return response;
    };
    /**
     * @hidden
     *
     * This method sets up the elements of an ID Token cache item and calls saveToken to save it in
     * Access Token Cache item format for the client application to use.
     *
     * @param response The AuthResponse object that will be used to build the cache item
     * @param authority The authority under which the ID token will be cached
     * @param parameters The response's Hash Params, which contain the ID token returned from the server
     * @param clientInfo Client Info object that is used to generate the homeAccountIdentifier
     * @param idTokenObj ID Token object from which the ID token's expiration is extracted
     */
    /* tslint:disable:no-string-literal */
    UserAgentApplication.prototype.saveIdToken = function (response, authority, parameters, clientInfo, idTokenObj) {
        this.logger.verbose("SaveIdToken has been called");
        var idTokenResponse = __assign({}, response);
        // Scopes are undefined so they don't show up in ID token cache key
        var scopes;
        idTokenResponse.scopes = Constants.oidcScopes;
        idTokenResponse.accessToken = parameters[ServerHashParamKeys.ID_TOKEN];
        var expiration = Number(idTokenObj.expiration);
        // Set ID Token item in cache
        this.logger.verbose("Saving ID token to cache");
        return this.saveToken(idTokenResponse, authority, scopes, clientInfo, expiration);
    };
    /**
     * @hidden
     *
     * This method sets up the elements of an Access Token cache item and calls saveToken to save it to the cache
     *
     * @param response The AuthResponse object that will be used to build the cache item
     * @param authority The authority under which the access token will be cached
     * @param parameters The response's Hash Params, which contain the access token returned from the server
     * @param clientInfo Client Info object that is used to generate the homeAccountIdentifier
     */
    /* tslint:disable:no-string-literal */
    UserAgentApplication.prototype.saveAccessToken = function (response, authority, parameters, clientInfo) {
        this.logger.verbose("SaveAccessToken has been called");
        var accessTokenResponse = __assign({}, response);
        // read the scopes
        var scope = parameters[ServerHashParamKeys.SCOPE];
        var consentedScopes = scope.split(" ");
        // retrieve all access tokens from the cache, remove the dup scopes
        var accessTokenCacheItems = this.cacheStorage.getAllAccessTokens(this.clientId, authority);
        this.logger.verbose("Retrieving all access tokens from cache and removing duplicates");
        for (var i = 0; i < accessTokenCacheItems.length; i++) {
            var accessTokenCacheItem = accessTokenCacheItems[i];
            if (accessTokenCacheItem.key.homeAccountIdentifier === response.account.homeAccountIdentifier) {
                var cachedScopes = accessTokenCacheItem.key.scopes.split(" ");
                if (ScopeSet.isIntersectingScopes(cachedScopes, consentedScopes)) {
                    this.cacheStorage.removeItem(JSON.stringify(accessTokenCacheItem.key));
                }
            }
        }
        accessTokenResponse.accessToken = parameters[ServerHashParamKeys.ACCESS_TOKEN];
        accessTokenResponse.scopes = consentedScopes;
        var expiresIn = TimeUtils.parseExpiresIn(parameters[ServerHashParamKeys.EXPIRES_IN]);
        var parsedState = RequestUtils.parseLibraryState(parameters[ServerHashParamKeys.STATE]);
        var expiration = parsedState.ts + expiresIn;
        this.logger.verbose("Saving access token to cache");
        return this.saveToken(accessTokenResponse, authority, scope, clientInfo, expiration);
    };
    /**
     * @hidden
     * Saves token or error received in the response from AAD in the cache. In case of id_token, it also creates the account object.
     * @ignore
     */
    UserAgentApplication.prototype.saveTokenFromHash = function (hash, stateInfo) {
        this.logger.verbose("SaveTokenFromHash has been called");
        this.logger.info("State status: " + stateInfo.stateMatch + "; Request type: " + stateInfo.requestType);
        var response = {
            uniqueId: "",
            tenantId: "",
            tokenType: "",
            idToken: null,
            idTokenClaims: null,
            accessToken: null,
            scopes: [],
            expiresOn: null,
            account: null,
            accountState: "",
            fromCache: false
        };
        var error;
        var hashParams = UrlUtils.deserializeHash(hash);
        var authorityKey = "";
        var acquireTokenAccountKey = "";
        var idTokenObj = null;
        // If server returns an error
        if (hashParams.hasOwnProperty(ServerHashParamKeys.ERROR_DESCRIPTION) || hashParams.hasOwnProperty(ServerHashParamKeys.ERROR)) {
            this.logger.verbose("Server returned an error");
            this.logger.infoPii("Error : " + hashParams[ServerHashParamKeys.ERROR] + "; Error description: " + hashParams[ServerHashParamKeys.ERROR_DESCRIPTION]);
            this.cacheStorage.setItem(ErrorCacheKeys.ERROR, hashParams[ServerHashParamKeys.ERROR]);
            this.cacheStorage.setItem(ErrorCacheKeys.ERROR_DESC, hashParams[ServerHashParamKeys.ERROR_DESCRIPTION]);
            // login
            if (stateInfo.requestType === Constants.login) {
                this.logger.verbose("RequestType is login, caching login error, generating authorityKey");
                this.cacheStorage.setItem(ErrorCacheKeys.LOGIN_ERROR, hashParams[ServerHashParamKeys.ERROR_DESCRIPTION] + ":" + hashParams[ServerHashParamKeys.ERROR]);
                authorityKey = AuthCache.generateAuthorityKey(stateInfo.state);
            }
            // acquireToken
            if (stateInfo.requestType === Constants.renewToken) {
                this.logger.verbose("RequestType is renewToken, generating acquireTokenAccountKey");
                authorityKey = AuthCache.generateAuthorityKey(stateInfo.state);
                var account = this.getAccount();
                var accountId = void 0;
                if (account && !StringUtils.isEmpty(account.homeAccountIdentifier)) {
                    accountId = account.homeAccountIdentifier;
                    this.logger.verbose("AccountId is set");
                }
                else {
                    accountId = Constants.no_account;
                    this.logger.verbose("AccountId is set as no_account");
                }
                acquireTokenAccountKey = AuthCache.generateAcquireTokenAccountKey(accountId, stateInfo.state);
            }
            var hashErr = hashParams[ServerHashParamKeys.ERROR];
            var hashErrDesc = hashParams[ServerHashParamKeys.ERROR_DESCRIPTION];
            if (InteractionRequiredAuthError.isInteractionRequiredError(hashErr) ||
                InteractionRequiredAuthError.isInteractionRequiredError(hashErrDesc)) {
                error = new InteractionRequiredAuthError(hashParams[ServerHashParamKeys.ERROR], hashParams[ServerHashParamKeys.ERROR_DESCRIPTION]);
            }
            else {
                error = new ServerError(hashParams[ServerHashParamKeys.ERROR], hashParams[ServerHashParamKeys.ERROR_DESCRIPTION]);
            }
        }
        // If the server returns "Success"
        else {
            this.logger.verbose("Server returns success");
            // Verify the state from redirect and record tokens to storage if exists
            if (stateInfo.stateMatch) {
                this.logger.info("State is right");
                if (hashParams.hasOwnProperty(ServerHashParamKeys.SESSION_STATE)) {
                    this.logger.verbose("Fragment has session state, caching");
                    this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.SESSION_STATE, stateInfo.state), hashParams[ServerHashParamKeys.SESSION_STATE]);
                }
                response.accountState = this.getAccountState(stateInfo.state);
                var clientInfo = void 0;
                // Process access_token
                if (hashParams.hasOwnProperty(ServerHashParamKeys.ACCESS_TOKEN)) {
                    this.logger.info("Fragment has access token");
                    response.accessToken = hashParams[ServerHashParamKeys.ACCESS_TOKEN];
                    if (hashParams.hasOwnProperty(ServerHashParamKeys.SCOPE)) {
                        response.scopes = hashParams[ServerHashParamKeys.SCOPE].split(" ");
                    }
                    // retrieve the id_token from response if present
                    if (hashParams.hasOwnProperty(ServerHashParamKeys.ID_TOKEN)) {
                        this.logger.verbose("Fragment has id_token");
                        idTokenObj = new IdToken(hashParams[ServerHashParamKeys.ID_TOKEN]);
                    }
                    else {
                        this.logger.verbose("No idToken on fragment, getting idToken from cache");
                        idTokenObj = new IdToken(this.cacheStorage.getItem(PersistentCacheKeys.IDTOKEN));
                    }
                    response = ResponseUtils.setResponseIdToken(response, idTokenObj);
                    // set authority
                    var authority = this.populateAuthority(stateInfo.state, this.inCookie, this.cacheStorage, idTokenObj);
                    this.logger.verbose("Got authority from cache");
                    // retrieve client_info - if it is not found, generate the uid and utid from idToken
                    if (hashParams.hasOwnProperty(ServerHashParamKeys.CLIENT_INFO)) {
                        this.logger.verbose("Fragment has clientInfo");
                        clientInfo = new ClientInfo(hashParams[ServerHashParamKeys.CLIENT_INFO], authority);
                    }
                    else if (this.authorityInstance.AuthorityType === AuthorityType.Adfs) {
                        clientInfo = ClientInfo.createClientInfoFromIdToken(idTokenObj, authority);
                    }
                    else {
                        this.logger.warning("ClientInfo not received in the response from AAD");
                    }
                    response.account = Account.createAccount(idTokenObj, clientInfo);
                    this.logger.verbose("Account object created from response");
                    var accountKey = void 0;
                    if (response.account && !StringUtils.isEmpty(response.account.homeAccountIdentifier)) {
                        this.logger.verbose("AccountKey set");
                        accountKey = response.account.homeAccountIdentifier;
                    }
                    else {
                        this.logger.verbose("AccountKey set as no_account");
                        accountKey = Constants.no_account;
                    }
                    acquireTokenAccountKey = AuthCache.generateAcquireTokenAccountKey(accountKey, stateInfo.state);
                    var acquireTokenAccountKey_noaccount = AuthCache.generateAcquireTokenAccountKey(Constants.no_account, stateInfo.state);
                    this.logger.verbose("AcquireTokenAccountKey generated");
                    var cachedAccount = this.cacheStorage.getItem(acquireTokenAccountKey);
                    var acquireTokenAccount = void 0;
                    // Check with the account in the Cache
                    if (!StringUtils.isEmpty(cachedAccount)) {
                        acquireTokenAccount = JSON.parse(cachedAccount);
                        this.logger.verbose("AcquireToken request account retrieved from cache");
                        if (response.account && acquireTokenAccount && Account.compareAccounts(response.account, acquireTokenAccount)) {
                            response = this.saveAccessToken(response, authority, hashParams, clientInfo);
                            this.logger.info("The user object received in the response is the same as the one passed in the acquireToken request");
                        }
                        else {
                            this.logger.warning("The account object created from the response is not the same as the one passed in the acquireToken request");
                        }
                    }
                    else if (!StringUtils.isEmpty(this.cacheStorage.getItem(acquireTokenAccountKey_noaccount))) {
                        this.logger.verbose("No acquireToken account retrieved from cache");
                        response = this.saveAccessToken(response, authority, hashParams, clientInfo);
                    }
                }
                // Process id_token
                if (hashParams.hasOwnProperty(ServerHashParamKeys.ID_TOKEN)) {
                    this.logger.info("Fragment has idToken");
                    // set the idToken
                    idTokenObj = new IdToken(hashParams[ServerHashParamKeys.ID_TOKEN]);
                    // set authority
                    var authority = this.populateAuthority(stateInfo.state, this.inCookie, this.cacheStorage, idTokenObj);
                    response = ResponseUtils.setResponseIdToken(response, idTokenObj);
                    if (hashParams.hasOwnProperty(ServerHashParamKeys.CLIENT_INFO)) {
                        this.logger.verbose("Fragment has clientInfo");
                        clientInfo = new ClientInfo(hashParams[ServerHashParamKeys.CLIENT_INFO], authority);
                    }
                    else if (this.authorityInstance.AuthorityType === AuthorityType.Adfs) {
                        clientInfo = ClientInfo.createClientInfoFromIdToken(idTokenObj, authority);
                    }
                    else {
                        this.logger.warning("ClientInfo not received in the response from AAD");
                    }
                    this.account = Account.createAccount(idTokenObj, clientInfo);
                    response.account = this.account;
                    this.logger.verbose("Account object created from response");
                    if (idTokenObj && idTokenObj.nonce) {
                        this.logger.verbose("IdToken has nonce");
                        // check nonce integrity if idToken has nonce - throw an error if not matched
                        var cachedNonce = this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.NONCE_IDTOKEN, stateInfo.state), this.inCookie);
                        if (idTokenObj.nonce !== cachedNonce) {
                            this.account = null;
                            this.cacheStorage.setItem(ErrorCacheKeys.LOGIN_ERROR, "Nonce Mismatch. Expected Nonce: " + cachedNonce + "," + "Actual Nonce: " + idTokenObj.nonce);
                            this.logger.error("Nonce Mismatch. Expected Nonce: " + cachedNonce + ", Actual Nonce: " + idTokenObj.nonce);
                            error = ClientAuthError.createNonceMismatchError(cachedNonce, idTokenObj.nonce);
                        }
                        // Save the token
                        else {
                            this.logger.verbose("Nonce matches, saving idToken to cache");
                            this.cacheStorage.setItem(PersistentCacheKeys.IDTOKEN, hashParams[ServerHashParamKeys.ID_TOKEN], this.inCookie);
                            this.cacheStorage.setItem(PersistentCacheKeys.CLIENT_INFO, clientInfo.encodeClientInfo(), this.inCookie);
                            // Save idToken as access token item for app itself
                            this.saveIdToken(response, authority, hashParams, clientInfo, idTokenObj);
                        }
                    }
                    else {
                        this.logger.verbose("No idToken or no nonce. Cache key for Authority set as state");
                        authorityKey = stateInfo.state;
                        acquireTokenAccountKey = stateInfo.state;
                        this.logger.error("Invalid id_token received in the response");
                        error = ClientAuthError.createInvalidIdTokenError(idTokenObj);
                        this.cacheStorage.setItem(ErrorCacheKeys.ERROR, error.errorCode);
                        this.cacheStorage.setItem(ErrorCacheKeys.ERROR_DESC, error.errorMessage);
                    }
                }
            }
            // State mismatch - unexpected/invalid state
            else {
                this.logger.verbose("State mismatch");
                authorityKey = stateInfo.state;
                acquireTokenAccountKey = stateInfo.state;
                var expectedState = this.cacheStorage.getItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_LOGIN, stateInfo.state), this.inCookie);
                this.logger.error("State Mismatch. Expected State: " + expectedState + ", Actual State: " + stateInfo.state);
                error = ClientAuthError.createInvalidStateError(stateInfo.state, expectedState);
                this.cacheStorage.setItem(ErrorCacheKeys.ERROR, error.errorCode);
                this.cacheStorage.setItem(ErrorCacheKeys.ERROR_DESC, error.errorMessage);
            }
        }
        // Set status to completed
        this.cacheStorage.removeItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.RENEW_STATUS, stateInfo.state));
        this.cacheStorage.resetTempCacheItems(stateInfo.state);
        this.logger.verbose("Status set to complete, temporary cache cleared");
        // this is required if navigateToLoginRequestUrl=false
        if (this.inCookie) {
            this.logger.verbose("InCookie is true, setting authorityKey in cookie");
            this.cacheStorage.setItemCookie(authorityKey, "", -1);
            this.cacheStorage.clearMsalCookie(stateInfo.state);
        }
        if (error) {
            // Error case, set status to cancelled
            throw error;
        }
        if (!response) {
            throw AuthError.createUnexpectedError("Response is null");
        }
        return response;
    };
    /**
     * Set Authority when saving Token from the hash
     * @param state
     * @param inCookie
     * @param cacheStorage
     * @param idTokenObj
     * @param response
     */
    UserAgentApplication.prototype.populateAuthority = function (state, inCookie, cacheStorage, idTokenObj) {
        this.logger.verbose("PopulateAuthority has been called");
        var authorityKey = AuthCache.generateAuthorityKey(state);
        var cachedAuthority = cacheStorage.getItem(authorityKey, inCookie);
        // retrieve the authority from cache and replace with tenantID
        return StringUtils.isEmpty(cachedAuthority) ? cachedAuthority : UrlUtils.replaceTenantPath(cachedAuthority, idTokenObj.tenantId);
    };
    /* tslint:enable:no-string-literal */
    // #endregion
    // #region Account
    /**
     * Returns the signed in account
     * (the account object is created at the time of successful login)
     * or null when no state is found
     * @returns {@link Account} - the account object stored in MSAL
     */
    UserAgentApplication.prototype.getAccount = function () {
        // if a session already exists, get the account from the session
        if (this.account) {
            return this.account;
        }
        // frame is used to get idToken and populate the account for the given session
        var rawIdToken = this.cacheStorage.getItem(PersistentCacheKeys.IDTOKEN, this.inCookie);
        var rawClientInfo = this.cacheStorage.getItem(PersistentCacheKeys.CLIENT_INFO, this.inCookie);
        if (!StringUtils.isEmpty(rawIdToken) && !StringUtils.isEmpty(rawClientInfo)) {
            var idToken = new IdToken(rawIdToken);
            var clientInfo = new ClientInfo(rawClientInfo, "");
            this.account = Account.createAccount(idToken, clientInfo);
            return this.account;
        }
        // if login not yet done, return null
        return null;
    };
    /**
     * @hidden
     *
     * Extracts state value from the accountState sent with the authentication request.
     * @returns {string} scope.
     * @ignore
     */
    UserAgentApplication.prototype.getAccountState = function (state) {
        if (state) {
            var splitIndex = state.indexOf(Constants.resourceDelimiter);
            if (splitIndex > -1 && splitIndex + 1 < state.length) {
                return state.substring(splitIndex + 1);
            }
        }
        return state;
    };
    /**
     * Use to get a list of unique accounts in MSAL cache based on homeAccountIdentifier.
     *
     * @param {@link Array<Account>} Account - all unique accounts in MSAL cache.
     */
    UserAgentApplication.prototype.getAllAccounts = function () {
        var accounts = [];
        var accessTokenCacheItems = this.cacheStorage.getAllAccessTokens(Constants.clientId, Constants.homeAccountIdentifier);
        for (var i = 0; i < accessTokenCacheItems.length; i++) {
            var idToken = new IdToken(accessTokenCacheItems[i].value.idToken);
            var clientInfo = new ClientInfo(accessTokenCacheItems[i].value.homeAccountIdentifier, "");
            var account = Account.createAccount(idToken, clientInfo);
            accounts.push(account);
        }
        return this.getUniqueAccounts(accounts);
    };
    /**
     * @hidden
     *
     * Used to filter accounts based on homeAccountIdentifier
     * @param {Array<Account>}  Accounts - accounts saved in the cache
     * @ignore
     */
    UserAgentApplication.prototype.getUniqueAccounts = function (accounts) {
        if (!accounts || accounts.length <= 1) {
            return accounts;
        }
        var flags = [];
        var uniqueAccounts = [];
        for (var index = 0; index < accounts.length; ++index) {
            if (accounts[index].homeAccountIdentifier && flags.indexOf(accounts[index].homeAccountIdentifier) === -1) {
                flags.push(accounts[index].homeAccountIdentifier);
                uniqueAccounts.push(accounts[index]);
            }
        }
        return uniqueAccounts;
    };
    // #endregion
    // #region Angular
    /**
     * @hidden
     *
     * Broadcast messages - Used only for Angular?  *
     * @param eventName
     * @param data
     */
    UserAgentApplication.prototype.broadcast = function (eventName, data) {
        var evt = new CustomEvent(eventName, { detail: data });
        window.dispatchEvent(evt);
    };
    /**
     * @hidden
     *
     * Helper function to retrieve the cached token
     *
     * @param scopes
     * @param {@link Account} account
     * @param state
     * @return {@link AuthResponse} AuthResponse
     */
    UserAgentApplication.prototype.getCachedTokenInternal = function (scopes, account, state, correlationId) {
        // Get the current session's account object
        var accountObject = account || this.getAccount();
        if (!accountObject) {
            return null;
        }
        // Construct AuthenticationRequest based on response type; set "redirectUri" from the "request" which makes this call from Angular - for this.getRedirectUri()
        var newAuthority = this.authorityInstance ? this.authorityInstance : AuthorityFactory.CreateInstance(this.authority, this.config.auth.validateAuthority);
        var responseType = this.getTokenType(accountObject, scopes);
        var serverAuthenticationRequest = new ServerRequestParameters(newAuthority, this.clientId, responseType, this.getRedirectUri(), scopes, state, correlationId);
        // get cached token
        return this.getCachedToken(serverAuthenticationRequest, account);
    };
    /**
     * @hidden
     *
     * Get scopes for the Endpoint - Used in Angular to track protected and unprotected resources without interaction from the developer app
     * Note: Please check if we need to set the "redirectUri" from the "request" which makes this call from Angular - for this.getRedirectUri()
     *
     * @param endpoint
     */
    UserAgentApplication.prototype.getScopesForEndpoint = function (endpoint) {
        // if user specified list of unprotectedResources, no need to send token to these endpoints, return null.
        if (this.config.framework.unprotectedResources.length > 0) {
            for (var i = 0; i < this.config.framework.unprotectedResources.length; i++) {
                if (endpoint.indexOf(this.config.framework.unprotectedResources[i]) > -1) {
                    return null;
                }
            }
        }
        // process all protected resources and send the matched one
        if (this.config.framework.protectedResourceMap.size > 0) {
            for (var _i = 0, _a = Array.from(this.config.framework.protectedResourceMap.keys()); _i < _a.length; _i++) {
                var key = _a[_i];
                // configEndpoint is like /api/Todo requested endpoint can be /api/Todo/1
                if (endpoint.indexOf(key) > -1) {
                    return this.config.framework.protectedResourceMap.get(key);
                }
            }
        }
        /*
         * default resource will be clientid if nothing specified
         * App will use idtoken for calls to itself
         * check if it's staring from http or https, needs to match with app host
         */
        if (endpoint.indexOf("http://") > -1 || endpoint.indexOf("https://") > -1) {
            if (UrlUtils.getHostFromUri(endpoint) === UrlUtils.getHostFromUri(this.getRedirectUri())) {
                return new Array(this.clientId);
            }
        }
        else {
            /*
             * in angular level, the url for $http interceptor call could be relative url,
             * if it's relative call, we'll treat it as app backend call.
             */
            return new Array(this.clientId);
        }
        // if not the app's own backend or not a domain listed in the endpoints structure
        return null;
    };
    /**
     * Return boolean flag to developer to help inform if login is in progress
     * @returns {boolean} true/false
     */
    UserAgentApplication.prototype.getLoginInProgress = function () {
        return this.cacheStorage.isInteractionInProgress(true);
    };
    /**
     * @hidden
     * @ignore
     *
     * @param loginInProgress
     */
    UserAgentApplication.prototype.setInteractionInProgress = function (inProgress) {
        this.cacheStorage.setInteractionInProgress(inProgress);
    };
    /**
     * @hidden
     * @ignore
     *
     * @param loginInProgress
     */
    UserAgentApplication.prototype.setloginInProgress = function (loginInProgress) {
        this.setInteractionInProgress(loginInProgress);
    };
    /**
     * @hidden
     * @ignore
     *
     * returns the status of acquireTokenInProgress
     */
    UserAgentApplication.prototype.getAcquireTokenInProgress = function () {
        return this.cacheStorage.isInteractionInProgress(true);
    };
    /**
     * @hidden
     * @ignore
     *
     * @param acquireTokenInProgress
     */
    UserAgentApplication.prototype.setAcquireTokenInProgress = function (acquireTokenInProgress) {
        this.setInteractionInProgress(acquireTokenInProgress);
    };
    /**
     * @hidden
     * @ignore
     *
     * returns the logger handle
     */
    UserAgentApplication.prototype.getLogger = function () {
        return this.logger;
    };
    /**
     * Sets the logger callback.
     * @param logger Logger callback
     */
    UserAgentApplication.prototype.setLogger = function (logger) {
        this.logger = logger;
    };
    // #endregion
    // #region Getters and Setters
    /**
     * Use to get the redirect uri configured in MSAL or null.
     * Evaluates redirectUri if its a function, otherwise simply returns its value.
     *
     * @returns {string} redirect URL
     */
    UserAgentApplication.prototype.getRedirectUri = function (reqRedirectUri) {
        if (reqRedirectUri) {
            return reqRedirectUri;
        }
        else if (typeof this.config.auth.redirectUri === "function") {
            return this.config.auth.redirectUri();
        }
        return this.config.auth.redirectUri;
    };
    /**
     * Use to get the post logout redirect uri configured in MSAL or null.
     * Evaluates postLogoutredirectUri if its a function, otherwise simply returns its value.
     *
     * @returns {string} post logout redirect URL
     */
    UserAgentApplication.prototype.getPostLogoutRedirectUri = function () {
        if (typeof this.config.auth.postLogoutRedirectUri === "function") {
            return this.config.auth.postLogoutRedirectUri();
        }
        return this.config.auth.postLogoutRedirectUri;
    };
    /**
     * Use to get the current {@link Configuration} object in MSAL
     *
     * @returns {@link Configuration}
     */
    UserAgentApplication.prototype.getCurrentConfiguration = function () {
        if (!this.config) {
            throw ClientConfigurationError.createNoSetConfigurationError();
        }
        return this.config;
    };
    /**
     * @ignore
     *
     * Utils function to create the Authentication
     * @param {@link account} account object
     * @param scopes
     *
     * @returns {string} token type: token, id_token or id_token token
     *
     */
    UserAgentApplication.prototype.getTokenType = function (accountObject, scopes) {
        var accountsMatch = Account.compareAccounts(accountObject, this.getAccount());
        return ServerRequestParameters.determineResponseType(accountsMatch, scopes);
    };
    /**
     * @hidden
     * @ignore
     *
     * Sets the cachekeys for and stores the account information in cache
     * @param account
     * @param state
     * @hidden
     */
    UserAgentApplication.prototype.setAccountCache = function (account, state) {
        // Cache acquireTokenAccountKey
        var accountId = account ? this.getAccountId(account) : Constants.no_account;
        var acquireTokenAccountKey = AuthCache.generateAcquireTokenAccountKey(accountId, state);
        this.cacheStorage.setItem(acquireTokenAccountKey, JSON.stringify(account));
    };
    /**
     * @hidden
     * @ignore
     *
     * Sets the cacheKey for and stores the authority information in cache
     * @param state
     * @param authority
     * @hidden
     */
    UserAgentApplication.prototype.setAuthorityCache = function (state, authority) {
        // Cache authorityKey
        var authorityKey = AuthCache.generateAuthorityKey(state);
        this.cacheStorage.setItem(authorityKey, UrlUtils.CanonicalizeUri(authority), this.inCookie);
    };
    /**
     * Updates account, authority, and nonce in cache
     * @param serverAuthenticationRequest
     * @param account
     * @hidden
     * @ignore
     */
    UserAgentApplication.prototype.updateCacheEntries = function (serverAuthenticationRequest, account, isLoginCall, loginStartPage) {
        // Cache Request Originator Page
        if (loginStartPage) {
            this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.LOGIN_REQUEST, serverAuthenticationRequest.state), loginStartPage, this.inCookie);
        }
        // Cache account and authority
        if (isLoginCall) {
            // Cache the state
            this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.STATE_LOGIN, serverAuthenticationRequest.state), serverAuthenticationRequest.state, this.inCookie);
        }
        else {
            this.setAccountCache(account, serverAuthenticationRequest.state);
        }
        // Cache authorityKey
        this.setAuthorityCache(serverAuthenticationRequest.state, serverAuthenticationRequest.authority);
        // Cache nonce
        this.cacheStorage.setItem(AuthCache.generateTemporaryCacheKey(TemporaryCacheKeys.NONCE_IDTOKEN, serverAuthenticationRequest.state), serverAuthenticationRequest.nonce, this.inCookie);
    };
    /**
     * Returns the unique identifier for the logged in account
     * @param account
     * @hidden
     * @ignore
     */
    UserAgentApplication.prototype.getAccountId = function (account) {
        // return `${account.accountIdentifier}` + Constants.resourceDelimiter + `${account.homeAccountIdentifier}`;
        var accountId;
        if (!StringUtils.isEmpty(account.homeAccountIdentifier)) {
            accountId = account.homeAccountIdentifier;
        }
        else {
            accountId = Constants.no_account;
        }
        return accountId;
    };
    /**
     * @ignore
     * @param extraQueryParameters
     *
     * Construct 'tokenRequest' from the available data in adalIdToken
     */
    UserAgentApplication.prototype.buildIDTokenRequest = function (request) {
        var tokenRequest = {
            scopes: Constants.oidcScopes,
            authority: this.authority,
            account: this.getAccount(),
            extraQueryParameters: request.extraQueryParameters,
            correlationId: request.correlationId
        };
        return tokenRequest;
    };
    /**
     * @ignore
     * @param config
     * @param clientId
     *
     * Construct TelemetryManager from Configuration
     */
    UserAgentApplication.prototype.getTelemetryManagerFromConfig = function (config, clientId) {
        if (!config) { // if unset
            return telemetry_TelemetryManager.getTelemetrymanagerStub(clientId, this.logger);
        }
        // if set then validate
        var applicationName = config.applicationName, applicationVersion = config.applicationVersion, telemetryEmitter = config.telemetryEmitter;
        if (!applicationName || !applicationVersion || !telemetryEmitter) {
            throw ClientConfigurationError.createTelemetryConfigError(config);
        }
        // if valid then construct
        var telemetryPlatform = {
            applicationName: applicationName,
            applicationVersion: applicationVersion
        };
        var telemetryManagerConfig = {
            platform: telemetryPlatform,
            clientId: clientId
        };
        return new telemetry_TelemetryManager(telemetryManagerConfig, telemetryEmitter, this.logger);
    };
    return UserAgentApplication;
}());

//# sourceMappingURL=UserAgentApplication.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(68421);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Figure; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15437);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0;\n  & > span {\n    height: 100% !important;\n    width: 100% !important;\n  }\n\n  & > picture {\n    & > span {\n      height: 100% !important;\n      width: 100% !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Figure = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-452f3b15-0"
})(_templateObject());


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
__webpack_unused_export__ = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 60357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* unused reexport */ __webpack_require__(1045);


/***/ }),

/***/ 68421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(40906);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/redux-persist/es/index.js + 7 modules
var es = __webpack_require__(72220);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__(28500);
;// CONCATENATED MODULE: ./redux/ContactUs/actionTypes.js
var sendContactDetails = "SEND_CONTACT_DETAILS";
var getContactDetails = "GET_CONTACT_DETAILS";

;// CONCATENATED MODULE: ./redux/ContactUs/reducer.js



var initialState = {
    contactDetails: null,
    done: false
};
var contactReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case sendContactDetails:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                contactDetails: action.payload
            });
        default:
            return initialState;
    }
};
/* harmony default export */ var reducer = (contactReducer);

// EXTERNAL MODULE: ./redux/createBot/actionTypes.js
var actionTypes = __webpack_require__(34300);
;// CONCATENATED MODULE: ./redux/createBot/reducer.js


var reducer_initialState = {};
var createBotReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case actionTypes/* firstBotCreateActionType */.g:
            return (0,_object_spread/* default */.Z)({}, state, action.payload);
        default:
            return reducer_initialState;
    }
};
/* harmony default export */ var createBot_reducer = (createBotReducer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./redux/storeBot/actionTypes.js
var storeBot_actionTypes = __webpack_require__(14138);
;// CONCATENATED MODULE: ./redux/storeBot/reducer.js





var storeBot_reducer_initialState = {
    allBots: [],
    currentBot: {},
    editedCurrentBot: {},
    totalIndex: null,
    filter: null,
    getBotsFailed: false
};
var botStorereducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : storeBot_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case storeBot_actionTypes/* saveBotsActionType */.Le:
            if (action.payload.botIndex == 0) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    allBots: (0,_to_consumable_array/* default */.Z)(action.payload.data.allBots),
                    totalIndex: action.payload.data.totalIndex,
                    filter: action.payload.filter
                });
            } else {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    allBots: (0,_to_consumable_array/* default */.Z)(state.allBots).concat((0,_to_consumable_array/* default */.Z)(action.payload.data.allBots)),
                    totalIndex: action.payload.data.totalIndex,
                    filter: action.payload.filter
                });
            }
        case storeBot_actionTypes/* saveCurrentBotActionType */.ZG:
            console.log("in reducer", action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentBot: action.payload
            });
        case storeBot_actionTypes/* editCurrentBotActionType */.Pu:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                editedCurrentBot: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.editedCurrentBot), (0,_define_property/* default */.Z)({}, action.payload.botID, (0,_object_spread/* default */.Z)({}, action.payload)))
            });
        case storeBot_actionTypes/* getBotsFailed */.$o:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                getBotsFailed: !state.getBotsFailed
            });
        default:
            return state;
    }
};
/* harmony default export */ var storeBot_reducer = (botStorereducer);

// EXTERNAL MODULE: ./redux/auth/reducer.js
var auth_reducer = __webpack_require__(69365);
// EXTERNAL MODULE: ./redux/globalSearch/actionTypes.js
var globalSearch_actionTypes = __webpack_require__(96713);
;// CONCATENATED MODULE: ./redux/globalSearch/reducer.js



var globalSearch_reducer_initialState = {
    searchResult: null,
    searchResultStatus: false,
    keyword: ""
};
var globalSearchReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : globalSearch_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case globalSearch_actionTypes/* FETCH_GLOBAL_SEARCH_RESULT */.rY:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searchResult: null,
                searchResultStatus: false
            });
        case globalSearch_actionTypes/* FETCH_GLOBAL_SEARCH_RESULT_SUCCESS */.$l:
            console.log("action.payload", action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searchResult: action.payload.data,
                searchResultStatus: true,
                keyword: action.payload.keyword
            });
        case globalSearch_actionTypes/* FETCH_GLOBAL_SEARCH_RESULT_FAILED */.Ke:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searchResult: null,
                searchResultStatus: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var globalSearch_reducer = (globalSearchReducer);

// EXTERNAL MODULE: ./redux/submitAnIdea/actionTypes.js
var submitAnIdea_actionTypes = __webpack_require__(74809);
;// CONCATENATED MODULE: ./redux/submitAnIdea/reducer.js



var submitAnIdea_reducer_initialState = {
    successState: null,
    data: "",
    updated: false
};
var submitAnIdeaReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : submitAnIdea_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case submitAnIdea_actionTypes/* submitAnIdeaSuccess */.m7:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                successState: true,
                message: action.payload,
                updated: true
            });
        case submitAnIdea_actionTypes/* submitAnIdeaFailed */.ke:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                successState: false,
                message: action.payload,
                updated: true
            });
        case submitAnIdea_actionTypes/* updated */.Ps:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                updated: false
            });
        case submitAnIdea_actionTypes/* reset */.mc:
            return (0,_object_spread/* default */.Z)({}, submitAnIdea_reducer_initialState);
        default:
            return state;
    }
};
/* harmony default export */ var submitAnIdea_reducer = (submitAnIdeaReducer);

// EXTERNAL MODULE: ./redux/global/actionTypes.js
var global_actionTypes = __webpack_require__(94006);
;// CONCATENATED MODULE: ./redux/global/reducer.js



var global_reducer_initialState = {
    session: false,
    token: null
};
var sessionReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case global_actionTypes/* sessionTimeOut */.pU:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                session: action.payload
            });
        case global_actionTypes/* getAccessToken */.hP:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                token: null
            });
        case global_actionTypes/* getAccessTokenSuccess */.s1:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                token: action.payload
            });
        case global_actionTypes/* getAccessTokenFailed */.hV:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                token: null
            });
        default:
            return global_reducer_initialState;
    }
};
/* harmony default export */ var global_reducer = (sessionReducer);

// EXTERNAL MODULE: ./redux/products/actionTypes.js
var products_actionTypes = __webpack_require__(39880);
;// CONCATENATED MODULE: ./redux/products/reducer.js





var products_reducer_initialState = {
    allProducts: [],
    filterList: [],
    currentProducts: {},
    editedCurrentProducts: {},
    totalIndex: null,
    filter: null,
    getProductsFailed: false,
    totalRecords: 0
};
var productStorereducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : products_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case products_actionTypes/* saveBotsActionType */.Le:
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                allProducts: (0,_to_consumable_array/* default */.Z)(action.payload.data),
                totalIndex: action.payload.data.lenght,
                filter: action.payload.filter,
                totalRecords: action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.total
            });
        case products_actionTypes/* saveCurrentBotActionType */.ZG:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentProducts: action.payload
            });
        case products_actionTypes/* saveFilterListProdnType */.YH:
            //console.log("in reducer", action.payload)
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filterList: action.payload.data
            });
        case products_actionTypes/* editCurrentBotActionType */.Pu:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                editedCurrentProducts: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.editedCurrentProducts), (0,_define_property/* default */.Z)({}, action.payload.botID, (0,_object_spread/* default */.Z)({}, action.payload)))
            });
        case products_actionTypes/* getBotsFailed */.$o:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                getProductsFailed: !state.currentProducts
            });
        default:
            return state;
    }
};
/* harmony default export */ var products_reducer = (productStorereducer);

;// CONCATENATED MODULE: ./redux/rootReducer.js









var rootReducer = (0,redux/* combineReducers */.UY)({
    contact: reducer,
    createBot: createBot_reducer,
    storeBot: storeBot_reducer,
    storeProduct: products_reducer,
    auth: auth_reducer/* default */.Z,
    search: globalSearch_reducer,
    submitAnIdea: submitAnIdea_reducer,
    session: global_reducer
});
/* harmony default export */ var redux_rootReducer = (rootReducer);

// EXTERNAL MODULE: ./utility/endpoints.js
var utility_endpoints = __webpack_require__(49530);
;// CONCATENATED MODULE: ./redux/store/index.js







var axiosInstance = axios_default().create({
    baseURL: utility_endpoints/* default.baseUrl */.ZP.baseUrl,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
});
var enhancers = (0,redux/* compose */.qC)((0,redux_devtools_extension/* composeWithDevTools */.Uo)((0,redux/* applyMiddleware */.md)(redux_thunk_es.withExtraArgument(axiosInstance))));
var store;
var isClient = "object" !== "undefined";
if (isClient) {
    var persistReducer = (__webpack_require__(72220)/* .persistReducer */ .OJ);
    var storage = (__webpack_require__(62168)/* ["default"] */ .Z);
    var persistConfig = {
        key: "root",
        storage: storage
    };
    store = (0,redux/* createStore */.MT)(persistReducer(persistConfig, redux_rootReducer), enhancers);
    store.__PERSISTOR = (0,es/* persistStore */.p5)(store);
} else {
    store = (0,redux/* createStore */.MT)(redux_rootReducer, enhancers);
}
/* harmony default export */ var redux_store = (store);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var STOREKEY = '__NEXT_REDUX_WRAPPER_STORE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var deserializeState = (_a === void 0 ? {} : _a).deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var serializeState = (_a === void 0 ? {} : _a).serializeState;
    return serializeState ? serializeState(state) : state;
};
var getStoreKey = function (_a) {
    var storeKey = (_a === void 0 ? {} : _a).storeKey;
    return storeKey || STOREKEY;
};
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context, config = _a.config;
    var storeKey = getStoreKey(config);
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!(storeKey in window)) {
        window[storeKey] = createStore();
    }
    return window[storeKey];
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context, _b = _a.isApp, isApp = _b === void 0 ? false : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, initialProps, _c, state;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore, config: config });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        _c = callback;
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, callback(
                            // merging store into context instead of just passing as another argument because it's impossible to override getInitialProps signature
                            isApp ? __assign(__assign({}, context), { ctx: __assign(__assign({}, context.ctx), { store: store }) }) : __assign(__assign({}, context), { store: store }))];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        initialProps = (_c) ||
                            {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (context.store) {
                console.warn('No need to wrap pages if _app was wrapped');
                return [2 /*return*/, callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context, isApp: true })];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }; }; // this is just to convince TS
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, props, settings, wrapperProps;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _c.sent(), _b = _a.initialProps, props = _b.props, settings = __rest(_b, ["props"]), wrapperProps = __rest(_a, ["initialProps"]);
                    return [2 /*return*/, __assign(__assign({}, settings), { props: __assign(__assign({}, wrapperProps), props) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
                case 1: return [2 /*return*/, _a.sent()]; // just not to repeat myself
            }
        });
    }); }; };
    var withRedux = function (Component) {
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        var Wrapper = function (_a, context) {
            var _b;
            var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
            var isFirstRender = (0,react.useRef)(true);
            // this happens when App has page with getServerSideProps/getStaticProps
            var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
            if (config.debug)
                console.log('4. WrappedApp created new store with', displayName, {
                    initialState: initialState,
                    initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                });
            var store = (0,react.useRef)(initStore({ makeStore: makeStore, config: config, context: context }));
            var hydrate = (0,react.useCallback)(function () {
                if (initialState)
                    store.current.dispatch({
                        type: HYDRATE,
                        payload: getDeserializedState(initialState, config),
                    });
                // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                // so we dispatch in this order
                if (initialStateFromGSPorGSSR)
                    store.current.dispatch({
                        type: HYDRATE,
                        payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                    });
            }, [initialStateFromGSPorGSSR, initialState]);
            // apply synchronously on first render (both server side and client side)
            if (isFirstRender.current)
                hydrate();
            // apply async in case props have changed, on navigation for example
            (0,react.useEffect)(function () {
                if (isFirstRender.current) {
                    isFirstRender.current = false;
                    return;
                }
                hydrate();
            }, [hydrate]);
            // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
            // @see https://github.com/zeit/next.js/issues/11648
            if (initialProps && initialProps.pageProps)
                props.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
            var resultProps = props;
            // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
            if (initialStateFromGSPorGSSR) {
                resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                delete resultProps.pageProps.initialState;
            }
            return (react.createElement(react_redux_es/* Provider */.zt, { store: store.current },
                react.createElement(Component, __assign({}, initialProps, resultProps))));
        };
        Wrapper.displayName = displayName;
        if ('getInitialProps' in Component)
            Wrapper.getInitialProps = function (context) { return __awaiter(void 0, void 0, void 0, function () {
                var callback;
                return __generator(this, function (_a) {
                    callback = Component.getInitialProps;
                    return [2 /*return*/, (context.ctx ? getInitialAppProps(callback) : getInitialPageProps(callback))(context)];
                });
            }); };
        return Wrapper;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        withRedux: withRedux,
    };
};
// Legacy
/* harmony default export */ var es6 = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
// EXTERNAL MODULE: ./components/imageLocalizer/AnimatedBanner.css
var AnimatedBanner = __webpack_require__(70279);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./components/shared/utils/Figure.js
var utils_Figure = __webpack_require__(16223);
;// CONCATENATED MODULE: ./components/bernardChatbot/FloatingChatBot.jsx







var FloatingChatBot = function() {
    var router = useRouter();
    var iconRef = useRef(null);
    var ref = useState({
        x: 0,
        y: 0
    }), position = ref[0], setPosition = ref[1];
    var ref1 = useState(false), dragging = ref1[0], setDragging = ref1[1];
    var ref2 = useState({
        x: 0,
        y: 0
    }), rel = ref2[0], setRel = ref2[1];
    var handleMouseDown = function(e) {
        var rect = iconRef.current.getBoundingClientRect();
        setDragging(true);
        setRel({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });
        e.preventDefault();
    };
    var handleMouseMove = function(e) {
        if (!dragging) return;
        setPosition({
            x: e.clientX - rel.x,
            y: e.clientY - rel.y
        });
        e.preventDefault();
    };
    var handleMouseUp = function() {
        setDragging(false);
    };
    useEffect(function() {
        if (dragging) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        } else {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        }
        return function() {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        dragging
    ]);
    // Initialize position to bottom right corner
    useEffect(function() {
        var offsetX = 50;
        var offsetY = 40;
        var iconSize = 56;
        var defaultX = window.innerWidth - iconSize - offsetX;
        var defaultY = window.innerHeight - iconSize - offsetY;
        setPosition({
            x: defaultX,
            y: defaultY
        });
    }, []);
    var handleClick = function() {
        window.open("".concat(endpoints.redirectUriLogin, "/bernard-chat"));
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: iconRef,
                onMouseDown: handleMouseDown,
                onClick: handleClick,
                style: {
                    left: "".concat(position.x, "px"),
                    top: "".concat(position.y, "px"),
                    position: "fixed",
                    width: "70px",
                    height: "70px",
                    borderRadius: "9999px",
                    backgroundColor: "#485acd",
                    display: router.pathname === "/bernard-chat" ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 9999
                },
                title: "Hi! I am Bernard",
                className: "jsx-3d5bcb649cbaee5" + " " + "floating-icon",
                children: /*#__PURE__*/ _jsx(Figure, {
                    className: "w-full h-full rouned-full",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/assets/images/bernard.jpeg",
                        alt: "ChatBot",
                        width: 56,
                        height: 56,
                        className: "rounded-full"
                    })
                })
            }),
            _jsx(_JSXStyle, {
                id: "3d5bcb649cbaee5",
                children: "@-webkit-keyframes float{0%{-webkit-transform:translateY(0px);transform:translateY(0px)}50%{-webkit-transform:translateY(-6px);transform:translateY(-6px)}100%{-webkit-transform:translateY(0px);transform:translateY(0px)}}@-moz-keyframes float{0%{-moz-transform:translateY(0px);transform:translateY(0px)}50%{-moz-transform:translateY(-6px);transform:translateY(-6px)}100%{-moz-transform:translateY(0px);transform:translateY(0px)}}@-o-keyframes float{0%{-o-transform:translateY(0px);transform:translateY(0px)}50%{-o-transform:translateY(-6px);transform:translateY(-6px)}100%{-o-transform:translateY(0px);transform:translateY(0px)}}@keyframes float{0%{-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}50%{-webkit-transform:translateY(-6px);-moz-transform:translateY(-6px);-o-transform:translateY(-6px);transform:translateY(-6px)}100%{-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}}.floating-icon.jsx-3d5bcb649cbaee5{-webkit-animation:float 3s ease-in-out infinite;-moz-animation:float 3s ease-in-out infinite;-o-animation:float 3s ease-in-out infinite;animation:float 3s ease-in-out infinite}"
            })
        ]
    });
};
/* harmony default export */ var bernardChatbot_FloatingChatBot = ((/* unused pure expression or super */ null && (FloatingChatBot)));

;// CONCATENATED MODULE: ./components/bernardChatbot/utils/useBernardAccess.js

var useBernardAccess = function() {
    var ref = (0,react.useState)(false), isAccess = ref[0], setIsAccess = ref[1];
    var accessList = [
        "Soumya.Mohanty@unilever.com",
        "komal.falodiya@unilever.com",
        "zufeshan.syeda@unilever.com",
        "gokul.sreenivas@unilever.com",
        "caique.amaral@unilever.com",
        "sneha.sagar2@unilever.com",
        "sweta.arya@unilever.com",
        "subhadip.das@unilever.com",
        "sajesh.m@unilever.com",
        "Rohit.Baid@unilever.com",
        "Aniket.Poddar@unilever.com",
        "Arresh.Velmurugan@unilever.com",
        "MS.Nayana@unilever.com",
        "Durgaprasadu.Povaru@unilever.com",
        "sudharson.m@unilever.com"
    ];
    var auth;
    if (true) {
        var ref1;
        auth = (ref1 = JSON.parse(localStorage.getItem("auth"))) === null || ref1 === void 0 ? void 0 : ref1.data;
    }
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = accessList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var email = _step.value;
                var ref;
                if ((auth === null || auth === void 0 ? void 0 : (ref = auth.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === email.toLowerCase()) {
                    setIsAccess(true);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        accessList
    ]);
    return {
        isAccess: isAccess
    };
};
/* harmony default export */ var utils_useBernardAccess = (useBernardAccess);

// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./pages/successModal/index.jsx
var successModal = __webpack_require__(99696);
;// CONCATENATED MODULE: ./pages/_app.js





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  *,\n  ::before,\n  ::after {\n    border-width: 0;\n    border-style: solid;\n  }\n\n  /* blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: 0;\n  }\n\n \n\n  \n  \n  .google-map * {\n    border-style: none;\n  } */\n\n  ol,\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\nli a{\n  color:inherit;\n}\n  a {\n    text-decoration: inherit;\n  }\n  img,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block;\n    vertical-align: middle;\n    max-width: 100%;\n    height: auto;\n  }\n\n  svg {\n    height: 100%;\n    display: block;\n  }\n\n  body {\n    line-height: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var queryClient = new react_query_es.QueryClient();
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79afd017-0"
})(_templateObject());
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps, sessionTimeOutCheck = param.sessionTimeOutCheck, session = param.session;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), routeChangeState = ref[0], setRouteChangeState = ref[1];
    var ref1 = (0,react.useState)(false), textActive = ref1[0], setTextActive = ref1[1];
    var ref2 = (0,react.useState)(""), getCurrentPath = ref2[0], setGetCurrentPath = ref2[1];
    var ref3 = (0,react.useState)(false), isProductPage = ref3[0], setIsProductPage = ref3[1];
    var ref4 = (0,react.useState)(false), sucessfullModal = ref4[0], setSuccessModal = ref4[1];
    var isAccess = utils_useBernardAccess().isAccess;
    var ref5 = (0,react.useState)(false), mounted = ref5[0], setMounted = ref5[1];
    var checkAuthorization = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authData, auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authData = JSON.parse(localStorage.getItem("auth"));
                        if (!authData || !authData.data) {
                            // Handle the case when authData or authData.data is falsy
                            sessionTimeOutCheck(true);
                            return [
                                2
                            ]; // Return without making the API call
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/checkAuthorization"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log("checkAuthorization", data);
                        if (data.data.code === 200) {
                            console.log("Authorized User", data.data);
                        } else if (data.code === 403) {
                            setTimeout(function() {
                                sessionTimeOutCheck(true);
                            }, 1000);
                            console.log("Error in authorization", data);
                        } else {
                            sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Authorization", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkAuthorization() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkAuthorization();
    }, []);
    (0,react.useEffect)(function() {
        var handleStart = function(url) {
            window.scrollTo(0, 0);
            url !== router.asPath && setRouteChangeState(true);
        };
        var handleComplete = function(url) {
            return setRouteChangeState(false);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleComplete);
        router.events.on("routeChangeError", handleComplete);
        setMounted(true);
        return function() {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleComplete);
            router.events.off("routeChangeError", handleComplete);
        };
    }, []);
    var goTo = function(link) {
        router.push(link);
    };
    var handleMouseEnter = function() {
        setTextActive(true);
    };
    var handleMouseLeave = function() {
        setTextActive(false);
    };
    (0,react.useEffect)(function() {
        var currentURL = router.asPath;
        if (true) {
            setGetCurrentPath(window.location.pathname);
        }
        if (currentURL.includes("product") || currentURL.includes("product_details") || currentURL.includes("profile") || currentURL.includes("return-on-investment") || currentURL.includes("hall-of-fame") || currentURL.includes("engagement-analytics") || currentURL.includes("decision-automation") || currentURL.includes("export-employeetwin") || currentURL.includes("bulk-bot-update") || currentURL.includes("BotStore") || currentURL.includes("unite") || currentURL.includes("createBotNew") || currentURL.includes("change-request") || currentURL.includes("bernard-chat") || currentURL.includes("login") || currentURL.includes("logout")) {
            setIsProductPage(true);
        } else {
            setTimeout(function() {
                setIsProductPage(false);
            }, 1000);
        }
    }, [
        router.asPath
    ]);
    console.log("getCurrentPath", getCurrentPath);
    console.log("isProductPage", isProductPage);
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_redux_es/* Provider */.zt, {
        store: redux_store,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.6.0/css/bootstrap-grid.min.css"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: " Automation Factory - Bot Store "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/sites/default/files/2021-05/Unilever%20logo_login%20page.svg",
                        type: "image/png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=G-HMZJN1HYGP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        children: "window.dataLayer = window.dataLayer || [];\n\n            function gtag(){dataLayer.push(arguments);}\n\n            gtag('js', new Date());\n\n          \n\n            gtag('config', 'G-HMZJN1HYGP');"
                    })
                ]
            }),
            session ? /*#__PURE__*/ (0,jsx_runtime.jsx)(successModal["default"], {
                message: "Session Expired",
                title: "Login Session Status",
                session: session,
                sessionTimeOutCheck: sessionTimeOutCheck,
                setSuccessModal: setSuccessModal,
                fail: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                autoClose: 1500
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                style: {
                    overflow: "hidden"
                },
                children: [
                    !isProductPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sideBtnWrapper !hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onMouseEnter: handleMouseEnter,
                                onMouseLeave: handleMouseLeave,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "rightFloatBtn rightBtn hideTooltipText ".concat(textActive ? "active" : ""),
                                        children: "ROI"
                                    }),
                                    textActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "Lst",
                                        onClick: function() {
                                            return goTo("/return-on-investment");
                                        },
                                        children: "Click here to Check ROI of your Automation"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                            routeChangeState: routeChangeState
                        }))
                    })
                ]
            })
        ]
    });
}
var makestore = function() {
    return redux_store;
};
var wrapper = createWrapper(makestore);
var mapStateToProps = function(state) {
    // console.log("state", state);
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var _app = (wrapper.withRedux((0,react_redux_es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(MyApp)));


/***/ }),

/***/ 99696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51963);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _public_assets_svg_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18023);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);






function index(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                //console.log(ref.current,"lllllll");
                //console.log(event.target,"eeeeeee");
                if (ref.current && !ref.current.contains(event.target)) {
                    // props.setSuccessModal(false);
                    if (props.name == "submitanidea") {} else {
                        props.setSuccessModal(false);
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    //console.log("success modal", props.fail);
    var auth = "";
    if (true) {
        if (JSON.parse(localStorage.getItem("auth")) != null) {
            auth = JSON.parse(localStorage.getItem("auth")).data;
        }
    }
    //console.log("this is prop message", props.message);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var closeIt = function() {
        var path = router === null || router === void 0 ? void 0 : router.asPath;
        localStorage.setItem("loginRedirectUrl", JSON.stringify(!(path === null || path === void 0 ? void 0 : path.includes("login")) ? path : "/"));
        props.setSuccessModal(false);
        document.body.style.overflow = "unset";
        if (props.setfail) {
            props.setFail(false);
        }
        if (props.parent == "createBot") {
            router.push("/botStore");
        }
        if (props.setMessage) {
            props.setMessage("");
        }
        if (props.session) {
            props.sessionTimeOutCheck(false);
        }
    // if(props.setFail){
    //   props.setFail(false)
    // }
    };
    //For submitAnIdea Popup Close Function
    var handlePopup = function() {
        props.onCloseModal(); // Call the onCloseModal function from the parent
    };
    var modalRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    useOutsideAlerter(modalRef);
    var capitalizeWords = function(e) {
        var userName = auth.name.split(" ");
        var capitalizedUserName = userName.map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedUserName.join(" ");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().successContainer), " ").concat(props.checkoutSessionCheck == "checkoutSessionCheck" ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().successCheckoutContainer) : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBox),
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                        children: props.title ? props.title : ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBody),
                    children: [
                        props.fail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fail),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg_index__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                name: "failure"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().status),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg_index__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                name: "whitetick"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textBody), " ml-3"),
                            children: [
                                !props.session ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().texthead),
                                    children: [
                                        "Hi ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                            children: [
                                                props.submitAnIdeaCloseBtn == "removeCloseBtn" ? capitalizeWords(auth.name) : auth.name,
                                                ","
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textcontent),
                                    children: props.message ? props.message : " We have received your request for getting the bot and is shared with our team. We will reach you with your requirements."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalFooter),
                    children: props.areYouSure ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().areYouSureBtn),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exportListBtn),
                                onClick: function() {
                                    return props.setSuccessModal(true);
                                },
                                children: "Yes"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exportListBtn),
                                onClick: function() {
                                    return props.setSuccessModal(false);
                                },
                                children: "No"
                            })
                        ]
                    }) : props.session ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().combinedBtn),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exportListBtn),
                            onClick: function() {
                                return closeIt();
                            },
                            children: "Ok"
                        })
                    }) : props.submitAnIdeaCloseBtn == "removeCloseBtn" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().SubmitAnIdeaBtn),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().submitAnIdeaOk),
                            onClick: handlePopup,
                            children: "OK"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().combinedBtn),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exportListBtn),
                            onClick: function() {
                                return closeIt();
                            },
                            children: "Close"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 18023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Icons; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./public/assets/svg/check.jsx







var check = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(check, _Component);
    var _super = _createSuper(check);
    function check(props) {
        _classCallCheck(this, check);
        return _super.call(this, props);
    }
    _createClass(check, [
        {
            key: "render",
            value: function render() {
                var _obj;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (_obj = {
                    className: this.props.className,
                    width: "20px",
                    height: "20px",
                    viewBox: "0 0 20 20",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0,_define_property/* default */.Z)(_obj, "xmlns", "http://www.w3.org/1999/xlink"), (0,_define_property/* default */.Z)(_obj, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Artboard",
                    stroke: "none",
                    strokeWidth: "1",
                    fill: "none",
                    "fill-rule": "evenodd",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Group-69",
                        stroke: "#66D990",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                id: "Oval-3",
                                cx: "10",
                                cy: "10",
                                r: "9.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                id: "Path-11-Copy-4",
                                points: "6 10.0985989 8.93353926 13 15 7"
                            })
                        ]
                    })
                })), _obj));
            }
        }
    ]);
    return check;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/searchDesktop.jsx






var searchDesktop = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(searchDesktop, _Component);
    var _super = _createSuper(searchDesktop);
    function searchDesktop(props) {
        _classCallCheck(this, searchDesktop);
        return _super.call(this, props);
    }
    _createClass(searchDesktop, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.4731 18.9448C15.6005 18.9448 18.9463 15.5993 18.9463 11.4724C18.9463 7.34552 15.6005 4 11.4731 4C7.34584 4 4 7.34552 4 11.4724C4 15.5993 7.34584 18.9448 11.4731 18.9448Z",
                            stroke: "#1F36C7",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.0006 20.0002L16.75 16.75",
                            stroke: "#1F36C7",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return searchDesktop;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/userDesktop.jsx






var userDesktop = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(userDesktop, Component);
    var _super = _createSuper(userDesktop);
    function userDesktop() {
        _classCallCheck(this, userDesktop);
        return _super.apply(this, arguments);
    }
    _createClass(userDesktop, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21",
                            stroke: "#EBEDFA",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
                            stroke: "#EBEDFA",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return userDesktop;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/searchMobile.jsx






var searchMobile = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(searchMobile, Component);
    var _super = _createSuper(searchMobile);
    function searchMobile() {
        _classCallCheck(this, searchMobile);
        return _super.apply(this, arguments);
    }
    _createClass(searchMobile, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.4731 18.9448C15.6005 18.9448 18.9463 15.5993 18.9463 11.4724C18.9463 7.34552 15.6005 4 11.4731 4C7.34584 4 4 7.34552 4 11.4724C4 15.5993 7.34584 18.9448 11.4731 18.9448Z",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.0006 20.0002L16.75 16.75",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return searchMobile;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/burgerMenu.jsx






var burgerMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(burgerMenu, Component);
    var _super = _createSuper(burgerMenu);
    function burgerMenu() {
        _classCallCheck(this, burgerMenu);
        return _super.apply(this, arguments);
    }
    _createClass(burgerMenu, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20 6L10 6",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20 12L4 12",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20 18L14 18",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return burgerMenu;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/enquiryIcon.jsx






var enquiryIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(enquiryIcon, Component);
    var _super = _createSuper(enquiryIcon);
    function enquiryIcon() {
        _classCallCheck(this, enquiryIcon);
        return _super.apply(this, arguments);
    }
    _createClass(enquiryIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18.3346 1.66602L9.16797 10.8327",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18.3346 1.66602L12.5013 18.3327L9.16797 10.8327L1.66797 7.49935L18.3346 1.66602Z",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return enquiryIcon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/uploadIcon.jsx






var uploadIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(uploadIcon, Component);
    var _super = _createSuper(uploadIcon);
    function uploadIcon() {
        _classCallCheck(this, uploadIcon);
        return _super.apply(this, arguments);
    }
    _createClass(uploadIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M17.5 12L17.5 15.3333C17.5 15.7754 17.3244 16.1993 17.0118 16.5118C16.6993 16.8244 16.2754 17 15.8333 17L4.16667 17C3.72464 17 3.30072 16.8244 2.98816 16.5118C2.67559 16.1993 2.5 15.7754 2.5 15.3333L2.5 12",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.5767 7.24609L9.99929 3.66868L6.42188 7.24609",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10 3.83398L10 13.834",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return uploadIcon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/searchGray.jsx






var searchGray = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(searchGray, Component);
    var _super = _createSuper(searchGray);
    function searchGray() {
        _classCallCheck(this, searchGray);
        return _super.apply(this, arguments);
    }
    _createClass(searchGray, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9.47315 16.9448C13.6005 16.9448 16.9463 13.5993 16.9463 9.47242C16.9463 5.34552 13.6005 2 9.47315 2C5.34584 2 2 5.34552 2 9.47242C2 13.5993 5.34584 16.9448 9.47315 16.9448Z",
                            stroke: "#73706E",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18.0006 18.0002L14.75 14.75",
                            stroke: "#73706E",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return searchGray;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/plusIcon.jsx






var plusIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(plusIcon, Component);
    var _super = _createSuper(plusIcon);
    function plusIcon() {
        _classCallCheck(this, plusIcon);
        return _super.apply(this, arguments);
    }
    _createClass(plusIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M4.10744 10.4629L15.8926 10.4629",
                            stroke: "#005EEF",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10 16.3555L10 4.57035",
                            stroke: "#005EEF",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return plusIcon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/chevron.jsx






var chevron = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(chevron, Component);
    var _super = _createSuper(chevron);
    function chevron() {
        _classCallCheck(this, chevron);
        return _super.apply(this, arguments);
    }
    _createClass(chevron, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7 10L12 15L17 10",
                        stroke: "#73706E",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                });
            }
        }
    ]);
    return chevron;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/rightArrow.jsx






var rightArrow = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(rightArrow, Component);
    var _super = _createSuper(rightArrow);
    function rightArrow() {
        _classCallCheck(this, rightArrow);
        return _super.apply(this, arguments);
    }
    _createClass(rightArrow, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    id: "right-arrow",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z",
                        stroke: "#73706E",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                });
            }
        }
    ]);
    return rightArrow;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/leftArrow.jsx






var leftArrow = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(leftArrow, Component);
    var _super = _createSuper(leftArrow);
    function leftArrow() {
        _classCallCheck(this, leftArrow);
        return _super.apply(this, arguments);
    }
    _createClass(leftArrow, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    id: "left-arrow",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.29,12l3.54-3.54a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L9.17,11.29a1,1,0,0,0,0,1.42L13.41,17a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41Z",
                        stroke: "#73706E",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                });
            }
        }
    ]);
    return leftArrow;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/information.jsx






var information = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(information, Component);
    var _super = _createSuper(information);
    function information() {
        _classCallCheck(this, information);
        return _super.apply(this, arguments);
    }
    _createClass(information, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    id: "information",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"
                    })
                });
            }
        }
    ]);
    return information;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/pencilDark.jsx






var pencilDark = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(pencilDark, Component);
    var _super = _createSuper(pencilDark);
    function pencilDark() {
        _classCallCheck(this, pencilDark);
        return _super.apply(this, arguments);
    }
    _createClass(pencilDark, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10 16.666H17.5",
                            stroke: "#D5D4D3",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.75 2.9162C14.0815 2.58468 14.5312 2.39844 15 2.39844C15.2321 2.39844 15.462 2.44416 15.6765 2.533C15.891 2.62184 16.0858 2.75205 16.25 2.9162C16.4142 3.08036 16.5444 3.27523 16.6332 3.48971C16.722 3.70418 16.7678 3.93406 16.7678 4.1662C16.7678 4.39835 16.722 4.62822 16.6332 4.8427C16.5444 5.05717 16.4142 5.25205 16.25 5.4162L5.83333 15.8329L2.5 16.6662L3.33333 13.3329L13.75 2.9162Z",
                            stroke: "#D5D4D3",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return pencilDark;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/listWhite.jsx






var listWhite = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(listWhite, Component);
    var _super = _createSuper(listWhite);
    function listWhite() {
        _classCallCheck(this, listWhite);
        return _super.apply(this, arguments);
    }
    _createClass(listWhite, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.33203 6H13.9987",
                            stroke: "#1063EA",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M2 6H2.00667",
                            stroke: "#1063EA",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.33398 10H14.0007",
                            stroke: "#1063EA",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M2 10H2.00667",
                            stroke: "#1063EA",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return listWhite;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/shoppingIcon.jsx






var shoppingIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(shoppingIcon, Component);
    var _super = _createSuper(shoppingIcon);
    function shoppingIcon() {
        _classCallCheck(this, shoppingIcon);
        return _super.apply(this, arguments);
    }
    _createClass(shoppingIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M3 6H21",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return shoppingIcon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/whiteTick.jsx






var whiteTick = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(whiteTick, Component);
    var _super = _createSuper(whiteTick);
    function whiteTick() {
        _classCallCheck(this, whiteTick);
        return _super.apply(this, arguments);
    }
    _createClass(whiteTick, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.3346 4L6.0013 11.3333L2.66797 8",
                        stroke: "white",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                });
            }
        }
    ]);
    return whiteTick;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/arrowback.jsx






var arrowback = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(arrowback, Component);
    var _super = _createSuper(arrowback);
    function arrowback() {
        _classCallCheck(this, arrowback);
        return _super.apply(this, arguments);
    }
    _createClass(arrowback, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19 12H5",
                            stroke: "#1063EA",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12 19L5 12L12 5",
                            stroke: "#1063EA",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return arrowback;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/filters.jsx






var filters = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(filters, Component);
    var _super = _createSuper(filters);
    function filters() {
        _classCallCheck(this, filters);
        return _super.apply(this, arguments);
    }
    _createClass(filters, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22 3H2L10 12.46V19L14 21V12.46L22 3Z",
                        stroke: "#1063EA",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                });
            }
        }
    ]);
    return filters;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/pdfdoc.jsx






var pdfdoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(pdfdoc, Component);
    var _super = _createSuper(pdfdoc);
    function pdfdoc() {
        _classCallCheck(this, pdfdoc);
        return _super.apply(this, arguments);
    }
    _createClass(pdfdoc, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "32",
                    height: "32",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8 0C6.9 0 6 0.9 6 2V30C6 31.1 6.9 32 8 32H28C29.1 32 30 31.1 30 30V8L22 0H8Z",
                            fill: "#E2E5E7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M24 8H30L22 0V6C22 7.1 22.9 8 24 8Z",
                            fill: "#B0B7BD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30 14L24 8H30V14Z",
                            fill: "#CAD1D8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M26 26C26 26.55 25.55 27 25 27H3C2.45 27 2 26.55 2 26V16C2 15.45 2.45 15 3 15H25C25.55 15 26 15.45 26 16V26Z",
                            fill: "#F15642"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.928 18C9.37067 18 9.74667 18.0773 10.056 18.232C10.3707 18.3867 10.6053 18.6027 10.76 18.88C10.92 19.1573 11 19.472 11 19.824C11 20.1707 10.92 20.488 10.76 20.776C10.6 21.064 10.3627 21.2933 10.048 21.464C9.73867 21.6347 9.36533 21.72 8.928 21.72H8.216V23.68H7V18H8.928ZM8.776 20.728C9.064 20.728 9.29333 20.6507 9.464 20.496C9.63467 20.336 9.72 20.112 9.72 19.824C9.72 19.5413 9.63467 19.3333 9.464 19.2C9.29867 19.0613 9.06933 18.992 8.776 18.992H8.216V20.728H8.776Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M14.1295 18C14.6948 18 15.1935 18.1173 15.6255 18.352C16.0628 18.5813 16.4015 18.9093 16.6415 19.336C16.8815 19.7573 17.0015 20.248 17.0015 20.808C17.0015 21.3733 16.8815 21.8747 16.6415 22.312C16.4015 22.744 16.0628 23.08 15.6255 23.32C15.1882 23.56 14.6895 23.68 14.1295 23.68H11.9375V18H14.1295ZM13.9455 22.608C14.4948 22.608 14.9295 22.4507 15.2495 22.136C15.5695 21.8213 15.7295 21.384 15.7295 20.824C15.7295 20.2693 15.5695 19.8373 15.2495 19.528C14.9348 19.2187 14.5028 19.064 13.9535 19.064H13.1535V22.608H13.9455Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21.4716 18V19.064H19.2316V20.36H21.3596V21.416H19.2316V23.68H18.0156V18H21.4716Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M25 27H6V28H25C25.55 28 26 27.55 26 27V26C26 26.55 25.55 27 25 27Z",
                            fill: "#CAD1D8"
                        })
                    ]
                });
            }
        }
    ]);
    return pdfdoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/ppt.jsx






var RandD = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(RandD, Component);
    var _super = _createSuper(RandD);
    function RandD() {
        _classCallCheck(this, RandD);
        return _super.apply(this, arguments);
    }
    _createClass(RandD, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "33",
                    height: "33",
                    viewBox: "0 0 33 33",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M8.99609 0.635254C7.89609 0.635254 6.99609 1.53525 6.99609 2.63525V30.6353C6.99609 31.7353 7.89609 32.6353 8.99609 32.6353H28.9961C30.0961 32.6353 30.9961 31.7353 30.9961 30.6353V8.63525L22.9961 0.635254H8.99609Z",
                                    fill: "#E2E5E7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M24.9961 8.63525H30.9961L22.9961 0.635254V6.63525C22.9961 7.73525 23.8961 8.63525 24.9961 8.63525Z",
                                    fill: "#B0B7BD"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M30.9961 14.6353L24.9961 8.63525H30.9961V14.6353Z",
                                    fill: "#CAD1D8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M26.9961 26.6353C26.9961 27.1853 26.5461 27.6353 25.9961 27.6353H3.99609C3.44609 27.6353 2.99609 27.1853 2.99609 26.6353V16.6353C2.99609 16.0853 3.44609 15.6353 3.99609 15.6353H25.9961C26.5461 15.6353 26.9961 16.0853 26.9961 16.6353V26.6353Z",
                                    fill: "#EF6C01"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M25.9961 27.6353H6.99609V28.6353H25.9961C26.5461 28.6353 26.9961 28.1853 26.9961 27.6353V26.6353C26.9961 27.1853 26.5461 27.6353 25.9961 27.6353Z",
                                    fill: "#CAD1D8"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10.1585 18.7954C10.6011 18.7954 10.9771 18.8727 11.2865 19.0274C11.6011 19.1821 11.8358 19.3981 11.9905 19.6754C12.1505 19.9527 12.2305 20.2674 12.2305 20.6194C12.2305 20.9661 12.1505 21.2834 11.9905 21.5714C11.8305 21.8594 11.5931 22.0887 11.2785 22.2594C10.9691 22.4301 10.5958 22.5154 10.1585 22.5154H9.44647V24.4754H8.23047V18.7954H10.1585ZM10.0065 21.5234C10.2945 21.5234 10.5238 21.4461 10.6945 21.2914C10.8651 21.1314 10.9505 20.9074 10.9505 20.6194C10.9505 20.3367 10.8651 20.1287 10.6945 19.9954C10.5291 19.8567 10.2998 19.7874 10.0065 19.7874H9.44647V21.5234H10.0065Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M15.096 18.7954C15.5386 18.7954 15.9146 18.8727 16.224 19.0274C16.5386 19.1821 16.7733 19.3981 16.928 19.6754C17.088 19.9527 17.168 20.2674 17.168 20.6194C17.168 20.9661 17.088 21.2834 16.928 21.5714C16.768 21.8594 16.5306 22.0887 16.216 22.2594C15.9066 22.4301 15.5333 22.5154 15.096 22.5154H14.384V24.4754H13.168V18.7954H15.096ZM14.944 21.5234C15.232 21.5234 15.4613 21.4461 15.632 21.2914C15.8026 21.1314 15.888 20.9074 15.888 20.6194C15.888 20.3367 15.8026 20.1287 15.632 19.9954C15.4666 19.8567 15.2373 19.7874 14.944 19.7874H14.384V21.5234H14.944Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21.7615 19.8514H20.2975V24.4754H19.0815V19.8514H17.6015V18.7954H21.7615V19.8514Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "32",
                                    height: "32",
                                    fill: "white",
                                    transform: "translate(0.996094 0.635254)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RandD;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/mailDoc.jsx






var Maildoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Maildoc, Component);
    var _super = _createSuper(Maildoc);
    function Maildoc() {
        _classCallCheck(this, Maildoc);
        return _super.apply(this, arguments);
    }
    _createClass(Maildoc, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "33",
                    fill: "none",
                    viewBox: "0 0 33 33",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#004FAC",
                            d: "M27.994 15.392l3.335-2.044c-.03-.074-.065-.146-.105-.215-.131-.233-.308-.437-.52-.6l-2.71-2.055-7.04-5.345-2.75-2.085c-.348-.263-.773-.405-1.21-.405-.436 0-.861.142-1.21.405l-2.75 2.085-7.04 5.345-2.71 2.055c-.212.163-.389.367-.52.6-.085.141-.15.295-.19.455l14.167 8.595 11.253-6.79z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#E2E5E7",
                            d: "M27.996 10.48V6.135c0-.265-.105-.52-.293-.707-.187-.187-.442-.293-.707-.293h-20c-.265 0-.52.106-.707.293-.188.188-.293.442-.293.707v9.53l10.747 6.52 11.253-6.79V10.48z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#006DF0",
                            d: "M16.742 22.186l14.013 8.501-14.013-8.501zM27.996 15.394l3.335-2.044-3.335 2.044zM27.995 15.394l-11.253 6.791 14.013 8.5c.232-.186.419-.422.547-.69.128-.269.194-.563.193-.86V14.13c.002-.269-.055-.535-.165-.78l-3.335 2.044z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#2488FF",
                            d: "M5.996 15.663l-3.42-2.075c-.054.175-.081.357-.08.54v15.005c0 .53.21 1.04.586 1.415.375.375.884.585 1.414.585h25c.46 0 .904-.16 1.26-.45l-24.76-15.02z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#005ECE",
                            d: "M31.33 13.35l-3.335 2.044v9.741c0 .576-.124 1.145-.365 1.668-.24.523-.591.988-1.028 1.362l4.153 2.52c.232-.186.419-.422.547-.69.128-.269.194-.563.193-.86V14.13c.001-.269-.055-.535-.165-.78z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#006DF0",
                            d: "M23.996 29.133h-21.5c0 .53.21 1.04.586 1.414.375.375.884.586 1.414.586h25c.46 0 .904-.16 1.26-.45l-4.153-2.52c-.724.626-1.65.97-2.607.97z"
                        })
                    ]
                });
            }
        }
    ]);
    return Maildoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/Docdoc.jsx







var Docdoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Docdoc, Component);
    var _super = _createSuper(Docdoc);
    function Docdoc() {
        _classCallCheck(this, Docdoc);
        return _super.apply(this, arguments);
    }
    _createClass(Docdoc, [
        {
            key: "render",
            value: function render() {
                var _obj;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (_obj = {
                    className: this.props.className,
                    onClick: this.props.onClick
                }, (0,_define_property/* default */.Z)(_obj, "className", this.props.className), (0,_define_property/* default */.Z)(_obj, "onClick", this.props.onClick), (0,_define_property/* default */.Z)(_obj, "xmlns", "http://www.w3.org/2000/svg"), (0,_define_property/* default */.Z)(_obj, "width", "29"), (0,_define_property/* default */.Z)(_obj, "height", "33"), (0,_define_property/* default */.Z)(_obj, "fill", "none"), (0,_define_property/* default */.Z)(_obj, "viewBox", "0 0 29 33"), (0,_define_property/* default */.Z)(_obj, "children", [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E2E5E7",
                        d: "M6.996.635c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-22l-8-8h-14z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#B0B7BD",
                        d: "M22.996 8.635h6l-8-8v6c0 1.1.9 2 2 2z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#CAD1D8",
                        d: "M28.996 14.635l-6-6h6v6zM19.436 27.235H4.996v1h14.44c.418 0 .76-.45.76-1v-1c0 .55-.342 1-.76 1z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#50BEE8",
                        d: "M20.196 26.302c0 .55-.36 1-.8 1h-17.6c-.44 0-.8-.45-.8-1v-10c0-.55.36-1 .8-1h17.6c.44 0 .8.45.8 1v10z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M5.49 19.368c.472 0 .887.098 1.247.294.365.19.647.464.847.82.2.35.3.76.3 1.226 0 .472-.1.89-.3 1.254-.2.36-.482.64-.847.84-.364.2-.78.3-1.246.3H3.664v-4.734h1.827zm-.153 3.84c.458 0 .82-.13 1.087-.393.267-.262.4-.627.4-1.093 0-.463-.133-.823-.4-1.08-.262-.258-.622-.387-1.08-.387h-.667v2.953h.66zM10.97 24.168c-.468 0-.89-.1-1.268-.3-.373-.204-.668-.49-.886-.86-.214-.368-.32-.793-.32-1.273 0-.48.106-.904.32-1.273.218-.37.513-.654.886-.854.378-.204.805-.306 1.28-.306.472 0 .896.102 1.274.306.378.2.673.485.886.854.218.364.327.784.327 1.26 0 .475-.109.9-.326 1.273-.214.369-.512.658-.894.867-.378.204-.804.306-1.28.306zm.012-.953c.276 0 .523-.062.74-.187.218-.128.387-.304.507-.526.12-.227.18-.482.18-.767 0-.284-.06-.538-.18-.76-.12-.227-.289-.402-.506-.527-.218-.128-.465-.193-.74-.193-.276 0-.523.065-.74.193-.218.125-.387.3-.507.527-.12.222-.18.476-.18.76 0 .285.06.54.18.767.12.222.289.398.506.526.218.125.465.187.74.187zM16.468 24.168c-.457 0-.868-.102-1.233-.306-.36-.205-.642-.491-.847-.86-.204-.37-.306-.79-.306-1.26 0-.476.104-.898.313-1.267.213-.373.505-.662.873-.867.37-.204.783-.306 1.24-.306.534 0 1.01.104 1.427.313l-.187.927c-.36-.196-.742-.294-1.146-.294-.285 0-.538.065-.76.194-.223.124-.396.3-.52.526-.12.223-.18.476-.18.76 0 .285.06.54.18.767.12.227.289.404.506.533.223.13.48.194.774.194.422 0 .829-.096 1.22-.287l.12.92c-.427.209-.918.313-1.474.313z"
                    })
                ]), _obj));
            }
        }
    ]);
    return Docdoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/JpgDoc.jsx






var Jpgdoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Jpgdoc, Component);
    var _super = _createSuper(Jpgdoc);
    function Jpgdoc() {
        _classCallCheck(this, Jpgdoc);
        return _super.apply(this, arguments);
    }
    _createClass(Jpgdoc, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "33",
                    fill: "none",
                    viewBox: "0 0 33 33",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#E2E5E7",
                                    d: "M8.996.635c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-22l-8-8h-14z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#B0B7BD",
                                    d: "M18.694 10.208c-.987 0-1.787-.8-1.787-1.786 0-.987.8-1.787 1.787-1.787.987 0 1.787.8 1.787 1.787 0 .986-.8 1.786-1.787 1.786z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M29.996 19.635h-22v-5.902l5.116-5.098 5.373 6.171 2.805-2.942 8.706 7.771z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#B0B7BD",
                                    d: "M24.996 8.635h6l-8-8v6c0 1.1.9 2 2 2z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M30.996 14.635l-6-6h6v6zM25.996 27.635h-19v1h19c.55 0 1-.45 1-1v-1c0 .55-.45 1-1 1z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#FF79C6",
                                    d: "M26.996 26.635c0 .55-.45 1-1 1h-22c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v10z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M9.076 24.475c-.427 0-.787-.056-1.08-.168l.192-1.056c.213.096.421.144.624.144.235 0 .413-.077.536-.232.123-.154.184-.39.184-.704v-3.744h1.208v3.824c0 .63-.15 1.11-.448 1.44-.299.33-.704.496-1.216.496zM13.866 18.715c.443 0 .819.078 1.128.232.315.155.55.37.704.648.16.278.24.592.24.944 0 .347-.08.664-.24.952-.16.288-.397.518-.712.688-.309.17-.682.256-1.12.256h-.712v1.96h-1.216v-5.68h1.928zm-.152 2.728c.288 0 .518-.077.688-.232.171-.16.256-.384.256-.672 0-.282-.085-.49-.256-.624-.165-.138-.394-.208-.688-.208h-.56v1.736h.56zM21.564 21.58v2.463c-.544.288-1.192.432-1.944.432-.614 0-1.15-.122-1.608-.368-.454-.245-.803-.59-1.048-1.032-.245-.448-.368-.965-.368-1.552 0-.565.122-1.066.368-1.504.245-.437.587-.776 1.024-1.016.442-.245.944-.368 1.504-.368.682 0 1.29.147 1.824.44l-.224 1.104c-.47-.272-.965-.408-1.488-.408-.357 0-.667.075-.928.224-.261.15-.461.358-.6.624-.139.267-.208.57-.208.912 0 .347.072.656.216.928.144.272.346.488.608.648.267.155.576.232.928.232.23 0 .472-.032.728-.096V21.58h1.216z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M0 0H32V32H0z",
                                    transform: "translate(.996 .635)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Jpgdoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/Pngdoc.jsx






var Pngdoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Pngdoc, Component);
    var _super = _createSuper(Pngdoc);
    function Pngdoc() {
        _classCallCheck(this, Pngdoc);
        return _super.apply(this, arguments);
    }
    _createClass(Pngdoc, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "33",
                    fill: "none",
                    viewBox: "0 0 33 33",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#E2E5E7",
                                    d: "M8.996.635c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-22l-8-8h-14z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#B0B7BD",
                                    d: "M24.996 8.635h6l-8-8v6c0 1.1.9 2 2 2z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M30.996 14.635l-6-6h6v6zM25.996 27.635h-19v1h19c.55 0 1-.45 1-1v-1c0 .55-.45 1-1 1z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#B0B7BD",
                                    d: "M18.694 10.208c-.987 0-1.787-.8-1.787-1.786 0-.987.8-1.787 1.787-1.787.987 0 1.787.8 1.787 1.787 0 .986-.8 1.786-1.787 1.786z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M29.996 19.635h-22v-5.902l5.116-5.098 5.373 6.171 2.805-2.942 8.706 7.771z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#A066AA",
                                    d: "M26.996 26.635c0 .55-.45 1-1 1h-22c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v10z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M8.924 18.715c.443 0 .819.078 1.128.232.315.155.55.37.704.648.16.278.24.592.24.944 0 .347-.08.664-.24.952-.16.288-.397.518-.712.688-.31.17-.683.256-1.12.256h-.712v1.96H6.996v-5.68h1.928zm-.152 2.728c.288 0 .517-.077.688-.232.17-.16.256-.384.256-.672 0-.282-.085-.49-.256-.624-.165-.138-.395-.208-.688-.208h-.56v1.736h.56zM16.902 18.715v5.68h-1.224l-2.584-3.8v3.8h-1.16v-5.68h1.232l2.584 3.808v-3.808h1.152zM22.887 21.58v2.463c-.544.288-1.192.432-1.944.432-.613 0-1.15-.122-1.608-.368-.453-.245-.802-.59-1.048-1.032-.245-.448-.368-.965-.368-1.552 0-.565.123-1.066.368-1.504.246-.437.587-.776 1.024-1.016.443-.245.944-.368 1.504-.368.683 0 1.29.147 1.824.44l-.224 1.104c-.47-.272-.965-.408-1.488-.408-.357 0-.666.075-.928.224-.261.15-.461.358-.6.624-.138.267-.208.57-.208.912 0 .347.072.656.216.928.144.272.347.488.608.648.267.155.576.232.928.232.23 0 .472-.032.728-.096V21.58h1.216z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M0 0H32V32H0z",
                                    transform: "translate(.996 .635)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Pngdoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/Xlsdoc.jsx






var Xlsdoc = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Xlsdoc, Component);
    var _super = _createSuper(Xlsdoc);
    function Xlsdoc() {
        _classCallCheck(this, Xlsdoc);
        return _super.apply(this, arguments);
    }
    _createClass(Xlsdoc, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "33",
                    fill: "none",
                    viewBox: "0 0 33 33",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#E2E5E7",
                                    d: "M8.996.635c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-22l-8-8h-14z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#B0B7BD",
                                    d: "M24.996 8.635h6l-8-8v6c0 1.1.9 2 2 2z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M30.996 14.635l-6-6h6v6z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#84BD5A",
                                    d: "M26.996 26.635c0 .55-.45 1-1 1h-22c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v10z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M11.636 24.395L10.5 22.38l-1.168 2.016H7.996l1.8-2.928-1.688-2.752h1.424l1.032 1.808 1.064-1.808H12.9l-1.632 2.712 1.776 2.968h-1.408zM17.263 23.307v1.088h-3.496v-5.68h1.216v4.592h2.28zM19.736 24.475c-.747 0-1.387-.141-1.92-.424l.2-1.112c.235.139.499.25.792.336.293.08.592.12.896.12.533 0 .8-.186.8-.56 0-.122-.035-.224-.104-.304-.07-.085-.173-.16-.312-.224-.139-.07-.357-.162-.656-.28-.496-.186-.87-.41-1.12-.672-.245-.261-.368-.613-.368-1.056 0-.522.181-.93.544-1.224.363-.293.84-.44 1.432-.44.293 0 .587.035.88.104.293.064.544.147.752.248l-.152 1.064c-.203-.096-.445-.178-.728-.248-.277-.074-.517-.112-.72-.112-.24 0-.424.046-.552.136-.128.09-.192.219-.192.384 0 .155.083.288.248.4.165.107.456.238.872.392.315.118.573.24.776.368.208.128.37.299.488.512.123.208.184.47.184.784 0 .57-.184 1.016-.552 1.336-.363.315-.859.472-1.488.472z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#CAD1D8",
                                    d: "M25.996 27.635h-19v1h19c.55 0 1-.45 1-1v-1c0 .55-.45 1-1 1z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M0 0H32V32H0z",
                                    transform: "translate(.996 .635)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Xlsdoc;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/downloadWhite.jsx






var downloadWhite = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(downloadWhite, Component);
    var _super = _createSuper(downloadWhite);
    function downloadWhite() {
        _classCallCheck(this, downloadWhite);
        return _super.apply(this, arguments);
    }
    _createClass(downloadWhite, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.83594 8.33398L10.0026 12.5007L14.1693 8.33398",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10 12.5V2.5",
                            stroke: "white",
                            strokeWidth: "1.6",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return downloadWhite;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/downloadBlue.jsx






var downloadBlue = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(downloadBlue, Component);
    var _super = _createSuper(downloadBlue);
    function downloadBlue() {
        _classCallCheck(this, downloadBlue);
        return _super.apply(this, arguments);
    }
    _createClass(downloadBlue, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "21",
                    height: "21",
                    fill: "none",
                    viewBox: "0 0 21 21",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#1F36C7",
                        "stroke-linecap": "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.6",
                        d: "M18.496 13.135v3.334c0 .442-.175.865-.488 1.178-.313.313-.736.488-1.179.488H5.163c-.442 0-.866-.175-1.179-.488-.312-.313-.488-.736-.488-1.178v-3.334M6.832 8.967l4.167 4.167 4.166-4.167M10.996 13.135v-10"
                    })
                });
            }
        }
    ]);
    return downloadBlue;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/delete.jsx






var delete_chevron = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(chevron, Component);
    var _super = _createSuper(chevron);
    function chevron() {
        _classCallCheck(this, chevron);
        return _super.apply(this, arguments);
    }
    _createClass(chevron, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "21",
                    height: "20",
                    viewBox: "0 0 21 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M3.49609 5H5.16276H18.4961",
                            stroke: "#D5D4D3",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M7.66406 5.0013V3.33464C7.66406 2.89261 7.83966 2.46868 8.15222 2.15612C8.46478 1.84356 8.8887 1.66797 9.33073 1.66797H12.6641C13.1061 1.66797 13.53 1.84356 13.8426 2.15612C14.1551 2.46868 14.3307 2.89261 14.3307 3.33464V5.0013M16.8307 5.0013V16.668C16.8307 17.11 16.6551 17.5339 16.3426 17.8465C16.03 18.159 15.6061 18.3346 15.1641 18.3346H6.83073C6.3887 18.3346 5.96478 18.159 5.65222 17.8465C5.33966 17.5339 5.16406 17.11 5.16406 16.668V5.0013H16.8307Z",
                            stroke: "#D5D4D3",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return chevron;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/logout.jsx






var logout = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(logout, Component);
    var _super = _createSuper(logout);
    function logout() {
        _classCallCheck(this, logout);
        return _super.apply(this, arguments);
    }
    _createClass(logout, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9",
                            stroke: "#333333",
                            strokeWidth: "2",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16 17L21 12L16 7",
                            stroke: "#333333",
                            strokeWidth: "2",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21 12H9",
                            stroke: "#333333",
                            strokeWidth: "2",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return logout;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/closeBurger.jsx






var closeBurger = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(closeBurger, Component);
    var _super = _createSuper(closeBurger);
    function closeBurger() {
        _classCallCheck(this, closeBurger);
        return _super.apply(this, arguments);
    }
    _createClass(closeBurger, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18 6L6 18",
                            stroke: "white",
                            strokeWidth: "2",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6 6L18 18",
                            stroke: "white",
                            strokeWidth: "2",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return closeBurger;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/customerDevelopment.jsx






var customerDevelopment = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(customerDevelopment, Component);
    var _super = _createSuper(customerDevelopment);
    function customerDevelopment() {
        _classCallCheck(this, customerDevelopment);
        return _super.apply(this, arguments);
    }
    _createClass(customerDevelopment, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12.1504 15.6641C13.8072 15.6641 15.1504 14.3209 15.1504 12.6641C15.1504 11.0072 13.8072 9.66406 12.1504 9.66406C10.4935 9.66406 9.15039 11.0072 9.15039 12.6641C9.15039 14.3209 10.4935 15.6641 12.1504 15.6641Z",
                                    stroke: "#001F82",
                                    strokeWidth: "1.6",
                                    "stroke-linecap": "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M19.5504 15.6641C19.4173 15.9657 19.3776 16.3003 19.4364 16.6247C19.4952 16.949 19.6499 17.2484 19.8804 17.4841L19.9404 17.5441C20.1263 17.7298 20.2739 17.9504 20.3745 18.1932C20.4752 18.436 20.527 18.6962 20.527 18.9591C20.527 19.2219 20.4752 19.4821 20.3745 19.7249C20.2739 19.9677 20.1263 20.1883 19.9404 20.3741C19.7546 20.56 19.5341 20.7075 19.2913 20.8082C19.0485 20.9088 18.7882 20.9606 18.5254 20.9606C18.2626 20.9606 18.0023 20.9088 17.7595 20.8082C17.5167 20.7075 17.2961 20.56 17.1104 20.3741L17.0504 20.3141C16.8147 20.0835 16.5154 19.9289 16.191 19.8701C15.8666 19.8112 15.532 19.8509 15.2304 19.9841C14.9346 20.1108 14.6824 20.3213 14.5047 20.5896C14.327 20.8579 14.2317 21.1723 14.2304 21.4941V21.6641C14.2304 22.1945 14.0197 22.7032 13.6446 23.0783C13.2695 23.4533 12.7608 23.6641 12.2304 23.6641C11.7 23.6641 11.1913 23.4533 10.8162 23.0783C10.4411 22.7032 10.2304 22.1945 10.2304 21.6641V21.5741C10.2226 21.2431 10.1155 20.9221 9.9229 20.6528C9.73029 20.3835 9.46113 20.1783 9.15039 20.0641C8.84877 19.9309 8.5142 19.8912 8.1898 19.9501C7.86541 20.0089 7.56607 20.1635 7.33039 20.3941L7.27039 20.4541C7.08464 20.64 6.86407 20.7875 6.62127 20.8882C6.37847 20.9888 6.11822 21.0406 5.85539 21.0406C5.59256 21.0406 5.33231 20.9888 5.08951 20.8882C4.84671 20.7875 4.62614 20.64 4.44039 20.4541C4.25444 20.2683 4.10692 20.0477 4.00627 19.8049C3.90562 19.5621 3.85382 19.3019 3.85382 19.0391C3.85382 18.7762 3.90562 18.516 4.00627 18.2732C4.10692 18.0304 4.25444 17.8098 4.44039 17.6241L4.50039 17.5641C4.73093 17.3284 4.88558 17.029 4.9444 16.7047C5.00321 16.3803 4.96351 16.0457 4.83039 15.7441C4.70363 15.4483 4.49315 15.196 4.22486 15.0184C3.95657 14.8407 3.64218 14.7453 3.32039 14.7441H3.15039C2.61996 14.7441 2.11125 14.5333 1.73618 14.1583C1.3611 13.7832 1.15039 13.2745 1.15039 12.7441C1.15039 12.2136 1.3611 11.7049 1.73618 11.3298C2.11125 10.9548 2.61996 10.7441 3.15039 10.7441H3.24039C3.57138 10.7363 3.8924 10.6292 4.16169 10.4366C4.43098 10.244 4.63611 9.9748 4.75039 9.66406C4.88351 9.36245 4.92321 9.02787 4.8644 8.70347C4.80558 8.37908 4.65093 8.07974 4.42039 7.84406L4.36039 7.78406C4.17444 7.59832 4.02692 7.37774 3.92627 7.13494C3.82562 6.89215 3.77382 6.63189 3.77382 6.36906C3.77382 6.10623 3.82562 5.84598 3.92627 5.60318C4.02692 5.36039 4.17444 5.13981 4.36039 4.95406C4.54614 4.76811 4.76671 4.62059 5.00951 4.51994C5.25231 4.41929 5.51256 4.36749 5.77539 4.36749C6.03822 4.36749 6.29848 4.41929 6.54127 4.51994C6.78407 4.62059 7.00464 4.76811 7.19039 4.95406L7.25039 5.01406C7.48607 5.2446 7.78541 5.39925 8.1098 5.45807C8.4342 5.51689 8.76877 5.47718 9.07039 5.34406H9.15039C9.44616 5.2173 9.69841 5.00682 9.87608 4.73853C10.0538 4.47024 10.1491 4.15585 10.1504 3.83406V3.66406C10.1504 3.13363 10.3611 2.62492 10.7362 2.24985C11.1113 1.87478 11.62 1.66406 12.1504 1.66406C12.6808 1.66406 13.1895 1.87478 13.5646 2.24985C13.9397 2.62492 14.1504 3.13363 14.1504 3.66406V3.75406C14.1517 4.07585 14.247 4.39024 14.4247 4.65853C14.6024 4.92682 14.8546 5.1373 15.1504 5.26406C15.452 5.39718 15.7866 5.43689 16.111 5.37807C16.4354 5.31925 16.7347 5.1646 16.9704 4.93406L17.0304 4.87406C17.2161 4.68811 17.4367 4.54059 17.6795 4.43994C17.9223 4.33929 18.1826 4.28749 18.4454 4.28749C18.7082 4.28749 18.9685 4.33929 19.2113 4.43994C19.4541 4.54059 19.6746 4.68811 19.8604 4.87406C20.0463 5.05981 20.1939 5.28039 20.2945 5.52318C20.3952 5.76598 20.447 6.02623 20.447 6.28906C20.447 6.55189 20.3952 6.81215 20.2945 7.05494C20.1939 7.29774 20.0463 7.51832 19.8604 7.70406L19.8004 7.76406C19.5699 7.99974 19.4152 8.29908 19.3564 8.62347C19.2976 8.94787 19.3373 9.28245 19.4704 9.58406V9.66406C19.5972 9.95983 19.8076 10.2121 20.0759 10.3898C20.3442 10.5674 20.6586 10.6628 20.9804 10.6641H21.1504C21.6808 10.6641 22.1895 10.8748 22.5646 11.2498C22.9397 11.6249 23.1504 12.1336 23.1504 12.6641C23.1504 13.1945 22.9397 13.7032 22.5646 14.0783C22.1895 14.4533 21.6808 14.6641 21.1504 14.6641H21.0604C20.7386 14.6653 20.4242 14.7607 20.1559 14.9384C19.8876 15.116 19.6772 15.3683 19.5504 15.6641V15.6641Z",
                                    stroke: "#001F82",
                                    strokeWidth: "1.6",
                                    "stroke-linecap": "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "24",
                                    height: "24",
                                    fill: "white",
                                    transform: "translate(0.150391 0.664062)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return customerDevelopment;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/supplyChain.jsx






var supplyChain = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(supplyChain, Component);
    var _super = _createSuper(supplyChain);
    function supplyChain() {
        _classCallCheck(this, supplyChain);
        return _super.apply(this, arguments);
    }
    _createClass(supplyChain, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.6504 10.065L7.65039 4.875",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21.1504 16.6659V8.66592C21.15 8.31519 21.0574 7.97073 20.8819 7.66708C20.7064 7.36343 20.4541 7.11128 20.1504 6.93592L13.1504 2.93592C12.8464 2.76038 12.5015 2.66797 12.1504 2.66797C11.7993 2.66797 11.4544 2.76038 11.1504 2.93592L4.15039 6.93592C3.84665 7.11128 3.59437 7.36343 3.41885 7.66708C3.24333 7.97073 3.15075 8.31519 3.15039 8.66592V16.6659C3.15075 17.0166 3.24333 17.3611 3.41885 17.6648C3.59437 17.9684 3.84665 18.2206 4.15039 18.3959L11.1504 22.3959C11.4544 22.5715 11.7993 22.6639 12.1504 22.6639C12.5015 22.6639 12.8464 22.5715 13.1504 22.3959L20.1504 18.3959C20.4541 18.2206 20.7064 17.9684 20.8819 17.6648C21.0574 17.3611 21.15 17.0166 21.1504 16.6659Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M3.41992 7.625L12.1499 12.675L20.8799 7.625",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.1504 22.7441V12.6641",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return supplyChain;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/itService.jsx






var itService = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(itService, Component);
    var _super = _createSuper(itService);
    function itService() {
        _classCallCheck(this, itService);
        return _super.apply(this, arguments);
    }
    _createClass(itService, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.1504 3.66406H4.15039C3.04582 3.66406 2.15039 4.55949 2.15039 5.66406V15.6641C2.15039 16.7686 3.04582 17.6641 4.15039 17.6641H20.1504C21.255 17.6641 22.1504 16.7686 22.1504 15.6641V5.66406C22.1504 4.55949 21.255 3.66406 20.1504 3.66406Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.15039 21.6641H16.1504",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.1504 17.6641V21.6641",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return itService;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/finance.jsx






var finance = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(finance, Component);
    var _super = _createSuper(finance);
    function finance() {
        _classCallCheck(this, finance);
        return _super.apply(this, arguments);
    }
    _createClass(finance, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "12.1504",
                            cy: "12.6641",
                            r: "10",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M15.0402 14.1457C15.0402 14.7829 14.8438 15.3051 14.4512 15.7126C14.0586 16.12 13.5029 16.3719 12.7843 16.4682V17.3128H11.6842V16.5016C11.2249 16.4645 10.7841 16.383 10.3618 16.2571C9.94698 16.1312 9.58027 15.9608 9.26172 15.7459L9.68399 14.3902C9.98773 14.6125 10.3433 14.7903 10.7508 14.9236C11.1656 15.0496 11.5916 15.1125 12.0287 15.1125C12.4362 15.1125 12.7473 15.0459 12.9621 14.9125C13.177 14.7717 13.2844 14.568 13.2844 14.3013C13.2844 14.0494 13.1659 13.8568 12.9288 13.7235C12.6917 13.5827 12.2917 13.4346 11.7287 13.279C11.0619 13.1012 10.5137 12.8493 10.084 12.5233C9.66176 12.1974 9.45063 11.7195 9.45063 11.0898C9.45063 10.4676 9.64695 9.96009 10.0396 9.56745C10.4322 9.17481 10.9804 8.93034 11.6842 8.83403V8.01172H12.7843V8.81181C13.1696 8.84144 13.5326 8.90441 13.8734 9.00072C14.2215 9.09703 14.5216 9.21556 14.7735 9.35632L14.3401 10.6565C13.9548 10.4713 13.6141 10.3379 13.3177 10.2564C13.0214 10.1749 12.6991 10.1342 12.351 10.1342C11.9954 10.1342 11.7176 10.1972 11.5175 10.3231C11.3175 10.4416 11.2175 10.6268 11.2175 10.8787C11.2175 11.138 11.336 11.3343 11.5731 11.4677C11.8102 11.601 12.1954 11.7455 12.7288 11.901C13.2177 12.0418 13.6252 12.1974 13.9511 12.3678C14.2771 12.5308 14.5401 12.7567 14.7401 13.0456C14.9401 13.3271 15.0402 13.6938 15.0402 14.1457Z",
                            fill: "#001F82"
                        })
                    ]
                });
            }
        }
    ]);
    return finance;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/workplaceService.jsx






var workplaceService = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(workplaceService, Component);
    var _super = _createSuper(workplaceService);
    function workplaceService() {
        _classCallCheck(this, workplaceService);
        return _super.apply(this, arguments);
    }
    _createClass(workplaceService, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.1328 7.66406H4.13281C3.02824 7.66406 2.13281 8.55949 2.13281 9.66406V19.6641C2.13281 20.7686 3.02824 21.6641 4.13281 21.6641H20.1328C21.2374 21.6641 22.1328 20.7686 22.1328 19.6641V9.66406C22.1328 8.55949 21.2374 7.66406 20.1328 7.66406Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.1328 21.6641V5.66406C16.1328 5.13363 15.9221 4.62492 15.547 4.24985C15.172 3.87478 14.6632 3.66406 14.1328 3.66406H10.1328C9.60238 3.66406 9.09367 3.87478 8.7186 4.24985C8.34353 4.62492 8.13281 5.13363 8.13281 5.66406V21.6641",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return workplaceService;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/legal.jsx






var legal = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(legal, Component);
    var _super = _createSuper(legal);
    function legal() {
        _classCallCheck(this, legal);
        return _super.apply(this, arguments);
    }
    _createClass(legal, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.84902 20.6237C2.39824 20.6237 2.03281 20.9891 2.03281 21.4399C2.03281 21.8907 2.39824 22.2561 2.84902 22.2561H13.234C13.6848 22.2561 14.0502 21.8907 14.0502 21.4399C14.0502 20.9891 13.6848 20.6237 13.234 20.6237H2.84902ZM11.455 15.9915L14.108 13.3383L20.543 19.7733C20.8617 20.0921 21.3784 20.0921 21.6971 19.7733C22.0159 19.4546 22.0159 18.9379 21.6971 18.6192L15.2621 12.1843L17.9153 9.53119L18.2166 9.83249C18.5354 10.1512 19.0521 10.1512 19.3708 9.83245C19.6895 9.51372 19.6895 8.99696 19.3708 8.67824L18.9987 8.30617L14.6722 3.97966L14.3001 3.60756C13.9814 3.28883 13.4646 3.28884 13.1459 3.60757C12.8272 3.92629 12.8272 4.44303 13.1459 4.76174L13.4473 5.06312L6.98693 11.5235L6.68555 11.2221C6.36683 10.9034 5.85009 10.9034 5.53137 11.2221C5.21264 11.5408 5.21264 12.0576 5.53136 12.3763L5.90347 12.7484L10.2301 17.0749L10.6022 17.447C10.9209 17.7657 11.4377 17.7657 11.7564 17.447C12.0751 17.1283 12.0751 16.6116 11.7564 16.2928L11.455 15.9915ZM14.0372 11.1007L13.0245 12.1134L10.3007 14.8373L8.1411 12.6777L14.6015 6.21729L16.7611 8.37688L14.0372 11.1007Z",
                        fill: "#001F82",
                        stroke: "#001F82",
                        strokeWidth: "0.2"
                    })
                });
            }
        }
    ]);
    return legal;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/IandA.jsx






var IandA = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(IandA, Component);
    var _super = _createSuper(IandA);
    function IandA() {
        _classCallCheck(this, IandA);
        return _super.apply(this, arguments);
    }
    _createClass(IandA, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.1328 22.6641C12.1328 22.6641 20.1328 18.6641 20.1328 12.6641V5.66406L12.1328 2.66406L4.13281 5.66406V12.6641C4.13281 18.6641 12.1328 22.6641 12.1328 22.6641Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M15.2503 10.9417L11.5768 14.6153L9.62722 12.6658",
                            stroke: "#001F82",
                            strokeWidth: "1.4",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return IandA;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/RandD.jsx






var RandD_RandD = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(RandD, Component);
    var _super = _createSuper(RandD);
    function RandD() {
        _classCallCheck(this, RandD);
        return _super.apply(this, arguments);
    }
    _createClass(RandD, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M14.4462 8.53516C17.3169 9.50079 19.3846 12.214 19.3846 15.4102C19.3846 19.4153 16.1378 22.662 12.1327 22.662C8.12763 22.662 4.88086 19.4153 4.88086 15.4102C4.88086 12.214 6.94854 9.50079 9.81923 8.53516",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M14.4463 8.53705V2.96406C14.4463 2.79838 14.312 2.66406 14.1463 2.66406H10.1184C9.95267 2.66406 9.81836 2.79838 9.81836 2.96406V8.53705",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "8.95724",
                            cy: "16.3537",
                            r: "0.86154",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "13.1366",
                            cy: "14.8905",
                            r: "1.46081",
                            fill: "#001F82"
                        })
                    ]
                });
            }
        }
    ]);
    return RandD;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/service.jsx






var service = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(service, Component);
    var _super = _createSuper(service);
    function service() {
        _classCallCheck(this, service);
        return _super.apply(this, arguments);
    }
    _createClass(service, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.31732 2.57659C8.23752 2.37938 8.38267 2.16406 8.59542 2.16406H15.6754C15.8882 2.16406 16.0333 2.37938 15.9535 2.57659L14.4949 6.18122C14.449 6.29453 14.339 6.36869 14.2168 6.36869H10.0541C9.93182 6.36869 9.82181 6.29453 9.77596 6.18122L8.31732 2.57659Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9.80219 6.60925C9.82988 6.4686 9.95321 6.36719 10.0966 6.36721L14.1695 6.3675C14.3129 6.36751 14.4362 6.46892 14.4638 6.60956L16.933 19.1543C16.9547 19.2645 16.913 19.3777 16.8249 19.4474L12.3188 23.0146C12.2097 23.101 12.0555 23.101 11.9464 23.0146L7.44037 19.4474C7.35226 19.3777 7.31052 19.2645 7.33223 19.1542L9.80219 6.60925Z",
                            stroke: "#001F82",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return service;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/cez.jsx






var cez = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(cez, Component);
    var _super = _createSuper(cez);
    function cez() {
        _classCallCheck(this, cez);
        return _super.apply(this, arguments);
    }
    _createClass(cez, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "737",
                    height: "474",
                    viewBox: "0 0 737 474",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M506.783 181.916C510.925 183.258 513.206 187.718 511.849 191.861C510.507 196.004 506.046 198.284 501.904 196.927C497.761 195.585 495.48 191.125 496.837 186.982C498.18 182.84 502.64 180.573 506.783 181.916Z",
                            fill: "#FCA6DE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M451.639 266.125C454.209 269.647 453.415 274.584 449.893 277.153C446.371 279.723 441.434 278.929 438.865 275.407C436.296 271.885 437.09 266.948 440.612 264.379C444.134 261.81 449.085 262.589 451.639 266.125Z",
                            fill: "#FF7C7D"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M357.545 301.821C357.545 306.181 354.009 309.717 349.649 309.717C345.29 309.717 341.754 306.181 341.754 301.821C341.754 297.462 345.29 293.926 349.649 293.926C354.009 293.926 357.545 297.462 357.545 301.821Z",
                            fill: "#CF98D9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M260.417 275.407C257.847 278.929 252.911 279.722 249.389 277.153C245.867 274.584 245.073 269.647 247.642 266.125C250.212 262.603 255.148 261.809 258.67 264.379C262.207 266.934 262.986 271.87 260.417 275.407Z",
                            fill: "#00D7C4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M197.379 196.941C193.236 198.284 188.776 196.017 187.433 191.875C186.091 187.732 188.357 183.272 192.5 181.929C196.642 180.587 201.103 182.853 202.445 186.996C203.802 191.139 201.536 195.584 197.379 196.941Z",
                            fill: "#00B2FF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M241.147 263.294C222.686 247.142 207.79 226.631 198.09 203.969L202.074 202.266C211.514 224.321 226.02 244.298 243.991 260.032L241.147 263.294Z",
                            fill: "#E1E1E1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M334.836 303.364C310.399 301.141 286.308 293.303 265.133 280.673L267.356 276.949C287.968 289.247 311.438 296.883 335.226 299.034L334.836 303.364Z",
                            fill: "#E1E1E1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M364.452 303.32L364.062 299.005C387.966 296.839 411.436 289.218 431.962 276.992L434.184 280.716C413.096 293.274 388.991 301.097 364.452 303.32Z",
                            fill: "#E1E1E1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M458.117 263.264L455.273 260.002C473.331 244.197 487.852 224.248 497.263 202.279L501.247 203.983C491.576 226.543 476.665 247.04 458.117 263.264Z",
                            fill: "#E1E1E1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M214.83 137.371L210.5 137.313C210.846 109.325 219.55 82.3618 235.659 59.3535L239.21 61.8362C223.606 84.1372 215.177 110.263 214.83 137.371Z",
                            fill: "#77DDF5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M241.631 58.472L238.152 55.8883C254.882 33.4429 277.775 16.7568 304.334 7.60547L305.748 11.7048C280.012 20.5675 257.841 36.7339 241.631 58.472Z",
                            fill: "#A3E1D2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M309.679 10.4056L308.395 6.27739C335.112 -2.03678 363.447 -2.09452 390.324 6.11861L389.054 10.2613C363.028 2.29352 335.574 2.33682 309.679 10.4056Z",
                            fill: "#E2BEE8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M457.297 58.0379C440.914 36.2999 418.685 20.2056 392.992 11.5017L394.378 7.40234C420.894 16.3805 443.844 32.9944 460.747 55.4253L457.297 58.0379Z",
                            fill: "#FF9998"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M484.434 136.808C483.958 109.585 475.427 83.5019 459.766 61.3741L463.302 58.877C479.468 81.7265 488.273 108.646 488.764 136.736L484.434 136.808Z",
                            fill: "#FFBDE7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M504.337 206.237C502.576 206.237 500.83 205.962 499.141 205.414C490.336 202.556 485.486 193.058 488.359 184.239C490.61 177.296 497.034 172.619 504.337 172.619C506.098 172.619 507.845 172.893 509.534 173.442C518.339 176.3 523.189 185.798 520.316 194.617C518.064 201.56 511.641 206.237 504.337 206.237ZM504.337 176.949C498.925 176.949 494.161 180.414 492.472 185.567C490.351 192.105 493.945 199.149 500.483 201.286C501.739 201.69 503.038 201.906 504.337 201.906C509.75 201.906 514.528 198.442 516.202 193.289C518.324 186.75 514.73 179.692 508.191 177.57C506.936 177.152 505.637 176.949 504.337 176.949Z",
                            fill: "#FCA6DE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M445.257 287.56C439.887 287.56 434.806 284.976 431.645 280.632C429.004 276.994 427.935 272.563 428.643 268.132C429.35 263.7 431.732 259.803 435.369 257.161C438.256 255.054 441.677 253.957 445.228 253.957C450.597 253.957 455.678 256.541 458.839 260.886C461.481 264.523 462.549 268.954 461.842 273.386C461.134 277.817 458.753 281.714 455.115 284.356C452.243 286.449 448.822 287.56 445.257 287.56ZM445.242 258.287C442.601 258.287 440.075 259.11 437.924 260.669C435.225 262.632 433.464 265.519 432.93 268.81C432.41 272.101 433.204 275.392 435.153 278.091C437.491 281.31 441.273 283.23 445.257 283.23C447.898 283.23 450.424 282.407 452.575 280.848C455.274 278.885 457.035 275.998 457.569 272.707C458.089 269.416 457.295 266.125 455.332 263.426C453.008 260.207 449.226 258.287 445.242 258.287Z",
                            fill: "#FF7C7D"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.645 318.623C340.378 318.623 332.844 311.088 332.844 301.821C332.844 292.554 340.378 285.02 349.645 285.02C358.912 285.02 366.447 292.554 366.447 301.821C366.447 311.088 358.912 318.623 349.645 318.623ZM349.645 289.35C342.775 289.35 337.174 294.95 337.174 301.821C337.174 308.692 342.775 314.292 349.645 314.292C356.53 314.292 362.117 308.692 362.117 301.821C362.117 294.95 356.516 289.35 349.645 289.35Z",
                            fill: "#CF98D9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M254.017 287.56C250.451 287.56 247.045 286.449 244.158 284.356C240.521 281.714 238.139 277.817 237.432 273.386C236.724 268.954 237.793 264.509 240.434 260.886C243.581 256.555 248.676 253.957 254.046 253.957C257.611 253.957 261.017 255.068 263.904 257.161C267.542 259.803 269.923 263.686 270.631 268.132C271.338 272.563 270.27 277.009 267.628 280.632C264.467 284.976 259.386 287.56 254.017 287.56ZM254.046 258.287C250.062 258.287 246.28 260.207 243.942 263.426C241.979 266.125 241.199 269.416 241.719 272.707C242.238 275.998 244.014 278.885 246.713 280.848C248.864 282.407 251.39 283.23 254.031 283.23C258.015 283.23 261.797 281.31 264.135 278.091C266.098 275.392 266.878 272.101 266.358 268.81C265.838 265.519 264.063 262.632 261.364 260.669C259.213 259.11 256.687 258.287 254.046 258.287Z",
                            fill: "#00D7C4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M194.934 206.237C187.63 206.237 181.206 201.574 178.955 194.617C176.097 185.812 180.932 176.314 189.737 173.442C191.426 172.893 193.173 172.619 194.934 172.619C202.237 172.619 208.646 177.281 210.912 184.239C212.298 188.511 211.937 193.058 209.902 197.056C207.867 201.055 204.388 204.028 200.13 205.414C198.441 205.962 196.694 206.237 194.934 206.237ZM194.934 176.949C193.634 176.949 192.335 177.152 191.08 177.57C184.541 179.692 180.947 186.75 183.069 193.289C184.743 198.442 189.506 201.906 194.934 201.906C196.233 201.906 197.532 201.704 198.787 201.286C201.949 200.261 204.532 198.052 206.048 195.093C207.564 192.12 207.823 188.742 206.799 185.581C205.124 180.414 200.361 176.949 194.934 176.949Z",
                            fill: "#00B2FF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M571.252 265.835C598.562 274.712 627.893 259.758 636.77 232.449C645.647 205.139 630.693 175.808 603.383 166.931C579.133 159.05 553.296 169.962 541.59 191.643L523.215 195.554L535.787 209.527C532.511 233.935 547.003 257.954 571.252 265.835Z",
                            fill: "#FCA6DE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M454.484 371.899C471.357 395.124 503.878 400.277 527.103 383.403C550.327 366.529 555.481 334.009 538.607 310.784C523.61 290.157 496.3 283.792 474.1 294.459L456.937 286.809L458.901 305.501C441.882 323.327 439.486 351.272 454.484 371.899Z",
                            fill: "#FF7C7D"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M297.648 389.075C297.648 417.785 320.931 441.068 349.641 441.068C378.351 441.068 401.633 417.785 401.633 389.075C401.633 363.57 383.258 342.38 359.038 337.949L349.641 321.682L340.244 337.949C316.023 342.366 297.648 363.57 297.648 389.075Z",
                            fill: "#CF98D9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M244.806 371.899C227.933 395.124 195.412 400.277 172.187 383.403C148.962 366.529 143.809 334.009 160.683 310.784C175.68 290.157 202.99 283.792 225.19 294.459L242.352 286.809L240.389 305.501C257.393 323.327 259.789 351.272 244.806 371.899Z",
                            fill: "#00D7C4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M128.018 265.835C100.709 274.712 71.3782 259.758 62.5011 232.449C53.624 205.139 68.5779 175.808 95.8877 166.931C120.137 159.05 145.975 169.962 157.681 191.643L176.056 195.554L163.484 209.527C166.76 233.935 152.283 257.954 128.018 265.835Z",
                            fill: "#00B2FF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            style: "mix-blend-mode:multiply",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    opacity: "0.6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0141",
                                            d: "M648.669 277.064C632.112 293.88 599.722 288.698 576.295 265.516C552.839 242.335 547.253 209.93 563.795 193.128C580.337 176.312 612.77 181.465 636.197 204.661C659.624 227.843 665.21 260.248 648.669 277.064Z",
                                            fill: "#F0EFF0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0282",
                                            d: "M648.264 276.198C631.939 293.043 599.808 288.15 576.439 265.3C553.055 242.451 547.325 210.291 563.636 193.475C579.947 176.63 612.121 181.509 635.49 204.373C658.859 227.194 664.575 259.368 648.264 276.198Z",
                                            fill: "#EEEDED"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0423",
                                            d: "M647.872 275.332C631.793 292.191 599.893 287.601 576.61 265.083C553.299 242.566 547.438 210.652 563.518 193.807C579.584 176.933 611.512 181.523 634.809 204.055C658.092 226.558 663.952 258.472 647.872 275.332Z",
                                            fill: "#EBEAEB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0563",
                                            d: "M647.483 274.464C631.634 291.352 599.994 287.036 576.769 264.851C553.53 242.665 547.525 210.996 563.374 194.137C579.209 177.249 610.892 181.536 634.117 203.736C657.327 225.907 663.317 257.576 647.483 274.464Z",
                                            fill: "#E9E8E8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0704",
                                            d: "M647.093 273.599C631.476 290.516 600.095 286.489 576.943 264.635C553.761 242.781 547.641 211.358 563.245 194.47C578.834 177.553 610.272 181.565 633.424 203.433C656.562 225.273 662.683 256.696 647.093 273.599Z",
                                            fill: "#E6E5E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0845",
                                            d: "M646.693 272.732C631.32 289.663 600.171 285.925 577.091 264.403C553.981 242.882 547.731 211.718 563.089 194.801C578.447 177.855 609.626 181.579 632.706 203.115C655.801 224.637 662.051 255.801 646.693 272.732Z",
                                            fill: "#E4E3E3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0986",
                                            d: "M646.298 271.867C631.156 288.827 600.267 285.377 577.259 264.188C554.221 242.998 547.827 212.08 562.969 195.134C578.096 178.174 609.029 181.609 632.037 202.813C655.031 223.988 661.425 254.906 646.298 271.867Z",
                                            fill: "#E1E0E1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1127",
                                            d: "M645.908 271.001C631.012 287.99 600.354 284.829 577.418 263.957C554.453 243.085 547.928 212.427 562.825 195.466C577.706 178.477 608.394 181.624 631.33 202.496C654.266 223.353 660.79 254.026 645.908 271.001Z",
                                            fill: "#DFDEDE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1268",
                                            d: "M645.506 270.134C630.841 287.137 600.442 284.265 577.578 263.739C554.686 243.199 548.031 212.786 562.682 195.797C577.333 178.779 607.761 181.637 630.639 202.191C653.503 222.703 660.157 253.13 645.506 270.134Z",
                                            fill: "#DCDBDC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1408",
                                            d: "M645.115 269.268C630.681 286.301 600.542 283.717 577.736 263.509C554.915 243.301 548.116 213.133 562.536 196.13C576.956 179.097 607.138 181.667 629.93 201.875C652.736 222.068 659.535 252.25 645.115 269.268Z",
                                            fill: "#DAD9D9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1549",
                                            d: "M644.728 268.403C630.539 285.464 600.631 283.169 577.912 263.293C555.163 243.417 548.235 213.509 562.424 196.462C576.598 179.401 606.535 181.681 629.269 201.572C651.974 221.433 658.903 251.356 644.728 268.403Z",
                                            fill: "#D7D6D7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.169",
                                            d: "M644.321 267.537C630.363 284.613 600.715 282.606 578.053 263.062C555.377 243.518 548.304 213.856 562.262 196.794C576.205 179.704 605.897 181.71 628.544 201.255C651.206 220.784 658.264 250.461 644.321 267.537Z",
                                            fill: "#D5D4D4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1831",
                                            d: "M643.934 266.671C630.207 283.776 600.804 282.058 578.229 262.846C555.624 243.634 548.422 214.217 562.134 197.126C575.847 180.022 605.279 181.725 627.868 200.951C650.444 220.149 657.646 249.581 643.934 266.671Z",
                                            fill: "#D2D1D2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1972",
                                            d: "M643.539 265.806C630.058 282.939 600.9 281.496 578.383 262.63C555.851 243.75 548.518 214.578 561.986 197.474C575.453 180.34 604.639 181.755 627.156 200.649C649.674 219.515 657.007 248.687 643.539 265.806Z",
                                            fill: "#D0CFCF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2113",
                                            d: "M643.139 264.939C629.888 282.087 600.991 280.947 578.545 262.399C556.085 243.851 548.608 214.924 561.859 197.791C575.095 180.628 604.036 181.769 626.482 200.317C648.913 218.865 656.375 247.791 643.139 264.939Z",
                                            fill: "#CDCCCD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2254",
                                            d: "M642.748 264.071C629.743 281.248 601.077 280.396 578.703 262.18C556.316 243.964 548.709 215.283 561.714 198.135C574.705 180.958 603.4 181.796 625.774 200.026C648.147 218.228 655.754 246.909 642.748 264.071Z",
                                            fill: "#CBCACA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2394",
                                            d: "M642.357 263.207C629.583 280.413 601.176 279.836 578.875 261.951C556.56 244.067 548.823 215.646 561.583 198.455C574.343 181.249 602.778 181.812 625.094 199.696C647.381 217.58 655.117 246.016 642.357 263.207Z",
                                            fill: "#C8C7C8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2535",
                                            d: "M641.953 262.34C629.41 279.56 601.248 279.286 579.02 261.734C556.762 244.182 548.895 216.006 561.424 198.8C573.953 181.566 602.143 181.84 624.372 199.406C646.616 216.944 654.482 245.12 641.953 262.34Z",
                                            fill: "#C6C5C5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2676",
                                            d: "M641.563 261.475C629.264 278.724 601.349 278.724 579.192 261.503C557.006 244.283 549.01 216.353 561.293 199.133C573.577 181.884 601.522 181.855 623.693 199.089C645.849 216.31 653.846 244.24 641.563 261.475Z",
                                            fill: "#C3C2C3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2817",
                                            d: "M641.174 260.608C629.107 277.871 601.451 278.175 579.352 261.286C557.239 244.398 549.098 216.713 561.165 199.464C573.218 182.186 600.903 181.883 623.002 198.786C645.086 215.66 653.227 243.345 641.174 260.608Z",
                                            fill: "#C1C0C0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2958",
                                            d: "M640.772 259.742C628.951 277.034 601.525 277.626 579.513 261.055C557.472 244.499 549.201 217.06 561.023 199.796C572.844 182.489 600.284 181.898 622.296 198.468C644.323 215.024 652.594 242.45 640.772 259.742Z",
                                            fill: "#BEBDBE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3099",
                                            d: "M640.379 258.876C628.788 276.197 601.623 277.063 579.668 260.839C557.699 244.615 549.299 217.435 560.875 200.128C572.451 182.807 599.645 181.926 621.6 198.165C643.555 214.375 651.955 241.569 640.379 258.876Z",
                                            fill: "#BCBBBB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3239",
                                            d: "M639.988 258.009C628.628 275.345 601.708 276.514 579.84 260.622C557.943 244.73 549.398 217.795 560.744 200.474C572.089 183.124 599.038 181.955 620.906 197.861C642.788 213.739 651.333 240.674 639.988 258.009Z",
                                            fill: "#B9B8B9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.338",
                                            d: "M639.604 257.144C628.49 274.508 601.815 275.952 580.005 260.391C558.18 244.831 549.505 218.142 560.619 200.792C571.719 183.413 598.423 181.97 620.233 197.544C642.029 213.105 650.704 239.779 639.604 257.144Z",
                                            fill: "#B7B6B7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3521",
                                            d: "M639.201 256.277C628.318 273.67 601.903 275.402 580.165 260.174C558.413 244.946 549.608 218.502 560.477 201.138C571.346 183.745 597.789 181.998 619.528 197.241C641.266 212.454 650.071 238.898 639.201 256.277Z",
                                            fill: "#B4B3B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3662",
                                            d: "M638.805 255.413C628.166 272.821 601.983 274.856 580.317 259.945C558.636 245.034 549.687 218.851 560.325 201.457C570.963 184.035 597.161 182 618.827 196.91C640.493 211.821 649.443 238.005 638.805 255.413Z",
                                            fill: "#B2B1B2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3803",
                                            d: "M638.417 254.546C628.01 271.983 602.085 274.292 580.492 259.728C558.884 245.149 549.804 219.225 560.197 201.803C570.59 184.352 596.543 182.043 618.136 196.621C639.73 211.171 648.809 237.124 638.417 254.546Z",
                                            fill: "#AFAEAF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3944",
                                            d: "M638.015 253.679C627.839 271.144 602.161 273.743 580.639 259.496C559.103 245.249 549.879 219.571 560.056 202.12C570.217 184.654 595.91 182.041 617.446 196.288C638.968 210.535 648.177 236.228 638.015 253.679Z",
                                            fill: "#ADACAD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4085",
                                            d: "M637.621 252.814C627.69 270.294 602.257 273.181 580.807 259.281C559.344 245.366 549.99 219.933 559.921 202.467C569.852 184.973 595.299 182.086 616.749 196.001C638.198 209.901 647.552 235.334 637.621 252.814Z",
                                            fill: "#AAA9AA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4225",
                                            d: "M637.234 251.948C627.534 269.456 602.361 272.632 580.969 259.049C559.563 245.467 550.094 220.279 559.779 202.784C569.465 185.275 594.667 182.086 616.059 195.668C637.436 209.251 646.919 234.453 637.234 251.948Z",
                                            fill: "#A8A7A8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4366",
                                            d: "M636.832 251.082C627.363 268.619 602.435 272.084 581.129 258.833C559.796 245.582 550.182 220.64 559.637 203.131C569.091 185.593 594.034 182.114 615.353 195.38C636.673 208.616 646.286 233.558 636.832 251.082Z",
                                            fill: "#A5A4A5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4507",
                                            d: "M636.442 250.216C627.218 267.768 602.536 271.521 581.288 258.603C560.027 245.684 550.283 221.001 559.507 203.449C568.716 185.883 593.428 182.13 614.675 195.048C635.908 207.967 645.665 232.664 636.442 250.216Z",
                                            fill: "#A3A2A3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4648",
                                            d: "M636.05 249.349C627.058 266.93 602.621 270.972 581.46 258.385C560.27 245.798 550.397 221.361 559.375 203.794C568.354 186.213 592.805 182.157 613.98 194.759C635.141 207.331 645.029 231.783 636.05 249.349Z",
                                            fill: "#A09FA0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4789",
                                            d: "M635.647 248.483C626.9 266.093 602.708 270.408 581.605 258.168C560.488 245.913 550.47 221.721 559.218 204.126C567.965 186.516 592.157 182.186 613.274 194.441C634.377 206.695 644.394 230.887 635.647 248.483Z",
                                            fill: "#9E9D9E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.493",
                                            d: "M635.262 247.618C626.746 265.242 602.813 269.861 581.783 257.939C560.737 246.016 550.59 222.069 559.092 204.46C567.594 186.821 591.555 182.202 612.585 194.139C633.616 206.047 643.764 229.994 635.262 247.618Z",
                                            fill: "#9B9A9B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.507",
                                            d: "M634.866 246.751C626.58 264.404 602.894 269.312 581.935 257.721C560.962 246.13 550.67 222.429 558.956 204.79C567.227 187.137 590.928 182.215 611.886 193.82C632.845 205.411 643.137 229.112 634.866 246.751Z",
                                            fill: "#999899"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5211",
                                            d: "M634.467 245.9C626.427 263.582 602.985 268.764 582.099 257.505C561.198 246.246 550.777 222.79 558.816 205.137C566.856 187.455 590.312 182.259 611.199 193.518C632.085 204.762 642.507 228.218 634.467 245.9Z",
                                            fill: "#969596"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5352",
                                            d: "M634.073 245.033C626.265 262.73 603.069 268.215 582.254 257.288C561.426 246.361 550.874 223.165 558.669 205.469C566.463 187.758 589.674 182.273 610.488 193.214C631.317 204.126 641.868 227.322 634.073 245.033Z",
                                            fill: "#949394"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5493",
                                            d: "M633.683 244.168C626.119 261.894 603.169 267.653 582.426 257.058C561.67 246.463 550.974 223.513 558.538 205.802C566.101 188.076 589.052 182.303 609.808 192.897C630.55 203.492 641.246 226.443 633.683 244.168Z",
                                            fill: "#919091"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5634",
                                            d: "M633.281 243.303C625.948 261.043 603.258 267.105 582.573 256.842C561.889 246.579 551.063 223.874 558.396 206.135C565.714 188.38 588.434 182.318 609.104 192.595C629.788 202.843 640.614 225.549 633.281 243.303Z",
                                            fill: "#8F8E8F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5775",
                                            d: "M632.887 242.435C625.785 260.204 603.34 266.555 582.742 256.61C562.13 246.679 551.174 224.219 558.262 206.465C565.349 188.682 587.809 182.345 608.421 192.276C629.019 202.207 639.974 224.652 632.887 242.435Z",
                                            fill: "#8C8B8C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5915",
                                            d: "M632.498 241.569C625.642 259.367 603.442 265.992 582.902 256.393C562.348 246.794 551.262 224.58 558.118 206.797C564.975 188.999 587.175 182.36 607.715 191.973C628.255 201.572 639.355 223.772 632.498 241.569Z",
                                            fill: "#8A898A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6056",
                                            d: "M632.096 240.703C625.47 258.515 603.516 265.443 583.062 256.162C562.58 246.895 551.365 224.941 557.975 207.129C564.586 189.302 586.555 182.374 607.023 191.655C627.491 200.922 638.721 222.877 632.096 240.703Z",
                                            fill: "#878687"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6197",
                                            d: "M631.701 239.838C625.321 257.678 603.612 264.881 583.216 255.946C562.806 246.997 551.446 225.302 557.84 207.461C564.22 189.606 585.93 182.403 606.325 191.353C626.721 200.288 638.081 221.997 631.701 239.838Z",
                                            fill: "#858485"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6338",
                                            d: "M631.313 238.971C625.164 256.841 603.714 264.332 583.391 255.73C563.053 247.112 551.563 225.663 557.712 207.808C563.861 189.938 585.311 182.432 605.649 191.049C625.958 199.638 637.462 221.102 631.313 238.971Z",
                                            fill: "#828182"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6479",
                                            d: "M630.927 238.106C625.009 255.99 603.805 263.785 583.554 255.5C563.288 247.214 551.669 226.01 557.572 208.126C563.476 190.228 584.694 182.447 604.946 190.733C625.197 199.004 636.831 220.208 630.927 238.106Z",
                                            fill: "#807F80"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.662",
                                            d: "M630.521 237.238C624.848 255.151 603.89 263.22 583.71 255.281C563.517 247.328 551.753 226.369 557.426 208.471C563.098 190.543 584.057 182.475 604.25 190.428C624.43 198.367 636.194 219.325 630.521 237.238Z",
                                            fill: "#7D7C7D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6761",
                                            d: "M630.131 236.373C624.689 254.315 603.99 262.673 583.869 255.051C563.747 247.43 551.854 226.731 557.295 208.789C562.737 190.848 583.45 182.476 603.557 190.097C623.664 197.718 635.558 218.432 630.131 236.373Z",
                                            fill: "#7B7A7B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6901",
                                            d: "M629.742 235.508C624.532 253.464 604.078 262.11 584.043 254.835C563.994 247.546 551.97 227.093 557.167 209.136C562.363 191.166 582.831 182.519 602.866 189.809C622.901 197.084 634.939 217.537 629.742 235.508Z",
                                            fill: "#787779"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7042",
                                            d: "M629.334 234.64C624.369 252.625 604.161 261.56 584.184 254.602C564.207 247.645 552.039 227.437 557.004 209.452C561.969 191.452 582.177 182.517 602.155 189.475C622.132 196.432 634.3 216.655 629.334 234.64Z",
                                            fill: "#767576"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7183",
                                            d: "M628.95 233.775C624.216 251.789 604.253 261.013 584.363 254.387C564.458 247.762 552.16 227.799 556.88 209.8C561.6 191.786 581.577 182.562 601.467 189.188C621.372 195.799 633.67 215.761 628.95 233.775Z",
                                            fill: "#737274"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7324",
                                            d: "M628.56 232.91C624.071 250.938 604.354 260.451 584.521 254.157C564.688 247.864 552.246 228.147 556.75 210.133C561.239 192.09 580.956 182.577 600.789 188.871C620.607 195.164 633.049 214.867 628.56 232.91Z",
                                            fill: "#717071"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7465",
                                            d: "M628.153 232.043C623.895 250.1 604.437 259.901 584.677 253.94C564.916 247.979 552.344 228.507 556.602 210.464C560.86 192.392 580.318 182.591 600.078 188.567C619.839 194.514 632.411 213.986 628.153 232.043Z",
                                            fill: "#6E6D6F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7606",
                                            d: "M627.761 231.177C623.733 249.263 604.521 259.338 584.833 253.709C565.145 248.079 552.442 228.867 556.455 210.795C560.468 192.709 579.694 182.62 599.383 188.249C619.071 193.878 631.773 213.09 627.761 231.177Z",
                                            fill: "#6C6B6C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7746",
                                            d: "M627.373 230.311C623.591 248.412 604.624 258.79 585.008 253.493C565.377 248.196 552.545 229.229 556.327 211.128C560.109 193.013 579.075 182.635 598.692 187.947C618.308 193.23 631.154 212.196 627.373 230.311Z",
                                            fill: "#69686A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7887",
                                            d: "M626.969 229.445C623.418 247.575 604.697 258.242 585.153 253.276C565.594 248.311 552.632 229.59 556.183 211.475C559.734 193.345 578.441 182.678 598 187.644C617.544 192.595 630.52 211.316 626.969 229.445Z",
                                            fill: "#676667"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8028",
                                            d: "M626.583 228.578C623.278 246.736 604.802 257.678 585.33 253.044C565.844 248.411 552.752 229.935 556.057 211.791C559.363 193.632 577.839 182.677 597.311 187.31C616.783 191.958 629.889 210.42 626.583 228.578Z",
                                            fill: "#646365"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8169",
                                            d: "M626.193 227.712C623.118 245.885 604.902 257.129 585.488 252.828C566.074 248.526 552.838 230.296 555.912 212.138C558.987 193.95 577.203 182.706 596.617 187.022C616.017 191.309 629.267 209.525 626.193 227.712Z",
                                            fill: "#626162"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.831",
                                            d: "M625.785 226.846C622.942 245.048 604.971 256.567 585.644 252.597C566.302 248.628 552.935 230.657 555.764 212.455C558.594 194.254 576.579 182.721 595.906 186.69C615.248 190.674 628.629 208.645 625.785 226.846Z",
                                            fill: "#5F5E60"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8451",
                                            d: "M625.397 225.979C622.799 244.195 605.073 256.017 585.803 252.38C566.534 248.742 553.023 231.017 555.636 212.801C558.234 194.57 575.959 182.749 595.229 186.4C614.484 190.023 627.995 207.749 625.397 225.979Z",
                                            fill: "#5D5C5D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8592",
                                            d: "M625.006 225.114C622.639 243.359 605.159 255.47 585.976 252.15C566.778 248.844 553.138 231.364 555.505 213.119C557.872 194.86 575.338 182.764 594.536 186.069C613.719 189.389 627.374 206.869 625.006 225.114Z",
                                            fill: "#5A595B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8732",
                                            d: "M624.604 224.248C622.468 242.522 605.248 254.906 586.123 251.933C566.997 248.945 553.227 231.725 555.349 213.465C557.47 195.191 574.705 182.792 593.83 185.78C612.956 188.754 626.741 205.974 624.604 224.248Z",
                                            fill: "#585758"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8873",
                                            d: "M624.211 223.381C622.32 241.669 605.345 254.357 586.292 251.701C567.239 249.045 553.324 232.071 555.215 213.782C557.106 195.48 574.081 182.806 593.134 185.448C612.187 188.104 626.102 205.078 624.211 223.381Z",
                                            fill: "#555456"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9014",
                                            d: "M623.826 222.516C622.167 240.833 605.437 253.795 586.456 251.486C567.475 249.162 553.43 232.447 555.09 214.13C556.75 195.798 573.465 182.836 592.446 185.16C611.427 187.47 625.472 204.199 623.826 222.516Z",
                                            fill: "#535253"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9155",
                                            d: "M623.433 221.651C622.019 239.997 605.535 253.248 586.626 251.256C567.717 249.264 553.542 232.794 554.957 214.448C556.371 196.102 572.855 182.837 591.764 184.829C610.659 186.835 624.848 203.305 623.433 221.651Z",
                                            fill: "#504F51"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9296",
                                            d: "M623.03 220.783C621.846 239.143 605.608 252.697 586.771 251.037C567.934 249.377 553.615 233.153 554.799 214.792C555.982 196.418 572.207 182.878 591.043 184.538C609.895 186.184 624.214 202.408 623.03 220.783Z",
                                            fill: "#4E4D4E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9437",
                                            d: "M622.643 219.917C621.691 238.306 605.712 252.134 586.947 250.821C568.168 249.493 553.734 233.514 554.672 215.125C555.61 196.721 571.589 182.893 590.368 184.221C609.133 185.549 623.582 201.528 622.643 219.917Z",
                                            fill: "#4B4A4C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9577",
                                            d: "M622.253 219.051C621.545 237.469 605.812 251.586 587.105 250.59C568.398 249.594 553.82 233.861 554.541 215.457C555.249 197.039 570.982 182.922 589.674 183.904C608.367 184.9 622.96 200.633 622.253 219.051Z",
                                            fill: "#494849"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9718",
                                            d: "M621.85 218.185C621.373 236.617 605.885 251.037 587.265 250.373C568.63 249.709 553.922 234.236 554.398 215.789C554.874 197.342 570.348 182.936 588.983 183.6C607.603 184.264 622.326 199.738 621.85 218.185Z",
                                            fill: "#464547"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9859",
                                            d: "M621.459 217.319C621.228 235.78 605.985 250.475 587.423 250.143C568.86 249.811 554.022 234.582 554.253 216.121C554.484 197.645 569.726 182.951 588.274 183.283C606.837 183.629 621.69 198.858 621.459 217.319Z",
                                            fill: "#444344"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M621.067 216.454C621.067 234.944 606.07 249.927 587.594 249.927C569.104 249.927 554.121 234.944 554.121 216.454C554.121 197.963 569.104 182.98 587.594 182.98C606.07 182.98 621.067 197.963 621.067 216.454Z",
                                            fill: "#414042"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    opacity: "0.6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0141",
                                            d: "M558.051 401.734C541.495 418.55 509.105 413.368 485.678 390.187C462.222 367.005 456.636 334.6 473.178 317.798C489.719 300.968 522.153 306.136 545.58 329.331C569.007 352.513 574.593 384.932 558.051 401.734Z",
                                            fill: "#F0EFEF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0282",
                                            d: "M557.647 400.868C541.322 417.713 509.191 412.82 485.822 389.97C462.438 367.121 456.708 334.961 473.019 318.145C489.329 301.3 521.504 306.179 544.873 329.043C568.242 351.878 573.958 384.038 557.647 400.868Z",
                                            fill: "#EDECEC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0423",
                                            d: "M557.255 400.002C541.175 416.861 509.276 412.271 485.993 389.753C462.682 367.236 456.821 335.321 472.901 318.477C488.966 301.603 520.895 306.193 544.192 328.725C567.475 351.243 573.321 383.157 557.255 400.002Z",
                                            fill: "#EAE9E9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0563",
                                            d: "M556.866 399.136C541.017 416.024 509.377 411.708 486.152 389.523C462.913 367.337 456.908 335.668 472.757 318.809C488.591 301.921 520.275 306.208 543.499 328.408C566.71 350.593 572.7 382.262 556.866 399.136Z",
                                            fill: "#E7E6E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0704",
                                            d: "M556.461 398.271C540.843 415.188 509.463 411.16 486.31 389.307C463.128 367.453 457.008 336.03 472.612 319.142C488.201 302.225 519.639 306.237 542.791 328.105C565.944 349.959 572.064 381.382 556.461 398.271Z",
                                            fill: "#E4E3E3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0845",
                                            d: "M556.076 397.418C540.703 414.349 509.554 410.611 486.473 389.089C463.364 367.567 457.114 336.404 472.472 319.487C487.83 302.541 519.008 306.265 542.089 327.801C565.184 349.308 571.434 380.486 556.076 397.418Z",
                                            fill: "#E1E0E0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0986",
                                            d: "M555.681 396.552C540.539 413.513 509.65 410.063 486.641 388.873C463.604 367.684 457.21 336.765 472.351 319.819C487.479 302.859 518.411 306.295 541.42 327.499C564.414 348.674 570.808 379.592 555.681 396.552Z",
                                            fill: "#DEDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1127",
                                            d: "M555.28 395.687C540.383 412.676 509.725 409.515 486.789 388.643C463.824 367.771 457.299 337.112 472.196 320.152C487.077 303.163 517.765 306.309 540.701 327.181C563.651 348.039 570.176 378.712 555.28 395.687Z",
                                            fill: "#DCDADA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1268",
                                            d: "M554.889 394.819C540.224 411.823 509.825 408.95 486.961 388.425C464.068 367.885 457.414 337.472 472.065 320.483C486.716 303.464 517.143 306.322 540.022 326.877C562.886 347.388 569.54 377.816 554.889 394.819Z",
                                            fill: "#D9D7D7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1408",
                                            d: "M554.498 393.954C540.063 410.986 509.925 408.403 487.118 388.195C464.298 367.987 457.499 337.819 471.919 320.815C486.339 303.783 516.521 306.352 539.313 326.56C562.119 346.754 568.918 376.921 554.498 393.954Z",
                                            fill: "#D6D4D4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1549",
                                            d: "M554.111 393.088C539.922 410.149 510.014 407.854 487.294 387.978C464.546 368.102 457.617 338.194 471.806 321.147C485.981 304.086 515.918 306.367 538.652 326.257C561.357 346.104 568.285 376.041 554.111 393.088Z",
                                            fill: "#D3D1D1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.169",
                                            d: "M553.704 392.222C539.746 409.298 510.098 407.292 487.436 387.748C464.759 368.204 457.687 338.541 471.645 321.48C485.588 304.39 515.279 306.396 537.927 325.94C560.589 345.47 567.647 375.147 553.704 392.222Z",
                                            fill: "#D0CECF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1831",
                                            d: "M553.316 391.356C539.589 408.461 510.187 406.743 487.611 387.531C465.007 368.319 457.805 338.902 471.517 321.812C485.23 304.707 514.661 306.411 537.251 325.637C559.826 344.835 567.029 374.252 553.316 391.356Z",
                                            fill: "#CDCBCC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1972",
                                            d: "M552.922 390.489C539.441 407.623 510.283 406.179 487.766 387.314C465.234 368.434 457.901 339.262 471.368 322.157C484.836 305.024 514.022 306.438 536.539 325.333C559.057 344.184 566.389 373.37 552.922 390.489Z",
                                            fill: "#CAC8C9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2113",
                                            d: "M552.522 389.625C539.271 406.773 510.373 405.632 487.928 387.084C465.468 368.536 457.991 339.61 471.242 322.476C484.478 305.314 513.419 306.454 535.864 325.002C558.295 343.55 565.758 372.477 552.522 389.625Z",
                                            fill: "#C7C5C6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2254",
                                            d: "M552.131 388.757C539.126 405.934 510.459 405.082 488.086 386.866C465.699 368.65 458.092 339.969 471.097 322.821C484.088 305.644 512.783 306.481 535.156 324.712C557.53 342.899 565.122 371.58 552.131 388.757Z",
                                            fill: "#C4C2C3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2394",
                                            d: "M551.74 387.892C538.966 405.098 510.559 404.52 488.258 386.636C465.943 368.752 458.206 340.331 470.966 323.154C483.726 305.948 512.161 306.511 534.477 324.395C556.763 342.265 564.5 370.701 551.74 387.892Z",
                                            fill: "#C1BFC0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2535",
                                            d: "M551.336 387.026C538.793 404.246 510.631 403.972 488.402 386.419C466.145 368.867 458.278 340.691 470.807 323.486C483.336 306.251 511.526 306.525 533.755 324.092C555.998 341.63 563.865 369.805 551.336 387.026Z",
                                            fill: "#BEBDBD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2676",
                                            d: "M550.945 386.161C538.647 403.41 510.731 403.41 488.574 386.189C466.388 368.969 458.392 341.039 470.69 323.819C482.973 306.57 510.918 306.555 533.089 323.775C555.232 340.981 563.228 368.912 550.945 386.161Z",
                                            fill: "#BBBABA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2817",
                                            d: "M550.557 385.294C538.49 402.557 510.834 402.86 488.735 385.972C466.622 369.084 458.481 341.399 470.548 324.15C482.6 306.872 510.285 306.569 532.384 323.471C554.469 340.345 562.61 368.03 550.557 385.294Z",
                                            fill: "#B8B7B7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2958",
                                            d: "M550.155 384.427C538.333 401.72 510.908 402.312 488.896 385.741C466.855 369.185 458.584 341.745 470.405 324.482C482.227 307.175 509.667 306.583 531.679 323.154C553.706 339.71 561.977 367.135 550.155 384.427Z",
                                            fill: "#B5B4B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3099",
                                            d: "M549.766 383.561C538.175 400.883 511.01 401.749 489.055 385.524C467.086 369.3 458.685 342.12 470.262 324.814C481.838 307.492 509.032 306.612 530.987 322.851C552.941 339.06 561.342 366.255 549.766 383.561Z",
                                            fill: "#B3B1B1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3239",
                                            d: "M549.371 382.696C538.011 400.031 511.091 401.2 489.223 385.294C467.326 369.402 458.781 342.467 470.126 325.146C481.472 307.796 508.421 306.627 530.289 322.533C552.171 338.426 560.716 365.36 549.371 382.696Z",
                                            fill: "#B0AEAE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.338",
                                            d: "M548.969 381.829C537.855 399.194 511.18 400.637 489.37 385.077C467.545 369.517 458.87 342.828 469.985 325.478C481.085 308.099 507.788 306.655 529.598 322.23C551.409 337.776 560.084 364.465 548.969 381.829Z",
                                            fill: "#ADABAB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3521",
                                            d: "M548.584 380.963C537.701 398.356 511.286 400.088 489.548 384.86C467.795 369.632 458.99 343.188 469.86 325.823C480.729 308.43 507.172 306.684 528.91 321.926C550.648 337.14 559.453 363.584 548.584 380.963Z",
                                            fill: "#AAA8A8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3662",
                                            d: "M548.187 380.098C537.549 397.506 511.365 399.541 489.699 384.631C468.019 369.72 459.07 343.536 469.708 326.143C480.346 308.721 506.544 306.685 528.21 321.596C549.876 336.507 558.825 362.69 548.187 380.098Z",
                                            fill: "#A7A5A5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3803",
                                            d: "M547.784 379.232C537.377 396.668 511.453 398.978 489.859 384.414C468.251 369.835 459.172 343.911 469.564 326.489C479.957 309.038 505.91 306.728 527.504 321.307C549.112 335.857 558.191 361.795 547.784 379.232Z",
                                            fill: "#A4A2A2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3944",
                                            d: "M547.398 378.365C537.222 395.83 511.543 398.428 490.022 384.182C468.486 369.935 459.262 344.256 469.438 326.805C479.6 309.34 505.293 306.727 526.829 320.974C548.351 335.22 557.56 360.913 547.398 378.365Z",
                                            fill: "#A19F9F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4085",
                                            d: "M547.004 377.5C537.073 394.98 511.64 397.867 490.19 383.966C468.726 370.052 459.373 344.618 469.304 327.153C479.235 309.658 504.682 306.772 526.132 320.686C547.581 334.572 556.92 360.02 547.004 377.5Z",
                                            fill: "#9E9C9C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4225",
                                            d: "M546.617 376.633C536.917 394.142 511.743 397.318 490.352 383.735C468.946 370.152 459.477 344.964 469.162 327.47C478.848 309.961 504.05 306.771 525.442 320.354C546.819 333.936 556.302 359.124 546.617 376.633Z",
                                            fill: "#9B9999"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4366",
                                            d: "M546.214 375.767C536.745 393.305 511.817 396.769 490.512 383.518C469.178 370.268 459.565 345.325 469.02 327.816C478.474 310.279 503.417 306.8 524.736 320.065C546.056 333.301 555.669 358.244 546.214 375.767Z",
                                            fill: "#989696"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4507",
                                            d: "M545.825 374.9C536.601 392.452 511.918 396.205 490.671 383.286C469.409 370.367 459.666 345.685 468.89 328.133C478.099 310.566 502.81 306.813 524.058 319.732C545.291 332.651 555.034 357.348 545.825 374.9Z",
                                            fill: "#959393"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4648",
                                            d: "M545.433 374.035C536.441 391.616 512.003 395.657 490.843 383.071C469.653 370.484 459.78 346.047 468.758 328.48C477.736 310.899 502.188 306.843 523.363 319.444C544.524 332.016 554.411 356.454 545.433 374.035Z",
                                            fill: "#929090"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4789",
                                            d: "M545.03 373.168C536.283 390.778 512.091 395.094 490.988 382.854C469.871 370.599 459.853 346.407 468.6 328.812C477.348 311.202 501.554 306.871 522.657 319.126C543.76 331.366 553.777 355.573 545.03 373.168Z",
                                            fill: "#8F8D8D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.493",
                                            d: "M544.645 372.302C536.128 389.926 512.196 394.545 491.165 382.622C470.12 370.7 459.973 346.753 468.475 329.143C476.976 311.504 500.937 306.885 521.968 318.823C542.999 330.731 553.146 354.677 544.645 372.302Z",
                                            fill: "#8C8A8A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.507",
                                            d: "M544.249 371.436C535.963 389.089 512.277 393.997 491.318 382.406C470.345 370.816 460.053 347.114 468.339 329.476C476.609 311.823 500.311 306.9 521.269 318.506C542.228 330.096 552.519 353.783 544.249 371.436Z",
                                            fill: "#8A8788"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5211",
                                            d: "M543.85 370.572C535.81 388.254 512.368 393.435 491.482 382.177C470.581 370.918 460.159 347.462 468.199 329.809C476.239 312.127 499.695 306.931 520.581 318.189C541.468 329.448 551.889 352.904 543.85 370.572Z",
                                            fill: "#878485"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5352",
                                            d: "M543.456 369.705C535.647 387.401 512.451 392.886 491.637 381.96C470.808 371.033 460.257 347.837 468.051 330.14C475.846 312.43 499.056 306.945 519.871 317.886C540.699 328.812 551.251 352.008 543.456 369.705Z",
                                            fill: "#848182"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5493",
                                            d: "M543.065 368.838C535.502 386.563 512.551 392.323 491.809 381.728C471.053 371.133 460.357 348.183 467.92 330.472C475.484 312.746 498.435 306.973 519.191 317.567C539.933 328.162 550.629 351.127 543.065 368.838Z",
                                            fill: "#817E7F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5634",
                                            d: "M542.664 367.973C535.331 385.713 512.641 391.775 491.956 381.512C471.272 371.249 460.446 348.544 467.779 330.804C475.097 313.05 497.817 306.988 518.486 317.265C539.171 327.528 549.997 350.233 542.664 367.973Z",
                                            fill: "#7E7B7C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5775",
                                            d: "M542.27 367.105C535.168 384.874 512.723 391.225 492.125 381.28C471.513 371.349 460.557 348.889 467.645 331.135C474.732 313.352 497.192 307.015 517.804 316.946C538.402 326.891 549.357 349.337 542.27 367.105Z",
                                            fill: "#7B7879"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5915",
                                            d: "M541.884 366.241C535.027 384.039 512.827 390.664 492.287 381.065C471.747 371.466 460.647 349.252 467.504 331.469C474.36 313.671 496.56 307.031 517.1 316.645C537.64 326.244 548.74 348.458 541.884 366.241Z",
                                            fill: "#787576"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6056",
                                            d: "M541.479 365.373C534.853 383.185 512.899 390.113 492.445 380.832C471.963 371.565 460.747 349.611 467.358 331.799C473.969 313.972 495.938 307.044 516.406 316.325C536.874 325.606 548.104 347.561 541.479 365.373Z",
                                            fill: "#757273"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6197",
                                            d: "M541.084 364.508C534.704 382.348 512.994 389.551 492.599 380.616C472.189 371.667 460.829 349.972 467.223 332.131C473.603 314.276 495.312 307.073 515.708 316.023C536.104 324.958 547.464 346.667 541.084 364.508Z",
                                            fill: "#726F70"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6338",
                                            d: "M540.696 363.641C534.547 381.511 513.097 389.002 492.774 380.4C472.436 371.782 460.946 350.333 467.095 332.478C473.244 314.608 494.693 307.102 515.031 315.719C535.341 324.322 546.83 345.786 540.696 363.641Z",
                                            fill: "#6F6C6D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6479",
                                            d: "M540.299 362.776C534.381 380.66 513.176 388.454 492.925 380.169C472.659 371.884 461.04 350.68 466.943 332.796C472.847 314.897 494.065 307.117 514.317 315.388C534.583 323.688 546.217 344.892 540.299 362.776Z",
                                            fill: "#6C696A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.662",
                                            d: "M539.904 361.91C534.231 379.823 513.272 387.892 493.093 379.953C472.9 372 461.136 351.041 466.808 333.143C472.481 315.215 493.44 307.147 513.633 315.1C533.812 323.039 545.576 343.997 539.904 361.91Z",
                                            fill: "#696667"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6761",
                                            d: "M539.514 361.059C534.072 379.001 513.373 387.358 493.252 379.737C473.13 372.116 461.236 351.417 466.678 333.475C472.12 315.533 492.833 307.161 512.94 314.783C533.047 322.404 544.941 343.117 539.514 361.059Z",
                                            fill: "#666364"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6901",
                                            d: "M539.11 360.193C533.899 378.15 513.445 386.796 493.411 379.521C473.361 372.232 461.338 351.778 466.534 333.822C471.73 315.851 492.198 307.205 512.233 314.494C532.282 321.769 544.32 342.223 539.11 360.193Z",
                                            fill: "#636061"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7042",
                                            d: "M538.717 359.325C533.752 377.311 513.544 386.245 493.567 379.288C473.59 372.331 461.421 352.123 466.387 334.137C471.352 316.138 491.56 307.203 511.537 314.16C531.514 321.118 543.683 341.326 538.717 359.325Z",
                                            fill: "#615D5E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7183",
                                            d: "M538.333 358.461C533.599 376.475 513.636 385.698 493.745 379.073C473.84 372.448 461.542 352.485 466.262 334.485C470.982 316.471 490.96 307.248 510.85 313.873C530.755 320.484 543.053 340.447 538.333 358.461Z",
                                            fill: "#5E5A5B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7324",
                                            d: "M537.943 357.594C533.454 375.623 513.737 385.135 493.904 378.842C474.071 372.548 461.629 352.831 466.132 334.803C470.621 316.76 490.339 307.247 510.171 313.541C529.99 319.834 542.432 339.551 537.943 357.594Z",
                                            fill: "#5B5758"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7465",
                                            d: "M537.536 356.729C533.278 374.786 513.82 384.587 494.06 378.625C474.299 372.664 461.727 353.192 465.985 335.149C470.243 317.077 489.701 307.277 509.461 313.252C529.222 319.199 541.794 338.657 537.536 356.729Z",
                                            fill: "#585455"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7606",
                                            d: "M537.143 355.862C533.116 373.948 513.904 384.024 494.216 378.394C474.527 372.765 461.825 353.553 465.838 335.481C469.851 317.395 489.077 307.305 508.766 312.935C528.454 318.564 541.156 337.776 537.143 355.862Z",
                                            fill: "#555252"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7746",
                                            d: "M536.753 354.997C532.972 373.098 514.005 383.476 494.389 378.178C474.758 372.881 461.926 353.914 465.708 335.814C469.49 317.699 488.456 307.32 508.072 312.632C527.689 317.915 540.535 336.882 536.753 354.997Z",
                                            fill: "#524F4F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7887",
                                            d: "M536.352 354.131C532.801 372.26 514.08 382.927 494.536 377.962C474.977 372.997 462.015 354.275 465.566 336.16C469.117 318.031 487.824 307.364 507.382 312.329C526.926 317.28 539.903 336.001 536.352 354.131Z",
                                            fill: "#4F4C4C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8028",
                                            d: "M535.966 353.263C532.661 371.422 514.185 382.363 494.713 377.73C475.227 373.096 462.135 354.62 465.44 336.476C468.746 318.318 487.222 307.362 506.693 311.996C526.165 316.629 539.272 335.105 535.966 353.263Z",
                                            fill: "#4C4949"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8169",
                                            d: "M535.576 352.398C532.501 370.571 514.285 381.815 494.871 377.513C475.457 373.212 462.221 354.981 465.295 336.823C468.37 318.636 486.586 307.392 506 311.707C525.4 315.994 538.636 334.21 535.576 352.398Z",
                                            fill: "#494646"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.831",
                                            d: "M535.168 351.532C532.325 369.734 514.354 381.252 495.026 377.283C475.684 373.313 462.318 355.343 465.147 337.141C467.976 318.939 485.962 307.406 505.289 311.376C524.631 315.36 538.012 333.33 535.168 351.532Z",
                                            fill: "#464343"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8451",
                                            d: "M534.78 350.665C532.181 368.881 514.456 380.703 495.186 377.065C475.916 373.428 462.406 355.702 465.019 337.486C467.617 319.256 485.342 307.434 504.612 311.086C523.867 314.709 537.378 332.434 534.78 350.665Z",
                                            fill: "#434041"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8592",
                                            d: "M534.389 349.8C532.022 368.045 514.542 380.155 495.359 376.835C476.161 373.53 462.521 356.05 464.888 337.805C467.255 319.545 484.721 307.45 503.918 310.755C523.102 314.075 536.742 331.54 534.389 349.8Z",
                                            fill: "#403D3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8732",
                                            d: "M533.987 348.933C531.851 367.207 514.631 379.592 495.505 376.618C476.38 373.63 462.609 356.41 464.731 338.151C466.853 319.877 484.088 307.478 503.213 310.466C522.339 313.425 536.124 330.659 533.987 348.933Z",
                                            fill: "#3D3A3B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8873",
                                            d: "M533.594 348.067C531.703 366.355 514.728 379.043 495.675 376.387C476.622 373.731 462.707 356.756 464.598 338.468C466.489 320.165 483.463 307.492 502.517 310.133C521.57 312.789 535.485 329.764 533.594 348.067Z",
                                            fill: "#3A3738"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9014",
                                            d: "M533.209 347.202C531.549 365.519 514.82 378.495 495.839 376.171C476.858 373.847 462.813 357.133 464.473 338.815C466.133 320.484 482.848 307.522 501.829 309.846C520.81 312.155 534.855 328.87 533.209 347.202Z",
                                            fill: "#383435"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9155",
                                            d: "M532.804 346.336C531.39 364.682 514.906 377.933 495.997 375.941C477.088 373.949 462.913 357.48 464.328 339.134C465.742 320.788 482.226 307.522 501.135 309.514C520.044 311.506 534.233 327.99 532.804 346.336Z",
                                            fill: "#353132"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9296",
                                            d: "M532.413 345.468C531.229 363.829 514.991 377.382 496.154 375.723C477.317 374.063 462.998 357.838 464.182 339.478C465.365 321.103 481.589 307.564 500.426 309.224C519.278 310.869 533.596 327.093 532.413 345.468Z",
                                            fill: "#322E2F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9437",
                                            d: "M532.026 344.603C531.074 362.992 515.095 376.82 496.33 375.506C477.551 374.179 463.117 358.2 464.055 339.81C464.993 321.407 480.972 307.579 499.751 308.907C518.516 310.22 532.964 326.199 532.026 344.603Z",
                                            fill: "#2F2B2C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9577",
                                            d: "M531.62 343.737C530.913 362.155 515.179 376.272 496.472 375.276C477.765 374.28 463.187 358.546 463.908 340.143C464.616 321.724 480.349 307.608 499.042 308.589C517.749 309.585 532.342 325.319 531.62 343.737Z",
                                            fill: "#2C2829"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9718",
                                            d: "M531.232 342.87C530.756 361.303 515.268 375.723 496.648 375.059C478.013 374.395 463.304 358.921 463.781 340.474C464.257 322.027 479.731 307.622 498.365 308.286C516.986 308.95 531.709 324.423 531.232 342.87Z",
                                            fill: "#292526"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9859",
                                            d: "M530.842 342.005C530.611 360.466 515.368 375.16 496.806 374.828C478.243 374.496 463.405 359.268 463.635 340.806C463.866 322.331 479.109 307.636 497.657 307.968C516.22 308.3 531.073 323.529 530.842 342.005Z",
                                            fill: "#262223"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M530.45 341.139C530.45 359.63 515.453 374.612 496.977 374.612C478.487 374.612 463.504 359.63 463.504 341.139C463.504 322.649 478.487 307.666 496.977 307.666C515.453 307.666 530.45 322.649 530.45 341.139Z",
                                            fill: "#231F20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    opacity: "0.6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0141",
                                            d: "M410.934 449.699C394.378 466.515 361.987 461.333 338.561 438.151C315.105 414.97 309.519 382.565 326.06 365.763C342.602 348.933 375.036 354.1 398.463 377.296C421.89 400.478 427.476 432.897 410.934 449.699Z",
                                            fill: "#F0EFEF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0282",
                                            d: "M410.526 448.833C394.201 465.678 362.07 460.785 338.701 437.935C315.317 415.086 309.587 382.926 325.898 366.11C342.208 349.265 374.382 354.144 397.752 377.008C421.121 399.843 426.837 432.003 410.526 448.833Z",
                                            fill: "#EDECEC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0423",
                                            d: "M410.142 447.966C394.062 464.826 362.162 460.236 338.88 437.718C315.568 415.201 309.708 383.286 325.788 366.441C341.853 349.568 373.782 354.158 397.079 376.69C420.361 399.193 426.207 431.122 410.142 447.966Z",
                                            fill: "#EAE9E9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0563",
                                            d: "M409.748 447.101C393.9 463.989 362.26 459.673 339.035 437.488C315.795 415.302 309.791 383.633 325.64 366.774C341.474 349.886 373.157 354.173 396.382 376.373C419.593 398.558 425.583 430.227 409.748 447.101Z",
                                            fill: "#E7E6E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0704",
                                            d: "M409.347 446.233C393.729 463.15 362.335 459.123 339.197 437.27C316.015 415.416 309.895 383.993 325.498 367.104C341.088 350.187 372.525 354.2 395.678 376.068C418.831 397.922 424.951 429.331 409.347 446.233Z",
                                            fill: "#E4E3E3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0845",
                                            d: "M408.955 445.369C393.582 462.3 362.433 458.562 339.352 437.04C316.243 415.519 309.993 384.355 325.351 367.438C340.709 350.492 371.887 354.216 394.968 375.752C418.063 397.274 424.313 428.452 408.955 445.369Z",
                                            fill: "#E1E0E0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0986",
                                            d: "M408.571 444.503C393.43 461.464 362.54 458.014 339.532 436.824C316.495 415.635 310.1 384.717 325.242 367.771C340.369 350.81 371.302 354.246 394.31 375.45C417.304 396.639 423.699 427.558 408.571 444.503Z",
                                            fill: "#DEDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1127",
                                            d: "M408.162 443.636C393.266 460.625 362.608 457.464 339.672 436.592C316.707 415.72 310.182 385.061 325.078 368.101C339.96 351.112 370.648 354.258 393.584 375.131C416.534 395.988 423.059 426.661 408.162 443.636Z",
                                            fill: "#DCDADA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1268",
                                            d: "M407.776 442.77C393.111 459.774 362.712 456.902 339.848 436.376C316.955 415.836 310.301 385.423 324.952 368.434C339.603 351.416 370.03 354.274 392.908 374.828C415.772 395.354 422.427 425.781 407.776 442.77Z",
                                            fill: "#D9D7D7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1408",
                                            d: "M407.385 441.905C392.95 458.938 362.811 456.354 340.005 436.146C317.184 415.938 310.386 385.77 324.806 368.766C339.226 351.734 369.408 354.303 392.2 374.511C415.006 394.719 421.79 424.887 407.385 441.905Z",
                                            fill: "#D6D4D4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1549",
                                            d: "M406.982 441.039C392.793 458.101 362.885 455.806 340.166 435.93C317.417 416.053 310.489 386.146 324.677 369.099C338.852 352.037 368.789 354.318 391.523 374.208C414.242 394.07 421.171 423.992 406.982 441.039Z",
                                            fill: "#D3D1D1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.169",
                                            d: "M406.594 440.174C392.636 457.249 362.988 455.243 340.326 435.699C317.65 416.155 310.577 386.492 324.535 369.431C338.479 352.341 368.17 354.347 390.818 373.891C413.479 393.435 420.538 423.112 406.594 440.174Z",
                                            fill: "#D0CECF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1831",
                                            d: "M406.203 439.306C392.476 456.41 363.073 454.693 340.498 435.481C317.894 416.269 310.691 386.851 324.404 369.761C338.117 352.656 367.548 354.36 390.138 373.586C412.713 392.784 419.901 422.215 406.203 439.306Z",
                                            fill: "#CDCBCC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1972",
                                            d: "M405.793 438.44C392.312 455.574 363.154 454.131 340.637 435.265C318.105 416.385 310.772 387.213 324.239 370.108C337.707 352.975 366.893 354.389 389.41 373.284C411.942 392.15 419.275 421.321 405.793 438.44Z",
                                            fill: "#CAC8C9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2113",
                                            d: "M405.404 437.574C392.154 454.722 363.256 453.582 340.811 435.033C318.351 416.485 310.874 387.559 324.125 370.425C337.361 353.263 366.302 354.403 388.747 372.951C411.178 391.514 418.641 420.44 405.404 437.574Z",
                                            fill: "#C7C5C6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2254",
                                            d: "M405.018 436.708C392.013 453.885 363.346 453.033 340.973 434.817C318.585 416.601 310.978 387.92 323.984 370.772C336.975 353.595 365.67 354.432 388.043 372.663C410.416 390.865 418.009 419.546 405.018 436.708Z",
                                            fill: "#C4C2C3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2394",
                                            d: "M404.63 435.857C391.856 453.063 363.449 452.485 341.148 434.601C318.818 416.717 311.096 388.296 323.856 371.119C336.616 353.913 365.051 354.476 387.367 372.36C409.653 390.23 417.39 418.666 404.63 435.857Z",
                                            fill: "#C1BFC0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2535",
                                            d: "M404.223 434.99C391.679 452.211 363.518 451.936 341.289 434.384C319.031 416.832 311.165 388.656 323.694 371.451C336.223 354.216 364.413 354.49 386.642 372.057C408.885 389.58 416.752 417.77 404.223 434.99Z",
                                            fill: "#BEBDBD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2676",
                                            d: "M403.832 434.125C391.534 451.374 363.618 451.374 341.461 434.154C319.276 416.934 311.279 389.003 323.563 371.783C335.846 354.534 363.791 354.505 385.962 371.74C408.119 388.945 416.116 416.876 403.832 434.125Z",
                                            fill: "#BBBABA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2817",
                                            d: "M403.444 433.258C391.377 450.522 363.721 450.825 341.622 433.937C319.508 417.049 311.367 389.364 323.435 372.115C335.487 354.837 363.172 354.534 385.271 371.436C407.356 388.31 415.497 415.995 403.444 433.258Z",
                                            fill: "#B8B7B7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2958",
                                            d: "M403.038 432.392C391.216 449.685 363.791 450.276 341.779 433.706C319.737 417.15 311.467 389.71 323.288 372.447C335.11 355.14 362.55 354.548 384.562 371.119C406.589 387.66 414.86 415.1 403.038 432.392Z",
                                            fill: "#B5B4B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3099",
                                            d: "M402.653 431.526C391.062 448.847 363.896 449.713 341.942 433.489C319.973 417.265 311.572 390.085 323.148 372.778C334.725 355.457 361.919 354.577 383.873 370.815C405.828 387.025 414.229 414.205 402.653 431.526Z",
                                            fill: "#B3B1B1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3239",
                                            d: "M402.261 430.66C390.902 447.995 363.982 449.164 342.114 433.272C320.217 417.38 311.672 390.446 323.017 373.124C334.362 355.774 361.311 354.605 383.179 370.512C405.062 386.375 413.607 413.324 402.261 430.66Z",
                                            fill: "#B0AEAE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.338",
                                            d: "M401.856 429.794C390.742 447.158 364.067 448.602 342.257 433.042C320.432 417.482 311.757 390.792 322.871 373.442C333.971 356.064 360.675 354.62 382.485 370.195C404.295 385.74 412.97 412.43 401.856 429.794Z",
                                            fill: "#ADABAB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3521",
                                            d: "M401.463 428.927C390.58 446.321 364.165 448.053 342.427 432.825C320.674 417.596 311.869 391.153 322.738 373.788C333.607 356.395 360.051 354.648 381.789 369.891C403.527 385.105 412.332 411.534 401.463 428.927Z",
                                            fill: "#AAA8A8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3662",
                                            d: "M401.078 428.063C390.44 445.471 364.256 447.506 342.59 432.595C320.91 417.685 311.96 391.501 322.599 374.108C333.237 356.685 359.435 354.65 381.101 369.561C402.767 384.457 411.702 410.655 401.078 428.063Z",
                                            fill: "#A7A5A5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3803",
                                            d: "M400.671 427.197C390.263 444.633 364.339 446.943 342.746 432.378C321.137 417.8 312.058 391.876 322.451 374.454C332.844 357.002 358.797 354.693 380.39 369.272C401.999 383.821 411.078 409.76 400.671 427.197Z",
                                            fill: "#A4A2A2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3944",
                                            d: "M400.281 426.329C390.105 443.795 364.426 446.393 342.905 432.146C321.369 417.9 312.145 392.221 322.321 374.77C332.483 357.304 358.176 354.692 379.712 368.939C401.234 383.185 410.443 408.864 400.281 426.329Z",
                                            fill: "#A19F9F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4085",
                                            d: "M399.894 425.465C389.963 442.944 364.53 445.831 343.081 431.931C321.617 418.016 312.264 392.583 322.194 375.118C332.125 357.623 357.573 354.736 379.022 368.651C400.472 382.537 409.811 407.985 399.894 425.465Z",
                                            fill: "#9E9C9C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4225",
                                            d: "M399.488 424.598C389.788 442.107 364.615 445.282 343.223 431.7C321.817 418.117 312.348 392.929 322.033 375.435C331.719 357.926 356.921 354.736 378.313 368.319C399.704 381.901 409.188 407.089 399.488 424.598Z",
                                            fill: "#9B9999"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4366",
                                            d: "M399.093 423.732C389.624 441.27 364.696 444.734 343.391 431.483C322.057 418.232 312.444 393.29 321.898 375.781C331.353 358.243 356.295 354.765 377.615 368.03C398.934 381.252 408.548 406.194 399.093 423.732Z",
                                            fill: "#989696"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4507",
                                            d: "M398.708 422.865C389.484 440.417 364.801 444.17 343.554 431.251C322.292 418.332 312.549 393.65 321.773 376.098C330.982 358.531 355.693 354.778 376.941 367.697C398.173 380.615 407.917 405.313 398.708 422.865Z",
                                            fill: "#959393"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4648",
                                            d: "M398.304 421.999C389.312 439.58 364.874 443.622 343.714 431.035C322.524 418.449 312.651 394.011 321.629 376.445C330.607 358.864 355.059 354.808 376.234 367.409C397.409 379.981 407.297 404.418 398.304 421.999Z",
                                            fill: "#929090"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4789",
                                            d: "M397.917 421.133C389.17 438.743 364.978 443.059 343.875 430.819C322.757 418.564 312.74 394.372 321.487 376.776C330.234 359.167 354.426 354.836 375.544 367.091C396.647 379.331 406.664 403.523 397.917 421.133Z",
                                            fill: "#8F8D8D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.493",
                                            d: "M397.523 420.267C389.007 437.891 365.075 442.51 344.044 430.587C322.999 418.664 312.852 394.718 321.354 377.108C329.855 359.469 353.816 354.85 374.847 366.787C395.878 378.696 406.025 402.642 397.523 420.267Z",
                                            fill: "#8C8A8A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.507",
                                            d: "M397.135 419.401C388.85 437.054 365.163 441.962 344.205 430.371C323.232 418.78 312.94 395.079 321.225 377.441C329.496 359.787 353.197 354.865 374.156 366.47C395.115 378.047 405.406 401.748 397.135 419.401Z",
                                            fill: "#8A8788"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5211",
                                            d: "M396.728 418.536C388.689 436.218 365.247 441.4 344.361 430.142C323.46 418.883 313.038 395.427 321.078 377.774C329.118 360.092 352.574 354.895 373.46 366.154C394.347 377.413 404.768 400.869 396.728 418.536Z",
                                            fill: "#878485"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5352",
                                            d: "M396.343 417.67C388.534 435.366 365.338 440.851 344.524 429.924C323.695 418.998 313.144 395.802 320.938 378.105C328.733 360.394 351.943 354.909 372.757 365.851C393.586 376.777 404.138 399.973 396.343 417.67Z",
                                            fill: "#848182"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5493",
                                            d: "M395.948 416.803C388.385 434.528 365.434 440.288 344.692 429.693C323.935 419.098 313.24 396.147 320.803 378.437C328.367 360.711 351.317 354.937 372.074 365.532C392.816 376.127 403.497 399.078 395.948 416.803Z",
                                            fill: "#817E7F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5634",
                                            d: "M395.543 415.938C388.21 433.677 365.519 439.74 344.835 429.477C324.151 419.214 313.325 396.509 320.658 378.769C327.976 361.015 350.695 354.953 371.365 365.23C392.05 375.493 402.875 398.198 395.543 415.938Z",
                                            fill: "#7E7B7C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5775",
                                            d: "M395.157 415.07C388.055 432.839 365.61 439.19 345.012 429.245C324.4 419.314 313.444 396.854 320.531 379.1C327.618 361.317 350.078 354.98 370.69 364.911C391.288 374.842 402.244 397.302 395.157 415.07Z",
                                            fill: "#7B7879"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5915",
                                            d: "M394.768 414.206C387.912 432.003 365.712 438.629 345.172 429.03C324.617 419.431 313.532 397.217 320.388 379.434C327.244 361.636 349.444 354.996 369.984 364.61C390.524 374.208 401.61 396.408 394.768 414.206Z",
                                            fill: "#787576"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6056",
                                            d: "M394.365 413.338C387.74 431.15 365.785 438.078 345.332 428.797C324.85 419.53 313.634 397.575 320.245 379.763C326.856 361.937 348.825 355.009 369.293 364.29C389.761 373.571 400.991 395.526 394.365 413.338Z",
                                            fill: "#757273"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6197",
                                            d: "M393.974 412.472C387.594 430.313 365.885 437.516 345.489 428.581C325.079 419.632 313.719 397.937 320.114 380.096C326.494 362.241 348.203 355.038 368.599 363.988C388.994 372.922 400.354 394.632 393.974 412.472Z",
                                            fill: "#726F70"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6338",
                                            d: "M393.586 411.608C387.437 429.478 365.988 436.969 345.664 428.366C325.326 419.749 313.837 398.3 319.986 380.444C326.135 362.575 347.584 355.069 367.922 363.686C388.231 372.289 399.721 393.738 393.586 411.608Z",
                                            fill: "#6F6C6D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6479",
                                            d: "M393.181 410.741C387.263 428.625 366.059 436.42 345.808 428.134C325.542 419.849 313.923 398.645 319.826 380.761C325.73 362.862 346.948 355.082 367.2 363.367C387.465 371.638 399.099 392.857 393.181 410.741Z",
                                            fill: "#6C696A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.662",
                                            d: "M392.794 409.875C387.122 427.788 366.163 435.857 345.984 427.918C325.79 419.965 314.026 399.006 319.699 381.108C325.372 363.18 346.33 355.111 366.524 363.065C386.703 371.004 398.467 391.962 392.794 409.875Z",
                                            fill: "#696667"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6761",
                                            d: "M392.4 409.008C386.959 426.95 366.245 435.307 346.138 427.686C326.017 420.065 314.123 399.366 319.565 381.424C325.007 363.482 345.72 355.11 365.827 362.732C385.934 370.367 397.828 391.066 392.4 409.008Z",
                                            fill: "#666364"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6901",
                                            d: "M392 408.143C386.79 426.099 366.336 434.745 346.301 427.47C326.252 420.181 314.228 399.727 319.425 381.771C324.621 363.8 345.089 355.154 365.124 362.444C385.173 369.718 397.211 390.186 392 408.143Z",
                                            fill: "#636061"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7042",
                                            d: "M391.608 407.277C386.642 425.262 366.434 434.197 346.457 427.239C326.48 420.282 314.312 400.074 319.277 382.089C324.243 364.089 344.451 355.154 364.428 362.112C384.405 369.083 396.573 389.291 391.608 407.277Z",
                                            fill: "#615D5E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7183",
                                            d: "M391.22 406.41C386.485 424.424 366.523 433.648 346.632 427.022C326.727 420.397 314.429 400.434 319.149 382.435C323.869 364.421 343.846 355.197 363.737 361.822C383.642 368.433 395.94 388.396 391.22 406.41Z",
                                            fill: "#5E5A5B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7324",
                                            d: "M390.814 405.545C386.325 423.573 366.608 433.085 346.775 426.792C326.942 420.499 314.5 400.781 319.003 382.767C323.493 364.724 343.21 355.212 363.043 361.506C382.875 367.799 395.318 387.516 390.814 405.545Z",
                                            fill: "#5B5758"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7465",
                                            d: "M390.426 404.678C386.168 422.735 366.711 432.536 346.95 426.575C327.19 420.613 314.617 401.156 318.876 383.098C323.134 365.027 342.591 355.226 362.352 361.202C382.112 367.163 394.685 386.62 390.426 404.678Z",
                                            fill: "#585455"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7606",
                                            d: "M390.034 403.813C386.007 421.9 366.795 431.975 347.106 426.345C327.418 420.716 314.716 401.504 318.729 383.432C322.741 365.346 341.968 355.256 361.656 360.886C381.345 366.515 394.047 385.742 390.034 403.813Z",
                                            fill: "#555252"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7746",
                                            d: "M389.625 402.946C385.843 421.047 366.876 431.425 347.26 426.128C327.629 420.83 314.797 401.864 318.579 383.763C322.361 365.648 341.327 355.27 360.944 360.581C380.574 365.879 393.406 384.846 389.625 402.946Z",
                                            fill: "#524F4F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7887",
                                            d: "M389.243 402.08C385.692 420.21 366.97 430.877 347.426 425.911C327.868 420.946 314.906 402.225 318.457 384.109C322.008 365.98 340.714 355.313 360.273 360.278C379.817 365.244 392.793 383.951 389.243 402.08Z",
                                            fill: "#4F4C4C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8028",
                                            d: "M388.853 401.213C385.548 419.371 367.072 430.312 347.6 425.679C328.113 421.045 315.021 402.57 318.327 384.426C321.632 366.267 340.108 355.312 359.58 359.945C379.052 364.593 392.158 383.069 388.853 401.213Z",
                                            fill: "#4C4949"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8169",
                                            d: "M388.459 400.363C385.384 418.535 367.168 429.78 347.754 425.478C328.34 421.177 315.103 402.946 318.178 384.788C321.252 366.601 339.469 355.356 358.883 359.672C378.282 363.959 391.519 382.175 388.459 400.363Z",
                                            fill: "#494646"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.831",
                                            d: "M388.053 399.497C385.209 417.698 367.239 429.217 347.911 425.248C328.569 421.278 315.203 403.307 318.032 385.106C320.861 366.904 338.846 355.371 358.174 359.341C377.516 363.31 390.897 381.281 388.053 399.497Z",
                                            fill: "#464343"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8451",
                                            d: "M387.666 398.63C385.068 416.846 367.343 428.668 348.073 425.03C328.803 421.393 315.293 403.667 317.905 385.451C320.503 367.221 338.229 355.399 357.499 359.051C376.754 362.674 390.265 380.399 387.666 398.63Z",
                                            fill: "#434041"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8592",
                                            d: "M387.276 397.765C384.909 416.01 367.429 428.12 348.246 424.8C329.048 421.495 315.408 404.015 317.775 385.77C320.142 367.51 337.608 355.414 356.805 358.72C375.988 362.04 389.629 379.505 387.276 397.765Z",
                                            fill: "#403D3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8732",
                                            d: "M386.874 396.898C384.752 415.172 367.518 427.557 348.392 424.583C329.267 421.595 315.496 404.375 317.618 386.116C319.74 367.842 336.974 355.443 356.1 358.431C375.225 361.39 389.01 378.61 386.874 396.898Z",
                                            fill: "#3D3A3B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8873",
                                            d: "M386.483 396.032C384.592 414.32 367.617 427.008 348.564 424.352C329.51 421.696 315.596 404.721 317.486 386.433C319.377 368.13 336.352 355.457 355.405 358.098C374.459 360.754 388.373 377.729 386.483 396.032Z",
                                            fill: "#3A3738"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9014",
                                            d: "M386.092 395.167C384.432 413.484 367.703 426.446 348.722 424.136C329.741 421.812 315.696 405.097 317.356 386.78C319.016 368.449 335.731 355.487 354.712 357.811C373.693 360.106 387.738 376.835 386.092 395.167Z",
                                            fill: "#383435"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9155",
                                            d: "M385.687 394.301C384.272 412.647 367.788 425.898 348.879 423.906C329.971 421.914 315.796 405.444 317.211 387.098C318.625 368.752 335.109 355.487 354.018 357.479C372.927 359.471 387.116 375.941 385.687 394.301Z",
                                            fill: "#353132"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9296",
                                            d: "M385.299 393.433C384.116 411.793 367.877 425.347 349.04 423.687C330.204 422.027 315.885 405.803 317.068 387.443C318.252 369.068 334.476 355.529 353.313 357.188C372.164 358.834 386.483 375.058 385.299 393.433Z",
                                            fill: "#322E2F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9437",
                                            d: "M384.909 392.567C383.956 410.957 367.978 424.785 349.213 423.471C330.434 422.143 316 406.165 316.938 387.775C317.876 369.372 333.855 355.543 352.634 356.871C371.398 358.185 385.847 374.164 384.909 392.567Z",
                                            fill: "#2F2B2C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9577",
                                            d: "M384.507 391.702C383.799 410.12 368.066 424.237 349.359 423.241C330.652 422.245 316.073 406.511 316.795 388.108C317.502 369.689 333.236 355.573 351.928 356.554C370.635 357.55 385.214 373.269 384.507 391.702Z",
                                            fill: "#2C2829"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9718",
                                            d: "M384.115 390.835C383.639 409.268 368.151 423.688 349.531 423.024C330.896 422.36 316.187 406.886 316.664 388.439C317.14 369.992 332.614 355.587 351.248 356.251C369.868 356.9 384.591 372.388 384.115 390.835Z",
                                            fill: "#292526"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9859",
                                            d: "M383.728 389.969C383.497 408.431 368.255 423.125 349.692 422.793C331.13 422.461 316.291 407.233 316.522 388.771C316.753 370.295 331.996 355.601 350.544 355.933C369.106 356.265 383.959 371.493 383.728 389.969Z",
                                            fill: "#262223"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M383.321 389.104C383.321 407.594 368.324 422.577 349.848 422.577C331.358 422.577 316.375 407.594 316.375 389.104C316.375 370.614 331.358 355.631 349.848 355.631C368.339 355.631 383.321 370.614 383.321 389.104Z",
                                            fill: "#231F20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    opacity: "0.6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0141",
                                            d: "M263.77 401.546C247.214 418.362 214.823 413.18 191.397 389.999C167.941 366.817 162.355 334.412 178.896 317.611C195.438 300.795 227.872 305.948 251.299 329.144C274.726 352.311 280.312 384.73 263.77 401.546Z",
                                            fill: "#F0EFEF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0282",
                                            d: "M263.362 400.681C247.037 417.525 214.906 412.632 191.537 389.783C168.153 366.933 162.423 334.774 178.734 317.958C195.044 301.113 227.218 305.991 250.588 328.855C273.957 351.676 279.673 383.85 263.362 400.681Z",
                                            fill: "#EDECEC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0423",
                                            d: "M262.978 399.814C246.898 416.673 214.998 412.083 191.716 389.566C168.404 367.048 162.544 335.134 178.624 318.289C194.689 301.415 226.618 306.006 249.915 328.537C273.197 351.041 279.043 382.955 262.978 399.814Z",
                                            fill: "#EAE9E9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0563",
                                            d: "M262.584 398.947C246.736 415.835 215.096 411.519 191.871 389.333C168.631 367.148 162.627 335.479 178.476 318.62C194.31 301.731 225.993 306.018 249.218 328.218C272.429 350.39 278.419 382.058 262.584 398.947Z",
                                            fill: "#E7E6E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0704",
                                            d: "M262.183 398.081C246.565 414.998 215.185 410.971 192.033 389.117C168.851 367.264 162.731 335.84 178.334 318.952C193.923 302.035 225.361 306.048 248.514 327.916C271.667 349.755 277.787 381.178 262.183 398.081Z",
                                            fill: "#E4E3E3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0845",
                                            d: "M261.791 397.214C246.418 414.146 215.269 410.407 192.188 388.886C169.079 367.364 162.829 336.201 178.187 319.284C193.545 302.338 224.723 306.062 247.804 327.598C270.899 349.119 277.149 380.283 261.791 397.214Z",
                                            fill: "#E1E0E0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0986",
                                            d: "M261.407 396.349C246.266 413.31 215.376 409.86 192.368 388.67C169.331 367.481 162.936 336.562 178.078 319.616C193.205 302.656 224.138 306.091 247.146 327.295C270.14 348.471 276.534 379.389 261.407 396.349Z",
                                            fill: "#DEDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1127",
                                            d: "M260.998 395.483C246.102 412.473 215.444 409.312 192.507 388.439C169.542 367.567 163.018 336.909 177.914 319.949C192.796 302.959 223.484 306.106 246.42 326.978C269.37 347.836 275.895 378.509 260.998 395.483Z",
                                            fill: "#DCDADA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1268",
                                            d: "M260.612 394.616C245.946 411.62 215.548 408.747 192.684 388.222C169.791 367.682 163.137 337.269 177.788 320.279C192.438 303.261 222.866 306.119 245.744 326.674C268.608 347.185 275.263 377.613 260.612 394.616Z",
                                            fill: "#D9D7D7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1408",
                                            d: "M260.222 393.751C245.788 410.783 215.649 408.2 192.843 387.992C170.022 367.784 163.224 337.616 177.644 320.612C192.064 303.58 222.246 306.149 245.037 326.357C267.844 346.551 274.628 376.718 260.222 393.751Z",
                                            fill: "#D6D4D4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1549",
                                            d: "M259.818 392.885C245.629 409.946 215.721 407.651 193.001 387.775C170.253 367.899 163.324 337.991 177.513 320.944C191.688 303.883 221.625 306.164 244.359 326.054C267.078 345.916 274.007 375.838 259.818 392.885Z",
                                            fill: "#D3D1D1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.169",
                                            d: "M259.43 392.019C245.472 409.095 215.824 407.089 193.162 387.545C170.486 368.001 163.413 338.338 177.371 321.277C191.315 304.187 221.006 306.193 243.653 325.737C266.315 345.267 273.374 374.944 259.43 392.019Z",
                                            fill: "#D0CECF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1831",
                                            d: "M259.039 391.153C245.312 408.258 215.909 406.54 193.334 387.328C170.73 368.116 163.527 338.699 177.24 321.609C190.952 304.504 220.384 306.207 242.974 325.434C265.549 344.632 272.737 374.049 259.039 391.153Z",
                                            fill: "#CDCBCC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1972",
                                            d: "M258.629 390.288C245.148 407.422 215.99 405.978 193.473 387.113C170.941 368.233 163.608 339.061 177.075 321.956C190.543 304.823 219.729 306.237 242.246 325.132C264.778 343.983 272.111 373.169 258.629 390.288Z",
                                            fill: "#CAC8C9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2113",
                                            d: "M258.24 389.422C244.99 406.569 216.092 405.429 193.647 386.881C171.187 368.333 163.71 339.407 176.961 322.273C190.197 305.111 219.138 306.251 241.583 324.799C264.014 343.347 271.477 372.274 258.24 389.422Z",
                                            fill: "#C7C5C6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2254",
                                            d: "M257.854 388.554C244.849 405.73 216.182 404.879 193.809 386.663C171.421 368.447 163.814 339.766 176.82 322.618C189.811 305.441 218.506 306.278 240.879 324.509C263.252 342.71 270.845 371.391 257.854 388.554Z",
                                            fill: "#C4C2C3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2394",
                                            d: "M257.447 387.689C244.673 404.895 216.266 404.317 193.965 386.433C171.65 368.549 163.913 340.128 176.673 322.951C189.433 305.745 217.868 306.308 240.184 324.192C262.485 342.062 270.222 370.498 257.447 387.689Z",
                                            fill: "#C1BFC0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2535",
                                            d: "M257.059 386.822C244.515 404.043 216.354 403.768 194.125 386.216C171.867 368.664 164.001 340.488 176.53 323.283C189.059 306.048 217.249 306.322 239.478 323.889C261.721 341.427 269.588 369.602 257.059 386.822Z",
                                            fill: "#BEBDBD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2676",
                                            d: "M256.669 385.957C244.371 403.206 216.455 403.206 194.299 385.986C172.113 368.766 164.116 340.835 176.414 323.615C188.698 306.366 216.643 306.337 238.814 323.572C260.956 340.778 268.953 368.722 256.669 385.957Z",
                                            fill: "#BBBABA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2817",
                                            d: "M256.28 385.09C244.213 402.354 216.557 402.657 194.458 385.769C172.344 368.881 164.203 341.196 176.27 323.947C188.323 306.669 216.008 306.366 238.107 323.268C260.192 340.142 268.333 367.827 256.28 385.09Z",
                                            fill: "#B8B7B7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2958",
                                            d: "M255.874 384.224C244.052 401.517 216.627 402.108 194.615 385.538C172.573 368.982 164.303 341.542 176.124 324.279C187.946 306.972 215.386 306.38 237.398 322.951C259.425 339.507 267.696 366.932 255.874 384.224Z",
                                            fill: "#B5B4B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3099",
                                            d: "M255.488 383.358C243.898 400.679 216.732 401.545 194.778 385.321C172.809 369.097 164.408 341.917 175.984 324.611C187.561 307.289 214.755 306.409 236.709 322.647C258.664 338.857 267.065 366.051 255.488 383.358Z",
                                            fill: "#B3B1B1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3239",
                                            d: "M255.097 382.492C243.737 399.828 216.817 400.997 194.949 385.091C173.053 369.198 164.508 342.264 175.853 324.943C187.198 307.593 214.147 306.424 236.015 322.33C257.898 338.222 266.428 365.157 255.097 382.492Z",
                                            fill: "#B0AEAE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.338",
                                            d: "M254.694 381.626C243.58 398.991 216.905 400.434 195.095 384.874C173.27 369.314 164.595 342.625 175.709 325.274C186.809 307.896 213.513 306.452 235.323 322.027C257.133 337.573 265.808 364.262 254.694 381.626Z",
                                            fill: "#ADABAB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3521",
                                            d: "M254.299 380.759C243.416 398.153 217.001 399.885 195.263 384.657C173.51 369.428 164.705 342.985 175.574 325.62C186.443 308.227 212.887 306.48 234.625 321.723C256.363 336.937 265.168 363.38 254.299 380.759Z",
                                            fill: "#AAA8A8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3662",
                                            d: "M253.914 379.895C243.276 397.303 217.092 399.338 195.426 384.428C173.746 369.517 164.796 343.333 175.434 325.94C186.073 308.517 212.271 306.482 233.937 321.393C255.603 336.303 264.538 362.487 253.914 379.895Z",
                                            fill: "#A7A5A5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3803",
                                            d: "M253.507 379.029C243.099 396.465 217.175 398.775 195.582 384.211C173.973 369.632 164.894 343.708 175.287 326.286C185.68 308.834 211.633 306.525 233.226 321.104C254.834 335.653 263.914 361.592 253.507 379.029Z",
                                            fill: "#A4A2A2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3944",
                                            d: "M253.117 378.161C242.941 395.627 217.262 398.225 195.74 383.978C174.204 369.732 164.981 344.053 175.157 326.602C185.319 309.136 211.012 306.524 232.548 320.771C254.07 335.017 263.279 360.71 253.117 378.161Z",
                                            fill: "#A19F9F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4085",
                                            d: "M252.73 377.297C242.799 394.777 217.366 397.663 195.917 383.763C174.453 369.848 165.099 344.415 175.03 326.95C184.961 309.455 210.409 306.568 231.858 320.483C253.308 334.383 262.647 359.817 252.73 377.297Z",
                                            fill: "#9E9C9C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4225",
                                            d: "M252.324 376.43C242.624 393.939 217.451 397.114 196.059 383.532C174.653 369.949 165.184 344.761 174.869 327.267C184.555 309.758 209.757 306.568 231.149 320.151C252.54 333.733 262.024 358.921 252.324 376.43Z",
                                            fill: "#9B9999"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4366",
                                            d: "M251.929 375.564C242.46 393.102 217.532 396.566 196.227 383.315C174.893 370.065 165.28 345.122 174.734 327.613C184.189 310.075 209.131 306.597 230.451 319.862C251.77 333.098 261.384 358.041 251.929 375.564Z",
                                            fill: "#989696"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4507",
                                            d: "M251.543 374.699C242.32 392.251 217.637 396.004 196.39 383.085C175.128 370.166 165.385 345.484 174.609 327.931C183.818 310.365 208.529 306.612 229.777 319.531C251.009 332.449 260.753 357.147 251.543 374.699Z",
                                            fill: "#959393"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4648",
                                            d: "M251.14 373.832C242.148 391.413 217.71 395.454 196.55 382.867C175.36 370.281 165.487 345.843 174.465 328.277C183.443 310.696 207.895 306.64 229.07 319.241C250.245 331.813 260.133 356.265 251.14 373.832Z",
                                            fill: "#929090"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4789",
                                            d: "M250.749 372.965C242.002 390.575 217.81 394.891 196.707 382.651C175.589 370.396 165.572 346.204 174.319 328.608C183.066 310.999 207.258 306.668 228.376 318.923C249.479 331.178 259.496 355.37 250.749 372.965Z",
                                            fill: "#8F8D8D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.493",
                                            d: "M250.361 372.101C241.845 389.725 217.913 394.344 196.882 382.421C175.837 370.498 165.675 346.552 174.192 328.942C182.693 311.303 206.654 306.684 227.685 318.621C248.716 330.53 258.863 354.476 250.361 372.101Z",
                                            fill: "#8C8A8A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.507",
                                            d: "M249.956 371.233C241.67 388.886 217.984 393.794 197.025 382.203C176.052 370.612 165.76 346.911 174.046 329.273C182.316 311.619 206.018 306.697 226.976 318.302C247.949 329.893 258.241 353.594 249.956 371.233Z",
                                            fill: "#8A8788"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5211",
                                            d: "M249.564 370.368C241.524 388.05 218.083 393.232 197.197 381.974C176.296 370.715 165.874 347.259 173.914 329.606C181.954 311.924 205.41 306.727 226.296 317.986C247.183 329.245 257.604 352.701 249.564 370.368Z",
                                            fill: "#878485"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5352",
                                            d: "M249.179 369.502C241.37 387.198 218.174 392.683 197.36 381.757C176.531 370.83 165.98 347.634 173.774 329.937C181.569 312.226 204.779 306.741 225.593 317.683C246.422 328.609 256.974 351.805 249.179 369.502Z",
                                            fill: "#848182"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5493",
                                            d: "M248.784 368.635C241.221 386.36 218.27 392.12 197.528 381.525C176.771 370.93 166.076 347.979 173.639 330.269C181.203 312.543 204.153 306.769 224.91 317.364C245.652 327.973 256.333 350.924 248.784 368.635Z",
                                            fill: "#817E7F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5634",
                                            d: "M248.379 367.77C241.046 385.509 218.355 391.572 197.671 381.309C176.987 371.046 166.161 348.341 173.494 330.601C180.812 312.847 203.531 306.785 224.201 317.062C244.886 327.325 255.711 350.03 248.379 367.77Z",
                                            fill: "#7E7B7C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5775",
                                            d: "M247.993 366.902C240.891 384.671 218.446 391.022 197.848 381.077C177.236 371.146 166.28 348.686 173.367 330.932C180.454 313.149 202.914 306.812 223.526 316.743C244.124 326.688 255.08 349.134 247.993 366.902Z",
                                            fill: "#7B7879"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5915",
                                            d: "M247.604 366.052C240.748 383.849 218.548 390.474 198.008 380.876C177.453 371.277 166.368 349.062 173.224 331.279C180.08 313.482 202.28 306.842 222.82 316.455C243.36 326.04 254.446 348.254 247.604 366.052Z",
                                            fill: "#787576"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6056",
                                            d: "M247.201 365.185C240.576 382.997 218.621 389.926 198.168 380.645C177.685 371.378 166.47 349.423 173.081 331.611C179.692 313.785 201.661 306.856 222.129 316.138C242.597 325.404 253.826 347.359 247.201 365.185Z",
                                            fill: "#757273"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6197",
                                            d: "M246.81 364.32C240.43 382.161 218.721 389.364 198.325 380.429C177.915 371.479 166.555 349.785 172.95 331.944C179.33 314.089 201.039 306.886 221.435 315.835C241.83 324.77 253.19 346.465 246.81 364.32Z",
                                            fill: "#726F70"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6338",
                                            d: "M246.418 363.454C240.269 381.323 218.82 388.815 198.496 380.212C178.158 371.595 166.669 350.145 172.818 332.29C178.967 314.42 200.416 306.915 220.754 315.532C241.063 324.12 252.553 345.584 246.418 363.454Z",
                                            fill: "#6F6C6D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6479",
                                            d: "M246.017 362.588C240.099 380.472 218.895 388.267 198.644 379.982C178.378 371.696 166.758 350.492 172.662 332.608C178.566 314.71 199.784 306.93 220.036 315.2C240.301 323.486 251.935 344.69 246.017 362.588Z",
                                            fill: "#6C696A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.662",
                                            d: "M245.626 361.721C239.954 379.634 218.995 387.703 198.816 379.764C178.622 371.81 166.858 350.852 172.531 332.953C178.204 315.026 199.162 306.957 219.356 314.91C239.535 322.835 251.299 343.793 245.626 361.721Z",
                                            fill: "#696667"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6761",
                                            d: "M245.236 360.856C239.795 378.798 219.081 387.155 198.974 379.534C178.853 371.913 166.959 351.214 172.401 333.272C177.843 315.33 198.556 306.958 218.663 314.579C238.77 322.201 250.664 342.914 245.236 360.856Z",
                                            fill: "#666364"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6901",
                                            d: "M244.832 359.99C239.622 377.947 219.168 386.593 199.133 379.318C179.084 372.028 167.06 351.575 172.257 333.619C177.453 315.648 197.921 307.002 217.956 314.291C238.005 321.566 250.043 342.019 244.832 359.99Z",
                                            fill: "#636061"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7042",
                                            d: "M244.444 359.122C239.478 377.107 219.27 386.042 199.293 379.085C179.316 372.128 167.148 351.92 172.113 333.934C177.079 315.935 197.287 307 217.264 313.957C237.241 320.915 249.409 341.137 244.444 359.122Z",
                                            fill: "#615D5E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7183",
                                            d: "M244.056 358.258C239.321 376.272 219.359 385.495 199.468 378.87C179.563 372.245 167.265 352.282 171.985 334.282C176.705 316.268 196.682 307.045 216.573 313.67C236.478 320.281 248.776 340.244 244.056 358.258Z",
                                            fill: "#5E5A5B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7324",
                                            d: "M243.65 357.391C239.161 375.42 219.444 384.932 199.611 378.638C179.778 372.345 167.336 352.628 171.839 334.599C176.328 316.556 196.046 307.044 215.878 313.338C235.711 319.631 248.139 339.348 243.65 357.391Z",
                                            fill: "#5B5758"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7465",
                                            d: "M243.258 356.525C239 374.583 219.543 384.384 199.782 378.422C180.022 372.461 167.449 352.989 171.708 334.946C175.966 316.874 195.423 307.073 215.184 313.049C234.944 318.996 247.517 338.468 243.258 356.525Z",
                                            fill: "#585455"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7606",
                                            d: "M242.866 355.659C238.839 373.745 219.627 383.82 199.938 378.191C180.25 372.562 167.548 353.35 171.561 335.278C175.573 317.192 194.8 307.102 214.488 312.731C234.177 318.361 246.879 337.573 242.866 355.659Z",
                                            fill: "#555252"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7746",
                                            d: "M242.462 354.794C238.681 372.894 219.714 383.273 200.098 377.975C180.467 372.678 167.635 353.711 171.417 335.611C175.199 317.496 194.165 307.117 213.781 312.429C233.412 317.712 246.244 336.679 242.462 354.794Z",
                                            fill: "#524F4F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7887",
                                            d: "M242.075 353.928C238.524 372.057 219.803 382.724 200.258 377.759C180.7 372.794 167.738 354.072 171.289 335.957C174.84 317.828 193.546 307.161 213.105 312.126C232.649 317.077 245.625 335.798 242.075 353.928Z",
                                            fill: "#4F4C4C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8028",
                                            d: "M241.685 353.06C238.38 371.219 219.904 382.16 200.432 377.527C180.945 372.893 167.853 354.417 171.159 336.273C174.464 318.115 192.94 307.159 212.412 311.793C231.884 316.441 244.99 334.902 241.685 353.06Z",
                                            fill: "#4C4949"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8169",
                                            d: "M241.283 352.195C238.208 370.367 219.992 381.612 200.578 377.31C181.164 373.009 167.928 354.778 171.002 336.62C174.077 318.433 192.293 307.188 211.707 311.504C231.121 315.791 244.357 334.007 241.283 352.195Z",
                                            fill: "#494646"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.831",
                                            d: "M240.891 351.329C238.047 369.531 220.077 381.049 200.749 377.08C181.407 373.11 168.041 355.139 170.87 336.938C173.699 318.736 191.684 307.203 211.012 311.173C230.354 315.156 243.734 333.127 240.891 351.329Z",
                                            fill: "#464343"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8451",
                                            d: "M240.502 350.462C237.904 368.678 220.179 380.5 200.909 376.862C181.639 373.225 168.129 355.499 170.741 337.283C173.339 319.053 191.065 307.231 210.335 310.883C229.59 314.506 243.1 332.231 240.502 350.462Z",
                                            fill: "#434041"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8592",
                                            d: "M240.112 349.597C237.745 367.842 220.265 379.952 201.082 376.632C181.884 373.327 168.243 355.847 170.611 337.602C172.978 319.342 190.443 307.246 209.641 310.552C228.824 313.872 242.465 331.337 240.112 349.597Z",
                                            fill: "#403D3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8732",
                                            d: "M239.71 348.73C237.588 367.004 220.353 379.389 201.228 376.415C182.102 373.427 168.332 356.207 170.454 337.948C172.576 319.674 189.81 307.275 208.936 310.263C228.061 313.236 241.846 330.456 239.71 348.73Z",
                                            fill: "#3D3A3B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8873",
                                            d: "M239.32 347.864C237.43 366.152 220.455 378.84 201.401 376.184C182.348 373.528 168.433 356.553 170.324 338.265C172.215 319.962 189.19 307.289 208.243 309.93C227.297 312.586 241.211 329.561 239.32 347.864Z",
                                            fill: "#3A3738"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9014",
                                            d: "M238.928 346.999C237.268 365.316 220.539 378.292 201.558 375.968C182.576 373.644 168.532 356.929 170.192 338.612C171.852 320.281 188.567 307.319 207.548 309.643C226.529 311.952 240.574 328.667 238.928 346.999Z",
                                            fill: "#383435"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9155",
                                            d: "M238.523 346.133C237.108 364.479 220.624 377.73 201.715 375.738C182.806 373.746 168.632 357.277 170.047 338.93C171.461 320.584 187.945 307.319 206.854 309.311C225.763 311.303 239.952 327.787 238.523 346.133Z",
                                            fill: "#353132"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9296",
                                            d: "M238.135 345.265C236.952 363.626 220.713 377.179 201.876 375.519C183.04 373.859 168.721 357.635 169.904 339.275C171.088 320.9 187.312 307.361 206.149 309.021C225 310.666 239.319 326.89 238.135 345.265Z",
                                            fill: "#322E2F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9437",
                                            d: "M237.745 344.399C236.792 362.789 220.813 376.617 202.049 375.303C183.27 373.975 168.836 357.997 169.774 339.607C170.712 321.204 186.691 307.375 205.47 308.703C224.234 310.031 238.683 326.01 237.745 344.399Z",
                                            fill: "#2F2B2C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9577",
                                            d: "M237.343 343.534C236.635 361.952 220.902 376.069 202.195 375.073C183.488 374.077 168.909 358.343 169.631 339.94C170.338 321.521 186.072 307.405 204.764 308.386C223.471 309.382 238.05 325.115 237.343 343.534Z",
                                            fill: "#2C2829"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9718",
                                            d: "M236.951 342.667C236.475 361.1 220.987 375.52 202.366 374.856C183.732 374.192 169.023 358.718 169.5 340.271C169.976 321.824 185.449 307.419 204.084 308.083C222.704 308.747 237.427 324.22 236.951 342.667Z",
                                            fill: "#292526"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9859",
                                            d: "M236.564 341.801C236.333 360.263 221.091 374.957 202.528 374.625C183.966 374.293 169.127 359.065 169.358 340.603C169.589 322.127 184.832 307.433 203.38 307.765C221.942 308.097 236.795 323.34 236.564 341.801Z",
                                            fill: "#262223"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M236.157 340.936C236.157 359.426 221.16 374.409 202.684 374.409C184.194 374.409 169.211 359.426 169.211 340.936C169.211 322.446 184.194 307.463 202.684 307.463C221.174 307.463 236.157 322.446 236.157 340.936Z",
                                            fill: "#231F20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    opacity: "0.6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0141",
                                            d: "M173.008 276.284C156.452 293.1 124.062 287.918 100.635 264.737C77.179 241.555 71.5929 209.15 88.1347 192.349C104.676 175.533 137.11 180.686 160.537 203.882C183.964 227.063 189.55 259.483 173.008 276.284Z",
                                            fill: "#F0EFEF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0282",
                                            d: "M172.6 275.419C156.275 292.264 124.144 287.371 100.775 264.521C77.3914 241.671 71.661 209.512 87.9718 192.696C104.283 175.851 136.457 180.73 159.826 203.594C183.195 226.429 188.911 258.588 172.6 275.419Z",
                                            fill: "#EDECEC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0423",
                                            d: "M172.216 274.552C156.136 291.412 124.237 286.822 100.954 264.304C77.6425 241.787 71.7822 209.872 87.862 193.027C103.927 176.154 135.856 180.744 159.153 203.276C182.436 225.779 188.282 257.693 172.216 274.552Z",
                                            fill: "#EAE9E9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0563",
                                            d: "M171.823 273.687C155.974 290.575 124.334 286.259 101.109 264.074C77.8697 241.888 71.865 210.219 87.7139 193.36C103.548 176.472 135.232 180.759 158.457 202.959C181.667 225.144 187.657 256.813 171.823 273.687Z",
                                            fill: "#E7E6E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0704",
                                            d: "M171.422 272.821C155.804 289.738 124.424 285.711 101.271 263.858C78.0893 242.004 71.9692 210.581 87.5727 193.692C103.162 176.775 134.6 180.788 157.752 202.656C180.905 224.495 187.025 255.919 171.422 272.821Z",
                                            fill: "#E4E3E3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0845",
                                            d: "M171.029 271.955C155.656 288.886 124.507 285.148 101.427 263.626C78.3173 242.104 72.0672 210.941 87.4253 194.024C102.783 177.078 133.962 180.802 157.042 202.338C180.137 223.86 186.387 255.023 171.029 271.955Z",
                                            fill: "#E1E0E0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.0986",
                                            d: "M170.646 271.089C155.504 288.05 124.615 284.6 101.606 263.41C78.5691 242.221 72.1747 211.302 87.3163 194.357C102.443 177.396 133.376 180.832 156.384 202.036C179.378 223.225 185.773 254.144 170.646 271.089Z",
                                            fill: "#DEDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1127",
                                            d: "M170.237 270.224C155.34 287.213 124.682 284.052 101.746 263.18C78.7807 242.308 72.2564 211.649 87.1526 194.689C102.034 177.7 132.722 180.846 155.658 201.718C178.608 222.576 185.133 253.249 170.237 270.224Z",
                                            fill: "#DCDADA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1268",
                                            d: "M169.85 269.356C155.185 286.36 124.786 283.488 101.922 262.962C79.0293 242.422 72.3751 212.009 87.0259 195.02C101.677 178.002 132.104 180.86 154.983 201.414C177.847 221.94 184.501 252.353 169.85 269.356Z",
                                            fill: "#D9D7D7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1408",
                                            d: "M169.461 268.491C155.026 285.524 124.888 282.94 102.081 262.732C79.2606 242.524 72.4621 212.356 86.8819 195.352C101.302 178.32 131.484 180.889 154.276 201.097C177.082 221.291 183.866 251.473 169.461 268.491Z",
                                            fill: "#D6D4D4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1549",
                                            d: "M169.056 267.625C154.867 284.687 124.959 282.392 102.24 262.515C79.4912 242.639 72.5628 212.732 86.7517 195.685C100.926 178.623 130.863 180.904 153.597 200.794C176.317 220.656 183.245 250.578 169.056 267.625Z",
                                            fill: "#D3D1D1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.169",
                                            d: "M168.668 266.76C154.71 283.835 125.062 281.829 102.401 262.285C79.7242 242.741 72.6514 213.078 86.6094 196.017C100.553 178.927 130.244 180.933 152.892 200.477C175.554 220.021 182.612 249.698 168.668 266.76Z",
                                            fill: "#D0CECF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1831",
                                            d: "M168.277 265.892C154.55 282.996 125.148 281.279 102.572 262.067C79.9682 242.854 72.7655 213.437 86.4781 196.347C100.191 179.242 129.622 180.946 152.212 200.172C174.787 219.37 181.976 248.801 168.277 265.892Z",
                                            fill: "#CDCBCC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.1972",
                                            d: "M167.868 265.026C154.386 282.16 125.229 280.717 102.711 261.851C80.1791 242.971 72.8464 213.799 86.3136 196.694C99.7809 179.561 128.967 180.975 151.485 199.87C174.017 218.736 181.349 247.907 167.868 265.026Z",
                                            fill: "#CAC8C9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2113",
                                            d: "M167.479 264.16C154.228 281.308 125.33 280.167 102.885 261.619C80.4253 243.071 72.9483 214.145 86.199 197.011C99.4352 179.849 128.376 180.989 150.821 199.537C173.252 218.085 180.715 247.026 167.479 264.16Z",
                                            fill: "#C7C5C6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2254",
                                            d: "M167.092 263.294C154.087 280.471 125.42 279.619 103.047 261.403C80.6595 243.187 73.0526 214.506 86.0579 197.358C99.0488 180.181 127.744 181.018 150.117 199.249C172.491 217.45 180.083 246.131 167.092 263.294Z",
                                            fill: "#C4C2C3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2394",
                                            d: "M166.685 262.428C153.91 279.634 125.504 279.056 103.203 261.172C80.8727 243.288 73.1503 214.867 85.9103 197.676C98.6702 180.47 127.106 181.033 149.421 198.917C171.722 216.816 179.459 245.237 166.685 262.428Z",
                                            fill: "#C1BFC0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2535",
                                            d: "M166.297 261.563C153.754 278.783 125.592 278.509 103.363 260.956C81.1057 243.404 73.239 215.229 85.768 198.023C98.297 180.788 126.487 181.063 148.716 198.629C170.959 216.167 178.826 244.357 166.297 261.563Z",
                                            fill: "#BEBDBD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2676",
                                            d: "M165.906 260.695C153.608 277.944 125.692 277.944 103.536 260.724C81.35 243.504 73.3534 215.574 85.637 198.353C97.9206 181.104 125.865 181.076 148.037 198.31C170.193 215.53 178.19 243.461 165.906 260.695Z",
                                            fill: "#BBBABA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2817",
                                            d: "M165.518 259.831C153.451 277.094 125.795 277.397 103.696 260.509C81.5826 243.621 73.4416 215.936 85.5087 198.687C97.5614 181.409 125.246 181.106 147.345 198.008C169.43 214.882 177.571 242.567 165.518 259.831Z",
                                            fill: "#B8B7B7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.2958",
                                            d: "M165.112 258.965C153.29 276.257 125.865 276.849 103.853 260.278C81.8117 243.722 73.5408 216.282 85.3625 199.019C97.1842 181.712 124.624 181.12 146.636 197.691C168.663 214.247 176.934 241.687 165.112 258.965Z",
                                            fill: "#B5B4B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3099",
                                            d: "M164.727 258.098C153.136 275.42 125.971 276.286 104.016 260.062C82.047 243.837 73.6462 216.658 85.2225 199.351C96.7988 182.03 123.993 181.149 145.948 197.388C167.902 213.612 176.303 240.792 164.727 258.098Z",
                                            fill: "#B3B1B1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3239",
                                            d: "M164.336 257.232C152.976 274.568 126.056 275.737 104.188 259.845C82.2909 243.952 73.7458 217.018 85.0912 199.697C96.4365 182.347 123.385 181.178 145.253 197.084C167.136 212.962 175.667 239.896 164.336 257.232Z",
                                            fill: "#B0AEAE"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.338",
                                            d: "M163.932 256.366C152.818 273.731 126.143 275.174 104.333 259.614C82.5082 244.054 73.8332 217.365 84.9476 200.015C96.0476 182.636 122.751 181.192 144.561 196.767C166.372 212.327 175.047 239.016 163.932 256.366Z",
                                            fill: "#ADABAB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3521",
                                            d: "M163.537 255.513C152.654 272.907 126.239 274.639 104.501 259.411C82.7485 244.182 73.9436 217.739 84.8126 200.374C95.6817 182.981 122.125 181.234 143.863 196.477C165.602 211.691 174.406 238.12 163.537 255.513Z",
                                            fill: "#AAA8A8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3662",
                                            d: "M163.152 254.649C152.514 272.057 126.33 274.092 104.664 259.181C82.984 244.271 74.0347 218.087 84.6728 200.694C95.3109 183.271 121.509 181.236 143.175 196.147C164.841 211.043 173.776 237.227 163.152 254.649Z",
                                            fill: "#A7A5A5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3803",
                                            d: "M162.745 253.782C152.338 271.219 126.414 273.529 104.82 258.964C83.2117 244.386 74.1325 218.462 84.5252 201.039C94.9179 183.588 120.871 181.279 142.465 195.858C164.073 210.407 173.152 236.346 162.745 253.782Z",
                                            fill: "#A4A2A2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.3944",
                                            d: "M162.355 252.915C152.179 270.381 126.5 272.979 104.979 258.732C83.4428 244.486 74.2192 218.807 84.3954 201.356C94.5572 183.89 120.25 181.278 141.786 195.524C163.308 209.757 172.517 235.45 162.355 252.915Z",
                                            fill: "#A19F9F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4085",
                                            d: "M161.968 252.05C152.038 269.53 126.604 272.417 105.155 258.517C83.6912 244.602 74.3377 219.169 84.2685 201.704C94.1994 184.209 119.647 181.322 141.096 195.237C162.546 209.123 171.885 234.571 161.968 252.05Z",
                                            fill: "#9E9C9C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4225",
                                            d: "M161.562 251.184C151.862 268.693 126.689 271.868 105.297 258.286C83.891 244.703 74.4221 219.515 84.1075 202.021C93.793 184.512 118.995 181.322 140.387 194.905C161.779 208.487 171.262 233.675 161.562 251.184Z",
                                            fill: "#9B9999"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4366",
                                            d: "M161.167 250.318C151.699 267.856 126.77 271.32 105.465 258.069C84.1315 244.818 74.5182 219.876 83.9727 202.367C93.4272 184.829 118.37 181.351 139.689 194.616C161.009 207.838 170.622 232.78 161.167 250.318Z",
                                            fill: "#989696"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4507",
                                            d: "M160.782 249.453C151.558 267.005 126.876 270.758 105.628 257.839C84.3665 244.92 74.6233 220.238 83.8468 202.685C93.0559 185.119 117.767 181.366 139.015 194.285C160.248 207.203 169.991 231.9 160.782 249.453Z",
                                            fill: "#959393"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4648",
                                            d: "M160.379 248.585C151.386 266.166 126.949 270.208 105.788 257.621C84.5984 245.035 74.7253 220.597 83.7035 203.031C92.6816 185.45 117.133 181.394 138.309 193.995C159.484 206.553 169.371 231.004 160.379 248.585Z",
                                            fill: "#929090"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4789",
                                            d: "M159.987 247.719C151.24 265.329 127.048 269.645 105.945 257.404C84.8276 245.15 74.8102 220.958 83.5574 203.362C92.3046 185.752 116.511 181.422 137.614 193.677C158.717 205.917 168.734 230.109 159.987 247.719Z",
                                            fill: "#8F8D8D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.493",
                                            d: "M159.598 246.854C151.081 264.479 127.149 269.098 106.119 257.175C85.0733 245.252 74.9259 221.306 83.4278 203.696C91.9296 186.057 115.891 181.438 136.921 193.375C157.952 205.284 168.099 229.23 159.598 246.854Z",
                                            fill: "#8C8A8A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.507",
                                            d: "M159.194 245.987C150.909 263.64 127.222 268.548 106.263 256.957C85.2902 245.366 74.9985 221.665 83.2838 204.026C91.5547 186.373 115.256 181.451 136.214 193.056C157.188 204.633 167.479 228.334 159.194 245.987Z",
                                            fill: "#8A8788"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5211",
                                            d: "M158.803 245.122C150.763 262.804 127.321 267.986 106.435 256.728C85.534 245.469 75.1124 222.013 83.1524 204.36C91.1923 186.678 114.648 181.481 135.535 192.74C156.421 203.999 166.843 227.44 158.803 245.122Z",
                                            fill: "#878485"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5352",
                                            d: "M158.417 244.256C150.608 261.952 127.412 267.437 106.598 256.51C85.7693 245.584 75.2178 222.388 83.0124 204.691C90.8069 186.98 114.017 181.495 134.832 192.436C155.66 203.349 166.212 226.559 158.417 244.256Z",
                                            fill: "#848182"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5493",
                                            d: "M158.023 243.389C150.459 261.114 127.508 266.874 106.766 256.279C86.0097 245.684 75.3139 222.733 82.8775 205.022C90.441 187.297 113.392 181.523 134.148 192.118C154.89 202.713 165.572 225.664 158.023 243.389Z",
                                            fill: "#817E7F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5634",
                                            d: "M157.617 242.524C150.284 260.263 127.594 266.326 106.909 256.063C86.2249 245.8 75.3992 223.095 82.7318 205.355C90.0644 187.601 112.77 181.539 133.44 191.816C154.124 202.079 164.95 224.769 157.617 242.524Z",
                                            fill: "#7E7B7C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5775",
                                            d: "M157.231 241.656C150.129 259.425 127.684 265.776 107.086 255.831C86.4738 245.9 75.5182 223.44 82.6055 205.686C89.6927 187.903 112.153 181.566 132.765 191.497C153.362 201.428 164.318 223.888 157.231 241.656Z",
                                            fill: "#7B7879"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.5915",
                                            d: "M156.842 240.792C149.986 258.589 127.786 265.215 107.246 255.616C86.6914 246.017 75.6058 223.803 82.4622 206.02C89.3185 188.222 111.518 181.582 132.058 191.195C152.599 200.794 163.684 222.994 156.842 240.792Z",
                                            fill: "#787576"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6056",
                                            d: "M156.439 239.926C149.814 257.738 127.859 264.666 107.406 255.385C86.9237 246.118 75.7083 224.163 82.3192 206.351C88.9301 188.525 110.899 181.597 131.367 190.878C151.835 200.145 163.065 222.099 156.439 239.926Z",
                                            fill: "#757273"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6197",
                                            d: "M156.048 239.06C149.668 256.901 127.959 264.104 107.564 255.169C87.1535 246.22 75.7936 224.525 82.188 206.684C88.568 188.829 110.277 181.626 130.673 190.575C151.069 199.51 162.428 221.219 156.048 239.06Z",
                                            fill: "#726F70"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6338",
                                            d: "M155.657 238.194C149.508 256.064 128.058 263.555 107.735 254.952C87.3967 246.335 75.907 224.886 82.056 207.03C88.205 189.161 109.654 181.655 129.992 190.272C150.301 198.875 161.791 220.324 155.657 238.194Z",
                                            fill: "#6F6C6D"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6479",
                                            d: "M155.256 237.327C149.338 255.211 128.134 263.005 107.882 254.72C87.6164 246.435 75.9968 225.231 81.9004 207.347C87.804 189.448 109.022 181.668 129.274 189.953C149.54 198.224 161.174 219.443 155.256 237.327Z",
                                            fill: "#6C696A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.662",
                                            d: "M154.865 236.461C149.192 254.374 128.233 262.443 108.054 254.504C87.8606 246.551 76.0966 225.592 81.7693 207.693C87.442 189.766 108.401 181.697 128.594 189.651C148.773 197.589 160.537 218.548 154.865 236.461Z",
                                            fill: "#696667"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6761",
                                            d: "M154.475 235.594C149.033 253.536 128.32 261.893 108.213 254.272C88.0912 246.651 76.1973 225.952 81.639 208.01C87.0808 190.068 107.794 181.696 127.901 189.318C148.008 196.939 159.902 217.652 154.475 235.594Z",
                                            fill: "#666364"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.6901",
                                            d: "M154.071 234.728C148.86 252.685 128.406 261.331 108.372 254.056C88.3223 246.767 76.2985 226.313 81.4949 208.357C86.6912 190.386 107.159 181.74 127.194 189.029C147.243 196.304 159.281 216.772 154.071 234.728Z",
                                            fill: "#636061"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7042",
                                            d: "M153.682 233.862C148.717 251.848 128.509 260.782 108.531 253.825C88.5544 246.868 76.3862 226.66 81.3516 208.675C86.317 190.675 106.525 181.74 126.502 188.697C146.479 195.669 158.647 215.877 153.682 233.862Z",
                                            fill: "#615D5E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7183",
                                            d: "M153.294 232.996C148.559 251.01 128.597 260.234 108.706 253.608C88.8014 246.983 76.5033 227.02 81.2233 209.021C85.9434 191.007 105.92 181.783 125.811 188.408C145.716 195.019 158.014 214.982 153.294 232.996Z",
                                            fill: "#5E5A5B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7324",
                                            d: "M152.888 232.131C148.399 250.159 128.682 259.671 108.849 253.378C89.0165 247.085 76.5742 227.367 81.0777 209.353C85.5667 191.31 105.284 181.798 125.117 188.092C144.95 194.385 157.377 214.102 152.888 232.131Z",
                                            fill: "#5B5758"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7465",
                                            d: "M152.497 231.266C148.239 249.323 128.781 259.124 109.021 253.163C89.26 247.201 76.6877 227.744 80.9458 209.686C85.204 191.615 104.661 181.814 124.422 187.789C144.183 193.751 156.755 213.208 152.497 231.266Z",
                                            fill: "#585455"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7606",
                                            d: "M152.104 230.399C148.077 248.486 128.865 258.561 109.177 252.931C89.4883 247.302 76.7861 228.09 80.7989 210.018C84.8116 191.932 104.038 181.842 123.727 187.472C143.415 193.101 156.117 212.313 152.104 230.399Z",
                                            fill: "#555252"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7746",
                                            d: "M151.701 229.532C147.919 247.633 128.952 258.011 109.336 252.714C89.7053 247.416 76.8732 228.45 80.655 210.349C84.4368 192.234 103.404 181.856 123.02 187.167C142.65 192.465 155.483 211.431 151.701 229.532Z",
                                            fill: "#524F4F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.7887",
                                            d: "M151.313 228.666C147.762 246.796 129.041 257.463 109.497 252.497C89.9382 247.532 76.9762 228.81 80.527 210.695C84.0779 192.566 102.785 181.899 122.343 186.864C141.887 191.815 154.864 210.537 151.313 228.666Z",
                                            fill: "#4F4C4C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8028",
                                            d: "M150.923 227.801C147.603 245.959 129.142 256.915 109.67 252.267C90.1837 247.633 77.0918 229.157 80.3972 211.013C83.7027 192.855 102.179 181.899 121.651 186.533C141.122 191.181 154.229 209.642 150.923 227.801Z",
                                            fill: "#4C4949"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8169",
                                            d: "M150.533 226.935C147.458 245.108 129.242 256.352 109.828 252.051C90.4139 247.749 77.1776 229.519 80.2521 211.36C83.3266 193.173 101.543 181.929 120.957 186.244C140.357 190.546 153.593 208.762 150.533 226.935Z",
                                            fill: "#494646"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.831",
                                            d: "M150.129 226.067C147.286 244.269 129.315 255.787 109.987 251.818C90.6453 247.848 77.2791 229.878 80.1082 211.676C82.9374 193.474 100.923 181.941 120.25 185.911C139.592 189.895 152.973 207.865 150.129 226.067Z",
                                            fill: "#464343"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8451",
                                            d: "M149.741 225.202C147.142 243.418 129.417 255.24 110.147 251.602C90.8774 247.965 77.3669 230.24 79.9795 212.023C82.5777 193.793 100.303 181.971 119.573 185.623C138.828 189.261 152.339 206.971 149.741 225.202Z",
                                            fill: "#434041"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8592",
                                            d: "M149.35 224.337C146.983 242.582 129.503 254.692 110.32 251.372C91.1222 248.067 77.4817 230.587 79.849 212.342C82.2162 194.083 99.6817 181.987 118.879 185.292C138.063 188.612 151.703 206.092 149.35 224.337Z",
                                            fill: "#403D3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8732",
                                            d: "M148.948 223.47C146.826 241.744 129.592 254.129 110.466 251.155C91.3408 248.182 77.5704 230.947 79.6923 212.688C81.8141 194.414 99.0487 182.015 118.174 185.003C137.3 187.976 151.084 205.196 148.948 223.47Z",
                                            fill: "#3D3A3B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.8873",
                                            d: "M148.559 222.604C146.668 240.892 129.693 253.58 110.64 250.924C91.5864 248.268 77.6717 231.293 79.5626 213.005C81.4535 194.702 98.4283 182.029 117.482 184.67C136.535 187.341 150.45 204.316 148.559 222.604Z",
                                            fill: "#3A3738"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9014",
                                            d: "M148.166 221.739C146.506 240.056 129.777 253.018 110.796 250.708C91.8147 248.385 77.7702 231.67 79.4301 213.352C81.09 195.021 97.805 182.059 116.786 184.383C135.767 186.692 149.812 203.422 148.166 221.739Z",
                                            fill: "#383435"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9155",
                                            d: "M147.761 220.871C146.347 239.218 129.863 252.468 110.954 250.476C92.0447 248.484 77.8702 232.015 79.2848 213.669C80.6994 195.323 97.1834 182.058 116.092 184.05C135.001 186.056 149.19 202.525 147.761 220.871Z",
                                            fill: "#353132"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9296",
                                            d: "M147.374 220.019C146.19 238.379 129.951 251.933 111.115 250.273C92.2779 248.613 77.959 232.389 79.1426 214.029C80.3262 195.654 96.5504 182.114 115.387 183.774C134.238 185.405 148.557 201.644 147.374 220.019Z",
                                            fill: "#322E2F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9437",
                                            d: "M146.983 219.153C146.031 237.543 130.052 251.371 111.287 250.057C92.5081 248.729 78.0738 232.751 79.012 214.361C79.9502 195.957 95.929 182.129 114.708 183.457C133.473 184.771 147.921 200.75 146.983 219.153Z",
                                            fill: "#2F2B2C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9577",
                                            d: "M146.581 218.288C145.874 236.706 130.14 250.823 111.433 249.827C92.7264 248.831 78.1477 233.097 78.8694 214.693C79.5767 196.275 95.3101 182.158 114.003 183.14C132.709 184.136 147.288 199.855 146.581 218.288Z",
                                            fill: "#2C2829"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9718",
                                            d: "M146.189 217.421C145.713 235.854 130.225 250.274 111.605 249.61C92.9701 248.946 78.2615 233.472 78.7378 215.025C79.2141 196.578 94.6877 182.173 113.322 182.837C131.943 183.486 146.666 198.974 146.189 217.421Z",
                                            fill: "#292526"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.9859",
                                            d: "M145.803 216.555C145.572 235.017 130.329 249.711 111.766 249.379C93.2039 249.047 78.3655 233.819 78.5964 215.357C78.8274 196.881 94.07 182.187 112.618 182.519C131.181 182.851 146.034 198.079 145.803 216.555Z",
                                            fill: "#262223"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M145.396 215.69C145.396 234.18 130.398 249.163 111.922 249.163C93.432 249.163 78.4492 234.18 78.4492 215.69C78.4492 197.2 93.432 182.217 111.922 182.217C130.413 182.202 145.396 197.185 145.396 215.69Z",
                                            fill: "#231F20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0141",
                                    d: "M548.088 336.983C494.421 391.487 389.455 374.714 313.516 299.583C237.49 224.438 219.375 119.414 273.013 64.9822C326.622 10.4638 431.718 27.1931 507.672 102.367C583.625 177.454 601.711 282.522 548.088 336.983Z",
                                    fill: "#F1F0F0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0282",
                                    d: "M546.818 334.182C493.917 388.758 389.759 372.924 314.051 298.861C238.256 224.799 219.693 120.569 272.566 66.0647C325.41 11.4741 429.698 27.2653 505.421 101.371C581.143 175.376 599.662 279.635 546.818 334.182Z",
                                    fill: "#EFEEEE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0423",
                                    d: "M545.529 331.367C493.392 386.029 390.042 371.119 314.565 298.139C239.001 225.145 220.006 121.737 272.114 67.1465C324.193 12.4693 427.672 27.3366 503.164 100.36C578.655 173.311 597.622 276.747 545.529 331.367Z",
                                    fill: "#ECECEC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0563",
                                    d: "M544.259 328.566C492.888 383.301 390.346 369.329 315.1 297.417C239.767 225.505 220.339 122.892 271.682 68.229C322.981 13.4797 425.653 27.4088 500.928 99.3639C576.174 171.232 595.573 273.86 544.259 328.566Z",
                                    fill: "#EAE9E9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0704",
                                    d: "M542.974 325.766C492.382 380.573 390.635 367.539 315.605 296.695C240.503 225.852 220.642 124.046 271.219 69.3114C321.768 14.4754 423.631 27.4807 498.661 98.3532C573.691 169.154 593.538 270.988 542.974 325.766Z",
                                    fill: "#E8E7E7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0845",
                                    d: "M541.707 322.952C491.88 377.846 390.941 365.736 316.142 295.975C241.271 226.199 220.977 125.202 270.775 70.3951C320.559 15.4869 421.614 27.554 496.427 97.3584C571.225 167.076 591.491 268.102 541.707 322.952Z",
                                    fill: "#E6E5E5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.0986",
                                    d: "M540.422 320.15C491.36 375.116 391.229 363.944 316.661 295.251C242.007 226.558 221.294 126.37 270.327 71.4758C319.346 16.4955 419.592 27.6244 494.174 96.3606C568.742 164.996 589.441 265.213 540.422 320.15Z",
                                    fill: "#E4E3E3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1127",
                                    d: "M539.151 317.337C490.854 372.39 391.517 362.141 317.18 294.531C242.757 226.906 221.596 127.526 269.879 72.5455C318.133 17.4786 417.571 27.6837 491.922 95.3373C566.259 162.919 587.405 262.328 539.151 317.337Z",
                                    fill: "#E2E1E1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1268",
                                    d: "M537.865 314.536C490.333 369.661 391.819 360.351 317.699 293.808C243.506 227.266 221.912 128.68 269.43 73.6272C316.905 18.4881 415.549 27.7549 489.669 94.3404C563.775 160.839 585.354 259.44 537.865 314.536Z",
                                    fill: "#DFDFDF"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1408",
                                    d: "M536.596 311.735C489.829 366.932 392.109 358.56 318.234 293.086C244.273 227.612 222.246 129.834 268.984 74.7089C315.694 19.4832 413.529 27.8262 487.419 93.3436C561.308 158.774 583.32 256.567 536.596 311.735Z",
                                    fill: "#DDDCDD"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1549",
                                    d: "M535.314 308.921C489.312 364.204 392.4 356.756 318.756 292.365C245.025 227.959 222.565 131.003 268.539 75.792C314.483 20.4941 411.511 27.899 485.169 92.3338C558.827 156.696 581.273 253.681 535.314 308.921Z",
                                    fill: "#DBDADB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.169",
                                    d: "M534.041 306.12C488.804 361.476 392.7 354.966 319.287 291.643C245.788 228.319 222.895 132.158 268.103 76.8745C313.282 21.5044 409.502 27.971 482.929 91.3377C556.342 154.618 579.22 250.794 534.041 306.12Z",
                                    fill: "#D9D8D8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1831",
                                    d: "M532.755 303.307C488.282 358.735 392.987 353.164 319.805 290.908C246.536 228.653 223.211 133.3 267.639 77.93C312.054 22.4733 407.465 28.0161 480.661 90.3002C553.858 152.541 577.183 247.909 532.755 303.307Z",
                                    fill: "#D7D6D6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.1972",
                                    d: "M531.487 300.507C487.795 356.021 393.293 351.373 320.328 290.2C247.29 229.013 223.517 134.469 267.195 79.0264C310.844 23.4975 405.447 28.1021 478.412 89.3181C551.378 150.462 575.137 245.021 531.487 300.507Z",
                                    fill: "#D4D4D4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2113",
                                    d: "M530.201 297.706C487.274 353.293 393.58 349.583 320.846 289.479C248.039 229.374 223.833 135.638 266.746 80.1088C309.63 24.5078 403.425 28.1741 476.174 88.3219C548.908 148.383 573.1 242.148 530.201 297.706Z",
                                    fill: "#D2D2D2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2254",
                                    d: "M528.918 294.892C486.755 350.55 393.87 347.779 321.367 288.743C248.791 229.706 224.151 136.778 266.3 81.177C308.419 25.4894 401.405 28.2319 473.923 87.2972C546.427 146.305 571.051 239.262 528.918 294.892Z",
                                    fill: "#D0D0D0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2394",
                                    d: "M527.644 292.091C486.246 347.836 394.169 345.989 321.897 288.035C249.552 230.067 224.465 137.947 265.848 82.2736C307.203 26.5138 399.38 28.3181 471.667 86.3152C543.94 144.226 568.998 236.374 527.644 292.091Z",
                                    fill: "#CECDCE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2535",
                                    d: "M526.362 289.292C485.729 345.109 394.461 344.2 322.405 287.314C250.291 230.429 224.785 139.103 265.389 83.3573C305.978 27.5254 397.348 28.3914 469.404 85.3204C541.46 142.163 566.965 233.489 526.362 289.292Z",
                                    fill: "#CCCBCC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2676",
                                    d: "M525.092 286.476C485.225 342.365 394.765 342.394 322.94 286.591C251.057 230.774 225.104 140.27 264.957 84.4241C304.781 28.5055 395.342 28.4478 467.167 84.2942C538.993 140.083 564.917 230.6 525.092 286.476Z",
                                    fill: "#CAC9CA"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2817",
                                    d: "M523.804 283.676C484.702 339.652 395.05 340.604 323.456 285.87C251.804 231.135 225.418 141.425 264.506 85.5067C303.565 29.516 393.318 28.5201 464.912 83.2983C536.506 138.004 562.878 227.728 523.804 283.676Z",
                                    fill: "#C7C7C7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.2958",
                                    d: "M522.534 280.86C484.197 336.909 395.339 338.8 323.99 285.133C252.555 231.481 225.75 142.58 264.059 86.5889C302.353 30.5115 391.298 28.5918 462.661 82.2874C534.024 135.925 560.829 224.841 522.534 280.86Z",
                                    fill: "#C5C5C5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3099",
                                    d: "M521.253 278.061C483.681 334.181 395.632 337.01 324.514 284.426C253.324 231.828 226.072 143.735 263.615 87.6721C301.145 31.5226 389.28 28.6646 460.413 81.2921C531.545 133.847 558.783 221.955 521.253 278.061Z",
                                    fill: "#C3C3C3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3239",
                                    d: "M519.982 275.26C483.188 331.467 395.933 335.22 325.032 283.704C254.073 232.188 226.388 144.904 263.166 88.7543C299.93 32.5326 387.258 28.7364 458.159 80.2958C529.061 131.769 556.746 219.067 519.982 275.26Z",
                                    fill: "#C1C0C1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.338",
                                    d: "M518.695 272.445C482.667 328.724 396.22 333.415 325.549 282.967C254.821 232.519 226.703 146.043 262.717 89.8216C298.716 33.5133 385.235 28.7933 455.92 79.2701C526.59 129.689 554.694 216.18 518.695 272.445Z",
                                    fill: "#BFBEBF"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3521",
                                    d: "M517.43 269.645C482.167 325.997 396.528 331.626 326.088 282.261C255.577 232.881 227.026 147.213 262.274 90.905C297.508 34.5246 383.219 28.8663 453.673 78.275C524.113 127.612 552.664 213.308 517.43 269.645Z",
                                    fill: "#BCBCBD"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3662",
                                    d: "M516.143 266.844C481.645 323.282 396.814 329.836 326.606 281.538C256.325 233.241 227.341 148.367 261.824 91.9868C296.293 35.5342 381.196 28.9377 451.419 77.2782C521.628 125.547 550.612 210.42 516.143 266.844Z",
                                    fill: "#BABABB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3803",
                                    d: "M514.87 264.03C481.137 320.54 397.115 328.031 327.123 280.802C257.073 233.573 227.656 149.522 261.375 93.0551C295.064 36.5159 379.173 28.9956 449.165 76.2536C519.143 123.468 548.56 207.534 514.87 264.03Z",
                                    fill: "#B8B8B9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.3944",
                                    d: "M513.587 261.23C480.619 317.812 397.405 326.242 327.644 280.096C257.825 233.935 227.975 150.692 260.929 94.1526C293.854 37.5412 377.154 29.0827 446.915 75.2725C516.676 121.39 546.526 204.647 513.587 261.23Z",
                                    fill: "#B6B6B6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4085",
                                    d: "M512.314 258.416C480.111 315.085 397.706 324.438 328.176 279.36C258.588 234.282 228.305 151.833 260.479 95.2214C292.638 38.5378 375.13 29.1411 444.661 74.2483C514.191 119.312 544.474 201.761 512.314 258.416Z",
                                    fill: "#B4B4B4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4225",
                                    d: "M511.033 255.615C479.595 312.357 397.997 322.648 328.698 278.653C259.341 234.642 228.625 153.002 260.034 96.3039C291.429 39.5337 373.113 29.2132 442.412 73.2523C511.711 117.234 542.442 198.889 511.033 255.615Z",
                                    fill: "#B2B1B2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4366",
                                    d: "M509.762 252.815C479.089 309.629 398.3 320.858 329.231 277.931C260.106 235.003 228.942 154.171 259.6 97.3863C290.23 40.5439 371.091 29.2996 440.174 72.2561C509.227 115.155 540.391 196.002 509.762 252.815Z",
                                    fill: "#AFAFB0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4507",
                                    d: "M508.474 250C478.581 306.9 398.572 319.054 329.734 277.194C260.839 235.335 229.243 155.311 259.122 98.454C288.986 41.5251 369.039 29.3569 437.891 71.2309C506.742 113.076 538.339 193.114 508.474 250Z",
                                    fill: "#ADADAE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4648",
                                    d: "M507.188 247.2C478.059 304.172 398.858 317.264 330.252 276.487C261.588 235.696 229.558 156.48 258.672 99.5515C287.772 42.5503 367.016 29.444 435.651 70.2498C504.272 110.998 536.302 190.228 507.188 247.2Z",
                                    fill: "#ABABAC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.4789",
                                    d: "M505.926 244.399C477.562 301.458 399.17 315.474 330.794 275.765C262.361 236.056 229.898 157.635 258.247 100.634C286.582 43.5603 365.018 29.5157 433.422 69.2534C501.798 108.933 534.26 187.341 505.926 244.399Z",
                                    fill: "#A9A9AA"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.493",
                                    d: "M504.634 241.585C477.036 298.716 399.451 313.67 331.307 275.03C263.105 236.389 230.209 158.79 257.793 101.702C285.362 44.5425 362.99 29.5741 431.163 68.2292C499.308 106.855 532.218 184.469 504.634 241.585Z",
                                    fill: "#A7A7A8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.507",
                                    d: "M503.367 238.785C476.534 295.988 399.757 311.88 331.829 274.322C263.858 236.75 230.515 159.959 257.334 102.785C284.138 45.5527 360.958 29.6461 428.9 67.233C496.828 104.777 530.171 181.582 503.367 238.785Z",
                                    fill: "#A4A4A5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5211",
                                    d: "M502.083 235.971C476.014 293.26 400.046 310.076 332.349 273.587C264.609 237.097 230.833 161.1 256.887 103.853C282.926 46.5491 358.937 29.7042 426.649 66.2086C494.36 102.699 528.122 178.695 502.083 235.971Z",
                                    fill: "#A2A2A3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5352",
                                    d: "M500.816 233.17C475.513 290.532 400.353 308.286 332.887 272.879C265.378 237.457 231.169 162.269 256.457 104.95C281.732 47.5592 356.935 29.7761 424.415 65.2268C491.881 100.62 526.091 175.808 500.816 233.17Z",
                                    fill: "#A0A0A1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5493",
                                    d: "M499.528 230.369C474.99 287.803 400.639 306.495 333.404 272.156C266.125 237.802 231.483 163.437 256.007 106.031C280.516 48.5683 354.911 29.8614 422.16 64.2295C489.395 98.5399 524.038 172.92 499.528 230.369Z",
                                    fill: "#9E9E9F"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5634",
                                    d: "M498.258 227.554C474.485 285.075 400.942 304.691 333.938 271.42C266.89 238.149 231.815 164.577 255.559 107.099C279.304 49.5642 352.89 29.9191 419.908 63.2047C486.913 96.4613 522.002 170.048 498.258 227.554Z",
                                    fill: "#9C9C9D"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5775",
                                    d: "M496.978 224.755C473.984 282.348 401.235 302.902 334.448 270.714C267.631 238.511 232.123 165.747 255.102 108.198C278.082 50.5759 350.86 30.007 417.647 62.2244C484.435 94.3841 519.958 167.162 496.978 224.755Z",
                                    fill: "#999A9B"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.5915",
                                    d: "M495.704 221.955C473.475 279.62 401.535 301.113 334.978 269.992C268.393 238.857 232.437 166.902 254.665 109.266C276.88 51.5722 348.849 30.065 415.42 61.2143C481.963 92.3202 517.919 164.275 495.704 221.955Z",
                                    fill: "#979799"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6056",
                                    d: "M494.417 219.139C472.953 276.89 401.821 299.307 335.495 269.255C269.126 239.202 232.752 168.056 254.216 110.333C275.665 52.5666 346.826 30.1212 413.166 60.1879C479.478 90.2402 515.867 161.387 494.417 219.139Z",
                                    fill: "#959597"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6197",
                                    d: "M493.148 216.339C472.449 274.163 402.11 297.517 336.03 268.548C269.892 239.564 233.085 169.225 253.769 111.43C274.453 53.5773 344.806 30.2082 410.915 59.2067C476.996 88.162 513.818 158.5 493.148 216.339Z",
                                    fill: "#939394"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6338",
                                    d: "M491.861 213.525C471.927 271.421 402.397 295.714 336.533 267.812C270.626 239.911 233.386 170.366 253.305 112.499C273.21 54.574 342.769 30.2666 408.647 58.1826C474.511 86.0841 511.781 155.629 491.861 213.525Z",
                                    fill: "#919192"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6479",
                                    d: "M490.595 210.724C471.427 268.706 402.705 293.923 337.072 267.104C271.396 240.271 233.722 171.534 252.876 113.595C272.016 55.5834 340.767 30.3523 406.414 57.2001C472.047 84.0046 509.735 152.741 490.595 210.724Z",
                                    fill: "#8F8F90"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.662",
                                    d: "M489.307 207.924C470.903 265.979 402.99 292.134 337.588 266.383C272.143 240.618 234.022 172.705 252.426 114.664C270.8 56.5806 338.743 30.4112 404.159 56.1909C469.561 81.9273 507.697 149.855 489.307 207.924Z",
                                    fill: "#8C8D8E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6761",
                                    d: "M488.023 205.109C470.384 263.236 403.279 290.329 338.108 265.646C272.894 240.964 234.339 173.844 251.964 115.732C269.574 57.5757 336.708 30.468 401.893 55.1652C467.078 79.8478 505.647 146.967 488.023 205.109Z",
                                    fill: "#8A8B8C"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.6901",
                                    d: "M486.754 202.308C469.894 260.522 403.583 288.539 338.643 264.939C273.66 241.324 234.673 175.013 251.532 116.828C268.377 58.5858 334.703 30.5543 399.657 54.1833C464.597 77.769 503.599 144.095 486.754 202.308Z",
                                    fill: "#88888A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7042",
                                    d: "M485.469 199.509C469.375 257.795 403.872 286.75 339.148 264.218C274.396 241.672 234.976 176.169 251.07 117.912C267.15 59.5972 332.667 30.6275 397.391 53.1883C462.129 75.7059 501.563 141.209 485.469 199.509Z",
                                    fill: "#868688"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7183",
                                    d: "M484.195 196.694C468.866 255.052 404.171 284.946 339.679 263.482C275.157 242.018 235.304 177.323 250.619 118.98C265.934 60.593 330.643 30.6851 395.15 52.1634C459.642 73.6272 499.51 138.322 484.195 196.694Z",
                                    fill: "#848486"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7324",
                                    d: "M482.918 193.895C468.354 252.339 404.467 283.171 340.206 262.775C275.915 242.379 235.629 178.493 250.179 120.077C264.729 61.6041 328.629 30.7724 392.905 51.1825C457.167 71.5493 497.482 135.436 482.918 193.895Z",
                                    fill: "#818283"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7465",
                                    d: "M481.646 191.079C467.847 249.596 404.769 281.366 340.738 262.038C276.679 242.71 235.945 179.632 249.744 121.13C263.529 62.5845 326.622 30.8146 390.667 50.1421C454.683 69.4697 495.431 132.548 481.646 191.079Z",
                                    fill: "#7F8081"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7606",
                                    d: "M480.359 188.279C467.325 246.882 405.055 279.576 341.241 261.317C277.412 243.072 236.246 180.788 249.28 122.213C262.3 63.5953 324.584 30.8871 388.398 49.1466C452.198 67.3915 493.379 129.676 480.359 188.279Z",
                                    fill: "#7D7E7F"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7746",
                                    d: "M479.089 185.478C466.819 244.154 405.344 277.786 341.775 260.609C278.177 243.432 236.578 181.971 248.832 123.31C261.087 64.6053 322.563 30.9733 386.146 48.1646C449.729 65.3125 491.343 126.788 479.089 185.478Z",
                                    fill: "#7B7B7D"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.7887",
                                    d: "M477.803 182.663C466.299 241.411 405.631 275.981 342.294 259.872C278.927 243.778 236.894 183.111 248.384 124.377C259.874 65.6007 320.541 31.0306 383.893 47.1393C447.246 63.2335 489.293 123.901 477.803 182.663Z",
                                    fill: "#79797B"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8028",
                                    d: "M476.536 179.865C465.796 238.699 405.937 274.193 342.83 259.167C279.695 244.141 237.229 184.282 247.954 125.476C258.678 66.6132 318.537 31.1192 381.659 46.1598C444.766 61.157 487.26 121.016 476.536 179.865Z",
                                    fill: "#777779"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8169",
                                    d: "M475.251 177.063C465.292 235.97 406.226 272.402 343.35 258.444C280.446 244.486 237.547 185.435 247.507 126.543C257.466 67.6077 316.517 31.1755 379.407 45.1479C442.283 59.0915 485.211 118.128 475.251 177.063Z",
                                    fill: "#747577"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.831",
                                    d: "M473.979 174.249C464.784 233.227 406.527 270.598 343.868 257.708C281.194 244.833 237.848 186.59 247.043 127.611C256.237 68.6039 314.48 31.2335 377.139 44.1233C439.813 57.0132 483.159 115.256 473.979 174.249Z",
                                    fill: "#727375"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8451",
                                    d: "M472.697 171.449C464.267 230.514 406.819 268.808 344.39 257.001C281.947 245.194 238.168 187.76 246.598 128.709C255.027 69.6148 312.462 31.3205 374.904 43.1422C437.333 54.9351 481.127 112.369 472.697 171.449Z",
                                    fill: "#707172"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8592",
                                    d: "M471.423 168.635C463.758 227.772 407.118 267.004 344.92 256.265C282.694 245.526 238.496 188.9 246.161 129.777C253.825 70.6111 310.451 31.3786 372.663 42.1178C434.846 52.8569 479.073 109.483 471.423 168.635Z",
                                    fill: "#6E6F70"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8732",
                                    d: "M470.14 165.833C463.24 225.043 407.408 265.213 345.442 255.542C283.446 245.886 238.816 190.054 245.715 130.859C252.615 71.6201 308.432 31.4494 370.413 41.1204C432.365 50.777 477.04 106.594 470.14 165.833Z",
                                    fill: "#6C6C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.8873",
                                    d: "M468.857 163.034C462.722 222.33 407.698 263.425 345.948 254.836C284.184 246.248 239.12 191.239 245.24 131.957C251.36 72.6318 306.384 31.5373 368.134 40.1401C429.884 48.6997 474.991 103.709 468.857 163.034Z",
                                    fill: "#696A6C"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9014",
                                    d: "M467.585 160.219C462.215 219.588 408 261.621 346.481 254.1C284.947 246.58 239.436 192.379 244.805 133.011C250.16 73.6135 304.376 31.5808 365.895 39.1011C427.414 46.6213 472.94 100.837 467.585 160.219Z",
                                    fill: "#67686A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9155",
                                    d: "M466.303 157.419C461.698 216.859 408.292 259.83 347.003 253.393C285.701 246.955 239.756 193.548 244.361 134.107C248.951 74.638 302.358 31.6815 363.646 38.1192C424.934 44.5569 470.908 97.9494 466.303 157.419Z",
                                    fill: "#656668"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9296",
                                    d: "M465.03 154.604C461.191 214.131 408.578 258.026 347.535 252.656C286.463 247.287 240.086 194.688 243.925 135.175C247.75 75.6195 300.349 31.7392 361.406 37.1087C422.449 42.4783 468.855 95.0625 465.03 154.604Z",
                                    fill: "#636466"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9437",
                                    d: "M463.744 151.804C460.684 211.403 408.865 256.236 348.053 251.934C287.213 247.647 240.402 195.857 243.462 136.258C246.522 76.6296 298.313 31.8111 359.139 36.0981C419.965 40.3995 466.819 92.1754 463.744 151.804Z",
                                    fill: "#616264"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9577",
                                    d: "M462.473 149.004C460.178 208.675 409.167 254.446 348.572 251.228C287.962 248.009 240.719 197.027 243.014 137.355C245.309 77.6405 296.291 31.8982 356.886 35.117C417.496 38.3214 464.768 89.289 462.473 149.004Z",
                                    fill: "#5F5F61"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9718",
                                    d: "M461.185 146.189C459.655 205.947 409.453 252.642 349.088 250.491C288.71 248.341 241.033 198.167 242.563 138.423C244.093 78.6363 294.267 31.9557 354.646 34.092C415.01 36.2427 462.715 86.4164 461.185 146.189Z",
                                    fill: "#5C5D5F"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    opacity: "0.9859",
                                    d: "M459.922 143.389C459.157 203.219 409.762 250.853 349.629 249.77C289.481 248.702 241.357 199.322 242.122 139.492C242.887 79.6328 292.253 32.0139 352.4 33.0821C412.534 34.1647 460.687 83.53 459.922 143.389Z",
                                    fill: "#5A5B5D"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M458.634 140.588C458.634 200.49 410.048 249.062 350.146 249.062C290.229 249.062 241.672 200.505 241.672 140.588C241.672 80.6422 290.229 32.0996 350.146 32.0996C410.048 32.0852 458.634 80.6422 458.634 140.588Z",
                                    fill: "#58595B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M622.13 216.44C622.13 235.58 606.613 251.097 587.473 251.097C568.333 251.097 552.816 235.58 552.816 216.44C552.816 197.3 568.333 181.783 587.473 181.783C606.613 181.783 622.13 197.3 622.13 216.44Z",
                            fill: "url(#paint0_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M587.471 182.836C568.923 182.836 553.883 197.876 553.883 216.425C553.883 234.973 568.923 250.013 587.471 250.013C606.02 250.013 621.06 234.973 621.06 216.425C621.06 197.876 606.02 182.836 587.471 182.836Z",
                            fill: "url(#paint1_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M531.278 341.471C531.278 360.611 515.762 376.128 496.622 376.128C477.482 376.128 461.965 360.611 461.965 341.471C461.965 322.331 477.482 306.814 496.622 306.814C515.762 306.814 531.278 322.331 531.278 341.471Z",
                            fill: "url(#paint2_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M496.636 307.869C478.087 307.869 463.047 322.91 463.047 341.458C463.047 360.006 478.087 375.046 496.636 375.046C515.184 375.046 530.224 360.006 530.224 341.458C530.224 322.91 515.184 307.869 496.636 307.869Z",
                            fill: "url(#paint3_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M384.294 389.219C384.294 408.359 368.777 423.876 349.637 423.876C330.497 423.876 314.98 408.359 314.98 389.219C314.98 370.079 330.497 354.563 349.637 354.563C368.792 354.562 384.294 370.079 384.294 389.219Z",
                            fill: "url(#paint4_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.651 355.631C331.103 355.631 316.062 370.671 316.062 389.22C316.062 407.768 331.103 422.808 349.651 422.808C368.199 422.808 383.24 407.768 383.24 389.22C383.24 370.671 368.199 355.631 349.651 355.631Z",
                            fill: "url(#paint5_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M237.325 341.471C237.325 360.611 221.808 376.128 202.669 376.128C183.529 376.128 168.012 360.611 168.012 341.471C168.012 322.331 183.529 306.814 202.669 306.814C221.808 306.814 237.325 322.331 237.325 341.471Z",
                            fill: "url(#paint6_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M202.667 307.869C184.119 307.869 169.078 322.91 169.078 341.458C169.078 360.006 184.119 375.046 202.667 375.046C221.215 375.046 236.255 360.006 236.255 341.458C236.255 322.91 221.215 307.869 202.667 307.869Z",
                            fill: "url(#paint7_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M146.47 216.44C146.47 235.58 130.953 251.097 111.813 251.097C92.6731 251.097 77.1562 235.58 77.1562 216.44C77.1562 197.3 92.6731 181.783 111.813 181.783C130.967 181.783 146.47 197.3 146.47 216.44Z",
                            fill: "url(#paint8_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M111.827 182.836C93.2788 182.836 78.2383 197.876 78.2383 216.425C78.2383 234.973 93.2788 250.013 111.827 250.013C130.375 250.013 145.416 234.973 145.416 216.425C145.416 197.876 130.375 182.836 111.827 182.836Z",
                            fill: "url(#paint9_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M470.872 139.159C470.872 206.105 416.599 260.378 349.653 260.378C282.692 260.378 228.434 206.105 228.434 139.159C228.434 72.1981 282.707 17.9395 349.653 17.9395C416.599 17.9395 470.872 72.2125 470.872 139.159Z",
                            fill: "url(#paint10_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.329 21.6191C284.418 21.6191 231.805 74.2467 231.805 139.143C231.805 204.054 284.418 256.668 349.329 256.668C414.24 256.668 466.853 204.054 466.853 139.143C466.853 74.2322 414.226 21.6191 349.329 21.6191Z",
                            fill: "url(#paint11_linear)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M296.596 118.999V134.619H293.252V118.999H296.596Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M307.298 122.651C308.589 122.651 309.594 123.055 310.312 123.861C311.031 124.653 311.39 125.761 311.39 127.183V134.619H308.156V127.997C308.156 126.369 307.474 125.555 306.11 125.555C305.348 125.555 304.68 125.805 304.108 126.303C303.551 126.787 303.272 127.374 303.272 128.063V134.619H300.038V122.915H303.03L303.206 124.763C303.646 124.147 304.211 123.641 304.9 123.245C305.59 122.849 306.389 122.651 307.298 122.651Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M318.9 134.839C317.712 134.839 316.759 134.502 316.04 133.827C315.336 133.153 314.984 132.141 314.984 130.791V125.599H313.07L313.312 122.915H314.984L315.138 119.681L318.218 119.439V122.915H321.43L321.21 125.599H318.218V130.043C318.218 130.733 318.35 131.224 318.614 131.517C318.878 131.796 319.281 131.935 319.824 131.935C320.264 131.935 320.777 131.811 321.364 131.561L321.65 134.201C320.858 134.627 319.941 134.839 318.9 134.839Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M334.432 128.393C334.432 128.848 334.403 129.222 334.344 129.515H326.116C326.219 130.381 326.578 131.041 327.194 131.495C327.825 131.935 328.654 132.155 329.68 132.155C330.37 132.155 331.066 132.067 331.77 131.891C332.489 131.701 333.127 131.459 333.684 131.165L333.882 133.805C332.577 134.495 331.081 134.839 329.394 134.839C328.045 134.839 326.872 134.59 325.874 134.091C324.892 133.593 324.136 132.889 323.608 131.979C323.08 131.055 322.816 129.985 322.816 128.767C322.816 127.579 323.066 126.523 323.564 125.599C324.078 124.675 324.782 123.957 325.676 123.443C326.586 122.93 327.62 122.673 328.778 122.673C329.908 122.673 330.898 122.923 331.748 123.421C332.614 123.905 333.274 124.58 333.728 125.445C334.198 126.311 334.432 127.293 334.432 128.393ZM331.132 127.381C331.088 126.736 330.846 126.201 330.406 125.775C329.966 125.35 329.424 125.137 328.778 125.137C328.148 125.137 327.59 125.335 327.106 125.731C326.622 126.113 326.307 126.663 326.16 127.381H331.132Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M340.225 134.839C338.054 134.839 336.969 133.681 336.969 131.363V118.075L340.203 117.855V130.791C340.203 131.554 340.496 131.935 341.083 131.935C341.347 131.935 341.677 131.869 342.073 131.737L342.403 134.377C341.728 134.685 341.002 134.839 340.225 134.839Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M355.036 128.393C355.036 128.848 355.006 129.222 354.948 129.515H346.72C346.822 130.381 347.182 131.041 347.798 131.495C348.428 131.935 349.257 132.155 350.284 132.155C350.973 132.155 351.67 132.067 352.374 131.891C353.092 131.701 353.73 131.459 354.288 131.165L354.486 133.805C353.18 134.495 351.684 134.839 349.998 134.839C348.648 134.839 347.475 134.59 346.478 134.091C345.495 133.593 344.74 132.889 344.212 131.979C343.684 131.055 343.42 129.985 343.42 128.767C343.42 127.579 343.669 126.523 344.168 125.599C344.681 124.675 345.385 123.957 346.28 123.443C347.189 122.93 348.223 122.673 349.382 122.673C350.511 122.673 351.501 122.923 352.352 123.421C353.217 123.905 353.877 124.58 354.332 125.445C354.801 126.311 355.036 127.293 355.036 128.393ZM351.736 127.381C351.692 126.736 351.45 126.201 351.01 125.775C350.57 125.35 350.027 125.137 349.382 125.137C348.751 125.137 348.194 125.335 347.71 125.731C347.226 126.113 346.91 126.663 346.764 127.381H351.736Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M369.276 122.915V133.475C369.276 135.543 368.712 137.054 367.582 138.007C366.453 138.975 364.957 139.459 363.094 139.459C360.997 139.459 359.288 139.085 357.968 138.337L358.496 135.455C359.787 136.277 361.246 136.687 362.874 136.687C363.857 136.687 364.627 136.416 365.184 135.873C365.756 135.331 366.042 134.575 366.042 133.607V132.793C365.573 133.351 365.023 133.783 364.392 134.091C363.762 134.385 363.014 134.531 362.148 134.531C361.107 134.531 360.19 134.289 359.398 133.805C358.606 133.307 357.99 132.625 357.55 131.759C357.11 130.879 356.89 129.875 356.89 128.745C356.89 127.557 357.125 126.509 357.594 125.599C358.064 124.675 358.724 123.957 359.574 123.443C360.44 122.93 361.452 122.673 362.61 122.673C364.062 122.673 365.236 123.062 366.13 123.839L366.24 122.915H369.276ZM366.02 126.237C365.184 125.695 364.253 125.423 363.226 125.423C362.302 125.423 361.569 125.724 361.026 126.325C360.498 126.912 360.234 127.711 360.234 128.723C360.234 129.618 360.491 130.351 361.004 130.923C361.518 131.481 362.2 131.759 363.05 131.759C363.857 131.759 364.546 131.503 365.118 130.989C365.69 130.476 365.984 129.853 365.998 129.119L366.02 126.237Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M383.438 128.393C383.438 128.848 383.409 129.222 383.35 129.515H375.122C375.225 130.381 375.584 131.041 376.2 131.495C376.831 131.935 377.659 132.155 378.686 132.155C379.375 132.155 380.072 132.067 380.776 131.891C381.495 131.701 382.133 131.459 382.69 131.165L382.888 133.805C381.583 134.495 380.087 134.839 378.4 134.839C377.051 134.839 375.877 134.59 374.88 134.091C373.897 133.593 373.142 132.889 372.614 131.979C372.086 131.055 371.822 129.985 371.822 128.767C371.822 127.579 372.071 126.523 372.57 125.599C373.083 124.675 373.787 123.957 374.682 123.443C375.591 122.93 376.625 122.673 377.784 122.673C378.913 122.673 379.903 122.923 380.754 123.421C381.619 123.905 382.279 124.58 382.734 125.445C383.203 126.311 383.438 127.293 383.438 128.393ZM380.138 127.381C380.094 126.736 379.852 126.201 379.412 125.775C378.972 125.35 378.429 125.137 377.784 125.137C377.153 125.137 376.596 125.335 376.112 125.731C375.628 126.113 375.313 126.663 375.166 127.381H380.138Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M393.279 122.651C394.569 122.651 395.574 123.055 396.293 123.861C397.011 124.653 397.371 125.761 397.371 127.183V134.619H394.137V127.997C394.137 126.369 393.455 125.555 392.091 125.555C391.328 125.555 390.661 125.805 390.089 126.303C389.531 126.787 389.253 127.374 389.253 128.063V134.619H386.019V122.915H389.011L389.187 124.763C389.627 124.147 390.191 123.641 390.881 123.245C391.57 122.849 392.369 122.651 393.279 122.651Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M404.88 134.839C403.692 134.839 402.739 134.502 402.02 133.827C401.316 133.153 400.964 132.141 400.964 130.791V125.599H399.05L399.292 122.915H400.964L401.118 119.681L404.198 119.439V122.915H407.41L407.19 125.599H404.198V130.043C404.198 130.733 404.33 131.224 404.594 131.517C404.858 131.796 405.262 131.935 405.804 131.935C406.244 131.935 406.758 131.811 407.344 131.561L407.63 134.201C406.838 134.627 405.922 134.839 404.88 134.839Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M292.67 162.671H286.444L285.432 165.619H282.066L287.808 149.999H291.46L297.202 165.619H293.682L292.67 162.671ZM291.746 160.031L289.546 153.629L287.346 160.031H291.746Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M310.184 153.915V165.619H307.192L307.016 163.705C306.576 164.321 306.004 164.835 305.3 165.245C304.61 165.656 303.804 165.861 302.88 165.861C301.604 165.861 300.606 165.473 299.888 164.695C299.184 163.903 298.832 162.781 298.832 161.329V153.915H302.066V160.493C302.066 162.136 302.74 162.957 304.09 162.957C304.588 162.957 305.058 162.84 305.498 162.605C305.938 162.356 306.29 162.041 306.554 161.659C306.818 161.278 306.95 160.882 306.95 160.471V153.915H310.184Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M317.998 165.839C316.81 165.839 315.856 165.502 315.138 164.827C314.434 164.153 314.082 163.141 314.082 161.791V156.599H312.168L312.41 153.915H314.082L314.236 150.681L317.316 150.439V153.915H320.528L320.308 156.599H317.316V161.043C317.316 161.733 317.448 162.224 317.712 162.517C317.976 162.796 318.379 162.935 318.922 162.935C319.362 162.935 319.875 162.811 320.462 162.561L320.748 165.201C319.956 165.627 319.039 165.839 317.998 165.839Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M328.316 165.839C327.069 165.839 325.962 165.583 324.994 165.069C324.026 164.541 323.271 163.815 322.728 162.891C322.185 161.953 321.914 160.904 321.914 159.745C321.914 158.587 322.185 157.545 322.728 156.621C323.271 155.697 324.026 154.979 324.994 154.465C325.962 153.937 327.069 153.673 328.316 153.673C329.577 153.673 330.692 153.937 331.66 154.465C332.628 154.979 333.383 155.697 333.926 156.621C334.469 157.545 334.74 158.587 334.74 159.745C334.74 160.904 334.469 161.953 333.926 162.891C333.383 163.815 332.628 164.541 331.66 165.069C330.692 165.583 329.577 165.839 328.316 165.839ZM328.316 162.869C329.24 162.869 329.981 162.583 330.538 162.011C331.11 161.425 331.396 160.669 331.396 159.745C331.396 158.821 331.11 158.073 330.538 157.501C329.981 156.915 329.247 156.621 328.338 156.621C327.414 156.621 326.666 156.915 326.094 157.501C325.537 158.073 325.258 158.821 325.258 159.745C325.258 160.684 325.537 161.439 326.094 162.011C326.666 162.583 327.407 162.869 328.316 162.869Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M352.098 153.651C353.315 153.651 354.261 154.055 354.936 154.861C355.625 155.653 355.97 156.761 355.97 158.183V165.619H352.714V158.997C352.714 157.369 352.076 156.555 350.8 156.555C350.198 156.555 349.648 156.761 349.15 157.171C348.651 157.567 348.358 158.051 348.27 158.623V165.619H345.014V158.997C345.014 157.369 344.376 156.555 343.1 156.555C342.674 156.555 342.264 156.665 341.868 156.885C341.472 157.091 341.149 157.377 340.9 157.743C340.665 158.11 340.548 158.506 340.548 158.931V165.619H337.314V153.915H340.306L340.482 155.741C340.892 155.14 341.428 154.641 342.088 154.245C342.748 153.849 343.518 153.651 344.398 153.651C345.278 153.651 346.018 153.864 346.62 154.289C347.236 154.715 347.683 155.316 347.962 156.093C348.343 155.419 348.886 154.847 349.59 154.377C350.294 153.893 351.13 153.651 352.098 153.651Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M372.254 165.443C371.697 165.707 371.074 165.839 370.384 165.839C369.636 165.839 369.028 165.656 368.558 165.289C368.104 164.923 367.818 164.417 367.7 163.771C366.747 165.15 365.383 165.839 363.608 165.839C362.582 165.839 361.672 165.59 360.88 165.091C360.088 164.593 359.472 163.896 359.032 163.001C358.607 162.092 358.394 161.058 358.394 159.899C358.394 158.682 358.622 157.604 359.076 156.665C359.546 155.727 360.213 154.993 361.078 154.465C361.944 153.937 362.948 153.673 364.092 153.673C365.442 153.673 366.549 154.062 367.414 154.839L367.524 153.915H370.56V161.769C370.56 162.151 370.626 162.444 370.758 162.649C370.89 162.855 371.081 162.957 371.33 162.957C371.536 162.957 371.77 162.913 372.034 162.825L372.254 165.443ZM367.304 157.237C366.498 156.695 365.632 156.423 364.708 156.423C363.784 156.423 363.058 156.731 362.53 157.347C362.002 157.963 361.738 158.807 361.738 159.877C361.738 160.831 361.988 161.601 362.486 162.187C362.985 162.774 363.645 163.067 364.466 163.067C364.965 163.067 365.427 162.957 365.852 162.737C366.278 162.517 366.622 162.224 366.886 161.857C367.15 161.491 367.282 161.095 367.282 160.669L367.304 157.237Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M378.841 165.839C377.653 165.839 376.7 165.502 375.981 164.827C375.277 164.153 374.925 163.141 374.925 161.791V156.599H373.011L373.253 153.915H374.925L375.079 150.681L378.159 150.439V153.915H381.371L381.151 156.599H378.159V161.043C378.159 161.733 378.291 162.224 378.555 162.517C378.819 162.796 379.223 162.935 379.765 162.935C380.205 162.935 380.719 162.811 381.305 162.561L381.591 165.201C380.799 165.627 379.883 165.839 378.841 165.839Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M385.347 152.551C384.775 152.551 384.299 152.383 383.917 152.045C383.551 151.708 383.367 151.275 383.367 150.747C383.367 150.205 383.551 149.765 383.917 149.427C384.299 149.09 384.775 148.921 385.347 148.921C385.919 148.921 386.396 149.09 386.777 149.427C387.159 149.765 387.349 150.205 387.349 150.747C387.349 151.275 387.159 151.708 386.777 152.045C386.396 152.383 385.919 152.551 385.347 152.551ZM386.975 153.915V165.619H383.741V153.915H386.975Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M395.949 165.839C394.702 165.839 393.595 165.583 392.627 165.069C391.659 164.541 390.903 163.815 390.361 162.891C389.818 161.953 389.547 160.904 389.547 159.745C389.547 158.587 389.818 157.545 390.361 156.621C390.903 155.697 391.659 154.979 392.627 154.465C393.595 153.937 394.702 153.673 395.949 153.673C397.21 153.673 398.325 153.937 399.293 154.465C400.261 154.979 401.016 155.697 401.559 156.621C402.101 157.545 402.373 158.587 402.373 159.745C402.373 160.904 402.101 161.953 401.559 162.891C401.016 163.815 400.261 164.541 399.293 165.069C398.325 165.583 397.21 165.839 395.949 165.839ZM395.949 162.869C396.873 162.869 397.613 162.583 398.171 162.011C398.743 161.425 399.029 160.669 399.029 159.745C399.029 158.821 398.743 158.073 398.171 157.501C397.613 156.915 396.88 156.621 395.971 156.621C395.047 156.621 394.299 156.915 393.727 157.501C393.169 158.073 392.891 158.821 392.891 159.745C392.891 160.684 393.169 161.439 393.727 162.011C394.299 162.583 395.039 162.869 395.949 162.869Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M412.207 153.651C413.497 153.651 414.502 154.055 415.221 154.861C415.939 155.653 416.299 156.761 416.299 158.183V165.619H413.065V158.997C413.065 157.369 412.383 156.555 411.019 156.555C410.256 156.555 409.589 156.805 409.017 157.303C408.459 157.787 408.181 158.374 408.181 159.063V165.619H404.947V153.915H407.939L408.115 155.763C408.555 155.147 409.119 154.641 409.809 154.245C410.498 153.849 411.297 153.651 412.207 153.651Z",
                            fill: "#001F82"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.25166 290.288C4.35899 290.288 3.55732 290.089 2.84666 289.69C2.14466 289.291 1.59432 288.732 1.19566 288.013C0.79699 287.294 0.597656 286.475 0.597656 285.556C0.597656 284.629 0.801323 283.805 1.20866 283.086C1.62466 282.358 2.19232 281.795 2.91166 281.396C3.63099 280.997 4.43699 280.798 5.32966 280.798C6.36966 280.798 7.29699 281.002 8.11166 281.409L7.74766 283.216C7.04566 282.835 6.30032 282.644 5.51166 282.644C4.95699 282.644 4.46299 282.77 4.02966 283.021C3.59632 283.264 3.25832 283.606 3.01566 284.048C2.78166 284.481 2.66466 284.975 2.66466 285.53C2.66466 286.085 2.78166 286.583 3.01566 287.025C3.24966 287.467 3.57899 287.814 4.00366 288.065C4.43699 288.316 4.93966 288.442 5.51166 288.442C6.33499 288.442 7.12799 288.256 7.89066 287.883L8.12466 289.677C7.29266 290.084 6.33499 290.288 5.25166 290.288Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.898 290.288C12.1613 290.288 11.507 290.136 10.935 289.833C10.363 289.521 9.91666 289.092 9.59599 288.546C9.27533 287.991 9.11499 287.372 9.11499 286.687C9.11499 286.002 9.27533 285.387 9.59599 284.841C9.91666 284.295 10.363 283.87 10.935 283.567C11.507 283.255 12.1613 283.099 12.898 283.099C13.6433 283.099 14.302 283.255 14.874 283.567C15.446 283.87 15.8923 284.295 16.213 284.841C16.5337 285.387 16.694 286.002 16.694 286.687C16.694 287.372 16.5337 287.991 16.213 288.546C15.8923 289.092 15.446 289.521 14.874 289.833C14.302 290.136 13.6433 290.288 12.898 290.288ZM12.898 288.533C13.444 288.533 13.8817 288.364 14.211 288.026C14.549 287.679 14.718 287.233 14.718 286.687C14.718 286.141 14.549 285.699 14.211 285.361C13.8817 285.014 13.4483 284.841 12.911 284.841C12.365 284.841 11.923 285.014 11.585 285.361C11.2557 285.699 11.091 286.141 11.091 286.687C11.091 287.242 11.2557 287.688 11.585 288.026C11.923 288.364 12.3607 288.533 12.898 288.533Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M22.5049 283.086C23.2676 283.086 23.8612 283.324 24.2859 283.801C24.7106 284.269 24.9229 284.923 24.9229 285.764V290.158H23.0119V286.245C23.0119 285.283 22.6089 284.802 21.8029 284.802C21.3522 284.802 20.9579 284.949 20.6199 285.244C20.2906 285.53 20.1259 285.877 20.1259 286.284V290.158H18.2149V283.242H19.9829L20.0869 284.334C20.3469 283.97 20.6806 283.671 21.0879 283.437C21.4952 283.203 21.9676 283.086 22.5049 283.086Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M32.949 283.242L30.297 290.158H28.399L25.708 283.242H27.814L29.4 287.87L30.999 283.242H32.949Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M40.2016 286.479C40.2016 286.748 40.1843 286.969 40.1497 287.142H35.2876C35.3483 287.653 35.5606 288.043 35.9246 288.312C36.2973 288.572 36.787 288.702 37.3937 288.702C37.801 288.702 38.2127 288.65 38.6287 288.546C39.0533 288.433 39.4303 288.29 39.7596 288.117L39.8766 289.677C39.1053 290.084 38.2213 290.288 37.2246 290.288C36.4273 290.288 35.734 290.141 35.1446 289.846C34.564 289.551 34.1176 289.135 33.8056 288.598C33.4936 288.052 33.3377 287.419 33.3377 286.7C33.3377 285.998 33.485 285.374 33.7796 284.828C34.083 284.282 34.499 283.857 35.0276 283.554C35.565 283.251 36.176 283.099 36.8606 283.099C37.528 283.099 38.113 283.246 38.6157 283.541C39.127 283.827 39.517 284.226 39.7856 284.737C40.063 285.248 40.2016 285.829 40.2016 286.479ZM38.2516 285.881C38.2256 285.5 38.0826 285.183 37.8226 284.932C37.5626 284.681 37.242 284.555 36.8606 284.555C36.488 284.555 36.1586 284.672 35.8727 284.906C35.5867 285.131 35.4003 285.456 35.3136 285.881H38.2516Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M45.1976 283.086C45.4836 283.086 45.7739 283.138 46.0686 283.242L45.9516 284.984C45.6223 284.906 45.3449 284.867 45.1196 284.867C44.6949 284.867 44.3396 285.019 44.0536 285.322C43.7676 285.625 43.6246 286.028 43.6246 286.531V290.158H41.7266V283.242H43.4816L43.5726 284.269C43.9973 283.48 44.5389 283.086 45.1976 283.086Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M49.346 290.288C48.8347 290.288 48.3407 290.232 47.864 290.119C47.396 289.998 47.006 289.842 46.694 289.651L46.915 288.13C47.2877 288.338 47.6907 288.507 48.124 288.637C48.566 288.767 48.9777 288.832 49.359 288.832C49.6537 288.832 49.8834 288.784 50.048 288.689C50.2127 288.585 50.295 288.433 50.295 288.234C50.295 288.095 50.2517 287.983 50.165 287.896C50.0784 287.801 49.9354 287.714 49.736 287.636C49.5454 287.558 49.242 287.454 48.826 287.324C48.202 287.125 47.721 286.882 47.383 286.596C47.0537 286.301 46.889 285.864 46.889 285.283C46.889 284.841 47.006 284.455 47.24 284.126C47.474 283.788 47.799 283.528 48.215 283.346C48.631 283.164 49.1034 283.073 49.632 283.073C50.464 283.073 51.2224 283.229 51.907 283.541L51.764 285.049C51.4694 284.902 51.114 284.776 50.698 284.672C50.2907 284.568 49.9354 284.516 49.632 284.516C49.3547 284.516 49.138 284.564 48.982 284.659C48.826 284.754 48.748 284.893 48.748 285.075C48.748 285.257 48.8434 285.4 49.034 285.504C49.2247 285.599 49.593 285.725 50.139 285.881C50.8064 286.072 51.309 286.327 51.647 286.648C51.985 286.96 52.154 287.389 52.154 287.935C52.154 288.672 51.907 289.248 51.413 289.664C50.9277 290.08 50.2387 290.288 49.346 290.288Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M61.4339 290.054C61.1046 290.21 60.7362 290.288 60.3289 290.288C59.8869 290.288 59.5272 290.18 59.2499 289.963C58.9812 289.746 58.8122 289.447 58.7429 289.066C58.1796 289.881 57.3736 290.288 56.3249 290.288C55.7182 290.288 55.1809 290.141 54.7129 289.846C54.2449 289.551 53.8809 289.14 53.6209 288.611C53.3696 288.074 53.2439 287.463 53.2439 286.778C53.2439 286.059 53.3782 285.422 53.6469 284.867C53.9242 284.312 54.3186 283.879 54.8299 283.567C55.3412 283.255 55.9349 283.099 56.6109 283.099C57.4082 283.099 58.0626 283.329 58.5739 283.788L58.6389 283.242H60.4329V287.883C60.4329 288.108 60.4719 288.282 60.5499 288.403C60.6279 288.524 60.7406 288.585 60.8879 288.585C61.0092 288.585 61.1479 288.559 61.3039 288.507L61.4339 290.054ZM58.5089 285.205C58.0322 284.884 57.5209 284.724 56.9749 284.724C56.4289 284.724 55.9999 284.906 55.6879 285.27C55.3759 285.634 55.2199 286.132 55.2199 286.765C55.2199 287.328 55.3672 287.783 55.6619 288.13C55.9566 288.477 56.3466 288.65 56.8319 288.65C57.1266 288.65 57.3996 288.585 57.6509 288.455C57.9022 288.325 58.1059 288.152 58.2619 287.935C58.4179 287.718 58.4959 287.484 58.4959 287.233L58.5089 285.205Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M65.3262 290.288C64.6242 290.288 64.0608 290.089 63.6362 289.69C63.2202 289.291 63.0122 288.693 63.0122 287.896V284.828H61.8812L62.0242 283.242H63.0122L63.1032 281.331L64.9232 281.188V283.242H66.8212L66.6912 284.828H64.9232V287.454C64.9232 287.861 65.0012 288.152 65.1572 288.325C65.3132 288.49 65.5515 288.572 65.8722 288.572C66.1322 288.572 66.4355 288.498 66.7822 288.351L66.9512 289.911C66.4832 290.162 65.9415 290.288 65.3262 290.288Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M69.1707 282.436C68.8327 282.436 68.5511 282.336 68.3257 282.137C68.1091 281.938 68.0007 281.682 68.0007 281.37C68.0007 281.049 68.1091 280.789 68.3257 280.59C68.5511 280.391 68.8327 280.291 69.1707 280.291C69.5087 280.291 69.7904 280.391 70.0157 280.59C70.2411 280.789 70.3537 281.049 70.3537 281.37C70.3537 281.682 70.2411 281.938 70.0157 282.137C69.7904 282.336 69.5087 282.436 69.1707 282.436ZM70.1327 283.242V290.158H68.2217V283.242H70.1327Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M75.4351 290.288C74.6984 290.288 74.0441 290.136 73.4721 289.833C72.9001 289.521 72.4538 289.092 72.1331 288.546C71.8124 287.991 71.6521 287.372 71.6521 286.687C71.6521 286.002 71.8124 285.387 72.1331 284.841C72.4538 284.295 72.9001 283.87 73.4721 283.567C74.0441 283.255 74.6984 283.099 75.4351 283.099C76.1804 283.099 76.8391 283.255 77.4111 283.567C77.9831 283.87 78.4294 284.295 78.7501 284.841C79.0708 285.387 79.2311 286.002 79.2311 286.687C79.2311 287.372 79.0708 287.991 78.7501 288.546C78.4294 289.092 77.9831 289.521 77.4111 289.833C76.8391 290.136 76.1804 290.288 75.4351 290.288ZM75.4351 288.533C75.9811 288.533 76.4188 288.364 76.7481 288.026C77.0861 287.679 77.2551 287.233 77.2551 286.687C77.2551 286.141 77.0861 285.699 76.7481 285.361C76.4188 285.014 75.9854 284.841 75.4481 284.841C74.9021 284.841 74.4601 285.014 74.1221 285.361C73.7928 285.699 73.6281 286.141 73.6281 286.687C73.6281 287.242 73.7928 287.688 74.1221 288.026C74.4601 288.364 74.8978 288.533 75.4351 288.533Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M85.042 283.086C85.8047 283.086 86.3983 283.324 86.823 283.801C87.2477 284.269 87.46 284.923 87.46 285.764V290.158H85.549V286.245C85.549 285.283 85.146 284.802 84.34 284.802C83.8893 284.802 83.495 284.949 83.157 285.244C82.8277 285.53 82.663 285.877 82.663 286.284V290.158H80.752V283.242H82.52L82.624 284.334C82.884 283.97 83.2177 283.671 83.625 283.437C84.0323 283.203 84.5047 283.086 85.042 283.086Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M97.0823 290.054C96.753 290.21 96.3847 290.288 95.9773 290.288C95.5353 290.288 95.1757 290.18 94.8983 289.963C94.6297 289.746 94.4607 289.447 94.3913 289.066C93.828 289.881 93.022 290.288 91.9733 290.288C91.3667 290.288 90.8293 290.141 90.3613 289.846C89.8933 289.551 89.5293 289.14 89.2693 288.611C89.018 288.074 88.8923 287.463 88.8923 286.778C88.8923 286.059 89.0267 285.422 89.2953 284.867C89.5727 284.312 89.967 283.879 90.4783 283.567C90.9897 283.255 91.5833 283.099 92.2593 283.099C93.0567 283.099 93.711 283.329 94.2223 283.788L94.2873 283.242H96.0813V287.883C96.0813 288.108 96.1203 288.282 96.1983 288.403C96.2763 288.524 96.389 288.585 96.5363 288.585C96.6577 288.585 96.7963 288.559 96.9523 288.507L97.0823 290.054ZM94.1573 285.205C93.6807 284.884 93.1693 284.724 92.6233 284.724C92.0773 284.724 91.6483 284.906 91.3363 285.27C91.0243 285.634 90.8683 286.132 90.8683 286.765C90.8683 287.328 91.0157 287.783 91.3103 288.13C91.605 288.477 91.995 288.65 92.4803 288.65C92.775 288.65 93.048 288.585 93.2993 288.455C93.5507 288.325 93.7543 288.152 93.9103 287.935C94.0663 287.718 94.1443 287.484 94.1443 287.233L94.1573 285.205Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M100.208 290.288C98.9249 290.288 98.2836 289.603 98.2836 288.234V280.382L100.195 280.252V287.896C100.195 288.347 100.368 288.572 100.715 288.572C100.871 288.572 101.066 288.533 101.3 288.455L101.495 290.015C101.096 290.197 100.667 290.288 100.208 290.288Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M110.752 288.416H107.073L106.475 290.158H104.486L107.879 280.928H110.037L113.43 290.158H111.35L110.752 288.416ZM110.206 286.856L108.906 283.073L107.606 286.856H110.206Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M116.614 280.928V290.158H114.638V280.928H116.614Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.6623 412.294H11.2833V419.808H9.30734V412.294H6.90234V410.578H13.6623V412.294Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.0578 416.129C20.0578 416.398 20.0405 416.619 20.0058 416.792H15.1438C15.2045 417.304 15.4168 417.694 15.7808 417.962C16.1535 418.222 16.6432 418.352 17.2498 418.352C17.6572 418.352 18.0688 418.3 18.4848 418.196C18.9095 418.084 19.2865 417.941 19.6158 417.767L19.7328 419.327C18.9615 419.735 18.0775 419.938 17.0808 419.938C16.2835 419.938 15.5902 419.791 15.0008 419.496C14.4202 419.202 13.9738 418.786 13.6618 418.248C13.3498 417.702 13.1938 417.07 13.1938 416.35C13.1938 415.648 13.3412 415.024 13.6358 414.478C13.9392 413.932 14.3552 413.508 14.8838 413.204C15.4212 412.901 16.0322 412.749 16.7168 412.749C17.3842 412.749 17.9692 412.897 18.4718 413.191C18.9832 413.477 19.3732 413.876 19.6418 414.387C19.9192 414.899 20.0578 415.479 20.0578 416.129ZM18.1078 415.531C18.0818 415.15 17.9388 414.834 17.6788 414.582C17.4188 414.331 17.0982 414.205 16.7168 414.205C16.3442 414.205 16.0148 414.322 15.7288 414.556C15.4428 414.782 15.2565 415.107 15.1698 415.531H18.1078Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M23.8448 419.938C23.3335 419.938 22.8395 419.882 22.3628 419.769C21.8948 419.648 21.5048 419.492 21.1928 419.301L21.4138 417.78C21.7865 417.988 22.1895 418.157 22.6228 418.287C23.0648 418.417 23.4765 418.482 23.8578 418.482C24.1525 418.482 24.3821 418.435 24.5468 418.339C24.7115 418.235 24.7938 418.084 24.7938 417.884C24.7938 417.746 24.7505 417.633 24.6638 417.546C24.5771 417.451 24.4341 417.364 24.2348 417.286C24.0441 417.208 23.7408 417.104 23.3248 416.974C22.7008 416.775 22.2198 416.532 21.8818 416.246C21.5525 415.952 21.3878 415.514 21.3878 414.933C21.3878 414.491 21.5048 414.106 21.7388 413.776C21.9728 413.438 22.2978 413.178 22.7138 412.996C23.1298 412.814 23.6021 412.723 24.1308 412.723C24.9628 412.723 25.7211 412.879 26.4058 413.191L26.2628 414.699C25.9681 414.552 25.6128 414.426 25.1968 414.322C24.7895 414.218 24.4341 414.166 24.1308 414.166C23.8535 414.166 23.6368 414.214 23.4808 414.309C23.3248 414.405 23.2468 414.543 23.2468 414.725C23.2468 414.907 23.3421 415.05 23.5328 415.154C23.7235 415.25 24.0918 415.375 24.6378 415.531C25.3051 415.722 25.8078 415.978 26.1458 416.298C26.4838 416.61 26.6528 417.039 26.6528 417.585C26.6528 418.322 26.4058 418.898 25.9118 419.314C25.4265 419.73 24.7375 419.938 23.8448 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30.7478 419.938C30.0458 419.938 29.4825 419.739 29.0578 419.34C28.6418 418.942 28.4338 418.344 28.4338 417.546V414.478H27.3028L27.4458 412.892H28.4338L28.5248 410.981L30.3448 410.838V412.892H32.2428L32.1128 414.478H30.3448V417.104C30.3448 417.512 30.4228 417.802 30.5788 417.975C30.7348 418.14 30.9731 418.222 31.2938 418.222C31.5538 418.222 31.8571 418.149 32.2038 418.001L32.3728 419.561C31.9048 419.813 31.3631 419.938 30.7478 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M40.7006 419.938C39.808 419.938 39.0063 419.739 38.2956 419.34C37.5936 418.942 37.0433 418.383 36.6446 417.663C36.246 416.944 36.0466 416.125 36.0466 415.206C36.0466 414.279 36.2503 413.456 36.6576 412.736C37.0736 412.008 37.6413 411.445 38.3606 411.046C39.0799 410.648 39.886 410.448 40.7786 410.448C41.8186 410.448 42.7459 410.652 43.5606 411.059L43.1966 412.866C42.4946 412.485 41.7493 412.294 40.9606 412.294C40.4059 412.294 39.912 412.42 39.4786 412.671C39.0453 412.914 38.7073 413.256 38.4646 413.698C38.2306 414.132 38.1136 414.626 38.1136 415.18C38.1136 415.735 38.2306 416.233 38.4646 416.675C38.6986 417.117 39.028 417.464 39.4526 417.715C39.886 417.967 40.3886 418.092 40.9606 418.092C41.784 418.092 42.577 417.906 43.3396 417.533L43.5736 419.327C42.7416 419.735 41.784 419.938 40.7006 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M47.1956 419.938C45.913 419.938 45.2716 419.254 45.2716 417.884V410.032L47.1826 409.902V417.546C47.1826 417.997 47.356 418.222 47.7026 418.222C47.8586 418.222 48.0536 418.183 48.2876 418.105L48.4826 419.665C48.084 419.847 47.655 419.938 47.1956 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M57.2735 419.704C56.9441 419.86 56.5758 419.938 56.1685 419.938C55.7265 419.938 55.3668 419.83 55.0895 419.613C54.8208 419.397 54.6518 419.098 54.5825 418.716C54.0191 419.531 53.2132 419.938 52.1645 419.938C51.5578 419.938 51.0205 419.791 50.5525 419.496C50.0845 419.202 49.7205 418.79 49.4605 418.261C49.2091 417.724 49.0835 417.113 49.0835 416.428C49.0835 415.709 49.2178 415.072 49.4865 414.517C49.7638 413.963 50.1581 413.529 50.6695 413.217C51.1808 412.905 51.7745 412.749 52.4505 412.749C53.2478 412.749 53.9022 412.979 54.4135 413.438L54.4785 412.892H56.2725V417.533C56.2725 417.759 56.3115 417.932 56.3895 418.053C56.4675 418.175 56.5802 418.235 56.7275 418.235C56.8488 418.235 56.9875 418.209 57.1435 418.157L57.2735 419.704ZM54.3485 414.855C53.8718 414.535 53.3605 414.374 52.8145 414.374C52.2685 414.374 51.8395 414.556 51.5275 414.92C51.2155 415.284 51.0595 415.783 51.0595 416.415C51.0595 416.979 51.2068 417.434 51.5015 417.78C51.7962 418.127 52.1862 418.3 52.6715 418.3C52.9662 418.3 53.2392 418.235 53.4905 418.105C53.7418 417.975 53.9455 417.802 54.1015 417.585C54.2575 417.369 54.3355 417.135 54.3355 416.883L54.3485 414.855Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M60.7628 419.938C60.2514 419.938 59.7574 419.882 59.2808 419.769C58.8128 419.648 58.4228 419.492 58.1108 419.301L58.3318 417.78C58.7044 417.988 59.1074 418.157 59.5408 418.287C59.9828 418.417 60.3944 418.482 60.7758 418.482C61.0704 418.482 61.3001 418.435 61.4648 418.339C61.6294 418.235 61.7118 418.084 61.7118 417.884C61.7118 417.746 61.6684 417.633 61.5818 417.546C61.4951 417.451 61.3521 417.364 61.1528 417.286C60.9621 417.208 60.6588 417.104 60.2428 416.974C59.6188 416.775 59.1378 416.532 58.7998 416.246C58.4704 415.952 58.3058 415.514 58.3058 414.933C58.3058 414.491 58.4228 414.106 58.6568 413.776C58.8908 413.438 59.2158 413.178 59.6318 412.996C60.0478 412.814 60.5201 412.723 61.0488 412.723C61.8808 412.723 62.6391 412.879 63.3238 413.191L63.1808 414.699C62.8861 414.552 62.5308 414.426 62.1148 414.322C61.7074 414.218 61.3521 414.166 61.0488 414.166C60.7714 414.166 60.5548 414.214 60.3988 414.309C60.2428 414.405 60.1648 414.543 60.1648 414.725C60.1648 414.907 60.2601 415.05 60.4508 415.154C60.6414 415.25 61.0098 415.375 61.5558 415.531C62.2231 415.722 62.7258 415.978 63.0638 416.298C63.4018 416.61 63.5708 417.039 63.5708 417.585C63.5708 418.322 63.3238 418.898 62.8298 419.314C62.3444 419.73 61.6554 419.938 60.7628 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M67.3516 419.938C66.8403 419.938 66.3463 419.882 65.8696 419.769C65.4016 419.648 65.0116 419.492 64.6996 419.301L64.9206 417.78C65.2933 417.988 65.6963 418.157 66.1296 418.287C66.5716 418.417 66.9833 418.482 67.3646 418.482C67.6593 418.482 67.889 418.435 68.0536 418.339C68.2183 418.235 68.3006 418.084 68.3006 417.884C68.3006 417.746 68.2573 417.633 68.1706 417.546C68.084 417.451 67.941 417.364 67.7416 417.286C67.551 417.208 67.2476 417.104 66.8316 416.974C66.2076 416.775 65.7266 416.532 65.3886 416.246C65.0593 415.952 64.8946 415.514 64.8946 414.933C64.8946 414.491 65.0116 414.106 65.2456 413.776C65.4796 413.438 65.8046 413.178 66.2206 412.996C66.6366 412.814 67.109 412.723 67.6376 412.723C68.4696 412.723 69.228 412.879 69.9126 413.191L69.7696 414.699C69.475 414.552 69.1196 414.426 68.7036 414.322C68.2963 414.218 67.941 414.166 67.6376 414.166C67.3603 414.166 67.1436 414.214 66.9876 414.309C66.8316 414.405 66.7536 414.543 66.7536 414.725C66.7536 414.907 66.849 415.05 67.0396 415.154C67.2303 415.25 67.5986 415.375 68.1446 415.531C68.812 415.722 69.3146 415.978 69.6526 416.298C69.9906 416.61 70.1596 417.039 70.1596 417.585C70.1596 418.322 69.9126 418.898 69.4186 419.314C68.9333 419.73 68.2443 419.938 67.3516 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M72.6275 412.086C72.2895 412.086 72.0078 411.987 71.7825 411.787C71.5658 411.588 71.4575 411.332 71.4575 411.02C71.4575 410.7 71.5658 410.44 71.7825 410.24C72.0078 410.041 72.2895 409.941 72.6275 409.941C72.9655 409.941 73.2472 410.041 73.4725 410.24C73.6978 410.44 73.8105 410.7 73.8105 411.02C73.8105 411.332 73.6978 411.588 73.4725 411.787C73.2472 411.987 72.9655 412.086 72.6275 412.086ZM73.5895 412.892V419.808H71.6785V412.892H73.5895Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M74.7709 414.478L74.9139 412.892H75.9409V412.528C75.9409 411.653 76.1662 410.999 76.6169 410.565C77.0762 410.123 77.6742 409.902 78.4109 409.902C78.7142 409.902 78.9959 409.928 79.2559 409.98C79.5159 410.024 79.7239 410.08 79.8799 410.149L79.5809 411.657C79.4769 411.614 79.3469 411.579 79.1909 411.553C79.0435 411.519 78.9049 411.501 78.7749 411.501C78.4715 411.501 78.2419 411.597 78.0859 411.787C77.9385 411.969 77.8649 412.268 77.8649 412.684V412.892H79.4509L79.3209 414.478H77.8649V419.808H75.9409V414.478H74.7709Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M81.692 412.086C81.354 412.086 81.0723 411.987 80.847 411.787C80.6303 411.588 80.5219 411.332 80.5219 411.02C80.5219 410.7 80.6303 410.44 80.847 410.24C81.0723 410.041 81.354 409.941 81.692 409.941C82.03 409.941 82.3116 410.041 82.537 410.24C82.7623 410.44 82.875 410.7 82.875 411.02C82.875 411.332 82.7623 411.588 82.537 411.787C82.3116 411.987 82.03 412.086 81.692 412.086ZM82.654 412.892V419.808H80.743V412.892H82.654Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M87.6703 419.938C86.9857 419.938 86.379 419.795 85.8503 419.509C85.3217 419.215 84.91 418.799 84.6153 418.261C84.3207 417.715 84.1733 417.074 84.1733 416.337C84.1733 415.609 84.3293 414.977 84.6413 414.439C84.962 413.902 85.3953 413.495 85.9413 413.217C86.496 412.931 87.1243 412.788 87.8263 412.788C88.2077 412.788 88.576 412.832 88.9313 412.918C89.2953 412.996 89.5987 413.105 89.8413 413.243L89.5553 414.79C89.0527 414.53 88.5283 414.4 87.9823 414.4C87.419 414.4 86.9683 414.574 86.6303 414.92C86.301 415.267 86.1363 415.735 86.1363 416.324C86.1363 416.922 86.3053 417.403 86.6433 417.767C86.9813 418.131 87.4277 418.313 87.9823 418.313C88.2857 418.313 88.5847 418.279 88.8793 418.209C89.1827 418.131 89.46 418.027 89.7113 417.897L89.8543 419.47C89.5943 419.609 89.2693 419.722 88.8793 419.808C88.4893 419.895 88.0863 419.938 87.6703 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M99.1426 419.704C98.8133 419.86 98.445 419.938 98.0376 419.938C97.5956 419.938 97.236 419.83 96.9586 419.613C96.69 419.397 96.521 419.098 96.4516 418.716C95.8883 419.531 95.0823 419.938 94.0336 419.938C93.427 419.938 92.8896 419.791 92.4216 419.496C91.9536 419.202 91.5896 418.79 91.3296 418.261C91.0783 417.724 90.9526 417.113 90.9526 416.428C90.9526 415.709 91.087 415.072 91.3556 414.517C91.633 413.963 92.0273 413.529 92.5386 413.217C93.05 412.905 93.6436 412.749 94.3196 412.749C95.117 412.749 95.7713 412.979 96.2826 413.438L96.3476 412.892H98.1416V417.533C98.1416 417.759 98.1806 417.932 98.2586 418.053C98.3366 418.175 98.4493 418.235 98.5966 418.235C98.718 418.235 98.8566 418.209 99.0126 418.157L99.1426 419.704ZM96.2176 414.855C95.741 414.535 95.2296 414.374 94.6836 414.374C94.1376 414.374 93.7086 414.556 93.3966 414.92C93.0846 415.284 92.9286 415.783 92.9286 416.415C92.9286 416.979 93.076 417.434 93.3706 417.78C93.6653 418.127 94.0553 418.3 94.5406 418.3C94.8353 418.3 95.1083 418.235 95.3596 418.105C95.611 417.975 95.8146 417.802 95.9706 417.585C96.1266 417.369 96.2046 417.135 96.2046 416.883L96.2176 414.855Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M103.035 419.938C102.333 419.938 101.77 419.739 101.345 419.34C100.929 418.942 100.721 418.344 100.721 417.546V414.478H99.5899L99.7329 412.892H100.721L100.812 410.981L102.632 410.838V412.892H104.53L104.4 414.478H102.632V417.104C102.632 417.512 102.71 417.802 102.866 417.975C103.022 418.14 103.26 418.222 103.581 418.222C103.841 418.222 104.144 418.149 104.491 418.001L104.66 419.561C104.192 419.813 103.65 419.938 103.035 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M106.879 412.086C106.541 412.086 106.26 411.987 106.034 411.787C105.818 411.588 105.709 411.332 105.709 411.02C105.709 410.7 105.818 410.44 106.034 410.24C106.26 410.041 106.541 409.941 106.879 409.941C107.217 409.941 107.499 410.041 107.724 410.24C107.95 410.44 108.062 410.7 108.062 411.02C108.062 411.332 107.95 411.588 107.724 411.787C107.499 411.987 107.217 412.086 106.879 412.086ZM107.841 412.892V419.808H105.93V412.892H107.841Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M113.144 419.938C112.407 419.938 111.753 419.787 111.181 419.483C110.609 419.171 110.162 418.742 109.842 418.196C109.521 417.642 109.361 417.022 109.361 416.337C109.361 415.653 109.521 415.037 109.842 414.491C110.162 413.945 110.609 413.521 111.181 413.217C111.753 412.905 112.407 412.749 113.144 412.749C113.889 412.749 114.548 412.905 115.12 413.217C115.692 413.521 116.138 413.945 116.459 414.491C116.779 415.037 116.94 415.653 116.94 416.337C116.94 417.022 116.779 417.642 116.459 418.196C116.138 418.742 115.692 419.171 115.12 419.483C114.548 419.787 113.889 419.938 113.144 419.938ZM113.144 418.183C113.69 418.183 114.127 418.014 114.457 417.676C114.795 417.33 114.964 416.883 114.964 416.337C114.964 415.791 114.795 415.349 114.457 415.011C114.127 414.665 113.694 414.491 113.157 414.491C112.611 414.491 112.169 414.665 111.831 415.011C111.501 415.349 111.337 415.791 111.337 416.337C111.337 416.892 111.501 417.338 111.831 417.676C112.169 418.014 112.606 418.183 113.144 418.183Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M122.751 412.736C123.513 412.736 124.107 412.975 124.532 413.451C124.956 413.919 125.169 414.574 125.169 415.414V419.808H123.258V415.895C123.258 414.933 122.855 414.452 122.049 414.452C121.598 414.452 121.204 414.6 120.866 414.894C120.536 415.18 120.372 415.527 120.372 415.934V419.808H118.461V412.892H120.229L120.333 413.984C120.593 413.62 120.926 413.321 121.334 413.087C121.741 412.853 122.213 412.736 122.751 412.736Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M136.037 419.808L135.27 419.002C134.378 419.626 133.403 419.938 132.345 419.938C131.721 419.938 131.167 419.834 130.681 419.626C130.205 419.418 129.832 419.124 129.563 418.742C129.295 418.352 129.16 417.893 129.16 417.364C129.16 416.827 129.312 416.359 129.615 415.96C129.927 415.562 130.452 415.159 131.188 414.751C130.85 414.379 130.595 414.028 130.421 413.698C130.248 413.369 130.161 413.018 130.161 412.645C130.161 412.255 130.265 411.891 130.473 411.553C130.681 411.215 130.989 410.947 131.396 410.747C131.804 410.539 132.289 410.435 132.852 410.435C133.372 410.435 133.84 410.535 134.256 410.734C134.672 410.934 134.993 411.202 135.218 411.54C135.452 411.87 135.569 412.221 135.569 412.593C135.569 413.053 135.426 413.486 135.14 413.893C134.854 414.292 134.382 414.682 133.723 415.063L135.296 416.662C135.73 416.064 136.072 415.349 136.323 414.517L138.091 414.881C137.736 416.034 137.203 417.031 136.492 417.871L138.403 419.808H136.037ZM132.865 411.878C132.571 411.878 132.341 411.961 132.176 412.125C132.012 412.281 131.929 412.472 131.929 412.697C131.929 412.897 131.986 413.092 132.098 413.282C132.211 413.464 132.402 413.698 132.67 413.984C133.121 413.733 133.42 413.508 133.567 413.308C133.723 413.1 133.801 412.884 133.801 412.658C133.801 412.45 133.715 412.268 133.541 412.112C133.368 411.956 133.143 411.878 132.865 411.878ZM132.566 418.287C133.104 418.287 133.624 418.131 134.126 417.819L132.254 415.869C131.838 416.129 131.552 416.363 131.396 416.571C131.249 416.771 131.175 416.987 131.175 417.221C131.175 417.559 131.301 417.824 131.552 418.014C131.804 418.196 132.142 418.287 132.566 418.287Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M147.737 418.066H144.058L143.46 419.808H141.471L144.864 410.578H147.022L150.415 419.808H148.335L147.737 418.066ZM147.191 416.506L145.891 412.723L144.591 416.506H147.191Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M155.835 412.736C156.597 412.736 157.191 412.975 157.616 413.451C158.04 413.919 158.253 414.574 158.253 415.414V419.808H156.342V415.895C156.342 414.933 155.939 414.452 155.133 414.452C154.682 414.452 154.288 414.6 153.95 414.894C153.62 415.18 153.456 415.527 153.456 415.934V419.808H151.545V412.892H153.313L153.417 413.984C153.677 413.62 154.01 413.321 154.418 413.087C154.825 412.853 155.297 412.736 155.835 412.736Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M167.875 419.704C167.546 419.86 167.177 419.938 166.77 419.938C166.328 419.938 165.968 419.83 165.691 419.613C165.422 419.397 165.253 419.098 165.184 418.716C164.621 419.531 163.815 419.938 162.766 419.938C162.159 419.938 161.622 419.791 161.154 419.496C160.686 419.202 160.322 418.79 160.062 418.261C159.811 417.724 159.685 417.113 159.685 416.428C159.685 415.709 159.819 415.072 160.088 414.517C160.365 413.963 160.76 413.529 161.271 413.217C161.782 412.905 162.376 412.749 163.052 412.749C163.849 412.749 164.504 412.979 165.015 413.438L165.08 412.892H166.874V417.533C166.874 417.759 166.913 417.932 166.991 418.053C167.069 418.175 167.182 418.235 167.329 418.235C167.45 418.235 167.589 418.209 167.745 418.157L167.875 419.704ZM164.95 414.855C164.473 414.535 163.962 414.374 163.416 414.374C162.87 414.374 162.441 414.556 162.129 414.92C161.817 415.284 161.661 415.783 161.661 416.415C161.661 416.979 161.808 417.434 162.103 417.78C162.398 418.127 162.788 418.3 163.273 418.3C163.568 418.3 163.841 418.235 164.092 418.105C164.343 417.975 164.547 417.802 164.703 417.585C164.859 417.369 164.937 417.135 164.937 416.883L164.95 414.855Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M171 419.938C169.718 419.938 169.076 419.254 169.076 417.884V410.032L170.987 409.902V417.546C170.987 417.997 171.161 418.222 171.507 418.222C171.663 418.222 171.858 418.183 172.092 418.105L172.287 419.665C171.889 419.847 171.46 419.938 171 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M179.583 412.892L176.645 420.575C176.377 421.277 176.03 421.802 175.605 422.148C175.181 422.495 174.622 422.668 173.928 422.668C173.469 422.668 173.057 422.595 172.693 422.447L172.914 420.848C173.122 420.918 173.339 420.952 173.564 420.952C173.876 420.952 174.141 420.883 174.357 420.744C174.574 420.606 174.747 420.372 174.877 420.042L175.098 419.509L172.355 412.892H174.448L176.086 417.364L177.607 412.892H179.583Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M183.231 419.938C182.529 419.938 181.966 419.739 181.541 419.34C181.125 418.942 180.917 418.344 180.917 417.546V414.478H179.786L179.929 412.892H180.917L181.008 410.981L182.828 410.838V412.892H184.726L184.596 414.478H182.828V417.104C182.828 417.512 182.906 417.802 183.062 417.975C183.218 418.14 183.457 418.222 183.777 418.222C184.037 418.222 184.341 418.149 184.687 418.001L184.856 419.561C184.388 419.813 183.847 419.938 183.231 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M187.076 412.086C186.738 412.086 186.456 411.987 186.231 411.787C186.014 411.588 185.906 411.332 185.906 411.02C185.906 410.7 186.014 410.44 186.231 410.24C186.456 410.041 186.738 409.941 187.076 409.941C187.414 409.941 187.695 410.041 187.921 410.24C188.146 410.44 188.259 410.7 188.259 411.02C188.259 411.332 188.146 411.588 187.921 411.787C187.695 411.987 187.414 412.086 187.076 412.086ZM188.038 412.892V419.808H186.127V412.892H188.038Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M193.054 419.938C192.369 419.938 191.763 419.795 191.234 419.509C190.705 419.215 190.294 418.799 189.999 418.261C189.704 417.715 189.557 417.074 189.557 416.337C189.557 415.609 189.713 414.977 190.025 414.439C190.346 413.902 190.779 413.495 191.325 413.217C191.88 412.931 192.508 412.788 193.21 412.788C193.591 412.788 193.96 412.832 194.315 412.918C194.679 412.996 194.982 413.105 195.225 413.243L194.939 414.79C194.436 414.53 193.912 414.4 193.366 414.4C192.803 414.4 192.352 414.574 192.014 414.92C191.685 415.267 191.52 415.735 191.52 416.324C191.52 416.922 191.689 417.403 192.027 417.767C192.365 418.131 192.811 418.313 193.366 418.313C193.669 418.313 193.968 418.279 194.263 418.209C194.566 418.131 194.844 418.027 195.095 417.897L195.238 419.47C194.978 419.609 194.653 419.722 194.263 419.808C193.873 419.895 193.47 419.938 193.054 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M199.027 419.938C198.516 419.938 198.022 419.882 197.545 419.769C197.077 419.648 196.687 419.492 196.375 419.301L196.596 417.78C196.969 417.988 197.372 418.157 197.805 418.287C198.247 418.417 198.659 418.482 199.04 418.482C199.335 418.482 199.565 418.435 199.729 418.339C199.894 418.235 199.976 418.084 199.976 417.884C199.976 417.746 199.933 417.633 199.846 417.546C199.76 417.451 199.617 417.364 199.417 417.286C199.227 417.208 198.923 417.104 198.507 416.974C197.883 416.775 197.402 416.532 197.064 416.246C196.735 415.952 196.57 415.514 196.57 414.933C196.57 414.491 196.687 414.106 196.921 413.776C197.155 413.438 197.48 413.178 197.896 412.996C198.312 412.814 198.785 412.723 199.313 412.723C200.145 412.723 200.904 412.879 201.588 413.191L201.445 414.699C201.151 414.552 200.795 414.426 200.379 414.322C199.972 414.218 199.617 414.166 199.313 414.166C199.036 414.166 198.819 414.214 198.663 414.309C198.507 414.405 198.429 414.543 198.429 414.725C198.429 414.907 198.525 415.05 198.715 415.154C198.906 415.25 199.274 415.375 199.82 415.531C200.488 415.722 200.99 415.978 201.328 416.298C201.666 416.61 201.835 417.039 201.835 417.585C201.835 418.322 201.588 418.898 201.094 419.314C200.609 419.73 199.92 419.938 199.027 419.938Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M267.059 469.326H263.38L262.782 471.068H260.793L264.186 461.838H266.344L269.737 471.068H267.657L267.059 469.326ZM266.513 467.766L265.213 463.983L263.913 467.766H266.513Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M275.157 463.996C275.92 463.996 276.513 464.234 276.938 464.711C277.363 465.179 277.575 465.833 277.575 466.674V471.068H275.664V467.155C275.664 466.193 275.261 465.712 274.455 465.712C274.004 465.712 273.61 465.859 273.272 466.154C272.943 466.44 272.778 466.787 272.778 467.194V471.068H270.867V464.152H272.635L272.739 465.244C272.999 464.88 273.333 464.581 273.74 464.347C274.147 464.113 274.62 463.996 275.157 463.996Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M282.79 471.198C282.054 471.198 281.399 471.046 280.827 470.743C280.255 470.431 279.809 470.002 279.488 469.456C279.168 468.901 279.007 468.282 279.007 467.597C279.007 466.912 279.168 466.297 279.488 465.751C279.809 465.205 280.255 464.78 280.827 464.477C281.399 464.165 282.054 464.009 282.79 464.009C283.536 464.009 284.194 464.165 284.766 464.477C285.338 464.78 285.785 465.205 286.105 465.751C286.426 466.297 286.586 466.912 286.586 467.597C286.586 468.282 286.426 468.901 286.105 469.456C285.785 470.002 285.338 470.431 284.766 470.743C284.194 471.046 283.536 471.198 282.79 471.198ZM282.79 469.443C283.336 469.443 283.774 469.274 284.103 468.936C284.441 468.589 284.61 468.143 284.61 467.597C284.61 467.051 284.441 466.609 284.103 466.271C283.774 465.924 283.341 465.751 282.803 465.751C282.257 465.751 281.815 465.924 281.477 466.271C281.148 466.609 280.983 467.051 280.983 467.597C280.983 468.152 281.148 468.598 281.477 468.936C281.815 469.274 282.253 469.443 282.79 469.443Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M296.843 463.996C297.562 463.996 298.121 464.234 298.52 464.711C298.927 465.179 299.131 465.833 299.131 466.674V471.068H297.207V467.155C297.207 466.193 296.83 465.712 296.076 465.712C295.721 465.712 295.396 465.833 295.101 466.076C294.806 466.31 294.633 466.596 294.581 466.934V471.068H292.657V467.155C292.657 466.193 292.28 465.712 291.526 465.712C291.275 465.712 291.032 465.777 290.798 465.907C290.564 466.028 290.373 466.197 290.226 466.414C290.087 466.631 290.018 466.865 290.018 467.116V471.068H288.107V464.152H289.875L289.979 465.231C290.222 464.876 290.538 464.581 290.928 464.347C291.318 464.113 291.773 463.996 292.293 463.996C292.813 463.996 293.251 464.122 293.606 464.373C293.97 464.624 294.234 464.98 294.399 465.439C294.624 465.04 294.945 464.702 295.361 464.425C295.777 464.139 296.271 463.996 296.843 463.996Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M308.754 470.964C308.424 471.12 308.056 471.198 307.649 471.198C307.207 471.198 306.847 471.09 306.57 470.873C306.301 470.656 306.132 470.357 306.063 469.976C305.499 470.791 304.693 471.198 303.645 471.198C303.038 471.198 302.501 471.051 302.033 470.756C301.565 470.461 301.201 470.05 300.941 469.521C300.689 468.984 300.564 468.373 300.564 467.688C300.564 466.969 300.698 466.332 300.967 465.777C301.244 465.222 301.638 464.789 302.15 464.477C302.661 464.165 303.255 464.009 303.931 464.009C304.728 464.009 305.382 464.239 305.894 464.698L305.959 464.152H307.753V468.793C307.753 469.018 307.792 469.192 307.87 469.313C307.948 469.434 308.06 469.495 308.208 469.495C308.329 469.495 308.468 469.469 308.624 469.417L308.754 470.964ZM305.829 466.115C305.352 465.794 304.841 465.634 304.295 465.634C303.749 465.634 303.32 465.816 303.008 466.18C302.696 466.544 302.54 467.042 302.54 467.675C302.54 468.238 302.687 468.693 302.982 469.04C303.276 469.387 303.666 469.56 304.152 469.56C304.446 469.56 304.719 469.495 304.971 469.365C305.222 469.235 305.426 469.062 305.582 468.845C305.738 468.628 305.816 468.394 305.816 468.143L305.829 466.115Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M311.879 471.198C310.596 471.198 309.955 470.513 309.955 469.144V461.292L311.866 461.162V468.806C311.866 469.257 312.039 469.482 312.386 469.482C312.542 469.482 312.737 469.443 312.971 469.365L313.166 470.925C312.767 471.107 312.338 471.198 311.879 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M320.462 464.152L317.524 471.835C317.255 472.537 316.909 473.061 316.484 473.408C316.059 473.755 315.5 473.928 314.807 473.928C314.348 473.928 313.936 473.854 313.572 473.707L313.793 472.108C314.001 472.177 314.218 472.212 314.443 472.212C314.755 472.212 315.019 472.143 315.236 472.004C315.453 471.865 315.626 471.631 315.756 471.302L315.977 470.769L313.234 464.152H315.327L316.965 468.624L318.486 464.152H320.462Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M327.865 461.838C328.784 461.838 329.594 462.029 330.296 462.41C331.007 462.783 331.557 463.316 331.947 464.009C332.337 464.694 332.532 465.491 332.532 466.401C332.532 467.32 332.337 468.134 331.947 468.845C331.557 469.547 331.007 470.093 330.296 470.483C329.586 470.873 328.775 471.068 327.865 471.068H324.303V461.838H327.865ZM327.566 469.326C328.459 469.326 329.165 469.07 329.685 468.559C330.205 468.048 330.465 467.337 330.465 466.427C330.465 465.526 330.205 464.824 329.685 464.321C329.174 463.818 328.472 463.567 327.579 463.567H326.279V469.326H327.566Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M340.537 467.389C340.537 467.658 340.52 467.879 340.485 468.052H335.623C335.684 468.563 335.896 468.953 336.26 469.222C336.633 469.482 337.123 469.612 337.729 469.612C338.137 469.612 338.548 469.56 338.964 469.456C339.389 469.343 339.766 469.2 340.095 469.027L340.212 470.587C339.441 470.994 338.557 471.198 337.56 471.198C336.763 471.198 336.07 471.051 335.48 470.756C334.9 470.461 334.453 470.045 334.141 469.508C333.829 468.962 333.673 468.329 333.673 467.61C333.673 466.908 333.821 466.284 334.115 465.738C334.419 465.192 334.835 464.767 335.363 464.464C335.901 464.161 336.512 464.009 337.196 464.009C337.864 464.009 338.449 464.156 338.951 464.451C339.463 464.737 339.853 465.136 340.121 465.647C340.399 466.158 340.537 466.739 340.537 467.389ZM338.587 466.791C338.561 466.41 338.418 466.093 338.158 465.842C337.898 465.591 337.578 465.465 337.196 465.465C336.824 465.465 336.494 465.582 336.208 465.816C335.922 466.041 335.736 466.366 335.649 466.791H338.587Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M344.638 471.198C343.936 471.198 343.373 470.999 342.948 470.6C342.532 470.201 342.324 469.603 342.324 468.806V465.738H341.193L341.336 464.152H342.324L342.415 462.241L344.235 462.098V464.152H346.133L346.003 465.738H344.235V468.364C344.235 468.771 344.313 469.062 344.469 469.235C344.625 469.4 344.864 469.482 345.184 469.482C345.444 469.482 345.748 469.408 346.094 469.261L346.263 470.821C345.795 471.072 345.254 471.198 344.638 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M353.816 467.389C353.816 467.658 353.799 467.879 353.765 468.052H348.902C348.963 468.563 349.175 468.953 349.539 469.222C349.912 469.482 350.402 469.612 351.008 469.612C351.416 469.612 351.827 469.56 352.243 469.456C352.668 469.343 353.045 469.2 353.374 469.027L353.492 470.587C352.72 470.994 351.836 471.198 350.84 471.198C350.042 471.198 349.349 471.051 348.759 470.756C348.179 470.461 347.732 470.045 347.421 469.508C347.109 468.962 346.952 468.329 346.952 467.61C346.952 466.908 347.1 466.284 347.395 465.738C347.698 465.192 348.114 464.767 348.643 464.464C349.18 464.161 349.791 464.009 350.476 464.009C351.143 464.009 351.728 464.156 352.23 464.451C352.742 464.737 353.132 465.136 353.4 465.647C353.678 466.158 353.816 466.739 353.816 467.389ZM351.867 466.791C351.84 466.41 351.698 466.093 351.438 465.842C351.177 465.591 350.857 465.465 350.476 465.465C350.103 465.465 349.774 465.582 349.488 465.816C349.201 466.041 349.015 466.366 348.928 466.791H351.867Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M358.409 471.198C357.725 471.198 357.118 471.055 356.589 470.769C356.061 470.474 355.649 470.058 355.354 469.521C355.06 468.975 354.912 468.334 354.912 467.597C354.912 466.869 355.068 466.236 355.38 465.699C355.701 465.162 356.134 464.754 356.68 464.477C357.235 464.191 357.863 464.048 358.565 464.048C358.947 464.048 359.315 464.091 359.67 464.178C360.034 464.256 360.338 464.364 360.58 464.503L360.294 466.05C359.792 465.79 359.267 465.66 358.721 465.66C358.158 465.66 357.707 465.833 357.369 466.18C357.04 466.527 356.875 466.995 356.875 467.584C356.875 468.182 357.044 468.663 357.382 469.027C357.72 469.391 358.167 469.573 358.721 469.573C359.025 469.573 359.324 469.538 359.618 469.469C359.922 469.391 360.199 469.287 360.45 469.157L360.593 470.73C360.333 470.869 360.008 470.981 359.618 471.068C359.228 471.155 358.825 471.198 358.409 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M364.963 471.198C364.261 471.198 363.698 470.999 363.273 470.6C362.857 470.201 362.649 469.603 362.649 468.806V465.738H361.518L361.661 464.152H362.649L362.74 462.241L364.56 462.098V464.152H366.458L366.328 465.738H364.56V468.364C364.56 468.771 364.638 469.062 364.794 469.235C364.95 469.4 365.189 469.482 365.509 469.482C365.769 469.482 366.073 469.408 366.419 469.261L366.588 470.821C366.12 471.072 365.579 471.198 364.963 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M368.808 463.346C368.47 463.346 368.188 463.246 367.963 463.047C367.746 462.848 367.638 462.592 367.638 462.28C367.638 461.959 367.746 461.699 367.963 461.5C368.188 461.301 368.47 461.201 368.808 461.201C369.146 461.201 369.428 461.301 369.653 461.5C369.878 461.699 369.991 461.959 369.991 462.28C369.991 462.592 369.878 462.848 369.653 463.047C369.428 463.246 369.146 463.346 368.808 463.346ZM369.77 464.152V471.068H367.859V464.152H369.77Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M375.072 471.198C374.336 471.198 373.681 471.046 373.109 470.743C372.537 470.431 372.091 470.002 371.77 469.456C371.45 468.901 371.289 468.282 371.289 467.597C371.289 466.912 371.45 466.297 371.77 465.751C372.091 465.205 372.537 464.78 373.109 464.477C373.681 464.165 374.336 464.009 375.072 464.009C375.818 464.009 376.476 464.165 377.048 464.477C377.62 464.78 378.067 465.205 378.387 465.751C378.708 466.297 378.868 466.912 378.868 467.597C378.868 468.282 378.708 468.901 378.387 469.456C378.067 470.002 377.62 470.431 377.048 470.743C376.476 471.046 375.818 471.198 375.072 471.198ZM375.072 469.443C375.618 469.443 376.056 469.274 376.385 468.936C376.723 468.589 376.892 468.143 376.892 467.597C376.892 467.051 376.723 466.609 376.385 466.271C376.056 465.924 375.623 465.751 375.085 465.751C374.539 465.751 374.097 465.924 373.759 466.271C373.43 466.609 373.265 467.051 373.265 467.597C373.265 468.152 373.43 468.598 373.759 468.936C374.097 469.274 374.535 469.443 375.072 469.443Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M384.679 463.996C385.442 463.996 386.036 464.234 386.46 464.711C386.885 465.179 387.097 465.833 387.097 466.674V471.068H385.186V467.155C385.186 466.193 384.783 465.712 383.977 465.712C383.527 465.712 383.132 465.859 382.794 466.154C382.465 466.44 382.3 466.787 382.3 467.194V471.068H380.389V464.152H382.157L382.261 465.244C382.521 464.88 382.855 464.581 383.262 464.347C383.67 464.113 384.142 463.996 384.679 463.996Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M394.521 471.198C393.308 471.198 392.268 470.968 391.401 470.509L391.726 468.702C392.107 468.927 392.536 469.109 393.013 469.248C393.49 469.378 393.975 469.443 394.469 469.443C395.336 469.443 395.769 469.14 395.769 468.533C395.769 468.334 395.713 468.169 395.6 468.039C395.487 467.9 395.318 467.779 395.093 467.675C394.868 467.562 394.512 467.411 394.027 467.22C393.221 466.917 392.614 466.553 392.207 466.128C391.808 465.703 391.609 465.131 391.609 464.412C391.609 463.563 391.904 462.9 392.493 462.423C393.082 461.946 393.858 461.708 394.82 461.708C395.297 461.708 395.773 461.764 396.25 461.877C396.727 461.981 397.134 462.115 397.472 462.28L397.225 464.009C396.896 463.853 396.501 463.719 396.042 463.606C395.591 463.485 395.201 463.424 394.872 463.424C394.482 463.424 394.183 463.498 393.975 463.645C393.767 463.792 393.663 464 393.663 464.269C393.663 464.52 393.797 464.737 394.066 464.919C394.335 465.092 394.807 465.305 395.483 465.556C395.994 465.747 396.415 465.946 396.744 466.154C397.082 466.362 397.346 466.639 397.537 466.986C397.736 467.324 397.836 467.749 397.836 468.26C397.836 469.187 397.537 469.911 396.939 470.431C396.35 470.942 395.544 471.198 394.521 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M405.842 467.389C405.842 467.658 405.825 467.879 405.79 468.052H400.928C400.989 468.563 401.201 468.953 401.565 469.222C401.938 469.482 402.427 469.612 403.034 469.612C403.441 469.612 403.853 469.56 404.269 469.456C404.694 469.343 405.071 469.2 405.4 469.027L405.517 470.587C404.746 470.994 403.862 471.198 402.865 471.198C402.068 471.198 401.374 471.051 400.785 470.756C400.204 470.461 399.758 470.045 399.446 469.508C399.134 468.962 398.978 468.329 398.978 467.61C398.978 466.908 399.125 466.284 399.42 465.738C399.723 465.192 400.139 464.767 400.668 464.464C401.205 464.161 401.816 464.009 402.501 464.009C403.168 464.009 403.753 464.156 404.256 464.451C404.767 464.737 405.157 465.136 405.426 465.647C405.703 466.158 405.842 466.739 405.842 467.389ZM403.892 466.791C403.866 466.41 403.723 466.093 403.463 465.842C403.203 465.591 402.882 465.465 402.501 465.465C402.128 465.465 401.799 465.582 401.513 465.816C401.227 466.041 401.041 466.366 400.954 466.791H403.892Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M410.838 463.996C411.124 463.996 411.414 464.048 411.709 464.152L411.592 465.894C411.263 465.816 410.985 465.777 410.76 465.777C410.335 465.777 409.98 465.929 409.694 466.232C409.408 466.535 409.265 466.938 409.265 467.441V471.068H407.367V464.152H409.122L409.213 465.179C409.638 464.39 410.179 463.996 410.838 463.996Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M419.435 464.152L416.783 471.068H414.885L412.194 464.152H414.3L415.886 468.78L417.485 464.152H419.435Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M421.379 463.346C421.041 463.346 420.76 463.246 420.534 463.047C420.318 462.848 420.209 462.592 420.209 462.28C420.209 461.959 420.318 461.699 420.534 461.5C420.76 461.301 421.041 461.201 421.379 461.201C421.717 461.201 421.999 461.301 422.224 461.5C422.45 461.699 422.562 461.959 422.562 462.28C422.562 462.592 422.45 462.848 422.224 463.047C421.999 463.246 421.717 463.346 421.379 463.346ZM422.341 464.152V471.068H420.43V464.152H422.341Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M427.358 471.198C426.673 471.198 426.066 471.055 425.538 470.769C425.009 470.474 424.597 470.058 424.303 469.521C424.008 468.975 423.861 468.334 423.861 467.597C423.861 466.869 424.017 466.236 424.329 465.699C424.649 465.162 425.083 464.754 425.629 464.477C426.183 464.191 426.812 464.048 427.514 464.048C427.895 464.048 428.263 464.091 428.619 464.178C428.983 464.256 429.286 464.364 429.529 464.503L429.243 466.05C428.74 465.79 428.216 465.66 427.67 465.66C427.106 465.66 426.656 465.833 426.318 466.18C425.988 466.527 425.824 466.995 425.824 467.584C425.824 468.182 425.993 468.663 426.331 469.027C426.669 469.391 427.115 469.573 427.67 469.573C427.973 469.573 428.272 469.538 428.567 469.469C428.87 469.391 429.147 469.287 429.399 469.157L429.542 470.73C429.282 470.869 428.957 470.981 428.567 471.068C428.177 471.155 427.774 471.198 427.358 471.198Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M437.314 467.389C437.314 467.658 437.296 467.879 437.262 468.052H432.4C432.46 468.563 432.673 468.953 433.037 469.222C433.409 469.482 433.899 469.612 434.506 469.612C434.913 469.612 435.325 469.56 435.741 469.456C436.165 469.343 436.542 469.2 436.872 469.027L436.989 470.587C436.217 470.994 435.333 471.198 434.337 471.198C433.539 471.198 432.846 471.051 432.257 470.756C431.676 470.461 431.23 470.045 430.918 469.508C430.606 468.962 430.45 468.329 430.45 467.61C430.45 466.908 430.597 466.284 430.892 465.738C431.195 465.192 431.611 464.767 432.14 464.464C432.677 464.161 433.288 464.009 433.973 464.009C434.64 464.009 435.225 464.156 435.728 464.451C436.239 464.737 436.629 465.136 436.898 465.647C437.175 466.158 437.314 466.739 437.314 467.389ZM435.364 466.791C435.338 466.41 435.195 466.093 434.935 465.842C434.675 465.591 434.354 465.465 433.973 465.465C433.6 465.465 433.271 465.582 432.985 465.816C432.699 466.041 432.512 466.366 432.426 466.791H435.364Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M592.087 280.928C593.006 280.928 593.816 281.119 594.518 281.5C595.229 281.873 595.779 282.406 596.169 283.099C596.559 283.784 596.754 284.581 596.754 285.491C596.754 286.41 596.559 287.224 596.169 287.935C595.779 288.637 595.229 289.183 594.518 289.573C593.808 289.963 592.997 290.158 592.087 290.158H588.525V280.928H592.087ZM591.788 288.416C592.681 288.416 593.387 288.16 593.907 287.649C594.427 287.138 594.687 286.427 594.687 285.517C594.687 284.616 594.427 283.914 593.907 283.411C593.396 282.908 592.694 282.657 591.801 282.657H590.501V288.416H591.788Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M601.678 290.288C600.942 290.288 600.287 290.136 599.715 289.833C599.143 289.521 598.697 289.092 598.376 288.546C598.056 287.991 597.895 287.372 597.895 286.687C597.895 286.002 598.056 285.387 598.376 284.841C598.697 284.295 599.143 283.87 599.715 283.567C600.287 283.255 600.942 283.099 601.678 283.099C602.424 283.099 603.082 283.255 603.654 283.567C604.226 283.87 604.673 284.295 604.993 284.841C605.314 285.387 605.474 286.002 605.474 286.687C605.474 287.372 605.314 287.991 604.993 288.546C604.673 289.092 604.226 289.521 603.654 289.833C603.082 290.136 602.424 290.288 601.678 290.288ZM601.678 288.533C602.224 288.533 602.662 288.364 602.991 288.026C603.329 287.679 603.498 287.233 603.498 286.687C603.498 286.141 603.329 285.699 602.991 285.361C602.662 285.014 602.229 284.841 601.691 284.841C601.145 284.841 600.703 285.014 600.365 285.361C600.036 285.699 599.871 286.141 599.871 286.687C599.871 287.242 600.036 287.688 600.365 288.026C600.703 288.364 601.141 288.533 601.678 288.533Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M610.063 290.288C609.379 290.288 608.772 290.145 608.243 289.859C607.715 289.564 607.303 289.148 607.008 288.611C606.714 288.065 606.566 287.424 606.566 286.687C606.566 285.959 606.722 285.326 607.034 284.789C607.355 284.252 607.788 283.844 608.334 283.567C608.889 283.281 609.517 283.138 610.219 283.138C610.601 283.138 610.969 283.181 611.324 283.268C611.688 283.346 611.992 283.454 612.234 283.593L611.948 285.14C611.446 284.88 610.921 284.75 610.375 284.75C609.812 284.75 609.361 284.923 609.023 285.27C608.694 285.617 608.529 286.085 608.529 286.674C608.529 287.272 608.698 287.753 609.036 288.117C609.374 288.481 609.821 288.663 610.375 288.663C610.679 288.663 610.978 288.628 611.272 288.559C611.576 288.481 611.853 288.377 612.104 288.247L612.247 289.82C611.987 289.959 611.662 290.071 611.272 290.158C610.882 290.245 610.479 290.288 610.063 290.288Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M620.392 283.242V290.158H618.624L618.52 289.027C618.26 289.391 617.922 289.694 617.506 289.937C617.098 290.18 616.622 290.301 616.076 290.301C615.322 290.301 614.732 290.071 614.308 289.612C613.892 289.144 613.684 288.481 613.684 287.623V283.242H615.595V287.129C615.595 288.1 615.993 288.585 616.791 288.585C617.085 288.585 617.363 288.516 617.623 288.377C617.883 288.23 618.091 288.043 618.247 287.818C618.403 287.593 618.481 287.359 618.481 287.116V283.242H620.392Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M631.08 283.086C631.799 283.086 632.358 283.324 632.757 283.801C633.164 284.269 633.368 284.923 633.368 285.764V290.158H631.444V286.245C631.444 285.283 631.067 284.802 630.313 284.802C629.958 284.802 629.633 284.923 629.338 285.166C629.043 285.4 628.87 285.686 628.818 286.024V290.158H626.894V286.245C626.894 285.283 626.517 284.802 625.763 284.802C625.512 284.802 625.269 284.867 625.035 284.997C624.801 285.118 624.61 285.287 624.463 285.504C624.324 285.721 624.255 285.955 624.255 286.206V290.158H622.344V283.242H624.112L624.216 284.321C624.459 283.966 624.775 283.671 625.165 283.437C625.555 283.203 626.01 283.086 626.53 283.086C627.05 283.086 627.488 283.212 627.843 283.463C628.207 283.714 628.471 284.07 628.636 284.529C628.861 284.13 629.182 283.792 629.598 283.515C630.014 283.229 630.508 283.086 631.08 283.086Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M641.665 286.479C641.665 286.748 641.647 286.969 641.613 287.142H636.751C636.811 287.653 637.024 288.043 637.388 288.312C637.76 288.572 638.25 288.702 638.857 288.702C639.264 288.702 639.676 288.65 640.092 288.546C640.516 288.433 640.893 288.29 641.223 288.117L641.34 289.677C640.568 290.084 639.684 290.288 638.688 290.288C637.89 290.288 637.197 290.141 636.608 289.846C636.027 289.551 635.581 289.135 635.269 288.598C634.957 288.052 634.801 287.419 634.801 286.7C634.801 285.998 634.948 285.374 635.243 284.828C635.546 284.282 635.962 283.857 636.491 283.554C637.028 283.251 637.639 283.099 638.324 283.099C638.991 283.099 639.576 283.246 640.079 283.541C640.59 283.827 640.98 284.226 641.249 284.737C641.526 285.248 641.665 285.829 641.665 286.479ZM639.715 285.881C639.689 285.5 639.546 285.183 639.286 284.932C639.026 284.681 638.705 284.555 638.324 284.555C637.951 284.555 637.622 284.672 637.336 284.906C637.05 285.131 636.863 285.456 636.777 285.881H639.715Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M647.48 283.086C648.242 283.086 648.836 283.324 649.261 283.801C649.685 284.269 649.898 284.923 649.898 285.764V290.158H647.987V286.245C647.987 285.283 647.584 284.802 646.778 284.802C646.327 284.802 645.933 284.949 645.595 285.244C645.265 285.53 645.101 285.877 645.101 286.284V290.158H643.19V283.242H644.958L645.062 284.334C645.322 283.97 645.655 283.671 646.063 283.437C646.47 283.203 646.942 283.086 647.48 283.086Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M654.335 290.288C653.633 290.288 653.07 290.089 652.645 289.69C652.229 289.291 652.021 288.693 652.021 287.896V284.828H650.89L651.033 283.242H652.021L652.112 281.331L653.932 281.188V283.242H655.83L655.7 284.828H653.932V287.454C653.932 287.861 654.01 288.152 654.166 288.325C654.322 288.49 654.56 288.572 654.881 288.572C655.141 288.572 655.444 288.498 655.791 288.351L655.96 289.911C655.492 290.162 654.95 290.288 654.335 290.288Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M663.651 280.928C664.57 280.928 665.38 281.119 666.082 281.5C666.793 281.873 667.343 282.406 667.733 283.099C668.123 283.784 668.318 284.581 668.318 285.491C668.318 286.41 668.123 287.224 667.733 287.935C667.343 288.637 666.793 289.183 666.082 289.573C665.371 289.963 664.561 290.158 663.651 290.158H660.089V280.928H663.651ZM663.352 288.416C664.245 288.416 664.951 288.16 665.471 287.649C665.991 287.138 666.251 286.427 666.251 285.517C666.251 284.616 665.991 283.914 665.471 283.411C664.96 282.908 664.258 282.657 663.365 282.657H662.065V288.416H663.352Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M670.837 282.436C670.499 282.436 670.217 282.336 669.992 282.137C669.775 281.938 669.667 281.682 669.667 281.37C669.667 281.049 669.775 280.789 669.992 280.59C670.217 280.391 670.499 280.291 670.837 280.291C671.175 280.291 671.456 280.391 671.682 280.59C671.907 280.789 672.02 281.049 672.02 281.37C672.02 281.682 671.907 281.938 671.682 282.137C671.456 282.336 671.175 282.436 670.837 282.436ZM671.799 283.242V290.158H669.888V283.242H671.799Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M680.637 283.242V289.482C680.637 290.704 680.304 291.597 679.636 292.16C678.969 292.732 678.085 293.018 676.984 293.018C675.745 293.018 674.735 292.797 673.955 292.355L674.267 290.652C675.03 291.137 675.892 291.38 676.854 291.38C677.435 291.38 677.89 291.22 678.219 290.899C678.557 290.578 678.726 290.132 678.726 289.56V289.079C678.449 289.408 678.124 289.664 677.751 289.846C677.379 290.019 676.937 290.106 676.425 290.106C675.81 290.106 675.268 289.963 674.8 289.677C674.332 289.382 673.968 288.979 673.708 288.468C673.448 287.948 673.318 287.354 673.318 286.687C673.318 285.985 673.457 285.365 673.734 284.828C674.012 284.282 674.402 283.857 674.904 283.554C675.416 283.251 676.014 283.099 676.698 283.099C677.556 283.099 678.25 283.329 678.778 283.788L678.843 283.242H680.637ZM678.713 285.205C678.219 284.884 677.669 284.724 677.062 284.724C676.516 284.724 676.083 284.902 675.762 285.257C675.45 285.604 675.294 286.076 675.294 286.674C675.294 287.203 675.446 287.636 675.749 287.974C676.053 288.303 676.456 288.468 676.958 288.468C677.435 288.468 677.842 288.316 678.18 288.013C678.518 287.71 678.692 287.341 678.7 286.908L678.713 285.205Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M683.519 282.436C683.181 282.436 682.9 282.336 682.674 282.137C682.458 281.938 682.349 281.682 682.349 281.37C682.349 281.049 682.458 280.789 682.674 280.59C682.9 280.391 683.181 280.291 683.519 280.291C683.857 280.291 684.139 280.391 684.364 280.59C684.59 280.789 684.702 281.049 684.702 281.37C684.702 281.682 684.59 281.938 684.364 282.137C684.139 282.336 683.857 282.436 683.519 282.436ZM684.481 283.242V290.158H682.57V283.242H684.481Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M689.095 290.288C688.393 290.288 687.829 290.089 687.405 289.69C686.989 289.291 686.781 288.693 686.781 287.896V284.828H685.65L685.793 283.242H686.781L686.872 281.331L688.692 281.188V283.242H690.59L690.46 284.828H688.692V287.454C688.692 287.861 688.77 288.152 688.926 288.325C689.082 288.49 689.32 288.572 689.641 288.572C689.901 288.572 690.204 288.498 690.551 288.351L690.72 289.911C690.252 290.162 689.71 290.288 689.095 290.288Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M692.939 282.436C692.601 282.436 692.32 282.336 692.094 282.137C691.878 281.938 691.769 281.682 691.769 281.37C691.769 281.049 691.878 280.789 692.094 280.59C692.32 280.391 692.601 280.291 692.939 280.291C693.277 280.291 693.559 280.391 693.784 280.59C694.01 280.789 694.122 281.049 694.122 281.37C694.122 281.682 694.01 281.938 693.784 282.137C693.559 282.336 693.277 282.436 692.939 282.436ZM693.901 283.242V290.158H691.99V283.242H693.901Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M698.424 284.828H695.473V283.242H701.102V284.503L698.06 288.572H701.245V290.158H695.356V288.91L698.424 284.828Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M710.339 290.054C710.01 290.21 709.642 290.288 709.234 290.288C708.792 290.288 708.433 290.18 708.155 289.963C707.887 289.746 707.718 289.447 707.648 289.066C707.085 289.881 706.279 290.288 705.23 290.288C704.624 290.288 704.086 290.141 703.618 289.846C703.15 289.551 702.786 289.14 702.526 288.611C702.275 288.074 702.149 287.463 702.149 286.778C702.149 286.059 702.284 285.422 702.552 284.867C702.83 284.312 703.224 283.879 703.735 283.567C704.247 283.255 704.84 283.099 705.516 283.099C706.314 283.099 706.968 283.329 707.479 283.788L707.544 283.242H709.338V287.883C709.338 288.108 709.377 288.282 709.455 288.403C709.533 288.524 709.646 288.585 709.793 288.585C709.915 288.585 710.053 288.559 710.209 288.507L710.339 290.054ZM707.414 285.205C706.938 284.884 706.426 284.724 705.88 284.724C705.334 284.724 704.905 284.906 704.593 285.27C704.281 285.634 704.125 286.132 704.125 286.765C704.125 287.328 704.273 287.783 704.567 288.13C704.862 288.477 705.252 288.65 705.737 288.65C706.032 288.65 706.305 288.585 706.556 288.455C706.808 288.325 707.011 288.152 707.167 287.935C707.323 287.718 707.401 287.484 707.401 287.233L707.414 285.205Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M714.232 290.288C713.53 290.288 712.966 290.089 712.542 289.69C712.126 289.291 711.918 288.693 711.918 287.896V284.828H710.787L710.93 283.242H711.918L712.009 281.331L713.829 281.188V283.242H715.727L715.597 284.828H713.829V287.454C713.829 287.861 713.907 288.152 714.063 288.325C714.219 288.49 714.457 288.572 714.778 288.572C715.038 288.572 715.341 288.498 715.688 288.351L715.857 289.911C715.389 290.162 714.847 290.288 714.232 290.288Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M718.076 282.436C717.738 282.436 717.456 282.336 717.231 282.137C717.014 281.938 716.906 281.682 716.906 281.37C716.906 281.049 717.014 280.789 717.231 280.59C717.456 280.391 717.738 280.291 718.076 280.291C718.414 280.291 718.696 280.391 718.921 280.59C719.146 280.789 719.259 281.049 719.259 281.37C719.259 281.682 719.146 281.938 718.921 282.137C718.696 282.336 718.414 282.436 718.076 282.436ZM719.038 283.242V290.158H717.127V283.242H719.038Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M724.34 290.288C723.604 290.288 722.949 290.136 722.377 289.833C721.805 289.521 721.359 289.092 721.038 288.546C720.718 287.991 720.557 287.372 720.557 286.687C720.557 286.002 720.718 285.387 721.038 284.841C721.359 284.295 721.805 283.87 722.377 283.567C722.949 283.255 723.604 283.099 724.34 283.099C725.086 283.099 725.744 283.255 726.316 283.567C726.888 283.87 727.335 284.295 727.655 284.841C727.976 285.387 728.136 286.002 728.136 286.687C728.136 287.372 727.976 287.991 727.655 288.546C727.335 289.092 726.888 289.521 726.316 289.833C725.744 290.136 725.086 290.288 724.34 290.288ZM724.34 288.533C724.886 288.533 725.324 288.364 725.653 288.026C725.991 287.679 726.16 287.233 726.16 286.687C726.16 286.141 725.991 285.699 725.653 285.361C725.324 285.014 724.891 284.841 724.353 284.841C723.807 284.841 723.365 285.014 723.027 285.361C722.698 285.699 722.533 286.141 722.533 286.687C722.533 287.242 722.698 287.688 723.027 288.026C723.365 288.364 723.803 288.533 724.34 288.533Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M733.947 283.086C734.71 283.086 735.304 283.324 735.728 283.801C736.153 284.269 736.365 284.923 736.365 285.764V290.158H734.454V286.245C734.454 285.283 734.051 284.802 733.245 284.802C732.795 284.802 732.4 284.949 732.062 285.244C731.733 285.53 731.568 285.877 731.568 286.284V290.158H729.657V283.242H731.425L731.529 284.334C731.789 283.97 732.123 283.671 732.53 283.437C732.938 283.203 733.41 283.086 733.947 283.086Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M499.665 410.578V419.808H497.689V410.578H499.665Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M510.435 412.736C511.155 412.736 511.714 412.975 512.112 413.451C512.52 413.919 512.723 414.574 512.723 415.414V419.808H510.799V415.895C510.799 414.933 510.422 414.452 509.668 414.452C509.313 414.452 508.988 414.574 508.693 414.816C508.399 415.05 508.225 415.336 508.173 415.674V419.808H506.249V415.895C506.249 414.933 505.872 414.452 505.118 414.452C504.867 414.452 504.624 414.517 504.39 414.647C504.156 414.769 503.966 414.938 503.818 415.154C503.68 415.371 503.61 415.605 503.61 415.856V419.808H501.699V412.892H503.467L503.571 413.971C503.814 413.616 504.13 413.321 504.52 413.087C504.91 412.853 505.365 412.736 505.885 412.736C506.405 412.736 506.843 412.862 507.198 413.113C507.562 413.365 507.827 413.72 507.991 414.179C508.217 413.781 508.537 413.443 508.953 413.165C509.369 412.879 509.863 412.736 510.435 412.736Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M522.346 419.704C522.017 419.86 521.648 419.938 521.241 419.938C520.799 419.938 520.439 419.83 520.162 419.613C519.893 419.397 519.724 419.098 519.655 418.716C519.092 419.531 518.286 419.938 517.237 419.938C516.63 419.938 516.093 419.791 515.625 419.496C515.157 419.202 514.793 418.79 514.533 418.261C514.282 417.724 514.156 417.113 514.156 416.428C514.156 415.709 514.29 415.072 514.559 414.517C514.836 413.963 515.231 413.529 515.742 413.217C516.253 412.905 516.847 412.749 517.523 412.749C518.32 412.749 518.975 412.979 519.486 413.438L519.551 412.892H521.345V417.533C521.345 417.759 521.384 417.932 521.462 418.053C521.54 418.175 521.653 418.235 521.8 418.235C521.921 418.235 522.06 418.209 522.216 418.157L522.346 419.704ZM519.421 414.855C518.944 414.535 518.433 414.374 517.887 414.374C517.341 414.374 516.912 414.556 516.6 414.92C516.288 415.284 516.132 415.783 516.132 416.415C516.132 416.979 516.279 417.434 516.574 417.78C516.869 418.127 517.259 418.3 517.744 418.3C518.039 418.3 518.312 418.235 518.563 418.105C518.814 417.975 519.018 417.802 519.174 417.585C519.33 417.369 519.408 417.135 519.408 416.883L519.421 414.855Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M530.413 412.892V419.132C530.413 420.354 530.079 421.247 529.412 421.81C528.744 422.382 527.86 422.668 526.76 422.668C525.52 422.668 524.511 422.447 523.731 422.005L524.043 420.302C524.805 420.788 525.668 421.03 526.63 421.03C527.21 421.03 527.665 420.87 527.995 420.549C528.333 420.229 528.502 419.782 528.502 419.21V418.729C528.224 419.059 527.899 419.314 527.527 419.496C527.154 419.67 526.712 419.756 526.201 419.756C525.585 419.756 525.044 419.613 524.576 419.327C524.108 419.033 523.744 418.63 523.484 418.118C523.224 417.598 523.094 417.005 523.094 416.337C523.094 415.635 523.232 415.016 523.51 414.478C523.787 413.932 524.177 413.508 524.68 413.204C525.191 412.901 525.789 412.749 526.474 412.749C527.332 412.749 528.025 412.979 528.554 413.438L528.619 412.892H530.413ZM528.489 414.855C527.995 414.535 527.444 414.374 526.838 414.374C526.292 414.374 525.858 414.552 525.538 414.907C525.226 415.254 525.07 415.726 525.07 416.324C525.07 416.853 525.221 417.286 525.525 417.624C525.828 417.954 526.231 418.118 526.734 418.118C527.21 418.118 527.618 417.967 527.956 417.663C528.294 417.36 528.467 416.992 528.476 416.558L528.489 414.855Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M538.781 416.129C538.781 416.398 538.763 416.619 538.729 416.792H533.867C533.927 417.304 534.14 417.694 534.504 417.962C534.876 418.222 535.366 418.352 535.973 418.352C536.38 418.352 536.792 418.3 537.208 418.196C537.632 418.084 538.009 417.941 538.339 417.767L538.456 419.327C537.684 419.735 536.8 419.938 535.804 419.938C535.006 419.938 534.313 419.791 533.724 419.496C533.143 419.202 532.697 418.786 532.385 418.248C532.073 417.702 531.917 417.07 531.917 416.35C531.917 415.648 532.064 415.024 532.359 414.478C532.662 413.932 533.078 413.508 533.607 413.204C534.144 412.901 534.755 412.749 535.44 412.749C536.107 412.749 536.692 412.897 537.195 413.191C537.706 413.477 538.096 413.876 538.365 414.387C538.642 414.899 538.781 415.479 538.781 416.129ZM536.831 415.531C536.805 415.15 536.662 414.834 536.402 414.582C536.142 414.331 535.821 414.205 535.44 414.205C535.067 414.205 534.738 414.322 534.452 414.556C534.166 414.782 533.979 415.107 533.893 415.531H536.831Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M550.847 419.704C550.518 419.86 550.149 419.938 549.742 419.938C549.3 419.938 548.94 419.83 548.663 419.613C548.394 419.397 548.225 419.098 548.156 418.716C547.593 419.531 546.787 419.938 545.738 419.938C545.131 419.938 544.594 419.791 544.126 419.496C543.658 419.202 543.294 418.79 543.034 418.261C542.783 417.724 542.657 417.113 542.657 416.428C542.657 415.709 542.791 415.072 543.06 414.517C543.337 413.963 543.732 413.529 544.243 413.217C544.754 412.905 545.348 412.749 546.024 412.749C546.821 412.749 547.476 412.979 547.987 413.438L548.052 412.892H549.846V417.533C549.846 417.759 549.885 417.932 549.963 418.053C550.041 418.175 550.154 418.235 550.301 418.235C550.422 418.235 550.561 418.209 550.717 418.157L550.847 419.704ZM547.922 414.855C547.445 414.535 546.934 414.374 546.388 414.374C545.842 414.374 545.413 414.556 545.101 414.92C544.789 415.284 544.633 415.783 544.633 416.415C544.633 416.979 544.78 417.434 545.075 417.78C545.37 418.127 545.76 418.3 546.245 418.3C546.54 418.3 546.813 418.235 547.064 418.105C547.315 417.975 547.519 417.802 547.675 417.585C547.831 417.369 547.909 417.135 547.909 416.883L547.922 414.855Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M556.364 412.736C557.127 412.736 557.721 412.975 558.145 413.451C558.57 413.919 558.782 414.574 558.782 415.414V419.808H556.871V415.895C556.871 414.933 556.468 414.452 555.662 414.452C555.212 414.452 554.817 414.6 554.479 414.894C554.15 415.18 553.985 415.527 553.985 415.934V419.808H552.074V412.892H553.842L553.946 413.984C554.206 413.62 554.54 413.321 554.947 413.087C555.355 412.853 555.827 412.736 556.364 412.736Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M567.534 409.902V419.808H565.74L565.675 418.924C565.397 419.254 565.068 419.505 564.687 419.678C564.305 419.852 563.85 419.938 563.322 419.938C562.706 419.938 562.165 419.791 561.697 419.496C561.229 419.202 560.865 418.79 560.605 418.261C560.345 417.724 560.215 417.113 560.215 416.428C560.215 415.709 560.353 415.072 560.631 414.517C560.908 413.963 561.298 413.529 561.801 413.217C562.312 412.905 562.91 412.749 563.595 412.749C564.392 412.749 565.042 412.944 565.545 413.334V410.032L567.534 409.902ZM563.855 418.3C564.34 418.3 564.747 418.157 565.077 417.871C565.415 417.577 565.588 417.2 565.597 416.74L565.61 414.855C565.116 414.535 564.565 414.374 563.959 414.374C563.413 414.374 562.979 414.561 562.659 414.933C562.347 415.297 562.191 415.791 562.191 416.415C562.191 416.979 562.342 417.434 562.646 417.78C562.949 418.127 563.352 418.3 563.855 418.3Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M579.982 410.578L576.68 419.808H574.535L571.233 410.578H573.365L575.627 417.52L577.876 410.578H579.982Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M581.854 412.086C581.516 412.086 581.235 411.987 581.009 411.787C580.793 411.588 580.684 411.332 580.684 411.02C580.684 410.7 580.793 410.44 581.009 410.24C581.235 410.041 581.516 409.941 581.854 409.941C582.192 409.941 582.474 410.041 582.699 410.24C582.925 410.44 583.037 410.7 583.037 411.02C583.037 411.332 582.925 411.588 582.699 411.787C582.474 411.987 582.192 412.086 581.854 412.086ZM582.816 412.892V419.808H580.905V412.892H582.816Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M591.655 409.902V419.808H589.861L589.796 418.924C589.518 419.254 589.189 419.505 588.808 419.678C588.426 419.852 587.971 419.938 587.443 419.938C586.827 419.938 586.286 419.791 585.818 419.496C585.35 419.202 584.986 418.79 584.726 418.261C584.466 417.724 584.336 417.113 584.336 416.428C584.336 415.709 584.474 415.072 584.752 414.517C585.029 413.963 585.419 413.529 585.922 413.217C586.433 412.905 587.031 412.749 587.716 412.749C588.513 412.749 589.163 412.944 589.666 413.334V410.032L591.655 409.902ZM587.976 418.3C588.461 418.3 588.868 418.157 589.198 417.871C589.536 417.577 589.709 417.2 589.718 416.74L589.731 414.855C589.237 414.535 588.686 414.374 588.08 414.374C587.534 414.374 587.1 414.561 586.78 414.933C586.468 415.297 586.312 415.791 586.312 416.415C586.312 416.979 586.463 417.434 586.767 417.78C587.07 418.127 587.473 418.3 587.976 418.3Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M600.023 416.129C600.023 416.398 600.006 416.619 599.971 416.792H595.109C595.17 417.304 595.382 417.694 595.746 417.962C596.119 418.222 596.608 418.352 597.215 418.352C597.622 418.352 598.034 418.3 598.45 418.196C598.875 418.084 599.252 417.941 599.581 417.767L599.698 419.327C598.927 419.735 598.043 419.938 597.046 419.938C596.249 419.938 595.555 419.791 594.966 419.496C594.385 419.202 593.939 418.786 593.627 418.248C593.315 417.702 593.159 417.07 593.159 416.35C593.159 415.648 593.306 415.024 593.601 414.478C593.904 413.932 594.32 413.508 594.849 413.204C595.386 412.901 595.997 412.749 596.682 412.749C597.349 412.749 597.934 412.897 598.437 413.191C598.948 413.477 599.338 413.876 599.607 414.387C599.884 414.899 600.023 415.479 600.023 416.129ZM598.073 415.531C598.047 415.15 597.904 414.834 597.644 414.582C597.384 414.331 597.063 414.205 596.682 414.205C596.309 414.205 595.98 414.322 595.694 414.556C595.408 414.782 595.222 415.107 595.135 415.531H598.073Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M604.902 419.938C604.165 419.938 603.511 419.787 602.939 419.483C602.367 419.171 601.921 418.742 601.6 418.196C601.279 417.642 601.119 417.022 601.119 416.337C601.119 415.653 601.279 415.037 601.6 414.491C601.921 413.945 602.367 413.521 602.939 413.217C603.511 412.905 604.165 412.749 604.902 412.749C605.647 412.749 606.306 412.905 606.878 413.217C607.45 413.521 607.896 413.945 608.217 414.491C608.538 415.037 608.698 415.653 608.698 416.337C608.698 417.022 608.538 417.642 608.217 418.196C607.896 418.742 607.45 419.171 606.878 419.483C606.306 419.787 605.647 419.938 604.902 419.938ZM604.902 418.183C605.448 418.183 605.886 418.014 606.215 417.676C606.553 417.33 606.722 416.883 606.722 416.337C606.722 415.791 606.553 415.349 606.215 415.011C605.886 414.665 605.452 414.491 604.915 414.491C604.369 414.491 603.927 414.665 603.589 415.011C603.26 415.349 603.095 415.791 603.095 416.337C603.095 416.892 603.26 417.338 603.589 417.676C603.927 418.014 604.365 418.183 604.902 418.183Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M618.446 418.066H614.767L614.169 419.808H612.18L615.573 410.578H617.731L621.124 419.808H619.044L618.446 418.066ZM617.9 416.506L616.6 412.723L615.3 416.506H617.9Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M626.544 412.736C627.307 412.736 627.9 412.975 628.325 413.451C628.75 413.919 628.962 414.574 628.962 415.414V419.808H627.051V415.895C627.051 414.933 626.648 414.452 625.842 414.452C625.391 414.452 624.997 414.6 624.659 414.894C624.33 415.18 624.165 415.527 624.165 415.934V419.808H622.254V412.892H624.022L624.126 413.984C624.386 413.62 624.72 413.321 625.127 413.087C625.534 412.853 626.007 412.736 626.544 412.736Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M638.584 419.704C638.255 419.86 637.887 419.938 637.479 419.938C637.037 419.938 636.678 419.83 636.4 419.613C636.132 419.397 635.963 419.098 635.893 418.716C635.33 419.531 634.524 419.938 633.475 419.938C632.869 419.938 632.331 419.791 631.863 419.496C631.395 419.202 631.031 418.79 630.771 418.261C630.52 417.724 630.394 417.113 630.394 416.428C630.394 415.709 630.529 415.072 630.797 414.517C631.075 413.963 631.469 413.529 631.98 413.217C632.492 412.905 633.085 412.749 633.761 412.749C634.559 412.749 635.213 412.979 635.724 413.438L635.789 412.892H637.583V417.533C637.583 417.759 637.622 417.932 637.7 418.053C637.778 418.175 637.891 418.235 638.038 418.235C638.16 418.235 638.298 418.209 638.454 418.157L638.584 419.704ZM635.659 414.855C635.183 414.535 634.671 414.374 634.125 414.374C633.579 414.374 633.15 414.556 632.838 414.92C632.526 415.284 632.37 415.783 632.37 416.415C632.37 416.979 632.518 417.434 632.812 417.78C633.107 418.127 633.497 418.3 633.982 418.3C634.277 418.3 634.55 418.235 634.801 418.105C635.053 417.975 635.256 417.802 635.412 417.585C635.568 417.369 635.646 417.135 635.646 416.883L635.659 414.855Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M641.71 419.938C640.427 419.938 639.786 419.254 639.786 417.884V410.032L641.697 409.902V417.546C641.697 417.997 641.87 418.222 642.217 418.222C642.373 418.222 642.568 418.183 642.802 418.105L642.997 419.665C642.598 419.847 642.169 419.938 641.71 419.938Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M650.292 412.892L647.354 420.575C647.086 421.277 646.739 421.802 646.314 422.148C645.89 422.495 645.331 422.668 644.637 422.668C644.178 422.668 643.766 422.595 643.402 422.447L643.623 420.848C643.831 420.918 644.048 420.952 644.273 420.952C644.585 420.952 644.85 420.883 645.066 420.744C645.283 420.606 645.456 420.372 645.586 420.042L645.807 419.509L643.064 412.892H645.157L646.795 417.364L648.316 412.892H650.292Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M653.941 419.938C653.239 419.938 652.675 419.739 652.251 419.34C651.835 418.942 651.627 418.344 651.627 417.546V414.478H650.496L650.639 412.892H651.627L651.718 410.981L653.538 410.838V412.892H655.436L655.306 414.478H653.538V417.104C653.538 417.512 653.616 417.802 653.772 417.975C653.928 418.14 654.166 418.222 654.487 418.222C654.747 418.222 655.05 418.149 655.397 418.001L655.566 419.561C655.098 419.813 654.556 419.938 653.941 419.938Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M657.785 412.086C657.447 412.086 657.165 411.987 656.94 411.787C656.723 411.588 656.615 411.332 656.615 411.02C656.615 410.7 656.723 410.44 656.94 410.24C657.165 410.041 657.447 409.941 657.785 409.941C658.123 409.941 658.405 410.041 658.63 410.24C658.855 410.44 658.968 410.7 658.968 411.02C658.968 411.332 658.855 411.588 658.63 411.787C658.405 411.987 658.123 412.086 657.785 412.086ZM658.747 412.892V419.808H656.836V412.892H658.747Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M663.763 419.938C663.079 419.938 662.472 419.795 661.943 419.509C661.415 419.215 661.003 418.799 660.708 418.261C660.414 417.715 660.266 417.074 660.266 416.337C660.266 415.609 660.422 414.977 660.734 414.439C661.055 413.902 661.488 413.495 662.034 413.217C662.589 412.931 663.217 412.788 663.919 412.788C664.301 412.788 664.669 412.832 665.024 412.918C665.388 412.996 665.692 413.105 665.934 413.243L665.648 414.79C665.146 414.53 664.621 414.4 664.075 414.4C663.512 414.4 663.061 414.574 662.723 414.92C662.394 415.267 662.229 415.735 662.229 416.324C662.229 416.922 662.398 417.403 662.736 417.767C663.074 418.131 663.521 418.313 664.075 418.313C664.379 418.313 664.678 418.279 664.972 418.209C665.276 418.131 665.553 418.027 665.804 417.897L665.947 419.47C665.687 419.609 665.362 419.722 664.972 419.808C664.582 419.895 664.179 419.938 663.763 419.938Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M669.737 419.938C669.225 419.938 668.731 419.882 668.255 419.769C667.787 419.648 667.397 419.492 667.085 419.301L667.306 417.78C667.678 417.988 668.081 418.157 668.515 418.287C668.957 418.417 669.368 418.482 669.75 418.482C670.044 418.482 670.274 418.435 670.439 418.339C670.603 418.235 670.686 418.084 670.686 417.884C670.686 417.746 670.642 417.633 670.556 417.546C670.469 417.451 670.326 417.364 670.127 417.286C669.936 417.208 669.633 417.104 669.217 416.974C668.593 416.775 668.112 416.532 667.774 416.246C667.444 415.952 667.28 415.514 667.28 414.933C667.28 414.491 667.397 414.106 667.631 413.776C667.865 413.438 668.19 413.178 668.606 412.996C669.022 412.814 669.494 412.723 670.023 412.723C670.855 412.723 671.613 412.879 672.298 413.191L672.155 414.699C671.86 414.552 671.505 414.426 671.089 414.322C670.681 414.218 670.326 414.166 670.023 414.166C669.745 414.166 669.529 414.214 669.373 414.309C669.217 414.405 669.139 414.543 669.139 414.725C669.139 414.907 669.234 415.05 669.425 415.154C669.615 415.25 669.984 415.375 670.53 415.531C671.197 415.722 671.7 415.978 672.038 416.298C672.376 416.61 672.545 417.039 672.545 417.585C672.545 418.322 672.298 418.898 671.804 419.314C671.318 419.73 670.629 419.938 669.737 419.938Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M123.824 213.232H123.545C122.42 210.968 120.538 209.169 118.225 208.149V205.087C118.759 204.899 119.208 204.527 119.495 204.039C119.781 203.551 119.886 202.977 119.79 202.419C119.694 201.862 119.405 201.355 118.972 200.991C118.539 200.626 117.991 200.426 117.425 200.426C116.859 200.426 116.312 200.626 115.879 200.991C115.446 201.355 115.156 201.862 115.061 202.419C114.965 202.977 115.069 203.551 115.356 204.039C115.642 204.527 116.092 204.899 116.626 205.087V207.544C113.497 206.597 110.157 206.597 107.029 207.544V205.087C107.562 204.899 108.012 204.527 108.298 204.039C108.585 203.551 108.689 202.977 108.594 202.419C108.498 201.862 108.208 201.355 107.775 200.991C107.343 200.626 106.795 200.426 106.229 200.426C105.663 200.426 105.115 200.626 104.682 200.991C104.25 201.355 103.96 201.862 103.864 202.419C103.768 202.977 103.873 203.551 104.159 204.039C104.446 204.527 104.895 204.899 105.429 205.087V208.15C103.116 209.17 101.234 210.968 100.11 213.232H99.8309C98.7707 213.233 97.7543 213.655 97.0046 214.404C96.255 215.154 95.8333 216.171 95.832 217.231V218.83C95.8333 219.89 96.255 220.907 97.0046 221.656C97.7543 222.406 98.7707 222.828 99.8309 222.829H100.015C101.258 225.621 103.648 227.64 107.029 228.588V231.626C107.029 231.766 107.066 231.903 107.135 232.024C107.204 232.145 107.304 232.246 107.425 232.316C107.545 232.387 107.682 232.424 107.822 232.426C107.961 232.427 108.099 232.392 108.22 232.324L113.972 229.092C118.54 228.557 121.955 226.242 123.575 222.829H123.824C124.884 222.828 125.901 222.406 126.65 221.656C127.4 220.907 127.821 219.89 127.823 218.83V217.231C127.821 216.171 127.4 215.154 126.65 214.405C125.901 213.655 124.884 213.233 123.824 213.232ZM117.425 202.035C117.583 202.035 117.738 202.082 117.87 202.17C118.001 202.258 118.104 202.383 118.164 202.529C118.225 202.675 118.241 202.836 118.21 202.991C118.179 203.146 118.103 203.289 117.991 203.401C117.879 203.513 117.736 203.589 117.581 203.62C117.426 203.651 117.265 203.635 117.119 203.574C116.973 203.514 116.848 203.411 116.76 203.28C116.672 203.148 116.626 202.993 116.626 202.835C116.626 202.623 116.71 202.42 116.86 202.27C117.01 202.12 117.213 202.036 117.425 202.035ZM106.229 202.035C106.387 202.035 106.542 202.082 106.673 202.17C106.805 202.258 106.907 202.383 106.968 202.529C107.028 202.675 107.044 202.836 107.013 202.991C106.983 203.146 106.906 203.289 106.795 203.401C106.683 203.513 106.54 203.589 106.385 203.62C106.23 203.651 106.069 203.635 105.923 203.574C105.777 203.514 105.652 203.411 105.564 203.28C105.476 203.148 105.429 202.993 105.429 202.835C105.429 202.623 105.514 202.42 105.664 202.27C105.814 202.12 106.017 202.036 106.229 202.035ZM97.4316 218.83V217.231C97.4331 216.656 97.6411 216.102 98.0174 215.668C98.3938 215.234 98.9135 214.949 99.4819 214.867C99.1823 215.895 99.0305 216.96 99.0311 218.03C99.0336 219.097 99.1727 220.159 99.4451 221.191C98.8842 221.1 98.3738 220.812 98.005 220.38C97.6362 219.948 97.433 219.398 97.4316 218.83ZM113.637 227.52C113.529 227.531 113.424 227.564 113.33 227.617L108.628 230.259V227.969C108.628 227.788 108.567 227.613 108.455 227.472C108.343 227.331 108.187 227.231 108.011 227.19C103.252 226.071 100.631 222.818 100.631 218.03C100.631 212.38 105.235 208.434 111.827 208.434C118.42 208.434 123.024 212.38 123.024 218.03C123.024 223.265 119.427 226.9 113.637 227.52ZM126.223 218.83C126.222 219.4 126.017 219.951 125.646 220.384C125.275 220.817 124.762 221.103 124.198 221.192C124.485 220.162 124.627 219.099 124.623 218.03C124.624 216.96 124.472 215.895 124.172 214.867C124.741 214.949 125.261 215.233 125.637 215.667C126.014 216.101 126.222 216.656 126.223 217.231V218.83Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M106.226 216.43C106.331 216.43 106.435 216.409 106.532 216.369C106.629 216.329 106.717 216.27 106.791 216.196C106.865 216.122 106.924 216.033 106.965 215.936C107.005 215.839 107.025 215.735 107.025 215.63C107.025 215.079 108.625 215.079 108.625 215.63C108.625 215.842 108.709 216.046 108.859 216.196C109.009 216.346 109.213 216.43 109.425 216.43C109.637 216.43 109.84 216.346 109.99 216.196C110.14 216.046 110.224 215.842 110.224 215.63C110.224 214.472 109.215 213.631 107.825 213.631C106.435 213.631 105.426 214.472 105.426 215.63C105.426 215.735 105.446 215.839 105.487 215.936C105.527 216.033 105.586 216.122 105.66 216.196C105.734 216.27 105.822 216.329 105.919 216.369C106.016 216.409 106.121 216.43 106.226 216.43Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M117.064 221.313C114.076 222.806 109.571 222.806 106.583 221.313C106.394 221.218 106.174 221.202 105.973 221.27C105.771 221.337 105.605 221.481 105.51 221.671C105.415 221.86 105.4 222.08 105.467 222.281C105.534 222.483 105.678 222.649 105.868 222.744C107.729 223.622 109.766 224.065 111.824 224.038C113.882 224.065 115.919 223.622 117.78 222.744C117.97 222.649 118.114 222.483 118.181 222.281C118.248 222.08 118.232 221.86 118.137 221.671C118.043 221.481 117.876 221.337 117.675 221.27C117.474 221.202 117.254 221.218 117.064 221.313H117.064Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M115.825 213.631C114.435 213.631 113.426 214.472 113.426 215.63C113.426 215.842 113.51 216.046 113.66 216.196C113.81 216.346 114.013 216.43 114.226 216.43C114.438 216.43 114.641 216.346 114.791 216.196C114.941 216.046 115.025 215.842 115.025 215.63C115.025 215.079 116.625 215.079 116.625 215.63C116.625 215.842 116.709 216.046 116.859 216.196C117.009 216.346 117.213 216.43 117.425 216.43C117.637 216.43 117.84 216.346 117.99 216.196C118.14 216.046 118.224 215.842 118.224 215.63C118.224 214.472 117.215 213.631 115.825 213.631Z",
                            fill: "#005EEF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M201.748 349.733L196.158 353.926C195.43 354.472 194.392 353.953 194.392 353.043V349.366C189.894 348.145 186.668 344.034 186.668 339.25C186.668 333.461 191.361 328.768 197.151 328.768H208.185C213.975 328.768 218.668 333.461 218.668 339.25C218.668 345.04 213.975 349.733 208.185 349.733H201.748ZM200.719 347.747C200.91 347.604 201.142 347.526 201.381 347.526H208.185C212.756 347.526 216.461 343.821 216.461 339.25C216.461 334.68 212.756 330.974 208.185 330.974H197.151C192.58 330.974 188.875 334.68 188.875 339.25C188.875 343.277 191.771 346.7 195.689 347.398C196.216 347.491 196.599 347.949 196.599 348.484V350.837L200.719 347.747ZM199.358 342.009C199.358 342.618 198.864 343.112 198.254 343.112C197.645 343.112 197.151 342.618 197.151 342.009V339.25C197.151 338.641 197.645 338.147 198.254 338.147C198.864 338.147 199.358 338.641 199.358 339.25V342.009ZM203.771 342.009C203.771 342.618 203.277 343.112 202.668 343.112C202.059 343.112 201.565 342.618 201.565 342.009V334.837C201.565 334.227 202.059 333.733 202.668 333.733C203.277 333.733 203.771 334.227 203.771 334.837V342.009ZM208.185 342.009C208.185 342.618 207.691 343.112 207.082 343.112C206.472 343.112 205.978 342.618 205.978 342.009V337.595C205.978 336.986 206.472 336.492 207.082 336.492C207.691 336.492 208.185 336.986 208.185 337.595V342.009Z",
                            fill: "#008651"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M599.703 221.129H597.82V224.894H599.703V221.129Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M597.82 229.599C597.82 229.849 597.721 230.088 597.544 230.265C597.368 230.441 597.128 230.541 596.879 230.541H595.938V232.423H596.879C597.628 232.423 598.346 232.125 598.875 231.596C599.405 231.066 599.702 230.348 599.702 229.599V228.658H597.82V229.599Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M592.175 230.541H588.41V232.423H592.175V230.541Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M584.644 230.541H580.879V232.423H584.644V230.541Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M577.117 229.599V228.658H575.234V229.599C575.234 230.348 575.532 231.066 576.061 231.596C576.591 232.125 577.309 232.423 578.058 232.423V230.541C577.808 230.541 577.569 230.441 577.392 230.265C577.216 230.088 577.117 229.849 577.117 229.599Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M577.117 221.129H575.234V224.894H577.117V221.129Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M602.528 215.483C602.278 215.483 602.039 215.582 601.862 215.758C601.686 215.935 601.586 216.174 601.586 216.424V217.365H599.704V208.894C599.703 208.645 599.603 208.405 599.427 208.228L591.898 200.699C591.721 200.524 591.482 200.425 591.233 200.424H578.057C577.308 200.424 576.59 200.721 576.06 201.251C575.531 201.78 575.233 202.499 575.233 203.247V217.365H573.351V216.424C573.351 216.174 573.252 215.935 573.075 215.758C572.899 215.582 572.66 215.483 572.41 215.483C572.16 215.483 571.921 215.582 571.744 215.758C571.568 215.935 571.469 216.174 571.469 216.424V220.189C571.469 220.438 571.568 220.678 571.744 220.854C571.921 221.031 572.16 221.13 572.41 221.13C572.66 221.13 572.899 221.031 573.075 220.854C573.252 220.678 573.351 220.438 573.351 220.189V219.247H601.586V220.189C601.586 220.438 601.686 220.678 601.862 220.854C602.039 221.031 602.278 221.13 602.528 221.13C602.777 221.13 603.017 221.031 603.193 220.854C603.37 220.678 603.469 220.438 603.469 220.189V216.424C603.469 216.174 603.37 215.935 603.193 215.758C603.017 215.582 602.777 215.483 602.528 215.483ZM592.175 203.637L596.491 207.953H593.116C592.866 207.953 592.627 207.854 592.45 207.678C592.274 207.501 592.175 207.262 592.175 207.012V203.637ZM577.116 217.365V203.247C577.116 202.998 577.215 202.758 577.391 202.582C577.568 202.405 577.807 202.306 578.057 202.306H590.292V207.012C590.292 207.761 590.59 208.479 591.119 209.009C591.649 209.538 592.367 209.836 593.116 209.836H597.822V217.365H577.116Z",
                            fill: "#FF0A7A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M491.407 350.5L488.617 348.889V352.111L491.407 350.5ZM491.407 350.5L488.617 348.889V352.111L491.407 350.5Z",
                            stroke: "#FF2828",
                            strokeWidth: "1.2",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M481.433 356.658V344.345H497.92V356.658H481.433Z",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M488.39 339.961V326.257H511.833V339.961H488.39Z",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M496.484 332.691C497.336 332.691 498.026 332 498.026 331.148C498.026 330.296 497.336 329.605 496.484 329.605C495.632 329.605 494.941 330.296 494.941 331.148C494.941 332 495.632 332.691 496.484 332.691Z",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M488.414 339.97L493.52 335.082L497.094 338.504L502.455 333.372L505.773 336.549L511.9 330.684",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.652 405.219C340.83 405.219 333.652 398.041 333.652 389.219C333.652 380.397 340.83 373.219 349.652 373.219C353.464 373.219 357.022 374.525 359.94 376.997C360.362 377.353 360.412 377.985 360.058 378.407C359.698 378.831 359.07 378.879 358.648 378.523C356.096 376.361 352.984 375.219 349.652 375.219C341.932 375.219 335.652 381.499 335.652 389.219C335.652 396.937 341.932 403.219 349.652 403.219C357.37 403.219 363.652 396.937 363.652 389.219C363.652 386.357 362.794 383.609 361.17 381.269C360.856 380.815 360.968 380.191 361.422 379.877C361.874 379.563 362.498 379.675 362.814 380.127C364.67 382.805 365.652 385.947 365.652 389.219C365.652 398.041 358.474 405.219 349.652 405.219Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M360.652 382.219C358.998 382.219 357.652 380.873 357.652 379.219C357.652 377.565 358.998 376.219 360.652 376.219C362.306 376.219 363.652 377.565 363.652 379.219C363.652 380.873 362.306 382.219 360.652 382.219ZM360.652 378.219C360.102 378.219 359.652 378.667 359.652 379.219C359.652 379.771 360.102 380.219 360.652 380.219C361.202 380.219 361.652 379.771 361.652 379.219C361.652 378.667 361.202 378.219 360.652 378.219Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.652 392.219C347.998 392.219 346.652 390.873 346.652 389.219C346.652 387.565 347.998 386.219 349.652 386.219C351.306 386.219 352.652 387.565 352.652 389.219C352.652 390.873 351.306 392.219 349.652 392.219ZM349.652 388.219C349.1 388.219 348.652 388.667 348.652 389.219C348.652 389.769 349.1 390.219 349.652 390.219C350.202 390.219 350.652 389.769 350.652 389.219C350.652 388.667 350.202 388.219 349.652 388.219Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M349.652 399.219C344.138 399.219 339.652 394.733 339.652 389.219C339.652 383.705 344.138 379.219 349.652 379.219C355.166 379.219 359.652 383.705 359.652 389.219C359.652 394.733 355.166 399.219 349.652 399.219ZM349.652 381.219C345.24 381.219 341.652 384.807 341.652 389.219C341.652 393.631 345.24 397.219 349.652 397.219C354.064 397.219 357.652 393.631 357.652 389.219C357.652 384.807 354.064 381.219 349.652 381.219Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint0_linear",
                                    x1: "562.815",
                                    y1: "191.778",
                                    x2: "611.738",
                                    y2: "240.7",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint1_linear",
                                    x1: "563.957",
                                    y1: "192.92",
                                    x2: "611.414",
                                    y2: "240.377",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint2_linear",
                                    x1: "471.974",
                                    y1: "316.809",
                                    x2: "520.896",
                                    y2: "365.731",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint3_linear",
                                    x1: "473.117",
                                    y1: "317.953",
                                    x2: "520.574",
                                    y2: "365.41",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "#EEF1F2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint4_linear",
                                    x1: "324.993",
                                    y1: "364.565",
                                    x2: "373.915",
                                    y2: "413.488",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint5_linear",
                                    x1: "326.135",
                                    y1: "365.709",
                                    x2: "373.592",
                                    y2: "413.166",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint6_linear",
                                    x1: "178.013",
                                    y1: "316.809",
                                    x2: "226.935",
                                    y2: "365.731",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint7_linear",
                                    x1: "179.154",
                                    y1: "317.953",
                                    x2: "226.611",
                                    y2: "365.41",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "#EEF1F2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint8_linear",
                                    x1: "87.1678",
                                    y1: "191.778",
                                    x2: "136.09",
                                    y2: "240.7",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint9_linear",
                                    x1: "88.3105",
                                    y1: "192.92",
                                    x2: "135.768",
                                    y2: "240.377",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint10_linear",
                                    x1: "263.396",
                                    y1: "52.9075",
                                    x2: "434.543",
                                    y2: "224.055",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#B9B9B9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                    id: "paint11_linear",
                                    x1: "267.071",
                                    y1: "56.892",
                                    x2: "433.092",
                                    y2: "222.913",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            "stop-color": "#EEF1F2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                            offset: "1",
                                            "stop-color": "#F3F7F7"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return cez;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./public/assets/svg/cez1.jsx





var flag = false;
var View = function(props) {
    var ref = (0,react.useState)(true), loading = ref[0], setloading = ref[1];
    var ref1 = (0,react.useState)([]), url = ref1[0], seturl = ref1[1];
    var ref2 = (0,react.useState)(1), page = ref2[0], setpage = ref2[1];
    var ref3 = (0,react.useState)(false), more = ref3[0], setmore = ref3[1];
    var imgdate = [];
    var observer = (0,react.useRef)();
    var lastRowRef = (0,react.useCallback)(function(lastTag) {
        if (loading) {
            return;
        }
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                if (flag && more) {
                    var x = page;
                    setpage(x + 1);
                } else {
                    flag = true;
                }
            }
        });
        if (lastTag) {
            observer.current.observe(lastTag);
        }
    }, [
        loading,
        more
    ]);
    (0,react.useEffect)(function() {
        setloading(true);
        var fileDates = [];
        axios_default()({
            method: "GET",
            url: "/view",
            params: {
                page: page
            }
        }).then(function(res) {
            if (!res) {
                console.log("Request failed");
            }
            var images = res.data;
            setmore(images.length > 0);
            images.forEach(function(filename, index) {
                filename = filename.split("-");
                var date = Number(filename[1]);
                date = new Date(date);
                date = date.toString();
                date = date.substr(4, 11);
                fileDates.push(date);
            });
            fileDates.sort().reverse();
            fileDates = fileDates.filter(function(value, index) {
                return fileDates.indexOf(value) === index;
            });
            images = images.map(function(filename) {
                return "https://typitophotoapp.herokuapp.com/" + filename;
            });
            fileDates.forEach(function(date, index) {
                imgdate.push({
                    date: date,
                    img: []
                });
                images.forEach(function(filename, index2) {
                    var splitfilename = filename.split("-");
                    var d = Number(splitfilename[1]);
                    d = new Date(d);
                    d = d.toString();
                    d = d.substr(4, 11);
                    if (d === imgdate[index].date) {
                        imgdate[index].img.push(filename);
                    }
                });
            });
            seturl(function(url) {
                if (url.length > 0 && imgdate.length > 0) {
                    if (url[url.length - 1].date === imgdate[0].date) {
                        var temp = url;
                        temp[temp.length - 1].img = temp[temp.length - 1].img.concat(imgdate[0].img);
                        imgdate.splice(0, 1);
                        temp = temp.concat(imgdate);
                        return temp;
                    }
                } else {
                    return (0,_to_consumable_array/* default */.Z)(url).concat((0,_to_consumable_array/* default */.Z)(imgdate));
                }
            });
            setloading(false);
        }).catch(function(err) {
            setloading(false);
        });
    }, [
        page
    ]);
    var showFullImage = function(e) {
        var fullimage = e.target.src;
        props.setselectedImage(fullimage, url);
        props.history.push("/fullimage");
    };
    var showImages = function() {
        var UI = [];
        var count = 0;
        for(var i = 0; i < url.length; i++){
            UI.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-center bg-info mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                    children: [
                        "----",
                        url[i].date,
                        "----"
                    ]
                })
            }));
            for(var j = 0; j < url[i].img.length; j = j + 6){
                if (count >= 24) {
                    count = 0;
                    UI.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row row-cols-8 mt-5",
                        ref: lastRowRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j],
                                    alt: "",
                                    onClick: showFullImage,
                                    className: "img-thumbnail"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 1],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 2],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 3],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 4],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 5],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            })
                        ]
                    }, i));
                } else {
                    count = count + 6;
                    UI.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row row-cols-8 mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j],
                                    alt: "",
                                    onClick: showFullImage,
                                    className: "img-thumbnail"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 1],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 2],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 3],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 4],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: url[i].img[j + 5],
                                    alt: "",
                                    className: "img-thumbnail",
                                    onClick: showFullImage
                                })
                            })
                        ]
                    }, i));
                }
            }
        }
        return UI;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mt-4",
                children: showImages()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mt-4",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mt-4 d-flex justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Loading..."
                    })
                }) : null
            })
        ]
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        setselectedImage: function(selectedImage, allImages) {
            var images = [];
            allImages.forEach(function(item, index) {
                item.img.forEach(function(item2, index) {
                    item2 = item2.substr(0, 37) + "720/" + item2.substr(37);
                    images.push(item2);
                });
            });
            selectedImage = selectedImage.substr(0, 37) + "720/" + selectedImage.substr(37);
            dispatch({
                type: "Set_Image",
                img: selectedImage,
                images: images
            });
        }
    };
};
/* harmony default export */ var cez1 = ((0,es/* connect */.$j)(null, mapDispatchToProps)(View));

;// CONCATENATED MODULE: ./public/assets/svg/videoicon.jsx






var videoicon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(videoicon, Component);
    var _super = _createSuper(videoicon);
    function videoicon() {
        _classCallCheck(this, videoicon);
        return _super.apply(this, arguments);
    }
    _createClass(videoicon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "52",
                    height: "52",
                    viewBox: "0 0 52 52",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "25.9887",
                            cy: "26.0512",
                            r: "25.3793",
                            fill: "url(#paint0_radial)",
                            "fill-opacity": "0.15"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "25.9889",
                            cy: "26.0514",
                            r: "18.4577",
                            fill: "#1063EA"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M31.6367 26.052L23.1073 31.8266L23.1073 20.2773L31.6367 26.052Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                                id: "paint0_radial",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(25.9887 26.0512) rotate(90) scale(25.3793)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "0.723958",
                                        "stop-color": "#1063EA",
                                        "stop-opacity": "0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "1",
                                        "stop-color": "#1063EA"
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return videoicon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/scrabble.jsx






var scrabble = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(scrabble, Component);
    var _super = _createSuper(scrabble);
    function scrabble() {
        _classCallCheck(this, scrabble);
        return _super.apply(this, arguments);
    }
    _createClass(scrabble, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "56",
                    height: "57",
                    viewBox: "0 0 56 57",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.1",
                            d: "M28 56.0898C43.464 56.0898 56 43.5538 56 28.0898C56 12.6259 43.464 0.0898438 28 0.0898438C12.536 0.0898438 0 12.6259 0 28.0898C0 43.5538 12.536 56.0898 28 56.0898Z",
                            fill: "#FF9E00"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "35.2651",
                            cy: "21.1753",
                            r: "3.83389",
                            stroke: "#FF9E00",
                            strokeWidth: "1.8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "31.4273",
                            y: "31.1695",
                            width: "7.66778",
                            height: "7.66778",
                            rx: "1.6",
                            stroke: "#FF9E00",
                            strokeWidth: "1.8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                            id: "path-4-inside-1",
                            fill: "white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "16.7109",
                                y: "16.4414",
                                width: "9.46778",
                                height: "9.46778",
                                rx: "1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "16.7109",
                            y: "16.4414",
                            width: "9.46778",
                            height: "9.46778",
                            rx: "1",
                            stroke: "#FF9E00",
                            strokeWidth: "3.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "bevel",
                            mask: "url(#path-4-inside-1)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21.3571 32.2547C21.3702 32.232 21.3828 32.2224 21.3928 32.2169C21.4053 32.21 21.4228 32.2047 21.4437 32.2047C21.4645 32.2047 21.4821 32.21 21.4945 32.2169C21.5046 32.2224 21.5172 32.232 21.5303 32.2547L25.2419 38.6834C25.2551 38.7062 25.257 38.7218 25.2568 38.7333C25.2566 38.7476 25.2524 38.7654 25.2419 38.7834C25.2315 38.8015 25.2182 38.814 25.206 38.8214C25.1961 38.8273 25.1816 38.8334 25.1553 38.8334H17.732C17.7058 38.8334 17.6913 38.8273 17.6814 38.8214C17.6692 38.814 17.6559 38.8015 17.6454 38.7834C17.635 38.7654 17.6308 38.7476 17.6306 38.7333C17.6304 38.7218 17.6323 38.7062 17.6454 38.6834L21.3571 32.2547Z",
                            stroke: "#FF9E00",
                            strokeWidth: "1.8",
                            "stroke-linecap": "round",
                            strokeLinejoin: "bevel"
                        })
                    ]
                });
            }
        }
    ]);
    return scrabble;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/redArrow.jsx






var redArrow = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(redArrow, Component);
    var _super = _createSuper(redArrow);
    function redArrow() {
        _classCallCheck(this, redArrow);
        return _super.apply(this, arguments);
    }
    _createClass(redArrow, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.className,
                    width: "172",
                    height: "308",
                    viewBox: "0 0 172 308",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M77.1172 83.793C80.4272 119.303 98.0272 154.013 98.0272 154.013C98.0272 154.013 80.4272 188.723 77.1172 224.233C91.5472 194.043 134.187 173.833 134.187 154.013C134.187 134.193 91.5472 113.983 77.1172 83.793Z",
                            fill: "#FF544F"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            style: "mix-blend-mode:multiply",
                            filter: "url(#filter0_f)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M44.3086 44.7852H47.2841L127.241 154.012L47.2841 263.239H44.3086V44.7852Z",
                                fill: "#BBC1DA"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.52734 8.27344H37.2402L109.316 139.577C114.251 148.568 114.252 159.458 109.316 168.449L37.2402 299.753H6.52734V8.27344Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                                id: "filter0_f",
                                x: "0.308594",
                                y: "0.785156",
                                width: "170.933",
                                height: "306.454",
                                filterUnits: "userSpaceOnUse",
                                "color-interpolation-filters": "sRGB",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                        "flood-opacity": "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "BackgroundImageFix",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                        stdDeviation: "22",
                                        result: "effect1_foregroundBlur"
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return redArrow;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/botinfo.jsx






var botinfo = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(botinfo, Component);
    var _super = _createSuper(botinfo);
    function botinfo() {
        _classCallCheck(this, botinfo);
        return _super.apply(this, arguments);
    }
    _createClass(botinfo, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "57",
                    height: "57",
                    viewBox: "0 0 57 57",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.1",
                            d: "M28.4961 56.0898C43.9601 56.0898 56.4961 43.5538 56.4961 28.0898C56.4961 12.6259 43.9601 0.0898438 28.4961 0.0898438C13.0321 0.0898438 0.496094 12.6259 0.496094 28.0898C0.496094 43.5538 13.0321 56.0898 28.4961 56.0898Z",
                            fill: "#FF2828"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30.668 18.0508H22.668C22.1375 18.0508 21.6288 18.2615 21.2538 18.6366C20.8787 19.0116 20.668 19.5203 20.668 20.0508V36.0508C20.668 36.5812 20.8787 37.0899 21.2538 37.465C21.6288 37.8401 22.1375 38.0508 22.668 38.0508H34.668C35.1984 38.0508 35.7071 37.8401 36.0822 37.465C36.4573 37.0899 36.668 36.5812 36.668 36.0508V24.0508L30.668 18.0508Z",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30.668 18.0508V24.0508H36.668",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M32.668 29.0508H24.668",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M32.668 33.0508H24.668",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M26.668 25.0508H25.668H24.668",
                            stroke: "#FF2828",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return botinfo;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/requestbot.jsx






var requestbot = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(requestbot, Component);
    var _super = _createSuper(requestbot);
    function requestbot() {
        _classCallCheck(this, requestbot);
        return _super.apply(this, arguments);
    }
    _createClass(requestbot, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "57",
                    height: "57",
                    viewBox: "0 0 57 57",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.1",
                            d: "M28.9961 56.0898C44.4601 56.0898 56.9961 43.5538 56.9961 28.0898C56.9961 12.6259 44.4601 0.0898438 28.9961 0.0898438C13.5321 0.0898438 0.996094 12.6259 0.996094 28.0898C0.996094 43.5538 13.5321 56.0898 28.9961 56.0898Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M26.7249 18.7679C27.0237 18.7679 27.2975 18.5179 27.2975 18.1831V16.6746C27.2975 16.3695 27.0527 16.0898 26.7249 16.0898C26.3971 16.0898 26.1523 16.3399 26.1523 16.6746V18.1831C26.1772 18.5179 26.4262 18.7679 26.7249 18.7679Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M24.0716 19.5489C24.1795 19.659 24.3164 19.7184 24.4824 19.7184C24.6193 19.7184 24.7811 19.6633 24.8931 19.5489C25.113 19.3243 25.113 18.9641 24.8931 18.7395L23.8558 17.6802C23.6359 17.4556 23.2833 17.4556 23.0634 17.6802C22.8435 17.9047 22.8435 18.2649 23.0634 18.4895L24.0716 19.5489Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M28.992 19.7145C29.1289 19.7145 29.2907 19.6594 29.4027 19.545L30.44 18.4856C30.6599 18.261 30.6599 17.9008 30.44 17.6763C30.2201 17.4517 29.8674 17.4517 29.6475 17.6763L28.6102 18.7356C28.3903 18.9602 28.3903 19.3204 28.6102 19.545C28.7181 19.6594 28.855 19.7145 28.992 19.7145Z",
                            fill: "#7705BC"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M38.694 32.9414C38.694 31.7125 37.7106 30.7083 36.4783 30.7083C36.0427 30.7083 35.6029 30.8481 35.2502 31.0727C34.9224 30.2633 34.1299 29.704 33.2296 29.704C32.7939 29.704 32.3541 29.8438 32.0015 30.0684C31.6737 29.2591 30.8812 28.6997 29.9808 28.6997C29.5991 28.6997 29.2423 28.7845 28.9436 28.9794V27.4324H31.404C31.7318 27.4324 31.9766 27.1824 31.9766 26.8476V20.8895C31.9766 20.5547 31.7318 20.3047 31.404 20.3047H22.0519C21.7241 20.3047 21.4793 20.5547 21.4793 20.8895V26.8476C21.4793 27.1824 21.7241 27.4324 22.0519 27.4324H24.5372V35.2593L23.0892 33.7804C22.3257 33.0261 21.1474 32.8863 20.2761 33.5007C19.7574 33.8652 19.4006 34.4203 19.3176 35.0644C19.2347 35.7084 19.4006 36.3483 19.8114 36.8526L22.2967 39.8654C22.4046 40.0052 22.5705 40.09 22.7324 40.09C22.8693 40.09 23.0062 40.0349 23.1141 39.9501C23.3589 39.7255 23.3879 39.3654 23.1971 39.1111L20.7117 36.1237C20.5209 35.8737 20.4379 35.594 20.4669 35.2847C20.5209 34.9796 20.6868 34.6999 20.9316 34.5304C21.3424 34.2508 21.915 34.3059 22.2718 34.6703L24.0476 36.4839C24.3215 36.7636 24.7322 36.8483 25.0849 36.7085C25.4417 36.5686 25.6865 36.2042 25.6865 35.8144V26.0252C25.6865 25.4405 26.1512 24.9659 26.7238 24.9659C26.9976 24.9362 27.2715 25.076 27.4623 25.271C27.6532 25.4659 27.7611 25.7456 27.7611 26.0252V32.0515C27.7611 32.3863 28.0349 32.6363 28.3336 32.6363C28.6614 32.6363 28.9062 32.3566 28.9062 32.0515V30.9583C28.9062 30.3735 29.3709 29.8989 29.9435 29.8989C30.5161 29.8989 30.9808 30.3735 30.9808 30.9583V33.0516C30.9808 33.3863 31.2546 33.6363 31.5533 33.6363C31.8811 33.6363 32.1259 33.3567 32.1259 33.0516V31.9625C32.1259 31.3778 32.5906 30.9032 33.1632 30.9032C33.7358 30.9032 34.2005 31.3778 34.2005 31.9625V34.0558C34.2005 34.3906 34.4743 34.6406 34.7731 34.6406C35.1008 34.6406 35.3456 34.3609 35.3456 34.0558V33.0219C35.3456 32.9922 35.3456 32.9668 35.3456 32.9372C35.3456 32.3524 35.8103 31.8778 36.3829 31.8778C36.9555 31.8778 37.4202 32.3524 37.4202 32.9372V38.4207C37.4202 38.7555 37.694 39.0055 37.9928 39.0055C38.3205 39.0055 38.5653 38.7258 38.5653 38.4207L38.694 32.9414ZM26.7238 23.7624C25.5205 23.7624 24.5372 24.7667 24.5372 26.0252V26.2332H22.6535V21.4742H30.8521V26.2332H28.9643V26.0252C28.9643 25.4108 28.7444 24.8515 28.3087 24.4362C27.8731 24.0209 27.3793 23.7921 26.7238 23.7624Z",
                            fill: "#7705BC"
                        })
                    ]
                });
            }
        }
    ]);
    return requestbot;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/crown.jsx






var crown = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(crown, Component);
    var _super = _createSuper(crown);
    function crown() {
        _classCallCheck(this, crown);
        return _super.apply(this, arguments);
    }
    _createClass(crown, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "25",
                    height: "33",
                    viewBox: "0 0 25 33",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "24.3281",
                            y: "28.6133",
                            width: "4",
                            height: "24",
                            transform: "rotate(90 24.3281 28.6133)",
                            fill: "#1F36C7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "clip-path": "url(#clip0)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.9792 9.97643C21.7099 9.80979 21.3652 9.8269 21.1129 10.02L16.8329 13.2969L12.9399 8.12852C12.7977 7.94023 12.5769 7.82787 12.3409 7.82431C12.1098 7.82074 11.8808 7.92621 11.733 8.11043L7.57708 13.2936L3.56256 10.0335C3.31338 9.83098 2.96411 9.80576 2.68844 9.97057C2.41305 10.1354 2.26985 10.4549 2.32999 10.7703L3.65481 17.7002C3.72386 18.0608 4.039 18.3212 4.40566 18.3212H20.2528C20.6197 18.3212 20.9348 18.0608 21.0033 17.7002L22.3282 10.7703C22.3878 10.459 22.249 10.1431 21.9792 9.97643ZM19.621 16.7925H5.03781L4.22481 12.5408L7.21056 14.9655C7.36853 15.0936 7.57131 15.1525 7.77363 15.1321C7.97594 15.1105 8.16138 15.0091 8.28878 14.8503L12.3104 9.83402L16.0758 14.832C16.1983 14.9948 16.3808 15.102 16.5828 15.1295C16.7856 15.1576 16.9889 15.1028 17.151 14.979L20.4508 12.4524L19.621 16.7925Z",
                                    fill: "#FFAE39"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M19.4878 17.5547V19.5165H5.16931V17.5547H3.64062V20.2808C3.64062 20.703 3.98277 21.0451 4.40497 21.0451H20.2521C20.6742 21.0451 21.0164 20.703 21.0164 20.2808V17.5547H19.4878Z",
                                    fill: "#FFAE39"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12.329 4.17969C10.9242 4.17969 9.78125 5.32264 9.78125 6.72744C9.78125 8.13228 10.9242 9.27519 12.329 9.27519C13.7339 9.27519 14.8768 8.13223 14.8768 6.72744C14.8768 5.32264 13.7339 4.17969 12.329 4.17969ZM12.329 7.74659C11.767 7.74659 11.3099 7.28952 11.3099 6.72748C11.3099 6.16545 11.767 5.70838 12.329 5.70838C12.891 5.70838 13.3481 6.16545 13.3481 6.72748C13.3481 7.28952 12.891 7.74659 12.329 7.74659Z",
                                    fill: "#FFAE39"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.7782 6.19531C20.3734 6.19531 19.2305 7.33822 19.2305 8.74306C19.2305 10.1479 20.3734 11.2908 21.7782 11.2908C23.1831 11.2908 24.326 10.1479 24.326 8.74306C24.326 7.33822 23.183 6.19531 21.7782 6.19531ZM21.7782 9.76217C21.2162 9.76217 20.7591 9.30509 20.7591 8.74306C20.7591 8.18103 21.2162 7.72395 21.7782 7.72395C22.3403 7.72395 22.7973 8.18103 22.7973 8.74306C22.7973 9.30509 22.3403 9.76217 21.7782 9.76217Z",
                                    fill: "#FFAE39"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M2.87587 6.19531C1.47108 6.19531 0.328125 7.33822 0.328125 8.74306C0.328125 10.1479 1.47108 11.2908 2.87587 11.2908C4.28072 11.2908 5.42362 10.1479 5.42362 8.74306C5.42367 7.33822 4.28072 6.19531 2.87587 6.19531ZM2.87587 9.76217C2.31384 9.76217 1.85677 9.30509 1.85677 8.74306C1.85677 8.18103 2.31384 7.72395 2.87587 7.72395C3.43791 7.72395 3.89498 8.18103 3.89498 8.74306C3.89498 9.30509 3.43795 9.76217 2.87587 9.76217Z",
                                    fill: "#FFAE39"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "24",
                                    height: "24",
                                    fill: "white",
                                    transform: "translate(0.328125 0.613281)"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return crown;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/grayclose.jsx






var grayclose = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(grayclose, Component);
    var _super = _createSuper(grayclose);
    function grayclose() {
        _classCallCheck(this, grayclose);
        return _super.apply(this, arguments);
    }
    _createClass(grayclose, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: this.props.className,
                    onClick: this.props.onClick,
                    width: "17",
                    height: "16",
                    viewBox: "0 0 17 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.9961 4L4.99609 12",
                            stroke: "#666666",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M4.99609 4L12.9961 12",
                            stroke: "#666666",
                            strokeWidth: "1.6",
                            "stroke-linecap": "round",
                            strokeLinejoin: "round"
                        })
                    ]
                });
            }
        }
    ]);
    return grayclose;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/ConversetionalAi.jsx






var ConversetionalAi = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ConversetionalAi, Component);
    var _super = _createSuper(ConversetionalAi);
    function ConversetionalAi() {
        _classCallCheck(this, ConversetionalAi);
        return _super.apply(this, arguments);
    }
    _createClass(ConversetionalAi, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "104",
                    height: "109",
                    fill: "none",
                    viewBox: "0 0 104 109",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#01B2FF",
                            d: "M.414 41.959C.414 64.926 19.033 83.545 42 83.545s41.586-18.619 41.586-41.586S64.967.373 42 .373.414 18.992.414 41.96z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "41.511",
                            cy: "41.825",
                            r: "30.685",
                            fill: "#fff",
                            transform: "rotate(-180 41.51 41.825)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#005EEF",
                            d: "M53.395 38.57h-.28c-1.12-2.258-2.997-4.05-5.304-5.068V30.45c.532-.188.98-.558 1.266-1.045.286-.487.39-1.059.295-1.615-.096-.556-.385-1.06-.816-1.424-.432-.364-.978-.563-1.542-.563-.565 0-1.111.2-1.543.563-.431.364-.72.868-.816 1.424-.095.556.01 1.128.295 1.615.285.487.734.857 1.266 1.045v2.45c-3.12-.945-6.45-.945-9.57 0v-2.45c.532-.188.98-.558 1.266-1.045.286-.487.39-1.059.294-1.615-.095-.556-.384-1.06-.816-1.424-.431-.364-.977-.563-1.542-.563-.564 0-1.11.2-1.542.563-.431.364-.72.868-.816 1.424-.095.556.009 1.128.294 1.615.286.487.735.857 1.267 1.045v3.053c-2.307 1.017-4.184 2.81-5.305 5.066h-.278c-1.057.002-2.07.422-2.818 1.17-.748.747-1.168 1.76-1.17 2.817v1.595c.002 1.056.422 2.07 1.17 2.817.747.747 1.76 1.168 2.818 1.17h.184c1.24 2.783 3.622 4.795 6.994 5.74v3.03c0 .138.037.275.106.396.07.12.169.22.289.291.12.07.257.108.396.11.139 0 .276-.035.397-.103l5.736-3.221c4.556-.533 7.96-2.842 9.577-6.244h.248c1.057-.001 2.07-.422 2.818-1.169.747-.747 1.168-1.76 1.169-2.817v-1.595c-.001-1.057-.422-2.07-1.17-2.817-.747-.748-1.76-1.168-2.818-1.17zm-6.381-11.163c.157 0 .311.047.443.135.13.087.233.212.293.358.06.145.077.306.046.46-.031.155-.107.297-.218.409-.112.111-.254.187-.409.218-.154.03-.315.015-.46-.046-.146-.06-.27-.162-.359-.293-.087-.131-.134-.285-.134-.443 0-.212.084-.414.234-.564.15-.15.352-.233.564-.233zm-11.166 0c.158 0 .312.047.444.135.13.087.233.212.293.358.06.145.076.306.046.46-.031.155-.107.297-.219.409-.111.111-.253.187-.408.218-.155.03-.315.015-.46-.046-.146-.06-.271-.162-.359-.293-.087-.131-.134-.285-.134-.443 0-.212.084-.414.234-.564.15-.15.352-.233.564-.233zm-8.772 16.744v-1.595c.001-.573.209-1.126.584-1.558.375-.433.893-.716 1.46-.799-.299 1.025-.45 2.087-.45 3.154.003 1.064.142 2.122.413 3.15-.559-.09-1.068-.376-1.436-.807-.367-.431-.57-.979-.571-1.545zm16.16 8.662c-.108.012-.212.045-.307.098l-4.688 2.634V53.26c0-.18-.06-.354-.172-.495-.112-.141-.268-.24-.443-.281-4.747-1.116-7.36-4.359-7.36-9.132 0-5.633 4.59-9.567 11.165-9.567 6.574 0 11.165 3.934 11.165 9.567 0 5.218-3.586 8.843-9.36 9.46zm12.551-8.662c-.002.568-.206 1.117-.576 1.549-.37.431-.882.716-1.443.805.285-1.026.428-2.087.423-3.152 0-1.067-.15-2.13-.45-3.154.568.083 1.086.366 1.462.799.375.432.582.985.584 1.558v1.595z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#005EEF",
                            d: "M35.852 41.757c.105 0 .209-.02.306-.06.096-.04.184-.099.258-.173.074-.074.133-.162.173-.259.04-.096.06-.2.06-.305 0-.55 1.596-.55 1.596 0 0 .212.084.414.233.564.15.15.353.233.564.233.212 0 .415-.084.564-.233.15-.15.234-.352.234-.564 0-1.155-1.006-1.993-2.393-1.993-1.386 0-2.392.838-2.392 1.993 0 .105.02.209.06.305.04.097.1.185.173.259.074.074.162.133.259.173.097.04.2.06.305.06zM46.66 46.621c-2.979 1.489-7.471 1.489-10.451 0-.19-.094-.408-.11-.609-.043-.2.067-.367.21-.461.4-.095.19-.11.408-.043.609.067.2.21.366.4.46 1.856.877 3.887 1.318 5.939 1.29 2.052.028 4.083-.414 5.94-1.29.188-.094.332-.26.4-.46.066-.201.05-.42-.044-.61-.095-.188-.26-.332-.461-.399-.2-.067-.42-.051-.61.043zM45.424 38.967c-1.386 0-2.393.838-2.393 1.993 0 .212.084.414.234.564.15.15.352.233.564.233.211 0 .414-.084.564-.233.15-.15.233-.352.233-.564 0-.55 1.595-.55 1.595 0 0 .212.084.414.234.564.15.15.352.233.564.233.212 0 .414-.084.564-.233.15-.15.233-.352.233-.564 0-1.155-1.006-1.993-2.392-1.993z"
                        })
                    ]
                });
            }
        }
    ]);
    return ConversetionalAi;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/TestClassification.jsx






var TestClassification = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(TestClassification, Component);
    var _super = _createSuper(TestClassification);
    function TestClassification() {
        _classCallCheck(this, TestClassification);
        return _super.apply(this, arguments);
    }
    _createClass(TestClassification, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "104",
                    height: "109",
                    fill: "none",
                    viewBox: "0 0 104 109",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#00D7C4",
                            d: "M.93 41.956c0 22.968 18.62 41.588 41.588 41.588s41.588-18.62 41.588-41.588S65.486.37 42.518.37.931 18.99.931 41.956z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "41.998",
                            cy: "41.824",
                            r: "30.686",
                            fill: "#fff",
                            transform: "rotate(-180 41.998 41.824)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#008651",
                            d: "M41.057 51.276l-5.71 4.282c-.743.557-1.803.027-1.803-.902v-3.755c-4.593-1.248-7.888-5.445-7.888-10.33 0-5.913 4.793-10.706 10.706-10.706H47.63c5.912 0 10.705 4.793 10.705 10.706 0 5.912-4.793 10.705-10.705 10.705h-6.573zm-1.052-2.029c.195-.146.432-.225.676-.225h6.95c4.667 0 8.45-3.784 8.45-8.451 0-4.668-3.783-8.452-8.45-8.452H36.36c-4.667 0-8.451 3.784-8.451 8.452 0 4.111 2.958 7.607 6.959 8.32.537.096.93.563.93 1.11v2.402l4.206-3.156zm-1.39-5.86c0 .623-.504 1.127-1.127 1.127-.622 0-1.127-.504-1.127-1.126V40.57c0-.623.505-1.127 1.127-1.127.623 0 1.127.504 1.127 1.127v2.817zm4.508 0c0 .623-.505 1.127-1.127 1.127-.623 0-1.127-.504-1.127-1.126v-7.325c0-.622.505-1.127 1.127-1.127s1.127.505 1.127 1.127v7.325zm4.507 0c0 .623-.504 1.127-1.127 1.127-.622 0-1.127-.504-1.127-1.126V38.88c0-.622.505-1.127 1.127-1.127.623 0 1.127.505 1.127 1.127v4.508z"
                        })
                    ]
                });
            }
        }
    ]);
    return TestClassification;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/AnomalyDetection.jsx






var AnomalyDetection = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AnomalyDetection, Component);
    var _super = _createSuper(AnomalyDetection);
    function AnomalyDetection() {
        _classCallCheck(this, AnomalyDetection);
        return _super.apply(this, arguments);
    }
    _createClass(AnomalyDetection, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "104",
                    height: "109",
                    fill: "none",
                    viewBox: "0 0 104 109",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#CF98D9",
                            d: "M.451 41.96c0 22.968 18.62 41.587 41.587 41.587 22.968 0 41.587-18.62 41.587-41.587 0-22.968-18.62-41.587-41.587-41.587C19.07.373.451 18.993.451 41.96z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "41.986",
                            cy: "41.832",
                            r: "30.686",
                            fill: "#fff",
                            transform: "rotate(-180 41.986 41.832)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#7705BC",
                            d: "M41.47 57.701c-8.794 0-15.95-7.156-15.95-15.951 0-8.795 7.156-15.951 15.95-15.951 3.801 0 7.348 1.302 10.257 3.766.421.355.47.985.118 1.406-.359.423-.985.47-1.406.116-2.544-2.156-5.647-3.294-8.968-3.294-7.697 0-13.958 6.26-13.958 13.957 0 7.694 6.261 13.957 13.958 13.957 7.694 0 13.957-6.263 13.957-13.957 0-2.853-.855-5.593-2.474-7.926-.313-.452-.202-1.075.25-1.387.451-.313 1.074-.202 1.389.249 1.85 2.67 2.829 5.802 2.829 9.064 0 8.795-7.156 15.951-15.951 15.951z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#7705BC",
                            d: "M52.44 34.773c-1.649 0-2.99-1.342-2.99-2.991 0-1.65 1.341-2.991 2.99-2.991 1.649 0 2.99 1.342 2.99 2.99 0 1.65-1.341 2.992-2.99 2.992zm0-3.988c-.548 0-.997.447-.997.997s.449.997.997.997.997-.447.997-.997-.449-.997-.997-.997zM41.471 44.741c-1.649 0-2.99-1.341-2.99-2.99 0-1.65 1.341-2.991 2.99-2.991 1.65 0 2.991 1.342 2.991 2.99 0 1.65-1.342 2.991-2.99 2.991zm0-3.987c-.55 0-.997.446-.997.997 0 .548.447.997.997.997.549 0 .997-.45.997-.997 0-.55-.448-.997-.997-.997z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#7705BC",
                            d: "M41.47 51.718c-5.498 0-9.97-4.472-9.97-9.97 0-5.496 4.472-9.969 9.97-9.969 5.497 0 9.969 4.473 9.969 9.97 0 5.497-4.472 9.97-9.97 9.97zm0-17.945c-4.4 0-7.976 3.577-7.976 7.976 0 4.398 3.577 7.975 7.975 7.975 4.399 0 7.976-3.577 7.976-7.975 0-4.399-3.577-7.976-7.976-7.976z"
                        })
                    ]
                });
            }
        }
    ]);
    return AnomalyDetection;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/ImgVdoAnalytics.jsx






var ImgVdoAnalytics = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ImgVdoAnalytics, Component);
    var _super = _createSuper(ImgVdoAnalytics);
    function ImgVdoAnalytics() {
        _classCallCheck(this, ImgVdoAnalytics);
        return _super.apply(this, arguments);
    }
    _createClass(ImgVdoAnalytics, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "104",
                    height: "109",
                    fill: "none",
                    viewBox: "0 0 104 109",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FF7C7D",
                            d: "M.654 41.957c0 22.968 18.619 41.588 41.587 41.588 22.968 0 41.587-18.62 41.587-41.588S65.208.37 42.241.37C19.273.37.654 18.99.654 41.957z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "42.068",
                            cy: "41.825",
                            r: "30.686",
                            fill: "#fff",
                            transform: "rotate(-180 42.068 41.825)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            stroke: "#FF2828",
                            "stroke-miterlimit": "10",
                            strokeWidth: "1.2",
                            d: "M36.774 49.622l-2.782-1.606v3.212l2.782-1.606zm0 0l-2.782-1.606v3.212l2.782-1.606z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            stroke: "#FF2828",
                            "stroke-miterlimit": "10",
                            strokeWidth: "1.6",
                            d: "M26.835 55.758v-12.27h16.432v12.27H26.835zM33.769 39.113V25.455h23.367v13.658H33.769z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            stroke: "#FF2828",
                            "stroke-miterlimit": "10",
                            strokeWidth: "1.6",
                            d: "M41.835 31.868c.849 0 1.538-.689 1.538-1.538 0-.85-.689-1.538-1.538-1.538-.85 0-1.538.688-1.538 1.538 0 .85.688 1.538 1.538 1.538zM33.793 39.124l5.09-4.872 3.563 3.41 5.345-5.116 3.308 3.167 6.109-5.847"
                        })
                    ]
                });
            }
        }
    ]);
    return ImgVdoAnalytics;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/DocumentDigitalization.jsx






var DocumentDigitalization = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(DocumentDigitalization, Component);
    var _super = _createSuper(DocumentDigitalization);
    function DocumentDigitalization() {
        _classCallCheck(this, DocumentDigitalization);
        return _super.apply(this, arguments);
    }
    _createClass(DocumentDigitalization, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "104",
                    height: "109",
                    fill: "none",
                    viewBox: "0 0 104 109",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FCA6DE",
                            d: "M.49 41.958c0 22.968 18.619 41.587 41.587 41.587 22.968 0 41.587-18.619 41.587-41.587C83.664 18.99 65.044.371 42.077.371 19.109.371.49 18.991.49 41.958z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "42.06",
                            cy: "41.822",
                            r: "30.686",
                            fill: "#fff",
                            transform: "rotate(-180 42.06 41.822)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FF0A7A",
                            d: "M54.623 47.57h-1.877v3.754h1.877V47.57zM52.744 56.016c0 .25-.1.488-.275.664-.176.176-.415.275-.663.275h-.939v1.876h.939c.746 0 1.462-.296 1.99-.824s.824-1.244.824-1.99v-.939h-1.876v.938zM47.117 56.957h-3.754v1.877h3.754v-1.877zM39.609 56.953h-3.754v1.877h3.754v-1.877zM32.103 56.016v-.938h-1.876v.938c0 .747.296 1.463.824 1.99.528.529 1.244.825 1.99.825v-1.876c-.248 0-.487-.1-.663-.275-.176-.176-.275-.415-.275-.664zM32.1 47.574h-1.877v3.753h1.876v-3.753z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FF0A7A",
                            d: "M57.437 41.943c-.25 0-.488.099-.664.274-.176.176-.275.415-.275.664v.938h-1.876v-8.445c-.002-.249-.1-.487-.276-.664l-7.506-7.506c-.177-.175-.415-.273-.663-.274H33.041c-.747 0-1.463.296-1.99.824-.528.528-.825 1.244-.825 1.99V43.82h-1.877v-.938c0-.249-.099-.488-.275-.664-.176-.175-.414-.274-.663-.274-.249 0-.488.099-.664.274-.175.176-.274.415-.274.664v3.753c0 .249.099.488.274.664.176.176.415.274.664.274.249 0 .487-.098.663-.274.176-.176.275-.415.275-.664v-.938H56.5v.938c0 .249.098.488.274.664.176.176.415.274.664.274.249 0 .487-.098.663-.274.176-.176.275-.415.275-.664v-3.753c0-.249-.099-.488-.275-.664-.176-.175-.414-.274-.663-.274zm-10.322-11.81l4.303 4.303h-3.364c-.25 0-.488-.099-.664-.275-.176-.176-.275-.414-.275-.663v-3.365zM32.102 43.82V29.745c0-.25.1-.488.275-.664.176-.176.415-.275.664-.275h12.198v4.692c0 .746.296 1.462.824 1.99s1.244.825 1.99.825h4.692v7.506H32.103z"
                        })
                    ]
                });
            }
        }
    ]);
    return DocumentDigitalization;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/threeDots.jsx






var threeDots_uploadIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(uploadIcon, Component);
    var _super = _createSuper(uploadIcon);
    function uploadIcon() {
        _classCallCheck(this, uploadIcon);
        return _super.apply(this, arguments);
    }
    _createClass(uploadIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    fill: "currentColor",
                    class: "bi bi-three-dots-vertical",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                    })
                });
            }
        }
    ]);
    return uploadIcon;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/crossIcon.jsx






var CrossIcon = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CrossIcon, Component);
    var _super = _createSuper(CrossIcon);
    function CrossIcon() {
        _classCallCheck(this, CrossIcon);
        return _super.apply(this, arguments);
    }
    _createClass(CrossIcon, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "17",
                    height: "17",
                    fill: "none",
                    viewBox: "0 0 17 17",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#666",
                        "stroke-linecap": "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.6",
                        d: "M12.996 4.635l-8 8M4.996 4.635l8 8"
                    })
                });
            }
        }
    ]);
    return CrossIcon;
}(react.Component);


// EXTERNAL MODULE: ./styles/components/failure.module.scss
var failure_module = __webpack_require__(8188);
var failure_module_default = /*#__PURE__*/__webpack_require__.n(failure_module);
;// CONCATENATED MODULE: ./public/assets/svg/failure.jsx







var Failure = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Failure, Component);
    var _super = _createSuper(Failure);
    function Failure() {
        _classCallCheck(this, Failure);
        return _super.apply(this, arguments);
    }
    _createClass(Failure, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (failure_module_default()).outer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (failure_module_default()).inner,
                            children: "!"
                        })
                    })
                });
            }
        }
    ]);
    return Failure;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/RPA.jsx






var RPA = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(RPA, Component);
    var _super = _createSuper(RPA);
    function RPA() {
        _classCallCheck(this, RPA);
        return _super.apply(this, arguments);
    }
    _createClass(RPA, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "84",
                    height: "84",
                    viewBox: "0 0 84 84",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            r: "41.5873",
                            transform: "matrix(-1 8.74228e-08 8.74228e-08 1 41.5875 41.5873)",
                            fill: "#4BA58A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30.8576 13.0654C15.1286 18.655 6.94005 35.8485 12.5709 51.4622C18.2018 67.0758 35.5224 75.2043 51.2514 69.6147C66.9804 64.0252 75.169 46.8316 69.5381 31.218C63.9073 15.6043 46.5866 7.47587 30.8576 13.0654Z",
                            fill: "url(#paint0_linear_5660_8912)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M35.7266 52.1641H40.9905",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M48.8882 55.7021V49.3338C49.2372 49.3338 49.572 49.1847 49.8188 48.9193C50.0656 48.6539 50.2042 48.2939 50.2042 47.9186V45.0882C50.2042 44.7129 50.0656 44.3529 49.8188 44.0875C49.572 43.8221 49.2372 43.673 48.8882 43.673V40.8426C48.8882 39.9043 48.5416 39.0044 47.9246 38.3409C47.3076 37.6774 46.4708 37.3047 45.5983 37.3047H31.1225C30.25 37.3047 29.4132 37.6774 28.7962 38.3409C28.1792 39.0044 27.8326 39.9043 27.8326 40.8426V43.673C27.4836 43.673 27.1488 43.8221 26.902 44.0875C26.6552 44.3529 26.5166 44.7129 26.5166 45.0882V47.9186C26.5166 48.2939 26.6552 48.6539 26.902 48.9193C27.1488 49.1847 27.4836 49.3338 27.8326 49.3338V55.7021H48.8882Z",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M38.3574 37.3047V32.3516",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M38.3607 32.351C39.4509 32.351 40.3347 31.4006 40.3347 30.2282C40.3347 29.0559 39.4509 28.1055 38.3607 28.1055C37.2705 28.1055 36.3867 29.0559 36.3867 30.2282C36.3867 31.4006 37.2705 32.351 38.3607 32.351Z",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M34.4102 44.3789V47.9169",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M42.3105 44.3789V47.9169",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M47.5723 33.0586C48.4448 33.0586 49.2816 33.4313 49.8986 34.0948C50.5156 34.7583 50.8622 35.6582 50.8622 36.5966",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M47.5723 30.2266C49.1429 30.2266 50.6491 30.8975 51.7597 32.0918C52.8703 33.2861 53.4942 34.9059 53.4942 36.5949",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M47.5723 27.3984C48.6956 27.3984 49.8079 27.6364 50.8457 28.0986C51.8835 28.5609 52.8265 29.2385 53.6208 30.0927C54.4151 30.9469 55.0451 31.9609 55.475 33.0769C55.9049 34.193 56.1261 35.3891 56.1261 36.5971",
                            stroke: "#489E84",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                id: "paint0_linear_5660_8912",
                                x1: "13.9784",
                                y1: "28.6407",
                                x2: "68.4819",
                                y2: "54.5984",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        "stop-color": "white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "1",
                                        "stop-color": "#F3F7F7"
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RPA;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/WebScrapping.jsx






var WebScrapping = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(WebScrapping, Component);
    var _super = _createSuper(WebScrapping);
    function WebScrapping() {
        _classCallCheck(this, WebScrapping);
        return _super.apply(this, arguments);
    }
    _createClass(WebScrapping, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    version: "1.2",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 84 84",
                    width: "84",
                    height: "84",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                                width: "84",
                                height: "84",
                                id: "img1",
                                href: "data:image/png;base64,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"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            href: "#img1",
                            x: "0",
                            y: "0"
                        })
                    ]
                });
            }
        }
    ]);
    return WebScrapping;
}(react.Component);


;// CONCATENATED MODULE: ./public/assets/svg/index.jsx



































































var Icons = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Icons, _Component);
    var _super = _createSuper(Icons);
    function Icons(props) {
        _classCallCheck(this, Icons);
        return _super.call(this, props);
    }
    _createClass(Icons, [
        {
            key: "render",
            value: function render() {
                switch(this.props.name){
                    case "failure":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Failure, (0,_object_spread/* default */.Z)({}, this.props));
                    case "CrossIcon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "threeDots":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(threeDots_uploadIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "check":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(check, (0,_object_spread/* default */.Z)({}, this.props));
                    case "searchDesktop":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(searchDesktop, (0,_object_spread/* default */.Z)({}, this.props));
                    case "userDesktop":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(userDesktop, (0,_object_spread/* default */.Z)({}, this.props));
                    case "searchMobile":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(searchMobile, (0,_object_spread/* default */.Z)({}, this.props));
                    case "burgerMenu":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(burgerMenu, (0,_object_spread/* default */.Z)({}, this.props));
                    case "enquiryicon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(enquiryIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "uploadicon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(uploadIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "searchGrayIcon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(searchGray, (0,_object_spread/* default */.Z)({}, this.props));
                    case "plusIcon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(plusIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "chevron":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron, (0,_object_spread/* default */.Z)({}, this.props));
                    case "leftArrow":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(leftArrow, (0,_object_spread/* default */.Z)({}, this.props));
                    case "rightArrow":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrow, (0,_object_spread/* default */.Z)({}, this.props));
                    case "information":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(information, (0,_object_spread/* default */.Z)({}, this.props));
                    case "pencilDark":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(pencilDark, (0,_object_spread/* default */.Z)({}, this.props));
                    case "listWhite":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(listWhite, (0,_object_spread/* default */.Z)({}, this.props));
                    case "marketing":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(shoppingIcon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "whitetick":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(whiteTick, (0,_object_spread/* default */.Z)({}, this.props));
                    case "ppt":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RandD, (0,_object_spread/* default */.Z)({}, this.props));
                    case "pptx":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RandD, (0,_object_spread/* default */.Z)({}, this.props));
                    case "arrowback":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowback, (0,_object_spread/* default */.Z)({}, this.props));
                    case "filters":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(filters, (0,_object_spread/* default */.Z)({}, this.props));
                    case "pdf":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(pdfdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "msg":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Maildoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "xlsx":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Xlsdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "xls":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Xlsdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "Xlsx":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Xlsdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "jpg":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Jpgdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "jpeg":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Jpgdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "doc":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Docdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "docx":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Docdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "png":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pngdoc, (0,_object_spread/* default */.Z)({}, this.props));
                    case "downloadWhite":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(downloadWhite, (0,_object_spread/* default */.Z)({}, this.props));
                    case "downloadBlue":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(downloadBlue, (0,_object_spread/* default */.Z)({}, this.props));
                    case "deleteicon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(delete_chevron, (0,_object_spread/* default */.Z)({}, this.props));
                    case "logout":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(logout, (0,_object_spread/* default */.Z)({}, this.props));
                    case "closewhite":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(closeBurger, (0,_object_spread/* default */.Z)({}, this.props));
                    case "whitelist":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(listWhite, (0,_object_spread/* default */.Z)({}, this.props));
                    case "customerDevelopment":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(customerDevelopment, (0,_object_spread/* default */.Z)({}, this.props));
                    case "supplyChain":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(supplyChain, (0,_object_spread/* default */.Z)({}, this.props));
                    case "iTService":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(itService, (0,_object_spread/* default */.Z)({}, this.props));
                    case "iTServices":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(itService, (0,_object_spread/* default */.Z)({}, this.props));
                    case "finance":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(finance, (0,_object_spread/* default */.Z)({}, this.props));
                    case "workplaceService":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(workplaceService, (0,_object_spread/* default */.Z)({}, this.props));
                    case "workplaceServices":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(workplaceService, (0,_object_spread/* default */.Z)({}, this.props));
                    case "legal":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(legal, (0,_object_spread/* default */.Z)({}, this.props));
                    case "i&A":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IandA, (0,_object_spread/* default */.Z)({}, this.props));
                    case "r&D":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RandD_RandD, (0,_object_spread/* default */.Z)({}, this.props));
                    case "hRServices":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service, (0,_object_spread/* default */.Z)({}, this.props));
                    case "hr":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service, (0,_object_spread/* default */.Z)({}, this.props));
                    case "hR":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service, (0,_object_spread/* default */.Z)({}, this.props));
                    case "hrService":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service, (0,_object_spread/* default */.Z)({}, this.props));
                    case "cez":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(cez, (0,_object_spread/* default */.Z)({}, this.props));
                    case "cezicon":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(cez1, (0,_object_spread/* default */.Z)({}, this.props));
                    case "video":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(videoicon, (0,_object_spread/* default */.Z)({}, this.props));
                    case "scrabble":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(scrabble, (0,_object_spread/* default */.Z)({}, this.props));
                    case "redarrow":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(redArrow, (0,_object_spread/* default */.Z)({}, this.props));
                    case "botinfo":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(botinfo, (0,_object_spread/* default */.Z)({}, this.props));
                    case "requestbot":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(requestbot, (0,_object_spread/* default */.Z)({}, this.props));
                    case "crown":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(crown, (0,_object_spread/* default */.Z)({}, this.props));
                    case "grayclose":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(grayclose, (0,_object_spread/* default */.Z)({}, this.props));
                    case "ConversationalAi":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConversetionalAi, (0,_object_spread/* default */.Z)({}, this.props));
                    case "RPA":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RPA, (0,_object_spread/* default */.Z)({}, this.props));
                    case "WebScrapping":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WebScrapping, (0,_object_spread/* default */.Z)({}, this.props));
                    case "TestClassification":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestClassification, (0,_object_spread/* default */.Z)({}, this.props));
                    case "AnomalyDetection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnomalyDetection, (0,_object_spread/* default */.Z)({}, this.props));
                    case "ImgVdoAnalytics":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgVdoAnalytics, (0,_object_spread/* default */.Z)({}, this.props));
                    case "DocumentDigitalization":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentDigitalization, (0,_object_spread/* default */.Z)({}, this.props));
                    case "ConversationAiSelected":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConversationalAiSelected, (0,_object_spread/* default */.Z)({}, this.props));
                    default:
                        return "";
                }
            }
        }
    ]);
    return Icons;
}(react.Component);



/***/ }),

/***/ 79838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ LOGIN_USER_SUCCESS; },
/* harmony export */   "Q6": function() { return /* binding */ LOGOUT_USER_SUCCESS; },
/* harmony export */   "Ys": function() { return /* binding */ LOGIN_USER; },
/* harmony export */   "c0": function() { return /* binding */ LOGOUT_USER_FAILED; },
/* harmony export */   "sx": function() { return /* binding */ LOGIN_USER_FAILED; }
/* harmony export */ });
/* unused harmony exports sendContactDetails, getContactDetails, LOGOUT_USER */
var sendContactDetails = "SEND_CONTACT_DETAILS";
var getContactDetails = "GET_CONTACT_DETAILS";
var LOGIN_USER = "easyplatter/user/LOGIN_USER";
var LOGIN_USER_FAILED = "easyplatter/user/LOGIN_USER_FAILED";
var LOGIN_USER_SUCCESS = "easyplatter/user/LOGIN_USER_SUCCESS";
var LOGOUT_USER = "easyplatter/user/LOGOUT_USER";
var LOGOUT_USER_FAILED = "easyplatter/user/LOGOUT_USER_FAILED";
var LOGOUT_USER_SUCCESS = "easyplatter/user/LOGOUT_USER_SUCCESS";


/***/ }),

/***/ 69365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79838);



var initialState = {
    userData: {},
    loginUserStatus: false
};
var authReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LOGIN_USER */ .Ys:
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    loginUserStatus: false
                });
            }
        case _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LOGIN_USER_SUCCESS */ .$U:
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    userData: action.payload.data,
                    loginUserStatus: action.payload.success
                });
            }
        case _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LOGIN_USER_FAILED */ .sx:
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    userData: action.payload,
                    loginUserStatus: action.payload.success
                });
            }
        case _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LOGOUT_USER_SUCCESS */ .Q6:
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    userData: {},
                    loginUserStatus: false
                });
            }
        case _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LOGOUT_USER_FAILED */ .c0:
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    userData: action.payload
                });
            }
        default:
            return initialState;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (authReducer);


/***/ }),

/***/ 34300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ firstBotCreateActionType; }
/* harmony export */ });
var firstBotCreateActionType = "SAVE_FIRST_BOT_CREATE_PAGE";


/***/ }),

/***/ 94006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hP": function() { return /* binding */ getAccessToken; },
/* harmony export */   "hV": function() { return /* binding */ getAccessTokenFailed; },
/* harmony export */   "pU": function() { return /* binding */ sessionTimeOut; },
/* harmony export */   "s1": function() { return /* binding */ getAccessTokenSuccess; }
/* harmony export */ });
var sessionTimeOut = "SESSION_TIMEOUT_CHECK";
var getAccessToken = "GET_ACCESS_TOKEN";
var getAccessTokenSuccess = "GET_ACCESS_TOKEN_SUCCESS";
var getAccessTokenFailed = "GET_ACCESS_TOKEN_FAILED";


/***/ }),

/***/ 39471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ sessionTimeOutCheck; },
/* harmony export */   "Wr": function() { return /* binding */ checkExpiry; }
/* harmony export */ });
/* unused harmony exports sessionTimeOutChecking, getAccessToken */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94006);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49530);
/* harmony import */ var msal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8115);






var sessionTimeOutCheck = function(payload) {
    return function(dispatch) {
        dispatch(sessionTimeOutChecking(payload));
        if (payload == false) {
            next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/login");
        }
    };
};
var sessionTimeOutChecking = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_2__/* .sessionTimeOut */ .pU,
        payload: data
    };
};
var gettingAccessToken = function() {
    return {
        type: actionTypes.getAccessToken
    };
};
var gettingAccessTokenSuccess = function(data) {
    return {
        type: actionTypes.getAccessTokenSuccess,
        payload: data
    };
};
var gettingAccessTokenFailed = function() {
    return {
        type: actionTypes.getAccessTokenFailed
    };
};
function getAccessToken() {
    //console.log("getting access token again 1, Session");
    try {
        //console.log("getting access token again, Session");
        var msalConfig = {
            auth: {
                clientId: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].clientId */ .ZP.clientId),
                authority: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].authority */ .ZP.authority),
                redirectUri: _utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].redirectUriLogin */ .ZP.redirectUriLogin
            }
        };
        var msalInstance = new msal__WEBPACK_IMPORTED_MODULE_3__/* .UserAgentApplication */ .x(msalConfig);
        var loginRequest = {
            scopes: [
                "offline_access"
            ]
        };
        msalInstance.acquireTokenSilent(loginRequest).then(function(response) {
            //console.log("got access token again, Session", response);
            var auth = JSON.parse(localStorage.getItem("auth"));
            auth.data.accessToken = response.accessToken;
            auth.data.expiresOn = response.expiresOn;
            localStorage.setItem("auth", JSON.stringify(auth));
            return true;
        }).catch(function(error) {
            console.log(error, "Session in");
            return false;
        });
        return true;
    } catch (error) {
        console.log(error, "Session");
        return false;
    }
}
function checkExpiry(auth) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(dispatch, getState, api) {
            var myDate, minutes, newTokenStatus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        {}
                        myDate = new Date(auth.expiresOn);
                        minutes = myDate.getMinutes();
                        //console.log(minutes, "number2")
                        if (minutes < 10) {
                            myDate.setMinutes(60 - (10 - minutes));
                            myDate.setHours(myDate.getHours() - 1);
                        } else {
                            myDate.setMinutes(minutes - 10);
                        }
                        if (!(myDate > new Date())) return [
                            3,
                            1
                        ];
                        return [
                            2,
                            true
                        ];
                    case 1:
                        return [
                            4,
                            getAccessToken()
                        ];
                    case 2:
                        newTokenStatus = _state.sent();
                        if (newTokenStatus) {
                            return [
                                2,
                                true
                            ];
                        } else {
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState, api) {
            return _ref.apply(this, arguments);
        };
    }();
}


/***/ }),

/***/ 96713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ FETCH_GLOBAL_SEARCH_RESULT_SUCCESS; },
/* harmony export */   "Ke": function() { return /* binding */ FETCH_GLOBAL_SEARCH_RESULT_FAILED; },
/* harmony export */   "rY": function() { return /* binding */ FETCH_GLOBAL_SEARCH_RESULT; }
/* harmony export */ });
var FETCH_GLOBAL_SEARCH_RESULT = "FETCH_GLOBAL_SEARCH_RESULT";
var FETCH_GLOBAL_SEARCH_RESULT_SUCCESS = "FETCH_GLOBAL_SEARCH_RESULT_SUCCESS";
var FETCH_GLOBAL_SEARCH_RESULT_FAILED = "FETCH_GLOBAL_SEARCH_RESULT_FAILED";


/***/ }),

/***/ 39880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ getBotsFailed; },
/* harmony export */   "Le": function() { return /* binding */ saveBotsActionType; },
/* harmony export */   "Pu": function() { return /* binding */ editCurrentBotActionType; },
/* harmony export */   "YH": function() { return /* binding */ saveFilterListProdnType; },
/* harmony export */   "ZG": function() { return /* binding */ saveCurrentBotActionType; }
/* harmony export */ });
/* unused harmony export getBotsActionType */
var saveBotsActionType = "SAVE_PRODUCTS";
var getBotsActionType = "GET_PRODUCTS";
var saveCurrentBotActionType = "SAVE_CURRENT_PRODUCTS";
var saveFilterListProdnType = "SAVE_FILTERLIST_PRODUCTS";
var editCurrentBotActionType = "EDIT_CURRENT_PRODUCTS";
var getBotsFailed = "GET_PRODUCTS_FAILED";


/***/ }),

/***/ 14138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ getBotsFailed; },
/* harmony export */   "Le": function() { return /* binding */ saveBotsActionType; },
/* harmony export */   "Pu": function() { return /* binding */ editCurrentBotActionType; },
/* harmony export */   "ZG": function() { return /* binding */ saveCurrentBotActionType; }
/* harmony export */ });
/* unused harmony export getBotsActionType */
var saveBotsActionType = "SAVE_BOTS";
var getBotsActionType = "GET_BOTS";
var saveCurrentBotActionType = "SAVE_CURRENT_BOT";
var editCurrentBotActionType = "EDIT_CURRENT_BOT";
var getBotsFailed = "GET_BOTS_FAILED";


/***/ }),

/***/ 74809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ps": function() { return /* binding */ updated; },
/* harmony export */   "ke": function() { return /* binding */ submitAnIdeaFailed; },
/* harmony export */   "m7": function() { return /* binding */ submitAnIdeaSuccess; },
/* harmony export */   "mc": function() { return /* binding */ reset; }
/* harmony export */ });
/* unused harmony export submitAnIdea */
var submitAnIdea = "SUBMIT_AN_IDEA";
var submitAnIdeaSuccess = "SUBMIT_AN_IDEA_SUCCESS";
var submitAnIdeaFailed = "SUBMIT_AN_IDEA_FAILED";
var updated = "SUBMIT_AN_IDEA_UPDATED";
var reset = "RESET";


/***/ }),

/***/ 49530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports setDynamicSas, fetchSasFromApi */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
// In-memory and sessionStorage cache for dynamic SAS token and URL


var cachedSasUrl = "";
var cachedSasToken = "";
var fetchPromise = null;
var STORAGE_KEY_URL = "__AZURE_SAS_URL";
var STORAGE_KEY_TOKEN = "__AZURE_SAS_TOKEN";
var STORAGE_KEY_EXP = "__AZURE_SAS_EXP";
// Restore synchronously from sessionStorage if present and valid
if (true) {
    try {
        var storedExp = sessionStorage.getItem(STORAGE_KEY_EXP);
        var storedUrl = sessionStorage.getItem(STORAGE_KEY_URL);
        var storedToken = sessionStorage.getItem(STORAGE_KEY_TOKEN);
        if (storedUrl && storedExp && new Date(storedExp) > new Date()) {
            cachedSasUrl = storedUrl;
            cachedSasToken = storedToken || "";
        }
    } catch (e) {}
}
var setDynamicSas = function(token, url, expiresAt) {
    if (token) cachedSasToken = token;
    if (url) cachedSasUrl = url;
    if (true) {
        if (token) window.__AZURE_SAS_TOKEN = token;
        if (url) window.__AZURE_SAS_URL = url;
        try {
            if (url) sessionStorage.setItem(STORAGE_KEY_URL, url);
            if (token) sessionStorage.setItem(STORAGE_KEY_TOKEN, token);
            if (expiresAt) {
                sessionStorage.setItem(STORAGE_KEY_EXP, expiresAt);
            } else {
                // Default 15 minutes expiry for session storage
                sessionStorage.setItem(STORAGE_KEY_EXP, new Date(Date.now() + 15 * 60 * 1000).toISOString());
            }
        } catch (e) {}
    }
};
var fetchSasFromApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            if (cachedSasUrl && cachedSasUrl.includes("?sv=")) return [
                2,
                cachedSasUrl
            ];
            if (fetchPromise) return [
                2,
                fetchPromise
            ];
            if (false) {}
            fetchPromise = fetch("/api/sas/admin?minutes=15").then(function(res) {
                if (!res.ok) throw new Error("Failed to fetch admin SAS");
                return res.json();
            }).then(function(data) {
                if (data.sasUrl) {
                    setDynamicSas(data.sasToken, data.sasUrl, data.expiresAt);
                }
                fetchPromise = null;
                return cachedSasUrl;
            }).catch(function(err) {
                console.warn("Could not fetch dynamic SAS URL:", err);
                fetchPromise = null;
                return cachedSasUrl;
            });
            return [
                2,
                fetchPromise
            ];
        });
    });
    return function fetchSasFromApi() {
        return _ref.apply(this, arguments);
    };
}();
// Initiate dynamic fetch immediately in browser
if (true) {
    if (!cachedSasUrl || !cachedSasUrl.includes("?sv=")) {
        fetchSasFromApi();
    }
}
var accountName = "bnlwestgunileveraf01092" || 0;
var endpoints = {
    AccountName: accountName,
    redirectUriLogin: "https://automation.unilever.com/" || 0,
    baseUrl: "https://automation.unilever.com/api" || 0,
    createContact: "contact/createContact",
    globalSearch: "elastic/globalSearch",
    drupalIp: "https://automation.unilever.com" || 0,
    drupalIpContent: "http://10.234.240.77" || 0,
    fetchBlobUrl: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo" || 0,
    clientId: "78ded294-9fe9-47ae-8546-48b32a078f16" || 0,
    authority: "https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e" || 0,
    sumbitAnIdea: "ideas/submitIdea",
    demoRequest: "/demo/createDemoRequest",
    createBO: "/user/createBO",
    // Dynamic getter for blobSasUrlNew so all 26 components receive the secure token automatically
    get blobSasUrlNew () {
        if (cachedSasUrl) return cachedSasUrl;
        if ( true && window.__AZURE_SAS_URL) {
            return window.__AZURE_SAS_URL;
        }
        // Safe placeholder URL so `new BlobServiceClient(...)` does not crash during initial render
        return "https://".concat(accountName, ".blob.core.windows.net/?");
    },
    set blobSasUrlNew (val){
        setDynamicSas(cachedSasToken, val);
    },
    // Dynamic getter for sasToken
    get sasToken () {
        if (cachedSasToken) return cachedSasToken;
        if ( true && window.__AZURE_SAS_TOKEN) {
            return window.__AZURE_SAS_TOKEN;
        }
        return "";
    },
    set sasToken (val){
        setDynamicSas(val, cachedSasUrl);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (endpoints);


/***/ }),

/***/ 51963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"successModal_liveStatus__2iTYW","rejectedStatus":"successModal_rejectedStatus__BhUmS","retiredStatus":"successModal_retiredStatus__qja2l","onHoldStatus":"successModal_onHoldStatus__7s_Mz","in-ProgressStatus":"successModal_in-ProgressStatus__fk9JX","inProgressStatus":"successModal_inProgressStatus__5QE1h","uATStatus":"successModal_uATStatus__juRWX","initialDemandStatus":"successModal_initialDemandStatus__XfSt6","designFeasibilityStatus":"successModal_designFeasibilityStatus__1MH5Y","feasibilityStatus":"successModal_feasibilityStatus__7PX1T","designStatus":"successModal_designStatus__JeKte","ideasStatus":"successModal_ideasStatus__SZ4jM","buildStatus":"successModal_buildStatus__7VEjx","successContainer":"successModal_successContainer__7YWWu","modalBox":"successModal_modalBox__RGMsv","modalHeader":"successModal_modalHeader__u9FY6","content":"successModal_content__9R2Aq","modalBody":"successModal_modalBody__h95Qc","status":"successModal_status__HxiZx","textBody":"successModal_textBody__KKxRj","texthead":"successModal_texthead__7qSLP","textcontent":"successModal_textcontent__SSv07","modalFooter":"successModal_modalFooter__OU8HF","areYouSureBtn":"successModal_areYouSureBtn__ezCSL","exportListBtn":"successModal_exportListBtn__yF6ot","uploadIcon":"successModal_uploadIcon__PXRx2","combinedBtn":"successModal_combinedBtn__Q4DxI","rowBtn":"successModal_rowBtn__7Vl44","plusIcon":"successModal_plusIcon__ypkUW","SubmitAnIdeaBtn":"successModal_SubmitAnIdeaBtn__tj3ga","submitAnIdeaOk":"successModal_submitAnIdeaOk__vXV2i","successCheckoutContainer":"successModal_successCheckoutContainer__Ry8db"};

/***/ }),

/***/ 8188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outer":"failure_outer__GGNrt","inner":"failure_inner__Dus4b"};

/***/ }),

/***/ 40993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70279:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 78301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClient": function() { return /* reexport */ QueryClient; }
});

// UNUSED EXPORTS: CancelledError, InfiniteQueryObserver, MutationCache, MutationObserver, QueriesObserver, QueryCache, QueryObserver, dehydrate, focusManager, hashQueryKey, hydrate, isCancelledError, isError, notifyManager, onlineManager, setLogger

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,setPrototypeOf/* default */.Z)(t, o);
}

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/subscribable.js
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/focusManager.js



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!utils/* isServer */.sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(Subscribable);
var focusManager = new FocusManager();
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/onlineManager.js



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!utils/* isServer */.sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(Subscribable);
var onlineManager = new OnlineManager();
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/retryer.js




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,utils/* sleep */.Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!focusManager.isFocused() || !onlineManager.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new Retryer({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!isCancelledError(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (isCancelledError(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(Subscribable);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutation.js




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,esm_extends/* default */.Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,logger/* getLogger */.j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new Retryer({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,esm_extends/* default */.Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,esm_extends/* default */.Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,esm_extends/* default */.Z)({}, state, action.state);

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(Subscribable);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,utils/* getAbortController */.G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if (isCancelable(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if (isCancelable(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/index.js














 // Types



/***/ }),

/***/ 41909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationArgs, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, shallowEqualObjects, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return _extends({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return _extends({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return _extends({}, arg2, {
      mutationFn: arg1
    });
  }

  return _extends({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78301);
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38655);



/***/ }),

/***/ 38655:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Hydrate, QueryClientProvider, QueryErrorResetBoundary, useHydrate, useInfiniteQuery, useIsFetching, useIsMutating, useMutation, useQueries, useQuery, useQueryClient, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 14416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useSelector, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function Subscription_createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = Subscription_createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(72973);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? Context_ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = Subscription_createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(Context_ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useStore = context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = useReducer(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef();
  var latestStoreState = useRef();
  var latestSelectedState = useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function () {
    return useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/(/* unused pure expression or super */ null && (createSelectorHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 88359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 72973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(88359);
} else {}


/***/ }),

/***/ 28500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var compose = (__webpack_require__(14890)/* .compose */ .qC);

__webpack_unused_export__ = true;
exports.Uo =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

__webpack_unused_export__ =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),

/***/ 72220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OJ": function() { return /* reexport */ persistReducer; },
  "p5": function() { return /* reexport */ persistStore; }
});

// UNUSED EXPORTS: DEFAULT_VERSION, FLUSH, KEY_PREFIX, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, createMigrate, createPersistoid, createTransform, getStoredState, persistCombineReducers, purgeStoredState

;// CONCATENATED MODULE: ./node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel1.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      } // otherwise hard set the new value


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistoid.js

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;

  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }

  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);

    if (err && "production" !== 'production') {}
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }

    return writePromise || Promise.resolve();
  }; // return `persistoid`


  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js

function getStoredState_getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) {}
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {}
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistReducer.js
function persistReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistReducer_ownKeys(source, true).forEach(function (key) { persistReducer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistReducer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (false) {}

  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState = config.getStoredState || getStoredState_getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type


    var restState = rest;

    if (action.type === PERSIST) {
      var _sealed = false;

      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) {} // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };

      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return persistReducer_objectSpread({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }

      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };

        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) {}

          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return persistReducer_objectSpread({}, restState, {
        _persist: persistReducer_objectSpread({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below

      });

      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = persistReducer_objectSpread({}, reconciledRest, {
          _persist: persistReducer_objectSpread({}, _persist, {
            rehydrated: true
          })
        });

        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough


    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(persistReducer_objectSpread({}, newState, {
      _persist: _persist
    }));
  };
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function persistStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistStore_ownKeys(source, true).forEach(function (key) { persistStore_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistStore_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistStore_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REGISTER:
      return persistStore_objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });

    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);

      var registry = _toConsumableArray(state.registry);

      registry.splice(firstIndex, 1);
      return persistStore_objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });

    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) { var bannedKeys, optionsToTest; }

  var boostrappedCb = cb || false;

  var _pStore = (0,redux/* createStore */.MT)(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);

  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result

    };
    store.dispatch(rehydrateAction);

    _pStore.dispatch(rehydrateAction);

    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = persistStore_objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });

  if (!(options && options.manualPersist)) {
    persistor.persist();
  }

  return persistor;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js










/***/ }),

/***/ 23488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = createWebStorage;

var _getStorage = _interopRequireDefault(__webpack_require__(77290));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ 77290:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = getStorage;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) {}
    return false;
  }

  return true;
}

function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {}

    return noopStorage;
  }
}

/***/ }),

/***/ 62168:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = void 0;

var _createWebStorage = _interopRequireDefault(__webpack_require__(23488));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _createWebStorage.default)('session');

exports.Z = _default;

/***/ }),

/***/ 14890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ bindActionCreators; },
/* harmony export */   "MT": function() { return /* binding */ createStore; },
/* harmony export */   "UY": function() { return /* binding */ combineReducers; },
/* harmony export */   "md": function() { return /* binding */ applyMiddleware; },
/* harmony export */   "qC": function() { return /* binding */ compose; }
/* harmony export */ });
/* unused harmony exports __DO_NOT_USE__ActionTypes, legacy_createStore */
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 15437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ it; },
  "ZP": function() { return /* binding */ ut; },
  "F4": function() { return /* binding */ ft; },
  "zo": function() { return /* binding */ ut; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, createGlobalStyle, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var emotion_unitless_esm = __webpack_require__(94371);
;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'
var SCOPE = '@scope'

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof (value, search, position) {
	return value.indexOf(search, position)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter (array, pattern) {
	return array.filter(function (value) { return !match(value, pattern) })
}

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length, siblings) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: '', siblings: siblings}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0, root.siblings), root, {length: -root.length}, props)
}

/**
 * @param {object} root
 */
function lift (root) {
	while (root.root)
		root = copy(root.root, {children: [root]})

	Utility_append(root, root.siblings)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''

	for (var i = 0; i < children.length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case NAMESPACE: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: if (!Utility_strlen(element.value = element.props.join(','))) return ''
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */
function prefix (value, length, children) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
		case 6391: case 5879: case 5623: case 6135: case 4599:
			return WEBKIT + value + value
		// mask-composite
		case 4855:
			return WEBKIT + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value
		// tab-size
		case 4789:
			return MOZ + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
				// default: fallthrough to below
			}
		// flex, flex-direction, scroll-snap-type, writing-mode
		case 6828: case 4268: case 2903:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/g, '') + (!match(value, /flex-|baseline/) ? MS + 'grid-row-' + replace(value, /flex-|-self/g, '') : '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/g, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /space-between/, 'justify') + WEBKIT + value + value
		// justify-self
		case 4200:
			if (!match(value, /flex-|baseline/)) return MS + 'grid-column-align' + Utility_substr(value, length) + value
			break
		// grid-template-(columns|rows)
		case 2592: case 3360:
			return MS + replace(value, 'template-', '') + value
		// grid-(row|column)-start
		case 4384: case 3616:
			if (children && children.some(function (element, index) { return length = index, match(element.props, /grid-\w+-end/) })) {
				return ~indexof(value + (children = children[length].value), 'span', 0) ? value : (MS + replace(value, '-start', '') + value + MS + 'grid-row-span:' + (~indexof(children, 'span', 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ';')
			}
			return MS + replace(value, '-start', '') + value
		// grid-(row|column)-end
		case 4896: case 4128:
			return (children && children.some(function (element) { return match(element.props, /grid-\w+-start/) })) ? value : MS + replace(replace(value, '-end', '-span'), 'span ', '') + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch', 0) ? prefix(replace(value, 'stretch', 'fill-available'), length, children) + value : value
				}
			break
		// grid-(column|row)
		case 5152: case 5920:
			return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (_, a, b, c, d, e, f) { return (MS + a + ':' + b + f) + (c ? (MS + a + '-span:' + (d ? e : +e - +b)) + f : '') + value })
		// position: sticky
		case 4949:
			// stick(y)?
			if (Utility_charat(value, length + 6) === 121)
				return replace(value, ':', ':' + WEBKIT) + value
			break
		// display: (flex|inline-flex|grid|inline-grid)
		case 6444:
			switch (Utility_charat(value, Utility_charat(value, 14) === 45 ? 18 : 11)) {
				// (inline-)?fle(x)
				case 120:
					return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
				// (inline-)?gri(d)
				case 100:
					return replace(value, ':', ':' + MS) + value
			}
			break
		// scroll-margin, scroll-margin-(top|right|bottom|left)
		case 5719: case 2647: case 2135: case 3927: case 2391:
			return replace(value, 'scroll-', 'scroll-snap-') + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(children = element.props, function (value) {
							switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									lift(copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]}))
									lift(copy(element, {props: [value]}))
									Utility_assign(element, {props: filter(children, callback)})
									break
								// :placeholder
								case '::placeholder':
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}))
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}))
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]}))
									lift(copy(element, {props: [value]}))
									Utility_assign(element, {props: filter(children, callback)})
									break
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent, declarations), declarations)
						if ((token(previous || 1) == 5 || token(peek() || 1) == 5) && Utility_strlen(characters) && Utility_substr(characters, -1, void 0) !== ' ') characters += ' '
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length || (variable === 0 && previous === 47)))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else {
								switch (atrule) {
									// c(ontainer)
									case 99:
										if (Utility_charat(characters, 3) === 110) break
									// l(ayer)
									case 108:
										if (Utility_charat(characters, 2) === 97) break
									default:
										offset = 0
									// d(ocument) m(edia) s(upports)
									case 100: case 109: case 115:
								}
								if (offset) parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children)
								else parse(characters, reference, reference, reference, [''], children, 0, points, children)
							}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length, siblings)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment (value, root, parent, siblings) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0, siblings)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration (value, root, parent, length, siblings) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length, siblings)
}

;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
var a="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",c="active",u="data-styled-version",l="6.3.12",p="/*!sc*/\n",h="undefined"!=typeof window&&"undefined"!=typeof document,d=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),f={},m= false?0:{};function y(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],o=[],r=1,s=e.length;r<s;r+=1)o.push(e[r]);return o.forEach(function(e){n=n.replace(/%[a-z]/,e)}),n}function v(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];return true?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):0}var g=(/* unused pure expression or super */ null && (1<<30)),S=new Map,w=new Map,b=1,N=function(e){if(S.has(e))return S.get(e);for(;w.has(b);)b++;var t=b++;if(false){}return S.set(e,t),w.set(t,e),t},E=function(e,t){b=t+1,S.set(e,t),w.set(t,e)},C=/invalid hook call/i,_=new Set,A=function(t,n){if(false){ var a, r, s, i; }},P=Object.freeze([]),I=Object.freeze({});function O(e,t,n){return void 0===n&&(n=I),e.theme!==n.theme&&e.theme||t||n.theme}var D=new Set(["a","abbr","address","area","article","aside","audio","b","bdi","bdo","blockquote","body","button","br","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","label","legend","li","main","map","mark","menu","meter","nav","object","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","search","section","select","slot","small","span","strong","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","switch","symbol","text","textPath","tspan","use"]),R=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,T=/(^-|-$)/g;function x(e){return e.replace(R,"-").replace(T,"")}var j=/(a)(d)/gi,k=function(e){return String.fromCharCode(e+(e>25?39:97))};function M(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=k(t%52)+n;return(k(t%52)+n).replace(j,"$1-$2")}var V,F=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},G=function(e){return F(5381,e)};function L(e){return M(G(e)>>>0)}function B(e){return false||e.displayName||e.name||"Component"}function z(e){return"string"==typeof e&&( true||0)}var $="function"==typeof Symbol&&Symbol.for,Y=$?Symbol.for("react.memo"):60115,W=$?Symbol.for("react.forward_ref"):60112,q={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},H={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},U={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},J=((V={})[W]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},V[Y]=U,V);function X(e){return("type"in(t=e)&&t.type.$$typeof)===Y?U:"$$typeof"in e?J[e.$$typeof]:q;var t}var Z=Object.defineProperty,K=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,ne=Object.prototype;function oe(e,t,n){if("string"!=typeof t){if(ne){var o=te(t);o&&o!==ne&&oe(e,o,n)}var r=K(t);Q&&(r=r.concat(Q(t)));for(var s=X(e),i=X(t),a=0;a<r.length;++a){var c=r[a];if(!(c in H||n&&n[c]||i&&c in i||s&&c in s)){var u=ee(t,c);try{Z(e,c,u)}catch(e){}}}}return e}function re(e){return"function"==typeof e}function se(e){return"object"==typeof e&&"styledComponentId"in e}function ie(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ae(e,t){return e.join(t||"")}function ce(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function ue(e,t,n){if(void 0===n&&(n=!1),!n&&!ce(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var o=0;o<t.length;o++)e[o]=ue(e[o],t[o]);else if(ce(t))for(var o in t)e[o]=ue(e[o],t[o]);return e}function le(e,t){Object.defineProperty(e,"toString",{value:t})}var pe=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e,this._cGroup=0,this._cIndex=0}return e.prototype.indexOfGroup=function(e){if(e===this._cGroup)return this._cIndex;var t=this._cIndex;if(e>this._cGroup)for(var n=this._cGroup;n<e;n++)t+=this.groupSizes[n];else for(n=this._cGroup-1;n>=e;n--)t-=this.groupSizes[n];return this._cGroup=e,this._cIndex=t,t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,r=o;e>=r;)if((r<<=1)<0)throw v(16,"".concat(e));this.groupSizes=new Uint32Array(r),this.groupSizes.set(n),this.length=r;for(var s=o;s<r;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=(s=0,t.length);s<c;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++,a++);a>0&&this._cGroup>e&&(this._cIndex+=a)},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),o=n+t;this.groupSizes[e]=0;for(var r=n;r<o;r++)this.tag.deleteRule(n);t>0&&this._cGroup>e&&(this._cIndex-=t)}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],o=this.indexOfGroup(e),r=o+n,s=o;s<r;s++)t+=this.tag.getRule(s)+p;return t},e}(),he="style[".concat(a,"][").concat(u,'="').concat(l,'"]'),de=new RegExp("^".concat(a,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),fe=function(e){return"undefined"!=typeof ShadowRoot&&e instanceof ShadowRoot||"host"in e&&11===e.nodeType},me=function(e){if(!e)return document;if(fe(e))return e;if("getRootNode"in e){var t=e.getRootNode();if(fe(t))return t}return document},ye=function(e,t,n){for(var o,r=n.split(","),s=0,i=r.length;s<i;s++)(o=r[s])&&e.registerName(t,o)},ve=function(e,t){for(var n,o=(null!==(n=t.textContent)&&void 0!==n?n:"").split(p),r=[],s=0,i=o.length;s<i;s++){var a=o[s].trim();if(a){var c=a.match(de);if(c){var u=0|parseInt(c[1],10),l=c[2];0!==u&&(E(l,u),ye(e,l,c[3]),e.getTag().insertRules(u,r)),r.length=0}else r.push(a)}}},ge=function(e){for(var t=me(e.options.target).querySelectorAll(he),n=0,o=t.length;n<o;n++){var r=t[n];r&&r.getAttribute(a)!==c&&(ve(e,r),r.parentNode&&r.parentNode.removeChild(r))}};function Se(){return true?__webpack_require__.nc:0}var we=function(e){var t=document.head,n=e||t,o=document.createElement("style"),r=function(e){var t=Array.from(e.querySelectorAll("style[".concat(a,"]")));return t[t.length-1]}(n),s=void 0!==r?r.nextSibling:null;o.setAttribute(a,c),o.setAttribute(u,l);var i=Se();return i&&o.setAttribute("nonce",i),n.insertBefore(o,s),o},be=function(){function e(e){this.element=we(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){var t;if(e.sheet)return e.sheet;for(var n=null!==(t=e.getRootNode().styleSheets)&&void 0!==t?t:document.styleSheets,o=0,r=n.length;o<r;o++){var s=n[o];if(s.ownerNode===e)return s}throw v(17)}(this.element),this.length=0}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Ne=function(){function e(e){this.element=we(e),this.nodes=this.element.childNodes,this.length=0}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return!1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),Ee=function(){function e(e){this.rules=[],this.length=0}return e.prototype.insertRule=function(e,t){return e<=this.length&&(e===this.length?this.rules.push(t):this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),Ce=h,_e={isServer:!h,useCSSOMInjection:!d},Ae=function(){function e(e,n,o){void 0===e&&(e=I),void 0===n&&(n={});var r=this;this.options=(0,tslib_es6.__assign)((0,tslib_es6.__assign)({},_e),e),this.gs=n,this.names=new Map(o),this.server=!!e.isServer,!this.server&&h&&Ce&&(Ce=!1,ge(this)),le(this,function(){return function(e){for(var t=e.getTag(),n=t.length,o="",r=function(n){var r=function(e){return w.get(e)}(n);if(void 0===r)return"continue";var s=e.names.get(r);if(void 0===s||!s.size)return"continue";var i=t.getGroup(n);if(0===i.length)return"continue";var c=a+".g"+n+'[id="'+r+'"]',u="";s.forEach(function(e){e.length>0&&(u+=e+",")}),o+=i+c+'{content:"'+u+'"}'+p},s=0;s<n;s++)r(s);return o}(r)})}return e.registerId=function(e){return N(e)},e.prototype.rehydrate=function(){!this.server&&h&&ge(this)},e.prototype.reconstructWithOptions=function(n,o){void 0===o&&(o=!0);var r=new e((0,tslib_es6.__assign)((0,tslib_es6.__assign)({},this.options),n),this.gs,o&&this.names||void 0);return!this.server&&h&&n.target!==this.options.target&&me(this.options.target)!==me(n.target)&&ge(r),r},e.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new Ee(n):t?new be(n):new Ne(n)}(this.options),new pe(e)));var e},e.prototype.hasNameForId=function(e,t){var n,o;return null!==(o=null===(n=this.names.get(e))||void 0===n?void 0:n.has(t))&&void 0!==o&&o},e.prototype.registerName=function(e,t){N(e);var n=this.names.get(e);n?n.add(t):this.names.set(e,new Set([t]))},e.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(N(e),n)},e.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},e.prototype.clearRules=function(e){this.getTag().clearGroup(N(e)),this.clearNames(e)},e.prototype.clearTag=function(){this.tag=void 0},e}();function Pe(e,t){return null==t||"boolean"==typeof t||""===t?"":"number"!=typeof t||0===t||e in emotion_unitless_esm/* default */.Z||e.startsWith("--")?String(t).trim():"".concat(t,"px")}var Ie=function(e){return e>="A"&&e<="Z"};function Oe(e){for(var t="",n=0;n<e.length;n++){var o=e[n];if(1===n&&"-"===o&&"-"===e[0])return e;Ie(o)?t+="-"+o.toLowerCase():t+=o}return t.startsWith("ms-")?"-"+t:t}var De=Symbol.for("sc-keyframes");function Re(e){return"object"==typeof e&&null!==e&&De in e}var Te=function(e){return null==e||!1===e||""===e},xe=function(t){var n=[];for(var o in t){var r=t[o];t.hasOwnProperty(o)&&!Te(r)&&(Array.isArray(r)&&r.isCss||re(r)?n.push("".concat(Oe(o),":"),r,";"):ce(r)?n.push.apply(n,(0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)(["".concat(o," {")],xe(r),!1),["}"],!1)):n.push("".concat(Oe(o),": ").concat(Pe(o,r),";")))}return n};function je(e,t,n,o,r){if(void 0===r&&(r=[]),"string"==typeof e)return e&&r.push(e),r;if(Te(e))return r;if(se(e))return r.push(".".concat(e.styledComponentId)),r;if(re(e)){if(!re(i=e)||i.prototype&&i.prototype.isReactComponent||!t)return r.push(e),r;var s=e(t);return true||0,je(s,t,n,o,r)}var i;if(Re(e))return n?(e.inject(n,o),r.push(e.getName(o))):r.push(e),r;if(ce(e)){for(var a=xe(e),c=0;c<a.length;c++)r.push(a[c]);return r}if(!Array.isArray(e))return r.push(e.toString()),r;for(c=0;c<e.length;c++)je(e[c],t,n,o,r);return r}function ke(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!se(n))return!1}return!0}var Me=G(l),Ve=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ke(e),this.componentId=t,this.baseHash=F(Me,t),this.baseStyle=n,Ae.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n).className:"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))o=ie(o,this.staticRulesId);else{var r=ae(je(this.rules,e,t,n)),s=M(F(this.baseHash,r)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(r,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i)}o=ie(o,s),this.staticRulesId=s}else{for(var a=F(this.baseHash,n.hash),c="",u=0;u<this.rules.length;u++){var l=this.rules[u];if("string"==typeof l)c+=l, false&&(0);else if(l){var p=ae(je(l,e,t,n));a=F(F(a,String(u)),p),c+=p}}if(c){var h=M(a>>>0);if(!t.hasNameForId(this.componentId,h)){var d=n(c,".".concat(h),void 0,this.componentId);t.insertRules(this.componentId,h,d)}o=ie(o,h)}}return{className:o,css:"undefined"==typeof window?t.getTag().getGroup(N(this.componentId)):""}},e}(),Fe=/&/g,Ge=47,Le=42;function Be(e){if(-1===e.indexOf("}"))return!1;for(var t=e.length,n=0,o=0,r=!1,s=0;s<t;s++){var i=e.charCodeAt(s);if(0!==o||r||i!==Ge||e.charCodeAt(s+1)!==Le)if(r)i===Le&&e.charCodeAt(s+1)===Ge&&(r=!1,s++);else if(34!==i&&39!==i||0!==s&&92===e.charCodeAt(s-1)){if(0===o)if(123===i)n++;else if(125===i&&--n<0)return!0}else 0===o?o=i:o===i&&(o=0);else r=!0,s++}return 0!==n||0!==o}function ze(e,t){return e.map(function(e){return"rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return"".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=ze(e.children,t)),e})}function $e(e){var t,n,o,r=void 0===e?I:e,s=r.options,a=void 0===s?I:s,c=r.plugins,u=void 0===c?P:c,l=function(e,o,r){return r.startsWith(n)&&r.endsWith(n)&&r.replaceAll(n,"").length>0?".".concat(t):e},p=u.slice();p.push(function(e){e.type===Enum_RULESET&&e.value.includes("&")&&(o||(o=new RegExp("\\".concat(n,"\\b"),"g")),e.props[0]=e.props[0].replace(Fe,n).replace(o,l))}),a.prefix&&p.push(prefixer),p.push(stringify);var h=[],d=middleware(p.concat(rulesheet(function(e){return h.push(e)}))),f=function(e,r,s,c){void 0===r&&(r=""),void 0===s&&(s=""),void 0===c&&(c="&"),t=c,n=r,o=void 0;var u=function(e){if(!Be(e))return e;for(var t=e.length,n="",o=0,r=0,s=0,i=!1,a=0;a<t;a++){var c=e.charCodeAt(a);if(0!==s||i||c!==Ge||e.charCodeAt(a+1)!==Le)if(i)c===Le&&e.charCodeAt(a+1)===Ge&&(i=!1,a++);else if(34!==c&&39!==c||0!==a&&92===e.charCodeAt(a-1)){if(0===s)if(123===c)r++;else if(125===c){if(--r<0){for(var u=a+1;u<t;){var l=e.charCodeAt(u);if(59===l||10===l)break;u++}u<t&&59===e.charCodeAt(u)&&u++,r=0,a=u-1,o=u;continue}0===r&&(n+=e.substring(o,a+1),o=a+1)}else 59===c&&0===r&&(n+=e.substring(o,a+1),o=a+1)}else 0===s?s=c:s===c&&(s=0);else i=!0,a++}if(o<t){var p=e.substring(o);Be(p)||(n+=p)}return n}(function(e){if(-1===e.indexOf("//"))return e;for(var t=e.length,n=[],o=0,r=0,s=0,i=0;r<t;){var a=e.charCodeAt(r);if(34!==a&&39!==a||0!==r&&92===e.charCodeAt(r-1))if(0===s)if(a===Ge&&r+1<t&&e.charCodeAt(r+1)===Le){for(r+=2;r+1<t&&(e.charCodeAt(r)!==Le||e.charCodeAt(r+1)!==Ge);)r++;r+=2}else if(40===a&&r>=3&&108==(32|e.charCodeAt(r-1))&&114==(32|e.charCodeAt(r-2))&&117==(32|e.charCodeAt(r-3)))i=1,r++;else if(i>0)41===a?i--:40===a&&i++,r++;else if(a===Le&&r+1<t&&e.charCodeAt(r+1)===Ge)r>o&&n.push(e.substring(o,r)),o=r+=2;else if(a===Ge&&r+1<t&&e.charCodeAt(r+1)===Ge){for(r>o&&n.push(e.substring(o,r));r<t&&10!==e.charCodeAt(r);)r++;o=r}else r++;else r++;else 0===s?s=a:s===a&&(s=0),r++}return 0===o?e:(o<t&&n.push(e.substring(o)),n.join(""))}(e)),l=compile(s||r?"".concat(s," ").concat(r," { ").concat(u," }"):u);return a.namespace&&(l=ze(l,a.namespace)),h=[],serialize(l,d),h};return f.hash=u.length?u.reduce(function(e,t){return t.name||v(15),F(e,t.name)},5381).toString():"",f}var Ye=new Ae,We=$e(),qe=react.createContext({shouldForwardProp:void 0,styleSheet:Ye,stylis:We}),He=qe.Consumer,Ue=react.createContext(void 0);function Je(){return react.useContext(qe)}function Xe(e){if(!react.useMemo)return e.children;var t=Je().styleSheet,n=react.useMemo(function(){var n=t;return e.sheet?n=e.sheet:e.target&&(n=n.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(n=n.reconstructWithOptions({useCSSOMInjection:!1})),n},[e.disableCSSOMInjection,e.sheet,e.target,t]),r=react.useMemo(function(){return $e({options:{namespace:e.namespace,prefix:e.enableVendorPrefixes},plugins:e.stylisPlugins})},[e.enableVendorPrefixes,e.namespace,e.stylisPlugins]),s=react.useMemo(function(){return{shouldForwardProp:e.shouldForwardProp,styleSheet:n,stylis:r}},[e.shouldForwardProp,n,r]);return react.createElement(qe.Provider,{value:s},react.createElement(Ue.Provider,{value:r},e.children))}var Ze=react.createContext(void 0),Ke=Ze.Consumer;function Qe(){var e=o.useContext(Ze);if(!e)throw v(18);return e}function et(e){var n=o.useContext(Ze),r=o.useMemo(function(){return function(e,n){if(!e)throw v(14);if(re(e)){var o=e(n);if(false){}return o}if(Array.isArray(e)||"object"!=typeof e)throw v(8);return n?t(t({},n),e):e}(e.theme,n)},[e.theme,n]);return e.children?o.createElement(Ze.Provider,{value:r},e.children):null}var tt={},nt=new Set;function ot(e,s,i){var a=se(e),c=e,u=!z(e),p=s.attrs,h=void 0===p?P:p,d=s.componentId,f=void 0===d?function(e,t){var n="string"!=typeof e?"sc":x(e);tt[n]=(tt[n]||0)+1;var o="".concat(n,"-").concat(L(l+n+tt[n]));return t?"".concat(t,"-").concat(o):o}(s.displayName,s.parentComponentId):d,m=s.displayName,y=void 0===m?function(e){return z(e)?"styled.".concat(e):"Styled(".concat(B(e),")")}(e):m,v=s.displayName&&s.componentId?"".concat(x(s.displayName),"-").concat(s.componentId):s.componentId||f,g=a&&c.attrs?c.attrs.concat(h).filter(Boolean):h,S=s.shouldForwardProp;if(a&&c.shouldForwardProp){var w=c.shouldForwardProp;if(s.shouldForwardProp){var b=s.shouldForwardProp;S=function(e,t){return w(e,t)&&b(e,t)}}else S=w}var N=new Ve(i,v,a?c.componentStyle:void 0);function E(e,s){return function(e,s,i){var a=e.attrs,c=e.componentStyle,u=e.defaultProps,l=e.foldedComponentIds,p=e.styledComponentId,h=e.target,d=react.useContext(Ze),f=Je(),m=e.shouldForwardProp||f.shouldForwardProp; false&&0;var y=O(s,d,u)||I,v=function(e,n,o){for(var r,s=(0,tslib_es6.__assign)((0,tslib_es6.__assign)({},n),{className:void 0,theme:o}),i=0;i<e.length;i+=1){var a=re(r=e[i])?r(s):r;for(var c in a)"className"===c?s.className=ie(s.className,a[c]):"style"===c?s.style=(0,tslib_es6.__assign)((0,tslib_es6.__assign)({},s.style),a[c]):c in n&&void 0===n[c]||(s[c]=a[c])}return"className"in n&&"string"==typeof n.className&&(s.className=ie(s.className,n.className)),s}(a,s,y),g=v.as||h,S={};for(var w in v)void 0===v[w]||"$"===w[0]||"as"===w||"theme"===w&&v.theme===y||("forwardedAs"===w?S.as=v.forwardedAs:m&&!m(w,g)||(S[w]=v[w],m||"development"!=="production"||0||0||0||(0)));var b=function(e,t){var n=Je(),r=e.generateAndInjectStyles(t,n.styleSheet,n.stylis);return false&&0,r}(c,v),N=b.className; false&&0;var E=ie(l,p);return N&&(E+=" "+N),v.className&&(E+=" "+v.className),S[z(g)&&!D.has(g)?"class":"className"]=E,i&&(S.ref=i),(0,react.createElement)(g,S)}(C,e,s)}E.displayName=y;var C=react.forwardRef(E);return C.attrs=g,C.componentStyle=N,C.displayName=y,C.shouldForwardProp=S,C.foldedComponentIds=a?ie(c.foldedComponentIds,c.styledComponentId):"",C.styledComponentId=v,C.target=a?c.target:e,Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=a?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var o=0,r=t;o<r.length;o++)ue(e,r[o],!0);return e}({},c.defaultProps,e):e}}), false&&(0),le(C,function(){return".".concat(C.styledComponentId)}),u&&oe(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),C}function rt(e,t){for(var n=[e[0]],o=0,r=t.length;o<r;o+=1)n.push(t[o],e[o+1]);return n}var st=function(e){return Object.assign(e,{isCss:!0})};function it(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];if(re(t)||ce(t))return st(je(rt(P,(0,tslib_es6.__spreadArray)([t],n,!0))));var r=t;return 0===n.length&&1===r.length&&"string"==typeof r[0]?je(r):st(je(rt(r,n)))}function at(n,o,r){if(void 0===r&&(r=I),!o)throw v(1,o);var s=function(t){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return n(o,r,it.apply(void 0,(0,tslib_es6.__spreadArray)([t],s,!1)))};return s.attrs=function(e){return at(n,o,(0,tslib_es6.__assign)((0,tslib_es6.__assign)({},r),{attrs:Array.prototype.concat(r.attrs,e).filter(Boolean)}))},s.withConfig=function(e){return at(n,o,(0,tslib_es6.__assign)((0,tslib_es6.__assign)({},r),e))},s}var ct=function(e){return at(ot,e)},ut=ct;D.forEach(function(e){ut[e]=ct(e)});var lt,pt=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ke(e),Ae.registerId(this.componentId+1)}return e.prototype.createStyles=function(e,t,n,o){var r=o(ae(je(this.rules,t,n,o)),""),s=this.componentId+e;n.insertRules(s,s,r)},e.prototype.removeStyles=function(e,t){t.clearRules(this.componentId+e)},e.prototype.renderStyles=function(e,t,n,o){e>2&&Ae.registerId(this.componentId+e);var r=this.componentId+e;this.isStatic?n.hasNameForId(r,r)||this.createStyles(e,t,n,o):(this.removeStyles(e,n),this.createStyles(e,t,n,o))},e}();function ht(n){for(var r=[],s=1;s<arguments.length;s++)r[s-1]=arguments[s];var i=it.apply(void 0,e([n],r,!1)),a="sc-global-".concat(L(JSON.stringify(i))),c=new pt(i,a); false&&0;var u=new WeakMap,l=function(e){var n=Je(),r=o.useContext(Ze),s=u.get(n.styleSheet);return void 0===s&&(s=n.styleSheet.allocateGSInstance(a),u.set(n.styleSheet,s)), false&&0, false&&0,o.useLayoutEffect(function(){return n.styleSheet.server||function(e,n,o,r,s){if(c.isStatic)c.renderStyles(e,f,o,s);else{var i=t(t({},n),{theme:O(n,r,l.defaultProps)});c.renderStyles(e,i,o,s)}}(s,e,n.styleSheet,r,n.stylis),function(){c.removeStyles(s,n.styleSheet)}},[s,e,n.styleSheet,r,n.stylis]),null};return o.memo(l)}var dt=function(){function e(e,t){var n=this;this[lt]=!0,this.inject=function(e,t){void 0===t&&(t=We);var o=n.name+t.hash;e.hasNameForId(n.id,o)||e.insertRules(n.id,o,t(n.rules,o,"@keyframes"))},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,le(this,function(){throw v(12,String(n.name))})}return e.prototype.getName=function(e){return void 0===e&&(e=We),this.name+e.hash},e}();function ft(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o]; false&&0;var r=ae(it.apply(void 0,(0,tslib_es6.__spreadArray)([t],n,!1))),s=L(r);return new dt(s,r)}function mt(e){var n=o.forwardRef(function(n,r){var s=O(n,o.useContext(Ze),e.defaultProps);return false&&0,o.createElement(e,t(t({},n),{theme:s,ref:r}))});return n.displayName="WithTheme(".concat(B(e),")"),oe(n,e)}lt=De;var yt=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Se(),o=ae([n&&'nonce="'.concat(n,'"'),"".concat(a,'="true"'),"".concat(u,'="').concat(l,'"')].filter(Boolean)," ");return"<style ".concat(o,">").concat(t,"</style>")},this.getStyleTags=function(){if(e.sealed)throw v(2);return e._emitSheetCSS()},this.getStyleElement=function(){var n;if(e.sealed)throw v(2);var r=e.instance.toString();if(!r)return[];var s=((n={})[a]="",n[u]=l,n.dangerouslySetInnerHTML={__html:r},n),i=Se();return i&&(s.nonce=i),[react.createElement("style",(0,tslib_es6.__assign)({},s,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Ae({isServer:!0}),this.sealed=!1}return e.prototype.collectStyles=function(e){if(this.sealed)throw v(2);return react.createElement(Xe,{sheet:this.instance},e)},e.prototype.interleaveWithNodeStream=function(e){throw v(3)},e}(),vt={StyleSheet:Ae,mainSheet:Ye}; false&&0;var gt="__sc-".concat(a,"__"); false&&(0);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 55678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ Q; },
/* harmony export */   "Ix": function() { return /* binding */ k; }
/* harmony export */ });
/* unused harmony exports Bounce, Flip, Icons, Slide, Zoom, collapseToast, cssTransition, useToast, useToastContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
'use client';
const u=t=>"number"==typeof t&&!isNaN(t),d=t=>"string"==typeof t,p=t=>"function"==typeof t,m=t=>d(t)||p(t)?t:null,f=t=>(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)||d(t)||p(t)||u(t);function g(t,e,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=t;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition=`all ${n}ms`,requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(e,n)})})}function h(e){let{enter:a,exit:r,appendPosition:i=!1,collapse:l=!0,collapseDuration:c=300}=e;return function(e){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:h}=e;const y=i?`${a}--${d}`:a,v=i?`${r}--${d}`:r,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{const t=f.current,e=y.split(" "),n=o=>{o.target===f.current&&(t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",n),t.removeEventListener("animationcancel",n),0===T.current&&"animationcancel"!==o.type&&t.classList.remove(...e))};t.classList.add(...e),t.addEventListener("animationend",n),t.addEventListener("animationcancel",n)},[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const t=f.current,e=()=>{t.removeEventListener("animationend",e),l?g(t,m,c):m()};h||(p?e():(T.current=1,t.className+=` ${v}`,t.addEventListener("animationend",e)))},[h]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,u)}}function y(t,e){return null!=t?{content:t.content,containerId:t.props.containerId,id:t.props.toastId,theme:t.props.theme,type:t.props.type,data:t.props.data||{},isLoading:t.props.isLoading,icon:t.props.icon,status:e}:{}}const v={list:new Map,emitQueue:new Map,on(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off(t,e){if(e){const n=this.list.get(t).filter(t=>t!==e);return this.list.set(t,n),this}return this.list.delete(t),this},cancelEmit(t){const e=this.emitQueue.get(t);return e&&(e.forEach(clearTimeout),this.emitQueue.delete(t)),this},emit(t){this.list.has(t)&&this.list.get(t).forEach(e=>{const n=setTimeout(()=>{e(...[].slice.call(arguments,1))},0);this.emitQueue.has(t)||this.emitQueue.set(t,[]),this.emitQueue.get(t).push(n)})}},T=e=>{let{theme:n,type:o,...s}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":`var(--toastify-icon-color-${o})`,...s})},E={info:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Toastify__spinner"})}};function C(t){const[,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(t=>t+1,0),[l,c]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),h=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map).current,T=t=>-1!==l.indexOf(t),C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({toastKey:1,displayedToast:0,count:0,queue:[],props:t,containerId:null,isToastActive:T,getToast:t=>h.get(t)}).current;function b(t){let{containerId:e}=t;const{limit:n}=C.props;!n||e&&C.containerId!==e||(C.count-=C.queue.length,C.queue=[])}function I(t){c(e=>null==t?[]:e.filter(e=>e!==t))}function _(){const{toastContent:t,toastProps:e,staleId:n}=C.queue.shift();O(t,e,n)}function L(t,n){let{delay:s,staleId:r,...i}=n;if(!f(t)||function(t){return!g.current||C.props.enableMultiContainer&&t.containerId!==C.props.containerId||h.has(t.toastId)&&null==t.updateId}(i))return;const{toastId:l,updateId:c,data:T}=i,{props:b}=C,L=()=>I(l),N=null==c;N&&C.count++;const M={...b,style:b.toastStyle,key:C.toastKey++,...Object.fromEntries(Object.entries(i).filter(t=>{let[e,n]=t;return null!=n})),toastId:l,updateId:c,data:T,closeToast:L,isIn:!1,className:m(i.className||b.toastClassName),bodyClassName:m(i.bodyClassName||b.bodyClassName),progressClassName:m(i.progressClassName||b.progressClassName),autoClose:!i.isLoading&&(R=i.autoClose,w=b.autoClose,!1===R||u(R)&&R>0?R:w),deleteToast(){const t=y(h.get(l),"removed");h.delete(l),v.emit(4,t);const e=C.queue.length;if(C.count=null==l?C.count-C.displayedToast:C.count-1,C.count<0&&(C.count=0),e>0){const t=null==l?C.props.limit:1;if(1===e||1===t)C.displayedToast++,_();else{const n=t>e?e:t;C.displayedToast=n;for(let t=0;t<n;t++)_()}}else o()}};var R,w;M.iconOut=function(t){let{theme:n,type:o,isLoading:s,icon:r}=t,i=null;const l={theme:n,type:o};return!1===r||(p(r)?i=r(l):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(r)?i=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(r,l):d(r)||u(r)?i=r:s?i=E.spinner():(t=>t in E)(o)&&(i=E[o](l))),i}(M),p(i.onOpen)&&(M.onOpen=i.onOpen),p(i.onClose)&&(M.onClose=i.onClose),M.closeButton=b.closeButton,!1===i.closeButton||f(i.closeButton)?M.closeButton=i.closeButton:!0===i.closeButton&&(M.closeButton=!f(b.closeButton)||b.closeButton);let x=t;(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)&&!d(t.type)?x=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(t,{closeToast:L,toastProps:M,data:T}):p(t)&&(x=t({closeToast:L,toastProps:M,data:T})),b.limit&&b.limit>0&&C.count>b.limit&&N?C.queue.push({toastContent:x,toastProps:M,staleId:r}):u(s)?setTimeout(()=>{O(x,M,r)},s):O(x,M,r)}function O(t,e,n){const{toastId:o}=e;n&&h.delete(n);const s={content:t,props:e};h.set(o,s),c(t=>[...t,o].filter(t=>t!==n)),v.emit(4,y(s,null==s.props.updateId?"added":"updated"))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(C.containerId=t.containerId,v.cancelEmit(3).on(0,L).on(1,t=>g.current&&I(t)).on(5,b).emit(2,C),()=>{h.clear(),v.emit(3,C)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{C.props=t,C.isToastActive=T,C.displayedToast=l.length}),{getToastToRender:function(e){const n=new Map,o=Array.from(h.values());return t.newestOnTop&&o.reverse(),o.forEach(t=>{const{position:e}=t.props;n.has(e)||n.set(e,[]),n.get(e).push(t)}),Array.from(n,t=>e(t[0],t[1]))},containerRef:g,isToastActive:T}}function b(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientX:t.clientX}function I(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientY:t.clientY}function _(t){const[o,a]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),[r,l]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t),{autoClose:m,pauseOnHover:f,closeToast:g,onClick:h,closeOnClick:y}=t;function v(e){if(t.draggable){"touchstart"===e.nativeEvent.type&&e.nativeEvent.preventDefault(),u.didMove=!1,document.addEventListener("mousemove",_),document.addEventListener("mouseup",L),document.addEventListener("touchmove",_),document.addEventListener("touchend",L);const n=c.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=b(e.nativeEvent),u.y=I(e.nativeEvent),"x"===t.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(t.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===t.draggablePercent?1.5*t.draggablePercent:t.draggablePercent/100))}}function T(e){if(u.boundingRect){const{top:n,bottom:o,left:s,right:a}=u.boundingRect;"touchend"!==e.nativeEvent.type&&t.pauseOnHover&&u.x>=s&&u.x<=a&&u.y>=n&&u.y<=o?C():E()}}function E(){a(!0)}function C(){a(!1)}function _(e){const n=c.current;u.canDrag&&n&&(u.didMove=!0,o&&C(),u.x=b(e),u.y=I(e),u.delta="x"===t.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform=`translate${t.draggableDirection}(${u.delta}px)`,n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)))}function L(){document.removeEventListener("mousemove",_),document.removeEventListener("mouseup",L),document.removeEventListener("touchmove",_),document.removeEventListener("touchend",L);const e=c.current;if(u.canDrag&&u.didMove&&e){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return l(!0),void t.closeToast();e.style.transition="transform 0.2s, opacity 0.2s",e.style.transform=`translate${t.draggableDirection}(0)`,e.style.opacity="1"}}(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{d.current=t}),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(c.current&&c.current.addEventListener("d",E,{once:!0}),p(t.onOpen)&&t.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props),()=>{const t=d.current;p(t.onClose)&&t.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(t.pauseOnFocusLoss&&(document.hasFocus()||C(),window.addEventListener("focus",E),window.addEventListener("blur",C)),()=>{t.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",C))}),[t.pauseOnFocusLoss]);const O={onMouseDown:v,onTouchStart:v,onMouseUp:T,onTouchEnd:T};return m&&f&&(O.onMouseEnter=C,O.onMouseLeave=E),y&&(O.onClick=t=>{h&&h(t),u.canCloseOnClick&&g()}),{playToast:E,pauseToast:C,isRunning:o,preventExitTransition:r,toastRef:c,eventHandlers:O}}function L(e){let{closeToast:n,theme:o,ariaLabel:s="close"}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{className:`Toastify__close-button Toastify__close-button--${o}`,type:"button",onClick:t=>{t.stopPropagation(),n(t)},"aria-label":s},react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function O(e){let{delay:n,isRunning:o,closeToast:s,type:a="default",hide:r,className:i,style:l,controlledProgress:u,progress:d,rtl:m,isIn:f,theme:g}=e;const h=r||u&&0===d,y={...l,animationDuration:`${n}ms`,animationPlayState:o?"running":"paused",opacity:h?0:1};u&&(y.transform=`scaleX(${d})`);const v=(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated",`Toastify__progress-bar-theme--${g}`,`Toastify__progress-bar--${a}`,{"Toastify__progress-bar--rtl":m}),T=p(i)?i({rtl:m,type:a,defaultClassName:v}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(v,i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{role:"progressbar","aria-hidden":h?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s()}})}const N=n=>{const{isRunning:o,preventExitTransition:s,toastRef:r,eventHandlers:i}=_(n),{closeButton:l,children:u,autoClose:d,onClick:m,type:f,hideProgressBar:g,closeToast:h,transition:y,position:v,className:T,style:E,bodyClassName:C,bodyStyle:b,progressClassName:I,progressStyle:N,updateId:M,role:R,progress:w,rtl:x,toastId:$,deleteToast:k,isIn:P,isLoading:B,iconOut:D,closeOnClick:A,theme:z}=n,F=(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast",`Toastify__toast-theme--${z}`,`Toastify__toast--${f}`,{"Toastify__toast--rtl":x},{"Toastify__toast--close-on-click":A}),H=p(T)?T({rtl:x,position:v,type:f,defaultClassName:F}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(F,T),S=!!w||!d,q={closeToast:h,type:f,theme:z};let Q=null;return!1===l||(Q=p(l)?l(q):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(l)?(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(l,q):L(q)),react__WEBPACK_IMPORTED_MODULE_0__.createElement(y,{isIn:P,done:k,position:v,preventExitTransition:s,nodeRef:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{id:$,onClick:m,className:H,...i,style:E,ref:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{...P&&{role:R},className:p(C)?C({type:f}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-body",C),style:b},null!=D&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!B})},D),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null,u)),Q,react__WEBPACK_IMPORTED_MODULE_0__.createElement(O,{...M&&!S?{key:`pb-${M}`}:{},rtl:x,theme:z,delay:d,isRunning:o,isIn:P,closeToast:h,hide:g,type:f,style:N,className:I,controlledProgress:S,progress:w||0})))},M=function(t,e){return void 0===e&&(e=!1),{enter:`Toastify--animate Toastify__${t}-enter`,exit:`Toastify--animate Toastify__${t}-exit`,appendPosition:e}},R=h(M("bounce",!0)),w=h(M("slide",!0)),x=h(M("zoom")),$=h(M("flip")),k=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((e,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=C(e),{className:i,style:l,rtl:u,containerId:d}=e;function f(t){const e=(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-container",`Toastify__toast-container--${t}`,{"Toastify__toast-container--rtl":u});return p(i)?i({position:t,rtl:u,defaultClassName:e}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(e,m(i))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n&&(n.current=a.current)},[]),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{ref:a,className:"Toastify",id:d},o((e,n)=>{const o=n.length?{...l}:{...l,pointerEvents:"none"};return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:f(e),style:o,key:`container-${e}`},n.map((e,o)=>{let{content:s,props:a}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(N,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:`toast-${a.key}`},s)}))}))});k.displayName="ToastContainer",k.defaultProps={position:"top-right",transition:R,autoClose:5e3,closeButton:L,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let P,B=new Map,D=[],A=1;function z(){return""+A++}function F(t){return t&&(d(t.toastId)||u(t.toastId))?t.toastId:z()}function H(t,e){return B.size>0?v.emit(0,t,e):D.push({content:t,options:e}),e.toastId}function S(t,e){return{...e,type:e&&e.type||t,toastId:F(e)}}function q(t){return(e,n)=>H(e,S(t,n))}function Q(t,e){return H(t,S("default",e))}Q.loading=(t,e)=>H(t,S("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...e})),Q.promise=function(t,e,n){let o,{pending:s,error:a,success:r}=e;s&&(o=d(s)?Q.loading(s,n):Q.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(t,e,s)=>{if(null==e)return void Q.dismiss(o);const a={type:t,...i,...n,data:s},r=d(e)?{render:e}:e;return o?Q.update(o,{...a,...r}):Q(r.render,{...a,...r}),s},c=p(t)?t():t;return c.then(t=>l("success",r,t)).catch(t=>l("error",a,t)),c},Q.success=q("success"),Q.info=q("info"),Q.error=q("error"),Q.warning=q("warning"),Q.warn=Q.warning,Q.dark=(t,e)=>H(t,S("default",{theme:"dark",...e})),Q.dismiss=t=>{B.size>0?v.emit(1,t):D=D.filter(e=>null!=t&&e.options.toastId!==t)},Q.clearWaitingQueue=function(t){return void 0===t&&(t={}),v.emit(5,t)},Q.isActive=t=>{let e=!1;return B.forEach(n=>{n.isToastActive&&n.isToastActive(t)&&(e=!0)}),e},Q.update=function(t,e){void 0===e&&(e={}),setTimeout(()=>{const n=function(t,e){let{containerId:n}=e;const o=B.get(n||P);return o&&o.getToast(t)}(t,e);if(n){const{props:o,content:s}=n,a={delay:100,...o,...e,toastId:e.toastId||t,updateId:z()};a.toastId!==t&&(a.staleId=t);const r=a.render||s;delete a.render,H(r,a)}},0)},Q.done=t=>{Q.update(t,{progress:1})},Q.onChange=t=>(v.on(4,t),()=>{v.off(4,t)}),Q.POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},Q.TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},v.on(2,t=>{P=t.containerId||t,B.set(P,t),D.forEach(t=>{v.emit(0,t.content,t.options)}),D=[]}).on(3,t=>{B.delete(t.containerId||t),0===B.size&&v.off(0).off(1).off(5)});
//# sourceMappingURL=react-toastify.esm.mjs.map


/***/ }),

/***/ 88593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(91118), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);